var ATHENEUMJS_VERSION = "2.45.0";

if (window == undefined) {
    window = {};
}

if (window.localStorage == undefined) {
    localStorage = window.localStorage = {};
}

if (window.requestAnimationFrame == undefined) {
    window.requestAnimationFrame = function (callback) { callback(); };
}   

// Log to native console if possible, alert otherwise
window.console = typeof window.console === 'undefined'
    ? { log: function (/* polymorphic */) { alert(arguments) } }
    : window.console;

debugPreferences = function (prop, oldval, newval) {
    if (prop == 'atheneumUserPreferences') {

        var oldPrefs = oldval ? JSON.parse(oldval) : {};
        var prefs = {};
        for (var pref in oldPrefs) {
            if (oldPrefs[pref] !== undefined) {
                prefs[pref] = oldval[prefs];
            }
        }
        var newPrefs = JSON.parse(newval);
        // the only time things should 'disappear' from the preferences is when we logout and only the language remains
        var languagePresent = false;
        var otherThingsPresent = false;
        for (var pref in newPrefs) {
            if ("language" == pref) {
                languagePresent = true;
            } else {
                otherThingsPresent = true;
            }
        }
        if (!(languagePresent && !otherThingsPresent)) {
            for (var pref in prefs) {
                if (prefs[pref] && !newPrefs[pref]) {
                    console.log('atheneumUserPreferences missing params - debugger engaged');
                    console.log('before: ');
                    console.log(localStorage[prop] ? JSON.parse(localStorage[prop]) : localStorage[prop]);
                    console.log('after: ');
                    console.log(JSON.parse(newval));
                    debugger;
                    break;
                }
            }
        }
    }

    return newval;
};

/**

    // Instantiate Atheneum with the appId, or the full path to the site.

    AtheneumInstance = new Atheneum( "http://atheneum.co/restful/asdfasdfasdfasdfasdfasdf" );

    AtheneumInstance.HttpUtils			helper class to make api requests

    AtheneumInstance.API					all the api calls are methods of this class. You shouldn't need to access this directly
    AtheneumInstance.API.ErrorCodes		a property map { ERROR_CODE_NAME : 0xE7707CDE }

    AtheneumInstance.User					holds user details and provides methods to login / update the user
    AtheneumInstance.Library				holds all of the collection and asset meta-data, and methods
    AtheneumInstance.Favourites			holds the user's favourited collections / assets, has methods to add/remove
    AtheneumInstance.Cart					holds the user's cart, methods to share

    AtheneumInstance.UI					holds various UI element classes
                                        AtheneumUIElementInstance = AtheneumInstance.UI.Element( htmlElement );


    AtheneumUIElementInstance.on( event, callback )			attaches listeners for custom events
      

*/

// polyfills, because IE9

if (typeof String.prototype.startsWith !== "function") {
    String.prototype.startsWith = function (text, pos) {
        pos = pos || 0;
        return this.indexOf(text, pos) === pos;
    };
}

if (typeof String.prototype.contains !== "function") {
    String.prototype.contains = function (text) {
        return this.indexOf(text) != -1;
    }
}

if (typeof String.prototype.endsWith !== "function") {
    String.prototype.endsWith = function (text) {
        return this.indexOf(text, this.length - text.length) !== -1;
    }
}

if (typeof String.prototype.isEmpty !== "function") {
    String.prototype.isEmpty = function () {
        return (!this || 0 === this.length);
    }
}

if (typeof String.prototype.isBlank !== "function") {
    String.prototype.isBlank = function () {
        return (!this || /^\s*$/.test(this));
    }
}

if (typeof String.prototype.toTitleCase !== "function") {
    String.prototype.toTitleCase = function () {
        return this.replace(/\b\w+/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    }
}

if (typeof Array.prototype.contains !== "function") {
    Array.prototype.contains = function (thing) {
        return this.indexOf(thing) != -1;
    }
}

if (typeof HTMLElement.prototype.matches !== "function") {
    HTMLElement.prototype.matches = HTMLElement.prototype.matchesSelector || HTMLElement.prototype.msMatchesSelector;
}

if (typeof HTMLElement.prototype.insertAfter !== "function") {
    HTMLElement.prototype.insertAfter = function (nodeToInsert, nodeToInsertAfter) {
        if (nodeToInsertAfter == null)
            return this.insertBefore(nodeToInsert, this.firstChild);
        return this.insertBefore(nodeToInsert, nodeToInsertAfter.nextSibling);
    }
}

window.URL = window.URL || window.webkitURL;

try {
    (function () { new URL("http://www.example.com"); })();
} catch (e) {
    window.DodgyURL = window.URL;
    window.URL = undefined; // because some versions of IE support URLs, but don't support instantiating them...
}

if (!window.URL) {

    window.URL = function Polyfill_URL(href) {

        if (!(this instanceof Polyfill_URL))
            throw new TypeError("Constructor URL requires 'new'");

        this.href = href;

        var remaining = href;

        // protocol
        var protocolMatch = href.match(/^[^ \/]+:\/\//);

        if (!protocolMatch)
            throw new TypeError(href + " is not a valid url");

        this.protocol = protocolMatch ? protocolMatch[0].substring(0, protocolMatch[0].indexOf('://') + 1) : 'http:';
        remaining = remaining.substring(this.protocol.length + 2);

        if (this.protocol == 'file:') {
            this.origin = '';
            this.host = '';
            this.hostname = '';
            this.port = '';
        } else {

            // hostname
            var hostEnd = (remaining.match(/[\/#?]/) || { index: remaining.length }).index;
            var hostnameEnd = (remaining.match(/[\/#?:]/) || { index: remaining.length }).index;

            this.hostname = remaining.substring(0, hostnameEnd);

            // port
            var defaultPort = true;
            if (hostEnd != hostnameEnd) {
                defaultPort = false;
                this.port = parseInt(remaining.substring(hostnameEnd + 1, hostEnd));
            }
            else if (this.protocol == 'https:') {
                this.port = 443;
            }
            else if (this.protocol == 'ftp:') {
                this.port = 21;
            }
            else if (this.protocol == 'sftp:') {
                this.port = 22;
            }
            else {
                this.port = 80;
            }

            // host
            this.host = this.hostname + (defaultPort ? '' : (':' + this.port));

            // origin
            this.origin = this.protocol + '//' + this.host;

            remaining = remaining.substring(hostEnd);
        }

        // pathname
        var pathnameEnd = (remaining.match(/[#\?]/) || { index: remaining.length }).index;

        this.pathname = remaining.substring(0, pathnameEnd);
        remaining = remaining.substring(pathnameEnd);

        // search	
        var searchStart = remaining.indexOf('?');
        var searchEnd = remaining.indexOf('#');
        if (searchEnd == -1)
            searchEnd = remaining.length;

        if (searchStart != -1 && searchStart < searchEnd) {
            this.search = remaining.substring(0, searchEnd);
            remaining = remaining.substring(searchEnd);
        } else {
            this.search = "";
        }

        // hash
        this.hash = remaining;
    };

    window.URL.prototype.toString = function () {
        return this.href + '';
    }

    window.URL.prototype.toJSON = function () {
        return this.toString();
    }

    window.URL.createObjectURL = function (blob) {
        if (window.DodgyURL) {
            return DodgyURL.createObjectURL.apply(DodgyURL, arguments);
        }
        else {
            return null;
        }
    }

    window.URL.revokeObjectURL = function (url) {
        if (window.DodgyURL) {
            return DodgyURL.revokeObjectURL.apply(DodgyURL, arguments);
        }
        else {
            return null;
        }
    }
}


/**

    Regular Callback Format

        EITHER

            function( connection )

        OR

            {
                success: function( connection ) { ... } ,
                failure: function( connection ) { ... }
            }



    JSON Callback Format:

        EITHER

            function( json ) { ... }

            // a function which accepts one argument and will be called if the api call is successful

        OR

            {
                success: function( json ) { ... },
                failure: function( reason, httpStatus, errorCode ) { ... }
            }

            // an object containing upto two functions, which will be called in the appropriate circumstance:

*/

/**

    data-atheneum-entity
    data-atheneum-type		"asset" | "collection"
    data-atheneum-id			number
    data-atheneum-favourite	true | false
    data-atheneum-cart		true | false
    data-atheneum-action

*/

function IllegalArgumentException(message) {

    return {
        name: "Illegal Argument Exception",
        message: message,
        toString: function () { return this.name + ": " + this.message; }
    };
}

function IllegalStateException(message) {

    return {
        name: "Illegal State Exception",
        message: message,
        toString: function () { return this.name + ": " + this.message; }
    };
}

/**

    Atheneum( appId )
    Atheneum( baseUrl )
    Atheneum( appId, useProxy )
    Atheneum( baseUrl, useProxy )

*/
function Atheneum(appIdOrBaseUrl, useProxy, useCrossPlatform) {

    var atheneumStartTime = new Date();

    if (!(this instanceof Atheneum))
        return new Atheneum(appIdOrBaseUrl);

    var generic = false;
    var serverInstanceRequestUrl = undefined;
    if (typeof appIdOrBaseUrl === "object") {
        var options = appIdOrBaseUrl;
        appIdOrBaseUrl = (typeof options.baseUrl === "string" ? options.baseUrl : options.appId);
        useProxy = (typeof options.proxied === "boolean" ? options.proxied : false);
        useCrossPlatform = (typeof options.crossPlatform === "boolean" ? options.crossPlatform : false);
        generic = (typeof options.generic === "boolean" ? options.generic : true);
        serverInstanceRequestUrl = (typeof options.serverInstanceRequestUrl === "string"
            ? options.serverInstanceRequestUrl
            : ("https://atheneum.co/restful/" + (options.appId || "d7f5760b6e5f3cc7016e88acfcf10f97") + "/instance"));
    }

    if (generic && typeof appIdOrBaseUrl === "undefined" && typeof appIdOrBaseUrl === "string") {
        // this is fine
    }
    else if (typeof appIdOrBaseUrl !== "string" && !generic && typeof serverInstanceRequestUrl !== "string") {
        throw new IllegalArgumentException("appId or baseUrl is required and must be a string");
    }


    // a pointer to itself, so we can always use this.Atheneum.Something.method() no matter what this is.
    try {
        this.Proxy = new Atheneum.Proxy(this, !!useProxy);
    } catch (e) {
        console.log("Proxy not available, please check atheneumAPI.Proxy.js has been included");
        this.Proxy = new Object();
        this.Proxy.enabled = false;
    }

    try {
        this.CrossPlatform = new Atheneum.CrossPlatform(this, !!useCrossPlatform);
    } catch (e) {
        console.log("Cross platform not available, please check atheneumAPI.CrossPlatform.js has been included");
        this.CrossPlatform = new Object();
        this.CrossPlatform.enabled = false;
    }

    if (this.CrossPlatform.enabled) {
        var tempURL = this.CrossPlatform.getStartURL();
        if (typeof tempURL !== undefined && tempURL !== null && tempURL !== "")
            appIdOrBaseUrl = tempURL;

        this.version = this.CrossPlatform.getVersion();
    }

    var url = null;
    var appId = null;

    if (appIdOrBaseUrl && (
        appIdOrBaseUrl.startsWith("http://")
        || appIdOrBaseUrl.startsWith("https://")
        || appIdOrBaseUrl.startsWith("/"))) {
        url = appIdOrBaseUrl;
    }
    else if (appIdOrBaseUrl) {
        url = "https://atheneum.co/restful/" + appIdOrBaseUrl;
        appId = appIdOrBaseUrl;
    }
    else
        url = "";

    if (url.substring(url.length - 1) == "/")
        url = url.substring(0, url.length - 1);

    this.Atheneum = this;
    window.AtheneumInstance = this.Atheneum;
    // a pointer to itself, so we can always use this.Atheneum.Something.method() no matter what 'this' is.


    this.API = new Atheneum.API(this, {
        baseUrl: url,
        proxied: !!useProxy,
        crossPlatform: !!useCrossPlatform,
        serverInstanceRequestUrl: serverInstanceRequestUrl,
        appId: appId,
        generic: generic
    });


    this.LocalStorage = new Atheneum.LocalStorage(this);
    this.Archive = new Atheneum.Archive(this, true);

    this.User = new Atheneum.User(this);
    this.Library = new Atheneum.Library(this);
    this.Forms = new Atheneum.Forms(this);
    this.Filters = new Atheneum.Filters(this);
    this.Favourites = new Atheneum.Favourites(this);
    this.NewsFeed = new Atheneum.NewsFeed(this);
   
    this.UI = new Atheneum.UI(this);
    this.Pages = new Atheneum.Pages(this);
    this.Language = new Atheneum.Language(this);
    this.Translation = new Atheneum.Translation(this);
  
    
    this.Cache = new Atheneum.Cache(this);
    this.Offline = new Atheneum.Offline(this);
    this.Tracking = new Atheneum.Tracking(this);

    this.Callbacks = new Atheneum.Callbacks(this);
    this.Theme = new Atheneum.Theme(this);
    this.Cart = new Atheneum.Cart(this);
    this.Summary = new Atheneum.Summary(this);
    this.Contacts = new Atheneum.Contacts(this);
    this.Badges = new Atheneum.Badges(this);
    this.Session = new Atheneum.Session(this);
    this.Plugins = new Atheneum.Plugins(this);

    this.Admin = new Atheneum.Admin(this);

    if (this.CrossPlatform.enabled) {
        let unsyncedCount = (this.Offline.unsyncedActions) ? this.Offline.unsyncedActions.filter(function (x) { return (x.name == "shareCart" || x.name == "submitForm"); }).length : 0;
        this.CrossPlatform.reportOfflineActionsCount(unsyncedCount);

        let iOSPath = this.CrossPlatform.getiOSAppPath();
        if (iOSPath.length > 0) {
            this.LocalStorage.set("iOSPath", iOSPath);
        }
    }

    
    //For testing use
    this.DefaultCustomLibraryUI = "";

    this.ready = true; // TODO - replace this with some sort of function similar to jQuery:  atheneum.ready(function(){ ... })
}

Atheneum.prototype.jsVersion = Atheneum.version = ATHENEUMJS_VERSION;

Atheneum.prototype.DefaultImages = Atheneum.DefaultImages = {};
Atheneum.DefaultImages.MimeType = {};

Atheneum.DefaultImages.getForAssetWithMimeType = function (mimetype) {

    if (mimetype == null) {
        mimetype = "application/octet-stream";
    }
    var mimetypeParts = mimetype.split("/");

    var image = null;

    if (mimetypeParts[1] && mimetypeParts[1] != "*") {
        image = Atheneum.DefaultImages.MimeType[mimetypeParts[0] + "/" + mimetypeParts[1]];
    }
    if (image == null) {
        image = Atheneum.DefaultImages.MimeType[mimetypeParts[0] + "/*"];
    }
    image = Atheneum.DefaultImages.Asset;

    return image || null;
}

Atheneum.API = function AtheneumAPI(atheneum, baseUrl, useProxy, serverInstanceRequestUrl) {

    if (!(this instanceof Atheneum.API))
        return new Atheneum.API(atheneum, baseUrl, useProxy, serverInstanceRequestUrl);

    var STK_APPID = "54a6377877b043e60177b051d1e0012c";

    if (typeof baseUrl === "object") {
        var options = baseUrl;
        baseUrl = options.baseUrl;
        useProxy = options.proxied;
        STK_APPID = options.appId;
        this.isGeneric = options.generic;
        serverInstanceRequestUrl = options.serverInstanceRequestUrl;
        if (!serverInstanceRequestUrl && options.appId) {
            serverInstanceRequestUrl = "https://atheneum.co/restful/" + options.appId + "/instance";
        }
    }

    useProxy = !!useProxy;
    this.Atheneum = atheneum;

    this.SERVER_INSTANCE_REQUEST_URL = serverInstanceRequestUrl || ("https://atheneum.co/restful/" + STK_APPID + "/instance");

    this.SERVER_INSTANCE_BASE_URL = this.SERVER_INSTANCE_REQUEST_URL.replace(/\/instance\/?$/, '');

    this.URLs = new Atheneum.API.URLs(atheneum);

    var protocol = baseUrl.match(/^[^.]*:\/\//i);

    if (!protocol || protocol.length == 0)
        this.PROTOCOL = window.location.protocol.substring(0, window.location.protocol.length - 1);
    else
        this.PROTOCOL = protocol[0].substring(0, protocol[0].length - 3);

    if (useProxy && protocol.length > 0)
        this.BASE_URL = "/proxy/" + this.PROTOCOL + "/" + baseUrl.replace(protocol, '');
    else if (useProxy)
        this.BASE_URL = "/proxy/" + this.PROTOCOL + "/" + baseUrl;
    else
        this.BASE_URL = baseUrl;
}

Atheneum.API.URLs = function Atheneum_API_URLs(atheneum) {

    if (!(this instanceof Atheneum.API.URLs))
        return new Atheneum.API.URLs(atheneum);

    this.Atheneum = atheneum;
    this.API = atheneum.API;
}

Atheneum.API.prototype.version = Atheneum.API.version = "1.1.0"

function AtheneumAPIException(errorCode, message) {
    return {
        name: "AtheneumApiException",
        errorCode: errorCode,
        errorType: Atheneum.ErrorCodes.getName(errorCode),
        message: message,
        toString: function () { return this.name + ": (" + this.errorType + ") " + this.message; }
    };
}

Atheneum.API.prototype.Exception = Atheneum.API.Exception = AtheneumAPIException;

/** The JSON ErrorCodes returned by Atheneum.API requests */
Atheneum.API.prototype.ErrorCodes = Atheneum.API.ErrorCodes = {

    NO_ERROR: 0x00000000,

    UNDEFINED_ERROR: 0x00000001,

    ACCOUNT_ERROR: 0x01000000,  
    ACCOUNT_LOCKED: 0x01010000,
    ACCOUNT_INVALID_LOGIN: 0x01020000,

    APPLICATION_ERROR: 0x02000000,

    SERVER_ERROR: 0x04000000,
    DATABASE_ERROR: 0x04010000,

    API_ERROR: 0x08000000,
    API_ERROR_AUTH: 0x08010000,
    API_ERROR_AUTH_IP: 0x08010100,
    API_ERROR_AUTH_KEY: 0x08010200,
    API_ERROR_AUTH_EMAIL_UNCONFIRMED: 0x08010400,

    ATHENEUM_API_ERROR: 0x08060000,
    ATHENEUM_API_ERROR_APPID_INVALID: 0x08060001,
    ATHENEUM_API_ERROR_EMAIL: 0x08060100,
    ATHENEUM_API_ERROR_EMAIL_TO: 0x08060101,
    ATHENEUM_API_ERROR_EMAIL_FROM: 0x08060102,
    ATHENEUM_API_ERROR_STORY: 0x08060200,
    ATHENEUM_API_ERROR_STORY_ID_INVALID: 0x08060201,
    ATHENEUM_API_ERROR_STORY_SORT_INVALID: 0x08060202,
    ATHENEUM_API_ERROR_STORY_RANGE_INVALID: 0x08060204,
	ATHENEUM_API_ERROR_STORY_ITEMS_PER_PAGE_INVALID: 0x08060205,
	ATHENEUM_API_ERROR_STORY_PAGE_INDEX_INVALID: 0x08060206,
    ATHENEUM_API_ERROR_ASSET: 0x08060400,
    ATHENEUM_API_ERROR_ASSET_INVALIDID: 0x08060401,
    ATHENEUM_API_ERROR_LICENSE: 0x08060800,
    ATHENEUM_API_ERROR_LICENSE_QUOTAEXCEEDED: 0x08060801,
    ATHENEUM_API_ERROR_LICENSE_COUNTRYRESTRICTED: 0x08060802,
    ATHENEUM_API_ERROR_LICENSE_INVALID: 0x08060804,
    ATHENEUM_API_ERROR_SIGNUP: 0x08061000,
    ATHENEUM_API_ERROR_SIGNUP_EMAIL_INVALID: 0x08061001,
    ATHENEUM_API_ERROR_SIGNUP_USERNAME_TAKEN: 0x08061002,
    ATHENEUM_API_ERROR_SIGNUP_COUNTRY_INVALID: 0x08061004,
    ATHENEUM_API_ERROR_SIGNUP_PASSWORD_INCORRECT: 0x08061008,
    ATHENEUM_API_ERROR_SIGNUP_ACCESSCODE_INVALID: 0x08061010,
    ATHENEUM_API_ERROR_SIGNUP_USERNAME_PENDING: 0x08061030,
    ATHENEUM_API_ERROR_RATING: 0x08061100,
    ATHENEUM_API_ERROR_FAVOURITES: 0x08061200,
    ATHENEUM_API_ERROR_SHARE_DUPLICATE: 0x08062000,
    ATHENEUM_API_ERROR_INVITE: 0x08064000,
    ATHENEUM_API_ERROR_INVITE_EMAIL_INVALID: 0x08064001,
    ATHENEUM_API_ERROR_INVITE_USERNAME_TAKEN: 0x08064002,
    ATHENEUM_API_ERROR_INVITE_COUNTRY_INVALID: 0x08064004,
    ATHENEUM_API_ERROR_INVITE_PASSWORD_INCORRECT: 0x08064008,
    ATHENEUM_API_ERROR_INVITE_QUOTAEXCEEDED: 0x08064010,
    ATHENEUM_API_ERROR_PERMISSION_DENIED: 0x08068000,
    ATHENEUM_API_ERROR_PURCHASE: 0x08070000,
    ATHENEUM_API_ERROR_PURCHASE_REG: 0x08070100,
    ATHENEUM_API_ERROR_PURCHASE_REG_EMAIL_INVALID: 0x08070101,
    ATHENEUM_API_ERROR_PURCHASE_REG_USERNAME_TAKEN: 0x08070102,
    ATHENEUM_API_ERROR_PURCHASE_REG_COUNTRY_INVALID: 0x08070104,
    ATHENEUM_API_ERROR_PURCHASE_REG_PASSWORD_INCORRECT: 0x08070108,
    ATHENEUM_API_ERROR_PURCHASE_REG_QUOTAEXCEEDED: 0x08070110,
    ATHENEUM_API_ERROR_PURCHASE_REG_PRODUCT_ID: 0x08070120,
    ATHENEUM_API_ERROR_PURCHASE_REG_TRANSACTION_ID: 0x08070121,
    ATHENEUM_API_ERROR_BLOG: 0x08070400,
    ATHENEUM_API_ERROR_BLOG_INVALID: 0x08070401,
    ATHENEUM_API_ERROR_BLOGPOST: 0x08070402,
    ATHENEUM_API_ERROR_BLOGPOST_INVALID: 0x08070404,
    ATHENEUM_API_ERROR_BLOGPOST_REF_INVALID: 0x08070408,
    ATHENEUM_API_ERROR_EVENT_ITEM: 0x08070800,
    ATHENEUM_API_ERROR_EVENT_ITEM_INVALID: 0x08070801,
    ATHENEUM_API_ERROR_COMMENT: 0x08071000,
    ATHENEUM_API_ERROR_COMMENT_INVALID: 0x08071001,
    ATHENEUM_API_ERROR_SESSION: 0x08071100,
    ATHENEUM_API_ERROR_SESSION_INVALID: 0x08071101,
    ATHENEUM_API_ERROR_FORMS_INVALID_ID: 0x08071701,
    ATHENEUM_API_ERROR_CONSENT_REQUIRED: 0x08071400,
    ATHENEUM_API_ERROR_MEETING_FILE_READING: 0x08071702,
    ATHENEUM_API_ERROR_MEETING_FILE_NO_PARTICIPANTS: 0x08071703,
    ATHENEUM_API_ERROR_MEETING_FILE_FIELD_INVALID: 0x08071704,
    ATHENEUM_API_ERROR_FORMS_INVALID_CONFIG: 0x08071708,
    ATHENEUM_API_ERROR_SUBMISSION_EXCEEDED_CONTACTS_LIMIT: 0x08071706,
    ATHENEUM_API_ERROR_SUBMISSION_REQUIRED_CONTACTS_NOTPROVIDED: 0x08071707,
    UNDEFINED_CART_ERROR: 0x08071900,
    INVALID_CART_ID: 0x08071901,
    NAME_NOT_UNIQUE: 0x08071902,
    CART_EMPTY: 0x08071903,
    ADMIN_API_ERROR: 0x09000000,
    ADMIN_API_ERROR_ACCOUNT: 0x09010000,
    ADMIN_API_ERROR_ACCOUNT_INVALID_ID: 0x09010001,
    ADMIN_API_ERROR_ACCOUNT_INVALID_NAME: 0x09010002,
    ADMIN_API_ERROR_ACCOUNT_INVALID_TYPE: 0x09010003,
    ADMIN_API_ERROR_ACCOUNT_DUPLICATE_NAME: 0x09010004,
    ADMIN_API_ERROR_ACCOUNT_INVALID_REFERENCE_CODE: 0x09010005,
    ADMIN_API_ERROR_ACCOUNT_DUPLICATE_REFERENCE_CODE: 0x09010006,
    ADMIN_API_ERROR_ACCOUNT_INVALID_USER_LIMIT: 0x09010007,
    ADMIN_API_ERROR_ACCOUNT_USER_LIMIT_REACHED: 0x09010008,
    ADMIN_API_ERROR_ACCOUNT_INVALID_DATE_RANGE: 0x09010009,
    ADMIN_API_ERROR_ACCOUNT_INVALID_STORAGE_LIMIT: 0x09010010,
    ADMIN_API_ERROR_ACCOUNT_INVALID_NARRATIONS_LIMIT: 0x09010011,
    ADMIN_API_ERROR_USER: 0x09020000,
    ADMIN_API_ERROR_USER_INVALID_ID: 0x09020001,
    ADMIN_API_ERROR_USER_INVALID_USERNAME: 0x09020002,
    ADMIN_API_ERROR_USER_DUPLICATE_USERNAME: 0x09020003,
    ADMIN_API_ERROR_USER_INVALID_DATE_RANGE: 0x09020004,
    ADMIN_API_ERROR_USER_WEAK_PASSWORD: 0x09020005,
    ADMIN_API_ERROR_PERMISSIONS_SET: 0x09030000,
    ADMIN_API_ERROR_PERMISSIONS_SET_INVALID_ID: 0x09030001,
    ADMIN_API_ERROR_NARRATION_CONVERSION_CONFIG: 0x09040000,
    ADMIN_API_ERROR_NARRATION_CONVERSION_CONFIG_INVALID_ID: 0x09040001,
    ADMIN_API_ERROR_NARRATION_CONVERSION_HOST: 0x09050000,
    ADMIN_API_ERROR_NARRATION_CONVERSION_HOST_INVALID_ID: 0x09050001,
    ADMIN_API_ERROR_NARRATION_CONVERSION_HOST_INVALID_TYPE: 0x09050002,
    ADMIN_API_ERROR_USER_GROUP: 0x09060000,
    ADMIN_API_ERROR_USER_GROUP_INVALID_ID: 0x09060001,
    ADMIN_API_ERROR_USER_GROUP_DUPLICATE_EXTERNAL_ID: 0x09060002,
    ADMIN_API_ERROR_USER_GROUP_DUPLICATE_NAME: 0x09060003,
    ADMIN_API_ERROR_SELF_REGISTRATION: 0x09070000,
    ADMIN_API_ERROR_SELF_REGISTRATION_INVALID_ID: 0x09070001,
    ADMIN_API_ERROR_SELF_REGISTRATION_INVALID_STATUS: 0x09070002,
    ADMIN_API_ERROR_SELF_REGISTRATION_NOT_PENDING_APPROVAL: 0x09070003,
    ADMIN_API_ERROR_LIBRARY_TAGS: 0x09080000,
    ADMIN_API_ERROR_LIBRARY_TAGS_INVALID_ID: 0x09080001,
    ADMIN_API_ERROR_LIBRARY_TAGS_DUPLICATE_NAME: 0x09080002,
    ADMIN_API_ERROR_LIBRARY_TAGS_DUPLICATE_OPTION_NAME: 0x09080003,
    ADMIN_API_ERROR_LIBRARY_TAGS_INVALID_OPTION_NAME: 0x09080004,
    ADMIN_API_ERROR_LIBRARY_TAGS_IN_USE: 0x09080005,
    ADMIN_API_ERROR_LIBRARY_TAGS_AT_LEAST_ONE_OPTION_REQUIRED : 0x09080006,
    LINK_SUBMISSION_NOT_SUPPORTED_ON_FORM : 0x08071712,
    LINK_SUBMISSION_ID_INVALID : 0x08071713,
    LINK_SUBMISSION_FROM_DIFFERENT_FORM : 0x08071714,
    LINK_SUBMISSION_CURRENT_USER_PERMISSIONS_ERROR : 0x08071715

};

/** Converts a numeric error code into a human readable String */
Atheneum.API.prototype.ErrorCodes.getName = Atheneum.API.ErrorCodes.getName = function AtheneumAPIErrorCodes_getName(errorCode) {

    if (typeof errorCode !== "number" || isNaN(errorCode) || (errorCode % 1) > 0)
        throw new IllegalArgumentException("errorCode must be an integer");

    for (property in Atheneum.API.ErrorCodes) {

        if (property !== "getName"
            && Atheneum.API.ErrorCodes.hasOwnProperty(property)
            && Atheneum.API.ErrorCodes[property] == errorCode) {

            return property;
        }
    }

    if(errorCode ==  404){
        return 'API not implemented yet';
    }

    return "UNKNOWN_" + errorCode;
}


Atheneum.API.prototype.requestServerInstanceForFormCode = function (formCode, jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.SERVER_INSTANCE_BASE_URL + '/forms/selfregistration/' + formCode + '/lookup', jsonCallback);
}

Atheneum.API.prototype.requestServerInstance = function (username, jsonCallback) {
    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.SERVER_INSTANCE_REQUEST_URL, { userName: username }, jsonCallback);
}

Atheneum.prototype.HttpUtils = Atheneum.HttpUtils = {
    async: true,
    XMLHttpRequestPrototype: new XMLHttpRequest().__proto__
};

Atheneum.HttpUtils.TIMEOUT = 60000;

Atheneum.prototype.FileUtils = Atheneum.FileUtils = {};

Atheneum.FileUtils.inferFileExtensionFromMimeType = function (mimetype) {
    var extension = '';
    if (mimetype == 'application/pdf') {
        extension = '.pdf'
    }
    else if (mimetype == 'application/zip') {
        extension = '.zip'
    }
    else if (mimetype == 'audio/mp3') {
        extension = '.mp3'
    }
    else if (mimetype == 'audio/mp4' || mimetype == 'audio/m4a') {
        extension = '.m4a'
    }
    else if (mimetype == 'audio/flac') {
        extension = '.flac'
    }
    else if (mimetype == 'audio/wav' || mimetype == 'audio/x-wav') {
        extension = '.wav'
    }
    else if (mimetype == 'video/mp4') {
        extension = '.mp4'
    }
    else if (mimetype == 'video/quicktime' || mimetype == 'video/x-quicktime') {
        extension = '.mov'
    }
    else if (mimetype == 'text/html') {
        extension = '.html'
    }
    else if (mimetype == 'text/csv') {
        extension = '.csv'
    }
    else if (mimetype == 'text/plain') {
        extension = '.txt'
    }
    return extension;
}

Atheneum.FileUtils.saveBlobWithFileName = function (blob, filename) {

    // ie just has to be special...
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
        return;
    }

    var blobURL = window.URL.createObjectURL(blob);
    var downloadLink = document.createElement('A');
    downloadLink.setAttribute('download', filename);
    downloadLink.setAttribute('href', blobURL);
    downloadLink.setAttribute('style', 'visibility: hidden; position: absolute; top: 0; left: 0;');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    window.setTimeout(function () {
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobURL);
    }, 250);
}

/**
 * Awaits the completion of the requests
 * 
 * the callbacks will only be called once all of the connections have completed (or timed out)
 * successCallback will be called if all the connections succeed
 * failureCallback will be called if any of the connections fail
 * passing an empty array of connections will result in successCallback being called almost immediately
 * passing a single connection instead of an array of several is wasteful, but works
 * 
 * HttpUtils.await( requests, callbacks )
 * HttpUtils.await( requests, successCallback, failureCallback )
 */
Atheneum.prototype.HttpUtils.await = function (connectionOrConnectionList, callbacks) {

    // TODO: maybe validate callbacks

    if (typeof connectionOrConnectionList === "object" && !(connectionOrConnectionList instanceof Array))
        connectionOrConnectionList = [connectionOrConnectionList];

    for (var i = 0; i < connectionOrConnectionList.length; i++) {
        if (!connectionOrConnectionList[i] || !(connectionOrConnectionList[i].__proto__ == Atheneum.HttpUtils.XMLHttpRequestPrototype)) {
            // can't use instanceof because ~javascript~
            throw new IllegalArgumentException("Expected XMLHttpRequest, got " + connectionOrConnectionList);
        }
    }


    setTimeout(function () {

        var complete = true;
        var successful = true;

        for (var i = 0; i < connectionOrConnectionList.length; i++) {

            if (connectionOrConnectionList[i].readyState != 4) {
                complete = false;
                break;
            }

            if ((connectionOrConnectionList[i].status < 200 || connectionOrConnectionList[i].status >= 300)
                || (connectionOrConnectionList[i].responseJSON
                    && connectionOrConnectionList[i].responseJSON.errorCode != undefined
                    && connectionOrConnectionList[i].responseJSON.errorCode != Atheneum.API.ErrorCodes.NO_ERROR)) {

                successful = false;
            }
        }

        if (complete && successful) {
            callbacks.success();
        }
        else if (complete) {
            callbacks.failure();
        }
        else {
            Atheneum.HttpUtils.await(connectionOrConnectionList, callbacks);
        }

    }, 10);
}

/**
 * Makes a request to the supplied url, using the supplied method.
 * Optional query params or string data for the request body can be specified.
 *
 * 		required:		method, url, callback
 *
 * 	Variants:
 * 		HttpUtils.makeRequest( method, url, callback )
 * 		HttpUtils.makeRequest( method, url, queryParams, callback )
 * 		HttpUtils.makeRequest( method, url, requestBody, callback )
 * 		HttpUtils.makeRequest( method, url, queryParams, requestBody, callback )
 * 		HttpUtils.makeRequest( method, url, requestBody, queryParams, callback )
 * 		HttpUtils.makeRequest( method, url, queryParams, requestBody, requestHeaders, callback )
 * 		HttpUtils.makeRequest( method, url, requestBody, queryParams, requestHeaders, callback )
 *
 * 		HttpUtils.makeRequest( method, url, queryParams, requestBody, requestHeaders, responseType, callback )
 * 		HttpUtils.makeRequest( method, url, requestBody, queryParams, requestHeaders, responseType, callback )
 *
 * 	Example:
 * 		HttpUtils.makeRequest( "POST", "http://some.domain/path", { timestamp: 203716283 }, "body text", function(){ ... } );
 */
Atheneum.prototype.HttpUtils.makeRequest = function (method, url, queryParams, requestBody, requestHeaders, responseType, callback) {

    if (typeof requestHeaders === 'string') {
        responseType = requestHeaders;
        requestHeaders = undefined;
    }

    if (callback == undefined) {
        callback = responseType;
        responseType = undefined;
    }

    if (callback == undefined) {
        callback = requestHeaders;
        requestHeaders = undefined;
    }

    if (callback == undefined) {
        callback = requestBody;
        requestBody = undefined;
    }

    if (callback == undefined) {
        callback = queryParams;
        queryParams = undefined;
    }

    if (typeof queryParams === "string") {
        var tmp = queryParams;
        queryParams = requestBody;
        requestBody = tmp;
    }

    method = method.toUpperCase();

    queryParams = queryParams || {};

    if (!("_" in queryParams) && (method == "GET" || method == "HEAD")) {
        // prevent caching of API requests... I'm looking at you IE...
        queryParams["_"] = (new Date().getTime()) + "";
    }

    let body = document.body;
	if(body.classList.contains('testMode')){
        queryParams.testMode = true;
    }

    const sessionId = window.AtheneumInstance?.Session?.sessionId;

    if (typeof sessionId === 'string' && sessionId.length > 0) {
        queryParams.sessionId = sessionId;
    }

    var connection;

    // ie9 won't play nice
    var xmlHttpRequestSupportsCORS = !(window.XDomainRequest && (window.XMLHttpRequest && new XMLHttpRequest().responseType === undefined));
    var urlParser = document.createElement('a');
    urlParser.href = url;
    var corsUnnecessary = (urlParser.host == "") || (document.location.host == urlParser.host);

    if (xmlHttpRequestSupportsCORS || corsUnnecessary) {
        connection = new XMLHttpRequest();
    } else {
        connection = new XDomainRequest();
        connection.onprogress = function () { };
    }

    let apikey = "";
    if(queryParams && queryParams.hasOwnProperty('apikey')){
         apikey = queryParams.apikey;
         delete queryParams.apikey;
    }

    if(requestBody && requestBody.hasOwnProperty('apikey')){
        apikey = requestBody.apikey;
        delete requestBody.apikey;
    }

    if (responseType != undefined) {
        try {
            connection.responseType = responseType;
        }
        catch (e) {
            // internet explorer is special
            connection.onloadstart = function (ev) {
                connection.responseType = responseType;
            }
        }
    }


    if (typeof callback === "function") {
        connection.onreadystatechange = callback;

    } else {
        var successCallback = (callback || {}).success || callback;
        var failureCallback = (callback || {}).failure || undefined;

        var wrappedCallback = function () {

            if (connection.readyState == 4) {

                if (connection.status >= 200 && connection.status < 300 && successCallback != undefined) {
                    successCallback(connection);
                }
                else if (connection.status == 0 && url.startsWith("file://") && connection.responseType == "" && connection.responseText) {
                    // ios safari allows xhr requests for file:// urls, but pretends they failed. thanks safari.
                    successCallback(connection);
                }
                else if (failureCallback != undefined) {
                    failureCallback(connection);
                }

            }
        }

        if (xmlHttpRequestSupportsCORS || corsUnnecessary) {
            connection.onreadystatechange = wrappedCallback;
        } else {

            connection.onload = function () {

                connection.readyState = 4;
                connection.status = 200;

                if (successCallback != undefined) {
                    successCallback(connection);
                }
            }

            connection.onerror = function () {
                connection.readyState = 4;
                failureCallback(connection);
            }
        }

    }

    connection.open(method, Atheneum.HttpUtils.appendQueryParamsToUrl(url, queryParams), Atheneum.HttpUtils.async);

    if (Atheneum.HttpUtils.async)
        connection.timeout = Atheneum.HttpUtils.TIMEOUT || 0;

    if (xmlHttpRequestSupportsCORS || corsUnnecessary) {
        for (var header in requestHeaders) {
            if (requestHeaders.hasOwnProperty(header)) {
                connection.setRequestHeader(header, requestHeaders[header]);
            }
        }
    }
    
    if(apikey != "" && (url?.indexOf("atheneum.co") >= 0 || url?.indexOf("trustrack.co") >= 0 || (url?.indexOf('bmidocs') >= 0))){
        connection.setRequestHeader('Authorization', 'Bearer ' + apikey);
    }

    try {
        if (requestBody == undefined)
            connection.send();
        else
            connection.send(requestBody);
    } catch (e) {
        if (typeof failureCallback == "function")
            setTimeout(failureCallback(connection), 0);
    }

    return connection;
}

/** 
    Appends query parameters to the end of a url
	
    HttpUtils.appendQueryParamsToUrl( "http://some.domain/path", { width:110, height:70 } )

        => http://some.domain/path?width=110&height=70
	
*/
Atheneum.prototype.HttpUtils.appendQueryParamsToUrl = function (url, queryParams) {

    if (queryParams != undefined) {

        var atLeastOneParam = url.contains("?");
        for (var param in queryParams) {
            if (queryParams.hasOwnProperty(param)) {

                if (atLeastOneParam) {
                    url = url + "&" + encodeURIComponent(param) + "=" + encodeURIComponent(queryParams[param]);
                } else {
                    url = url + "?" + encodeURIComponent(param) + "=" + encodeURIComponent(queryParams[param]);
                    atLeastOneParam = true;
                }
            }
        }
    }

    return url;
}

/** Conditions which indicate that a Atheneum.API request was unsuccessful */
Atheneum.API.prototype.Problems = Atheneum.API.Problems = {
    CONNECTION_FAILED: "Encountered a problem establishing a connection to the server",
    HTTP_STATUS_ERROR: "Http status code indicated a problem",
    RESPONSE_NOT_JSON: "Response did not contain JSON",
    ERROR_CODE_PRESENT: "Response contained an error code",
    USER_ABORT: "Request was aborted by the user"
}

/**
    HttpUtils.requestJSON( method, url, jsonCallback )
    HttpUtils.requestJSON( method, url, queryParams, jsonCallback )
    HttpUtils.requestJSON( method, url, queryParams, requestBody, jsonCallback )
*/
Atheneum.prototype.HttpUtils.requestJSON = function (method, url, queryParams, requestBody, requestHeaders, jsonCallback) {

    if (jsonCallback == undefined) {
        jsonCallback = requestHeaders;
        requestHeaders = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = requestBody;
        requestBody = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = queryParams;
        queryParams = undefined;
    }

    if (requestHeaders == undefined) {
        requestHeaders = {};
    }

    if (method == "POST") {
        requestHeaders["Content-Type"] = "application/json;charset=UTF-8";
    }

    queryParams = queryParams || {};

    try{
        if(window.AtheneumInstance.User.apikey && !queryParams.hasOwnProperty('apikey')){
            queryParams.apikey = window.AtheneumInstance.User.apikey;
        }
    }catch(err){
        console.log("error adding apikey to queryParams - "+err);
    }

    var successCallback = (jsonCallback || {}).success || jsonCallback;
    var failureCallback = (jsonCallback || {}).failure || function () { };
    var offlineCallback = (jsonCallback || {}).offline || failureCallback;

    return Atheneum.HttpUtils.makeRequest(method, url, queryParams, requestBody, requestHeaders, {

        success: function (connection) {

            if (connection.responseText == undefined)
                return successCallback(undefined);

            var json;

            try {
                if (connection.status == 204)
                    json = JSON.parse('{"errorCode":0}');
                else
                    json = JSON.parse(connection.responseText);
            } catch (exception) {
                return failureCallback(Atheneum.API.Problems.RESPONSE_NOT_JSON, connection.status, undefined);
            }

            connection.responseJSON = json;

            if (json.errorCode !== undefined && json.errorCode != Atheneum.API.ErrorCodes.NO_ERROR)
                return failureCallback(Atheneum.API.Problems.ERROR_CODE_PRESENT, connection.status, json.errorCode, json);

            return successCallback(json);
        },

        failure: function (connection) {

            if (typeof (connection.response) === 'string') {
                Atheneum.Callbacks.logFailureDetails(connection.response, connection.status, undefined);
            }

            if (connection.status == 500 || connection.status == 503){
                if (typeof (connection.response) === 'string') {
                    let errorCode = undefined;
                    try{
                        let jsonResponse = JSON.parse(connection.response);
                        errorCode = jsonResponse.error?.code;
                    }catch(err){
                        errorCode = undefined;
                    }
                    return offlineCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, errorCode);
                   
                }else{
                    return offlineCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, undefined);
                }
               
            }
            if (!connection.status)
                return offlineCallback(Atheneum.API.Problems.CONNECTION_FAILED, connection.status, undefined);

            if (connection.status >= 400){
                if (typeof (connection.response) === 'string') {
                    let errorCode = undefined;
                    try{
                        let jsonResponse = JSON.parse(connection.response);
                        errorCode = jsonResponse.error?.code;
                    }catch(err){
                        errorCode = undefined;
                    }
                    return failureCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, errorCode);
                   
                }else{
                    return failureCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, undefined);
                }
            }
               

            // this should never happen, but just in case...
            return failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);
        }

    });
}

/**
    HttpUtils.getJSON( url, jsonCallback )
    HttpUtils.getJSON( url, queryParams, jsonCallback )
    HttpUtils.getJSON( url, queryParams, requestHeaders, jsonCallback )
*/
Atheneum.prototype.HttpUtils.getJSON = function (url, queryParams, requestHeaders, jsonCallback) {

    if (jsonCallback == undefined) {
        jsonCallback = requestHeaders;
        requestHeaders = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = queryParams;
        queryParams = undefined;
    }

    return Atheneum.HttpUtils.requestJSON("GET", url, queryParams, undefined, requestHeaders, jsonCallback);
}

/**
    HttpUtils.postJSON( url, jsonCallback )
    HttpUtils.postJSON( url, jsonData, jsonCallback )
    HttpUtils.postJSON( url, jsonData, queryParams, jsonCallback )
    HttpUtils.postJSON( url, jsonData, queryParams, requestHeaders, jsonCallback )
*/
Atheneum.prototype.HttpUtils.postJSON = function (url, jsonData, queryParams, requestHeaders, jsonCallback) {

    if (jsonCallback == undefined) {
        jsonCallback = requestHeaders;
        requestHeaders = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = queryParams;
        queryParams = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = jsonData;
        jsonData = undefined;
    }

    return Atheneum.HttpUtils.requestJSON("POST", url, queryParams, jsonData === undefined ? undefined : JSON.stringify(jsonData), requestHeaders, jsonCallback);
}

/**
    HttpUtils.deleteJSON( url, jsonCallback )
    HttpUtils.deleteJSON( url, jsonData, jsonCallback )
    HttpUtils.deleteJSON( url, jsonData, queryParams, jsonCallback )
    HttpUtils.deleteJSON( url, jsonData, queryParams, requestHeaders, jsonCallback )
*/
Atheneum.prototype.HttpUtils.deleteJSON = function (url, jsonData, queryParams, requestHeaders, jsonCallback) {

    if (jsonCallback == undefined) {
        jsonCallback = requestHeaders;
        requestHeaders = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = queryParams;
        queryParams = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = jsonData;
        jsonData = undefined;
    }

    return Atheneum.HttpUtils.requestJSON("DELETE", url, queryParams, jsonData === undefined ? undefined : JSON.stringify(jsonData), requestHeaders, jsonCallback);
}

Atheneum.API.prototype.getPlugins = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = undefined;
    if (this.Atheneum.User.apikey) {
        params = { apikey: this.Atheneum.User.apikey };
    }

    if (typeof timestamp === "number" && !isNaN(timestamp)) {
        if (params) {
            params.timestamp = timestamp
        }
        else {
            params = { timestamp: timestamp };
        }
    }
    else if (timestamp != undefined) {
        throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
    }

    return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/plugins", params, jsonCallback);
}

/** Retrieves the list of countries. If a timestamp is provided, only returns the list if there has been a change */
Atheneum.API.prototype.getCountries = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = undefined;
    if (this.Atheneum.User.apikey) {
        params = { apikey: this.Atheneum.User.apikey };
    }
    if (typeof timestamp === "number" && !isNaN(timestamp)) {
        if (params) {
            params.timestamp = timestamp
        }
        else {
            params = { timestamp: timestamp };
        }
    }
    else if (timestamp != undefined) {
        throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
    }
    return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/countries", params, jsonCallback);
}

/** Retrieves the list of languages. If a timestamp is provided, only returns the list if there has been a change */
Atheneum.API.prototype.getLanguages = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = undefined;
    if (this.Atheneum.User.apikey) {
        params = { apikey: this.Atheneum.User.apikey };
    }
    if (typeof timestamp === "number" && !isNaN(timestamp)) {
        if (params) {
            params.timestamp = timestamp
        }
        else {
            params = { timestamp: timestamp };
        }
    }
    else if (timestamp != undefined) {
        throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/languages", params, jsonCallback);
}

/**Retrieves list of languages for translations from the click event */
Atheneum.API.prototype.getTranslation = function (language, timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (language == undefined) {
        throw new IllegalArgumentException("language must be two chracter iso code");
    }

    var params = undefined;
    if (this.Atheneum.User.apikey) {
        params = { apikey: this.Atheneum.User.apikey };
    }
    if (typeof timestamp === "number" && !isNaN(timestamp)) {
        if (params) {
            params.timestamp = timestamp
        }
        else {
            params = { timestamp: timestamp };
        }
    }
    else if (timestamp != undefined) {
        throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/translations/" + language, params, jsonCallback);

}

Atheneum.API.prototype.getSelfRegistrationForm = function (code, jsonCallback) {

    if (typeof code !== 'string' || code == '') {
        throw new IllegalArgumentException("code is required and must be a string");
    }

    //	// test fields
    //	var registrationFormThemeProperties = { };
    //	var registrationForm = { 
    //		id: 'test-registration-form-id',
    //		title: 'Register',
    //		type: 'SELF_REGISTRATION',
    //		properties: {
    //			subheader: '<div style="text-align: center; font-size: 1.5rem; margin: -1rem 0 -0.5rem;">Register for Resource Centre Web</div>',
    //			tncsContent: '<h3>Privacy Policy</h3><div>Lorem Ipsum</div>'
    //		},
    //		fields: [
    //			{ label: 'Username', name: 'userName', type: 'TEXT', visible: true, required: true, order: 0 },
    //			{ label: 'First Name', name: 'firstName', type: 'TEXT', visible: true, required: true, order: 1 },
    //			{ label: 'Last Name', name: 'lastName', type: 'TEXT', visible: true, required: true, order: 2 },
    //			{ label: 'Email Address', name: 'email', type: 'EMAIL', visible: true, required: true, order: 3 },
    //			{ label: 'Password', name: 'password', type: 'PASSWORD', visible: true, required: true, order: 4 }
    //		]
    //	};
    //	
    //	jsonCallback.success({ form: registrationForm, theme: { properties: registrationFormThemeProperties } });
    //	return;

    return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/forms/selfregistration/" + code, {}, jsonCallback);
}

/** 
 * Atheneum.API.getContacts( [timestamp], callback )
 * 		- Retrieves the complete list of contacts.
 * 		  Do not use if the server is likely to have thousands of contacts (or more)
 * 
 * Atheneum.API.getContacts( itemsPerPage, pageIndex, [timestamp], callback )
 * 		- Retrieves a page of contacts. (Pages are 0 indexed, so page 0 is the first page).
 * 		  If there are 20 contacts, calling it with, itemsPerPage = 8, pageIndex = 1
 * 		  will return "Contact 9" through to "Contact 16".
 *
 */
Atheneum.API.prototype.getContacts = function (itemsPerPage, pageIndex, timestamp, jsonCallback) {

    if (arguments.length <= 2 && typeof pageIndex !== "number") {
        jsonCallback = pageIndex;
        timestamp = itemsPerPage;
        itemsPerPage = undefined;
        pageIndex = undefined;
    }

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp && !isNaN(timestamp)) {
        params.timestamp = timestamp;
    }
    if (typeof itemsPerPage === "number" && !isNaN(itemsPerPage)
        && typeof pageIndex === "number" && !isNaN(pageIndex)) {
        params.itemsPerPage = itemsPerPage;
        params.pageIndex = pageIndex;
    }

    return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/contacts", params, jsonCallback);
}

/** Retrieves the complete list of contacts the user can see that have status=PENDING. Do not use if the server is likely to have thousands of contacts (or more) */
Atheneum.API.prototype.getPendingContacts = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (timestamp == undefined)
        return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/contacts/pending", { apikey: this.Atheneum.User.apikey }, jsonCallback);

    if (typeof timestamp === "number" && !isNaN(timestamp))
        return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + "/contacts/pending", { timestamp: timestamp, apikey: this.Atheneum.User.apikey }, jsonCallback);

    throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
}

/** Retrieves the complete list of contacts in collections. Do not use if the server is likely to have thousands of contacts (or more) */
Atheneum.API.prototype.getCollectionsContacts = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }
    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp != undefined)
        params.timestamp = timestamp;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/contacts/collections", params, jsonCallback);
}

/**
 * 
 * searchContacts( params, jsonCallback );
 * 
 * searchContacts( query, jsonCallback );
 * searchContacts( query, partialMatch, jsonCallback );
 * searchContacts( query, itemsPerPage, jsonCallback );
 * searchContacts( query, itemsPerPage, pageIndex, jsonCallback );
 * searchContacts( query, partialMatch, itemsPerPage, jsonCallback );
 * searchContacts( query, partialMatch, itemsPerPage, pageIndex, jsonCallback );
 * 
 * searchContacts( fieldName, query, jsonCallback );
 * searchContacts( fieldName, query, partialMatch, jsonCallback );
 * searchContacts( fieldName, query, itemsPerPage, jsonCallback );
 * searchContacts( fieldName, query, itemsPerPage, pageIndex, jsonCallback );
 * searchContacts( fieldName, query, partialMatch, itemsPerPage, jsonCallback );
 * searchContacts( fieldName, query, partialMatch, itemsPerPage, pageIndex, jsonCallback );
 */
Atheneum.API.prototype.searchContacts = function (fieldName, query, partialMatch, itemsPerPage, pageIndex, jsonCallback) {

    if (typeof fieldName === 'object' && arguments.length <= 2) {
        jsonCallback = query;
        pageIndex = fieldName.pageIndex;
        itemsPerPage = fieldName.itemsPerPage;
        partialMatch = fieldName.partialMatch;
        query = fieldName.query;
        fieldName = fieldName.fieldName;
    }
    else {
        if (arguments.length < 6 && typeof query !== 'string') {
            jsonCallback = pageIndex;
            pageIndex = itemsPerPage;
            itemsPerPage = partialMatch;
            partialMatch = query;
            query = fieldName;
            fieldName = undefined;
        }
        if (typeof partialMatch !== 'boolean' && partialMatch != undefined) {
            jsonCallback = pageIndex;
            pageIndex = itemsPerPage;
            itemsPerPage = partialMatch;
            partialMatch = undefined;
        }
        if (jsonCallback == undefined && typeof pageIndex !== 'number') {
            jsonCallback = pageIndex;
            pageIndex = undefined;
        }
        if (jsonCallback == undefined && typeof itemsPerPage !== 'number') {
            jsonCallback = pageIndex;
            pageIndex = undefined;
        }
    }

    if (fieldName != undefined && typeof fieldName !== 'string') {
        throw new IllegalArgumentException("fieldName must be a string, or undefined");
    }
    if (typeof query !== 'string') {
        throw new IllegalArgumentException("query must be a string");
    }
    if (partialMatch != undefined && typeof partialMatch !== 'boolean') {
        throw new IllegalArgumentException("partialMatch must be a boolean, or undefined");
    }
    if (itemsPerPage != undefined && typeof itemsPerPage !== 'number') {
        throw new IllegalArgumentException("itemsPerPage must be a number, or undefined");
    }
    if (pageIndex != undefined && typeof pageIndex !== 'number') {
        throw new IllegalArgumentException("pageIndex must be a number, or undefined");
    }
    if (jsonCallback != undefined && typeof jsonCallback !== 'object' && typeof jsonCallback !== 'function') {
        throw new IllegalArgumentException("jsonCallback must be a function or callback object, or undefined");
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (fieldName != undefined) {
        params.fieldName = fieldName;
    }
    if (query != undefined) {
        params.query = query;
    }
    if (partialMatch != undefined) {
        params.partialMatch = partialMatch;
    }
    if (itemsPerPage != undefined) {
        params.itemsPerPage = itemsPerPage;
        params.pageIndex = ((pageIndex == undefined) ? 0 : pageIndex);
    }

    if (jsonCallback == undefined) {
        jsonCallback = { success: function () { }, failure: this.Atheneum.Callbacks.logFailureDetails };
    }

    return this.Atheneum.HttpUtils.getJSON(this.BASE_URL + '/contacts/search', params, jsonCallback);
}

/**
 * Search veeva contats
 *  
GET {{instanceUrl}}/restful/{{appId}}/contacts/veeva/search?apikey={{apikey}}&fields={{fieldsList}}&{{searchFieldName}}={{searchFieldValue}}
{{fieldsList}} should be replaced with a comma separated list of fieldNames you want back for each matching Veeva account. The fields must match one or more of the below list:

 

id
salutation
suffix
title
credentials
alternateName
preferredName
name
firstName
middleName
lastName
gender
specialty1
specialty2
language
phone
mobilePhone
fax
email
website
mailingStreet
mailingCity
mailingState
mailingPostalCode
mailingCountry
shippingStreet
shippingCity
shippingState
shippingPostalCode
shippingCountry
billingStreet
billingCity
billingState
billingPostalCode
billingCountry
territory
defaultOrderType

You must also supply one or more search terms as URL parameters. Eg for searching by email, use &email=john.smith@trustrack.com. 
If multiple search params are provided, it currently treats them as an AND operation.

 * @param {*} fieldsList 
 * @param {*} params 
 * @param {*} callbacks 
 * @returns 
 */
Atheneum.API.prototype.searchVeevaContacts = function (fieldsList, params, callbacks){
     if(typeof params !== 'object')
        throw new Error("searchVeevaContacts requires at least one {searchFields} in params setup");


    if(this.Atheneum.Theme.getBooleanProperty('normalizeVeevaSearchFields', true)){
        for(const key in params){
            if(!params.hasOwnProperty(key))
                continue;

            if(typeof params[key] === 'string')
                params[key] = params[key]?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
    }

    if (this.Atheneum.User.apikey != undefined)
        params.apikey = this.Atheneum.User.apikey;

    params.fields = fieldsList;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/contacts/veeva/search", params, callbacks);
}

// There should always be a status field in this call. If they don't have an email, they will be set as PENDING. If they have an email but it's opted out then status will be UNSUBSCRIBED. If they have email and have opted in it will be SUBSCRIBED.

//  * @param {*} extId 
//  * @param {*} callbacks 
//  * @returns 
//  */
Atheneum.API.prototype.searchVeevaContactDetails = function (crmId, callbacks){
   let params = {};
   
   if (this.Atheneum.User.apikey != undefined)
       params.apikey = this.Atheneum.User.apikey;

   return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/contacts/veeva/"+crmId, params, callbacks);
}


/**
 * Search GSK contacts:
GET /restful/{{appId}}/contacts/gsk/search?apikey={{apikey}}&{{fieldName}}={{value}}
 
Can use field names for parameters to search, eg: &country=CA&firstName=John&LastName=Smith
 
Can use any of the following parameters if available in the form:
country
crmId
firstName
middleName
lastName
addressLine1 - addressLine5
speciality1 + speciality2
city
state
postCode
 
Anything not in that list will be ignored. If searching by crmId then you don't need a country, but otherwise you do. So for our case it will always be required. I think you will get the generic error code back if you don't have it.
 
The response should be something like:
{
  "errorCode": 0,
  "accounts": [
    {
      "mdmId": "HCP38255679",
      "crmId": "001Dy00000zD8yQIAS",
      "country": "CA",
      "firstName": "OneConsent1001",
      "lastName": "TestAccount",
      "speciality1": "Family Medicine",
      ... 
      (if set will have any of the properties listed above)
    }
  ]
}
 
 * @param {*} fieldsList 
 * @param {*} params 
 * @param {*} callbacks 
 * @returns 
 */
Atheneum.API.prototype.searchGSKContacts = function (fieldsList, params, callbacks){
    if(typeof params !== 'object')
       throw new Error("searchGSKContacts requires at least one {searchFields} in params setup");

    if(this.Atheneum.Theme.getBooleanProperty('normalizeGSKSearchFields', true)){
        for(const key in params){
            if(!params.hasOwnProperty(key))
                continue;

            if(typeof params[key] === 'string')
                params[key] = params[key]?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
    }

   if (this.Atheneum.User.apikey != undefined)
       params.apikey = this.Atheneum.User.apikey;

   params.fields = fieldsList;

   return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/contacts/gsk/search", params, callbacks);
}

/**
 * Then to check for an email/phone and consent status for a particular contact, you can use:
 
GET /restful/{{appId}}/contacts/gsk/{{mdmId}}?apikey={{apikey}}
 
This will respond with something like:
{
    "errorCode": 0,
    "account": {
        "mdmId": "HCP38255679",
        "crmId": "001Dy00000zD8yQIAS",
        "country": "CA",
        "firstName": "OneConsent1001",
        "lastName": "TestAccount",
        "speciality1": "Family Medicine",
        ...(if set will have any of the properties listed above)
        "email": "development@tangent90.co.uk",
        "emailConsented": true,
        "phone": "310777731",
        "phoneConsented": true,
        "status": "SUBSCRIBED"
    }
}
 
There should always be a status field in this call. If they don't have an email, they will be set as PENDING. If they have an email but it's opted out then status will be UNSUBSCRIBED. If they have email and have opted in it will be SUBSCRIBED.

 * @param {*} mdmId 
 * @param {*} callbacks 
 * @returns 
 */
Atheneum.API.prototype.searchGSKContactDetails = function (mdmId, callbacks){
   let params = {};
   
   if (this.Atheneum.User.apikey != undefined)
       params.apikey = this.Atheneum.User.apikey;

   return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/contacts/gsk/"+mdmId, params, callbacks);
}

/** No idea what this is for */
Atheneum.API.prototype.getHomePageModules = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/modules", undefined, jsonCallback);
};

/**
    Atheneum.API.getLibrary( jsonCallback )
    Atheneum.API.getLibrary( timestamp, jsonCallback )
    Atheneum.API.getLibrary( timestamp, sort, jsonCallback )
    Atheneum.API.getLibrary( timestamp, range, jsonCallback )
    Atheneum.API.getLibrary( timestamp, sort, range, jsonCallback )
*/
Atheneum.API.prototype.getLibrary = function (timestamp, sort, range, jsonCallback) {

    if (typeof sort === "object" && (sort.hasOwnProperty("to") || sort.hasOwnProperty("from"))) {
        var temp = sort;
        sort = range;
        range = temp;
    }

    if (jsonCallback == undefined) {
        jsonCallback = range;
        range = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = sort;
        sort = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

	var itemsPerPage = undefined;
	var pageIndex = undefined;
	if( typeof sort === 'number' && typeof range === 'number' ) {
		itemsPerPage = sort;
		pageIndex = range;
		sort = undefined;
		range = undefined;
	}

    var options = {};
    if (sort != undefined) options.sort = sort;
    if (timestamp != undefined) {

        if (typeof timestamp === "number" && !isNaN(timestamp)) {
            options.libraryTimestamp = timestamp;
        }
        else if (typeof timestamp === "object" && timestamp instanceof Date) {
            options.libraryTimestamp = timestamp.getTime();
        }
        else {
            throw new IllegalArgumentException("timestamp must be a number or a date");
        }
    }

    if (range != undefined && range.to != undefined) options.rangeTo = range.to;
    if (range != undefined && range.from != undefined) options.rangeFrom = range.from;

	if(itemsPerPage != undefined) {
		options.itemsPerPage = itemsPerPage;
	}
	if(pageIndex != undefined) {
		options.pageIndex = pageIndex;
	}

    if (options == {})
        options = undefined;

    if (this.Atheneum.User.apikey != undefined)
        options.apikey = this.Atheneum.User.apikey;

    let url = "/stories/library";
    if(this.Atheneum.Theme.getBooleanProperty('useFlatLibrary', false)){
        url = "/library";
        if(options.hasOwnProperty('libraryTimestamp'))
            options.timestamp = options.libraryTimestamp;
        
    }
        
    
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + url, options, jsonCallback);
}

/**
 * Gtes total item counts for the library
 * @param {*} jsonCallback 
 * @returns 
 */
Atheneum.API.prototype.checkLibraryTotals = function (jsonCallback) {
    var options = {};
   
    if (this.Atheneum.User.apikey != undefined)
        options.apikey = this.Atheneum.User.apikey;

    let url = "/library/totals";
    
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + url, options, jsonCallback);
}

Atheneum.API.prototype.getCollection = function (collectionId, jsonCallback) {
    let options = {};
    if (this.Atheneum.User.apikey != undefined)
        options.apikey = this.Atheneum.User.apikey;
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/library/" + collectionId, options, jsonCallback);
};

Atheneum.API.prototype.getCollectionTheme = function (collectionId, jsonCallback) {
    let options = {};
    if (this.Atheneum.User.apikey != undefined)
        options.apikey = this.Atheneum.User.apikey;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/library/" + collectionId + "/theme", options, jsonCallback);
};

/**
    Atheneum.API.getCollectionThumbnail( collectionId, callback )
    Atheneum.API.getCollectionThumbnail( collectionId, format, callback )
    Atheneum.API.getCollectionThumbnail( collectionId, options, callback )
*/
Atheneum.API.prototype.getCollectionThumbnail = function (collectionId, options, callback) {

    if (callback == undefined) {
        callback = options;
        options = undefined;
    }

    var format = "jpg";
    if (typeof options === "string") {
        format = options;
        options = {};
    }

    options = options || {};
    delete options.format;

    var apikeyText = "";
    if(window.AtheneumInstance.User.apikey && !queryParams.hasOwnProperty('apikey')){
        apikeyText = "?apikey="+window.AtheneumInstance.User.apikey;
    }


    return this.Atheneum.HttpUtils.makeRequest(this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/thumb." + format + apikeyText, options, undefined, callback);
};

Atheneum.API.URLs.prototype.getAssetPreviewURL = function (collectionId, assetId) {
    if (this.Atheneum.Proxy.enabled) {
        var asset = this.Atheneum.Library.assets[assetId];
        if (asset && asset.mimetype == 'application/pdf') {
            return window.location.origin + '/restful/library/' + assetId + '/preview.pdf';
        }
    }
    return this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/assets/" + assetId;
}

Atheneum.API.prototype.getAsset = function (collectionId, assetId, callback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/assets/" + assetId, undefined, callback);
};

Atheneum.API.prototype.getAsset = async function (collectionId, assetId, callback) {
    return new Promise((resolve, reject) =>{
        this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/assets/" + assetId, undefined, {
            success: function (json){
                resolve(json);
            },
            failure: function (reason, httpStatus, errorCode){
                resolve({reason: reason, httpStatus: httpStatus, errorCode: errorCode });
            }
        });
    });
};

/**
    Atheneum.API.getAssetStream( collectionId, assetId, callback )
    Atheneum.API.getAssetStream( collectionId, assetId, quality, callback )
*/
Atheneum.API.prototype.getAssetStream = function (collectionId, assetId, quality, callback) {

    if (callback == undefined) {
        callback = quality;
        quality = undefined;
    }

    var streamUrl = this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/assets/" + assetId + "/stream";

    if (quality == undefined)
        return this.Atheneum.HttpUtils.getJSON(streamUrl, undefined, callback);

    return this.Atheneum.HttpUtils.getJSON(streamUrl + "/" + quality, undefined, callback);

};

Atheneum.API.prototype.VideoQuality = Atheneum.API.VideoQuality = {
    HIGH: "HIGH",
    HIGHMED: "HIGHMED",
    LOWMED: "LOWMED",
    LOW: "LOW"
}

/**
    Library.getAssetThumbnail( collectionId, assetId, callback )
    Library.getAssetThumbnail( collectionId, assetId, format, callback )
    Library.getAssetThumbnail( collectionId, assetId, options, callback )
*/
Atheneum.API.prototype.getAssetThumbnail = function (collectionId, assetId, options, callback) {

    if (callback == undefined) {
        callback = options;
        options = undefined;
    }

    var format = "jpg";
    if (typeof options === "string") {
        format = options;
        options = {};
    }

    options = options || {};
    delete options.format;

    var apikeyText = "";
    if(window.AtheneumInstance.User.apikey && !queryParams.hasOwnProperty('apikey')){
        apikeyText = "?apikey="+window.AtheneumInstance.User.apikey;
    }

    return this.Atheneum.HttpUtils.makeRequest(
        this.Atheneum.BASE_URL + "/stories/" + collectionId + "/thumb." + format + apikeyText, options, undefined, callback);

};

// this doesn't belong in Atheneum.API as it's not a wrapper for an api call
// Atheneum.Library.prototype.searchCollection would be a better place for it
// It also seems to have references to Atheneum in it which won't work
Atheneum.API.prototype.searchLibrary = function (collection, text) {
    if (typeof collection === 'string') {
        return searchCollection(this.Atheneum.Library.collections[collection], text);
    }

    var atheneum = this.Atheneum;
    if (collection == null) {
        return searchCollection({
            id: null,
            stories: atheneum.Library.getTopLevelCollections(),
            assets: [],
        }, text);
    }

    var filterText = text.toLowerCase();

    var matches = [];

    if (collection.stories) {
        checking_subcollections:
        for (var c = 0; c < collection.stories.length; c++) {
            var subcollection = collection.stories[c];

            if (!atheneum.User.canSee(subcollection)) {
                continue;
            }

            if (subcollection.name && subcollection.name.toLowerCase().indexOf(filterText) != -1) {
                matches[matches.length] = subcollection;
                continue;
            }

            if (subcollection.stories) {
                for (var s = 0; s < subcollection.stories.length; s++) {
                    var subsubcollection = subcollection.stories[s];
                    if (!atheneum.User.canSee(subsubcollection)) {
                        continue;
                    }

                    if (subsubcollection.name && subsubcollection.name.toLowerCase().indexOf(filterText) != -1) {
                        matches[matches.length] = subcollection;
                        continue checking_subcollections;
                    }
                }
            }

            if (subcollection.assets) {
                for (var a = 0; a < subcollection.assets.length; a++) {
                    var asset = subcollection.assets[a];
                    if (!atheneum.User.canSee(asset)) {
                        continue;
                    }
                    if (asset.name && asset.name.toLowerCase().indexOf(filterText) != -1) {
                        matches[matches.length] = subcollection;
                        continue checking_subcollections;
                    }
                }
            }

            // only include forms in the results if they are shown in in the library like collections
            if (this.Atheneum.Theme.TRUE_VALUES.contains(atheneum.Theme.getCollectionProperty(subcollection || null, 'showFormsInLibrary', 'off'))) {

                var subcollectionForms = atheneum.Forms.getGenericAndConsentFormsInCollection(subcollection);
                for (var f = 0; f < subcollectionForms.length; f++) {
                    var subcollectionForm = subcollectionForms[f];
                    if (!atheneum.User.canSee(subcollectionForm)) {
                        continue;
                    }
                    if (subcollectionForm.title && subcollectionForm.title.toLowerCase().indexOf(filterText) != -1) {
                        matches[matches.length] = subcollection;
                        break;
                    }
                }
            }
        }
    }

    // only include forms in the results if they are shown in in the library like collections
    if (atheneum.Theme.getBooleanProperty('showFormsInLibrary', false)) {

        var collectionForms = (collection.id != null) ?
            atheneum.Forms.getGenericAndConsentFormsInCollection(collection)
            : atheneum.Forms.getHomeScreenForms();

        for (var f = 0; f < collectionForms.length; f++) {
            var collectionForm = collectionForms[f];
            if (!atheneum.User.canSee(collectionForm)) {
                continue;
            }
            if (collectionForm.title && collectionForm.title.toLowerCase().indexOf(filterText) != -1) {
                matches[matches.length] = collectionForm;
            }
        }
    }

    matches.sort(function (a, b) {
        if (getOrder(a) < getOrder(b)) {
            return -1;
        }
        else if (getOrder(a) > getOrder(b)) {
            return 1;
        }
        else {
            return 0;
        }
    });

    return matches;
};

Atheneum.API.prototype.filterLibrary = function (filterOptions, sort, callback) { }; // TODO

Atheneum.API.prototype.login = function (username, password, jsonCallback) {
    if (username == undefined || password == undefined)
        throw new IllegalArgumentException("username and password are required");

    if (this.Atheneum.CrossPlatform.enabled) {
        return this.Atheneum.CrossPlatform.login(username, password, jsonCallback);
    }

    if (username == undefined || password == undefined)
        throw new IllegalArgumentException("username and password are required");

    var queryParams = {
        appVersion: this.Atheneum.version
    }

    var requestBody = { userName: username, password: password };

    // device info

    requestBody.appType = "webapp";
    requestBody.appName = "salestoolkit";
    requestBody.appUrl = window.location.host;
    requestBody.appVersion = this.Atheneum.version;
    requestBody.deviceIdiom = Atheneum.Device.getCategory();
    requestBody.deviceOSVersion = Atheneum.Device.getOSVersion();
    requestBody.devicePlatform = Atheneum.Device.getOSName();
    requestBody.browserName = Atheneum.Device.getBrowserName();
    requestBody.browserVersion = Atheneum.Device.getBrowserVersion();
    requestBody.screenSize = Atheneum.Device.getScreenDimensions();

    for (var prop in requestBody) {
        if (requestBody.hasOwnProperty(prop) && requestBody[prop] == null) {
            delete requestBody[prop];
        }
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.SERVER_INSTANCE_BASE_URL + "/login", requestBody, queryParams, jsonCallback);
}

Atheneum.API.prototype.selectedSSOLoginInstance = function (loginAttemptId, loginId) {
   
    //Should redirect - if not may need to add callbacks
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
        // return if not ready state 4
        if (this.readyState !== 4) {
          return;
        }
  
        // check for redirect
        if (this.status === 302 /* or may any other redirect? */) {
          var location = this.getResponseHeader("Location");
          return ajax.call(this, location /*params*/, callback);
        } 
  
        // return data
        if(this.responseURL)
            window.location.href = this.responseURL;
    };
    xmlhttp.open("GET", "https://www.atheneum.co/sso/selection?loginAttemptId="+loginAttemptId+"&loginId="+loginId, true);
    xmlhttp.send();
}

Atheneum.API.prototype.initiateLogin = function (username, jsonCallback) {
    if (username == undefined)
        throw new IllegalArgumentException("username are required");

    if (this.Atheneum.CrossPlatform.enabled) {
        return this.Atheneum.CrossPlatform.initiateLogin(username, jsonCallback);
    }

    if (username == undefined)
        throw new IllegalArgumentException("username are required");

    var queryParams = {
        appVersion: this.Atheneum.version
    }

    var requestBody = { userName: username };

    // device info

    requestBody.appType = "webapp";
    requestBody.appName = "salestoolkit";
    requestBody.appUrl = window.location.host;
    requestBody.appVersion = this.Atheneum.version;
    requestBody.deviceIdiom = Atheneum.Device.getCategory();
    requestBody.deviceOSVersion = Atheneum.Device.getOSVersion();
    requestBody.devicePlatform = Atheneum.Device.getOSName();
    requestBody.browserName = Atheneum.Device.getBrowserName();
    requestBody.browserVersion = Atheneum.Device.getBrowserVersion();
    requestBody.screenSize = Atheneum.Device.getScreenDimensions();

    for (var prop in requestBody) {
        if (requestBody.hasOwnProperty(prop) && requestBody[prop] == null) {
            delete requestBody[prop];
        }
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.SERVER_INSTANCE_BASE_URL + "/initiate-login", requestBody, queryParams, jsonCallback);
}

Atheneum.API.prototype.logout = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/logout", { apikey: this.Atheneum.User.apikey }, undefined, jsonCallback);
}

Atheneum.API.prototype.sendPasswordResetEmail = function (username, redirectURL, jsonCallback) {
    if (username == undefined)
        throw new IllegalArgumentException("username is required");

    if (arguments.length == 2 && typeof redirectURL !== 'string') {
        jsonCallback = redirectURL;
        redirectURL = null;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/reset-password", { 'userName': username, 'redirectURL': redirectURL }, jsonCallback);
}

Atheneum.API.prototype.checkUserLoginStatus = function (jsonCallback) {

    let params = { apikey: this.Atheneum.User.apikey };
    if (this.Atheneum.CrossPlatform.enabled) {
        let json = this.Atheneum.CrossPlatform.getDeviceInfo();
        try {
            json = JSON.parse(json);
            json.apikey = params.apikey;
            params = json;
        } catch (err) {

        }
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/login-status", params, undefined, jsonCallback);
}

Atheneum.API.prototype.verifyUserPassword = function (password, jsonCallback) {
    if (password == undefined) {
        throw new IllegalArgumentException("password is required");
    }
    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/verify/password", { password: password }, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.changeUserPassword = function (password, jsonCallback) {
    if (password == undefined) {
        throw new IllegalArgumentException("password is required");
    }
    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/change-password", { password: password }, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getFilters = function (timestamp, jsonCallback) {

    if (arguments.length <= 1) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = { success: function () { } };
    }

    var params = {};
    if (this.Atheneum.User.apikey) {
        params.apikey = this.Atheneum.User.apikey;
    }
    if (timestamp != undefined) {
        params.filtersTimestamp = timestamp;
    }

    params.includeAppliedCounts = true;
    
    if(this.Atheneum.Theme.getStringProperty('filterSortOptionsBy', 'APPLIED_ASSETS_DESC').length > 0){
        params.sortOptionsBy = this.Atheneum.Theme.getStringProperty('filterSortOptionsBy', 'APPLIED_ASSETS_DESC');
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/filters-full", params, jsonCallback);
};

Atheneum.API.prototype.getFilteredFilters = function(filterOptions, jsonCallback){
    var params = {};
    if (this.Atheneum.User.apikey) {
        params.apikey = this.Atheneum.User.apikey;
    }

    params.includeAppliedCounts = true;

    if(this.Atheneum.Theme.getStringProperty('filterSortOptionsBy', 'APPLIED_ASSETS_DESC').length > 0){
        params.sortOptionsBy = this.Atheneum.Theme.getStringProperty('filterSortOptionsBy', 'APPLIED_ASSETS_DESC');
    }

    Object.assign(params, filterOptions);

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/filters-full", params, jsonCallback);
}

Atheneum.API.prototype.getSortOptions = function (timestamp, callback) {

    if (arguments.length <= 1) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (jsonCallback == undefined) {
        jsonCallback = { success: function () { } };
    }

    var params = {};
    if (this.Atheneum.User.apikey) {
        params.apikey = this.Atheneum.User.apikey;
    }
    if (timestamp != undefined) {
        params.filtersTimestamp = timestamp;
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/stories/sort/options", params, jsonCallback);
};

/** Retrieves a list of the user's favourite collections and assets. 
    If a timestamp is provided, only assets added or deleted since the timestamp will be returned */
Atheneum.API.prototype.getFavourites = function (timestamp, callback) {

    var url = this.Atheneum.API.BASE_URL + "/favourites/all-ids";

    if (callback == undefined && typeof timestamp !== "number") {
        callback = timestamp;
        timestamp = undefined;
    }

    if (timestamp == undefined)
        return this.Atheneum.HttpUtils.getJSON(url, { apikey: this.Atheneum.User.apikey }, callback);

    if (typeof timestamp === "number" && !isNaN(timestamp))
        return this.Atheneum.HttpUtils.getJSON(url, { apikey: this.Atheneum.User.apikey, favouritesTimestamp: timestamp }, callback);

    throw new IllegalArgumentException("timestamp must be an integer representing the number of milliseconds since 1970");
}

/** Adds a collection to the user's favourites */
Atheneum.API.prototype.addCollectionToFavourites = function (collectionId, callback) {

    if (collectionId == undefined)
        throw new IllegalArgumentException("collectionId is required");

    var url = this.Atheneum.API.BASE_URL + "/favourites/" + collectionId + "/add";

    return this.Atheneum.HttpUtils.postJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/** Adds an asset to the user's favourites */
Atheneum.API.prototype.addAssetToFavourites = function (collectionId, assetId, callback) {

    if (collectionId == undefined || assetId == undefined)
        throw new IllegalArgumentException("collectionId and assetId are required");

    var url = this.Atheneum.API.BASE_URL + "/favourites/" + collectionId + "/" + assetId + "/add";

    return this.Atheneum.HttpUtils.postJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/** Removes a collection from the user's favourites */
Atheneum.API.prototype.removeCollectionFromFavourites = function (collectionId, callback) {
    if (collectionId == undefined)
        throw new IllegalArgumentException("collectionId is required");

    var url = this.Atheneum.API.BASE_URL + "/favourites/" + collectionId + "/remove";

    return this.Atheneum.HttpUtils.postJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/** Removes an asset from the user's favourites */
Atheneum.API.prototype.removeAssetFromFavourites = function (collectionId, assetId, callback) {

    if (collectionId == undefined)
        throw new IllegalArgumentException("collectionId and assetId are required");

    var url = this.Atheneum.API.BASE_URL + "/favourites/" + collectionId + "/" + assetId + "/remove";

    return this.Atheneum.HttpUtils.postJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

Atheneum.API.prototype.getFeedItems = function (timestamp, maxItems, jsonCallback) {

    if (jsonCallback == undefined && typeof maxItems !== "number") {
        jsonCallback = maxItems;
        maxItems = undefined;
    }

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };
    if (timestamp != undefined)
        params.timestamp = timestamp;
    if (maxItems != undefined)
        params.max = maxItems;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/feeds/items", params, jsonCallback);
}

Atheneum.API.prototype.postFeedItemComment = function (itemId, comment, jsonCallback) {
    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/feeds/items/" + itemId + "/comment",
        { comment: comment }, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getUserPreferences = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/preferences", { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.setUserPreferences = function (preferences, jsonCallback) {

    // FIXME: workaround for language resetting to English unless provided on every setUserPreferences call
    if (!preferences.hasOwnProperty("language") && this.Atheneum.User.preferences.language) {
        preferences.language = this.Atheneum.User.preferences.language;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/preferences", preferences, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getUserPermissions = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/permissions", { apikey: this.Atheneum.User.apikey }, undefined, jsonCallback);
}

Atheneum.API.prototype.rateCollection = function (collectionId, rating, comment, jsonCallback) {
    if (typeof comment !== "string") {
        jsonCallback = comment;
        comment = undefined;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/rating/" + collectionId + "/rate",
        { comment: comment, rating: rating }, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.rateAsset = function (collectionId, assetId, rating, comment, jsonCallback) {
    if (jsonCallback == undefined && typeof comment !== "string") {
        jsonCallback = comment;
        comment = undefined;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/rating/" + collectionId + "/" + assetId + "/rate",
        { comment: comment, rating: rating }, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getUserRatings = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/rating/all", { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getUserRatingsWithComments = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/rating/all-with-comments", { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getAssetDownloadLink = function (collectionId, assetId, jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/share/" + collectionId + "/" + assetId + "/vendlink", { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

/**
 * @param {string} collectionId
 * @param {string} assetId
 * @param {string} {object} shareFormData
 * @param {number|Date} timestamp
 * @param {function|object} blobJsonCallback
 * 
 * shareDownloadCollectionAsset( collectionId, assetId, shareFormData [, timestamp], blobJsonCallback )
 * 
 * The callback this method expects is rather unique
 * callbacks.success( blob );
 * callbacks.failure( reason, httpStatus, errorCode );
 * callbacks.offline( reason, httpStatus, errorCode );
 */
Atheneum.API.prototype.shareDownloadCollectionAsset = function (collectionId, assetId, shareFormData, timestamp, sessionId, blobJsonCallback) {

    if (typeof sessionId !== 'string' && blobJsonCallback == undefined) {
        blobJsonCallback = sessionId;
        sessionId = undefined;
    }

    if (typeof timestamp !== 'number' && (typeof timestamp !== 'object' || !(timestamp instanceof Date))) {
        blobJsonCallback = timestamp;
        timestamp = undefined;
    }

    if (typeof collectionId !== 'string') {
        throw new IllegalArgumentException('collectionId must be a string');
    }

    if (typeof assetId !== 'string') {
        throw new IllegalArgumentException('assetId must be a string');
    }

    if (typeof sessionId !== 'string' && sessionId) {
        throw new IllegalArgumentException('sessionId must be a string');
    }

    if (timestamp != undefined
        && (typeof timestamp !== 'number')
        && ((typeof timestamp !== 'object')
            || !(timestamp instanceof Date))) {
        throw new IllegalArgumentException('timestamp must be a number, or a Date');
    }


    var data = {};
    for (var field in shareFormData) {
        if (!shareFormData.hasOwnProperty(field))
            continue;
        data[field] = shareFormData[field];
    }
    if (timestamp != undefined) {
        data.shareTimeStamp = timestamp;
    }

    if (sessionId != undefined) {
        data.sessionId = sessionId;
    }


    if (blobJsonCallback == undefined) {
        blobJsonCallback = {};
    }
    if (typeof blobJsonCallback === 'function') {
        blobJsonCallback = { success: blobJsonCallback };
    }
    if (blobJsonCallback.success == undefined) {
        blobJsonCallback.success = function () { };
    }
    if (blobJsonCallback.failure == undefined) {
        blobJsonCallback.failure = Atheneum.Callbacks.logFailureDetails;
    }
    if (blobJsonCallback.offline == undefined) {
        blobJsonCallback.offline = blobJsonCallback.failure;
    }

    // blobJsonCallback.success is fine, expects a blob, gets a blob
    // blobJsonCallback.failure

    var successCallback = blobJsonCallback.success;
    var failureCallback = blobJsonCallback.failure;


    var convertBlobToJson = function (blob, success, failure) {

        var reader = new FileReader();
        reader.onload = function (event) {
            var contents = event.target.result;
            var json;
            try {
                json = JSON.parse(contents);
            }
            catch (exception) {
                failure();
            }
            success(json);
        };

        reader.onerror = function (event) {
            failure();
        };

        reader.readAsText(blob);
    }

    var wrappedSuccessCallback = function (connection) {

        if (connection.response == null) {
            if (connection.status == 204) {
                return successCallback(connection.response);
            }
            return failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, connection.status, undefined);
        }

        // almost certainly not a json file - likely an error response using http 200 :(
        if ((connection.getResponseHeader('Content-Type') || '').replace(/;.*/g, '') == 'application/json') {
            return convertBlobToJson(connection.response,
                function (json) {
                    connection.responseJSON = json;
                    if (json && json.errorCode != undefined && json.errorCode != Atheneum.API.ErrorCodes.NO_ERROR) {

                        if (typeof connection.status != 'number' || connection.status < 200 || connection.status >= 300) {
                            return failureCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, json.errorCode);
                        }

                        return failureCallback(
                            Atheneum.API.Problems.ERROR_CODE_PRESENT,
                            connection.status,
                            json.errorCode
                        );
                    }
                },
                function () {
                    if (typeof connection.status != 'number' || connection.status < 200 || connection.status >= 300) {
                        return failureCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, json.errorCode);
                    }
                    return failureCallback(Atheneum.API.Problems.RESPONSE_NOT_JSON, connection.status, undefined);
                }
            );
        }

        if (typeof connection.status != 'number' || connection.status < 200 || connection.status >= 300) {
            return failureCallback(Atheneum.API.Problems.HTTP_STATUS_ERROR, connection.status, undefined);
        }

        return successCallback(connection.response);

    };

    blobJsonCallback.success = wrappedSuccessCallback;

    var url = this.Atheneum.API.BASE_URL + "/share/" + collectionId + "/" + assetId + "/download";
    if (this.Atheneum.Archive.autorecord) {
        blobJsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            blobJsonCallback,
            'SHARE_DOWNLOAD_STORY_ASSET',
            data.shareTimeStamp,
            { method: 'POST', url: url, responseType: 'blob', body: JSON.stringify(data) }
        );
    }

    return Atheneum.HttpUtils.makeRequest(
        'POST',
        url,
        JSON.stringify(data),
        { apikey: this.Atheneum.User.apikey, '_': new Date().getTime() },
        { 'Content-Type': 'application/json;charset=UTF-8' },
        'blob',
        blobJsonCallback
    );
}

/**
 * @param {string} collectionId
 * @param {string|Array} assetIds
 * @param {object} shareFormData,
 * @param {number|Date} timestamp
 * @param {function} jsonCallback
 * @returns {XMLHttpRequest}
 * 
 * Atheneum.API.prototype.shareCollectionAssets( collectionId [, assetIds], shareFormData [, timestamp] [, sessionId],  jsonCallback )
 */
Atheneum.API.prototype.shareCollectionAssets = function (collectionId, assetIds, shareFormData, timestamp, sessionId, jsonCallback) {

    if (typeof assetIds === 'object' && !(assetIds instanceof Array)) {
        jsonCallback = sessionId;
        sessionId = timestamp;
        timestamp = shareFormData;
        shareFormData = assetIds;
        assetIds = undefined;
    }

    if (typeof sessionId !== 'string' && jsonCallback == undefined) {
        jsonCallback = sessionId;
        sessionId = undefined;
    }

    if (typeof timestamp !== 'number' && (typeof timestamp !== 'object' || !(timestamp instanceof Date))) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (typeof collectionId !== 'string') {
        throw new IllegalArgumentException('collectionId must be a string');
    }

    if (assetIds != undefined) {

        if (typeof assetIds !== 'object' || !(assetIds instanceof Array))
            throw new IllegalArgumentException('assetIds must be a string, or an array of strings');

        for (var a = 0; a < assetIds.length; a++) {
            if (typeof assetIds[a] !== 'string')
                throw new IllegalArgumentException('assetIds must be a string, or an array of strings');
        }
    }

    if (typeof timestamp !== 'number' && (typeof timestamp !== 'object' || !(timestamp instanceof Date))) {
        throw new IllegalArgumentException('timestamp must be a number, or a Date');
    }

    if (typeof jsonCallback !== 'object' && typeof jsonCallback !== 'function') {
        throw new IllegalArgumentException('jsonCallback must be a function, or an object');
    }

    if (typeof assetIds === 'string')
        assetIds = [assetIds];

    if (timestamp == undefined)
        timestamp = new Date();

    if (typeof timestamp === 'object')
        timestamp = timestamp.getTime();

    var data = {};
    for (var field in shareFormData) {
        if (!shareFormData.hasOwnProperty(field))
            continue;
        data[field] = shareFormData[field];
    }
    data.assetIds = assetIds;
    data.shareTimeStamp = timestamp;

    if (sessionId) {
        data.sessionId = sessionId;
    }

    var url = this.Atheneum.API.BASE_URL + "/share/" + collectionId + "/email";
    if (this.Atheneum.Archive.autorecord) {
        jsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            jsonCallback,
            'SHARE_STORY_ASSETS',
            data.shareTimeStamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);

}

/**
 * shareCart( emailAddress, cart, jsonCallback )
 * shareCart( fields, emailAddress, cart, jsonCallback )
 *
 * shareCart( emailAddresses, cart, jsonCallback )
 * shareCart( fields, emailAddresses, cart, jsonCallback )
 *
 * shareCart( fields, cart, timestamp, jsonCallback )		// "to" should be ones of the fields
 * shareCart( fields, timestamp, jsonCallback )				// "to" and "cart" should be in the fields
 * shareCart( fields, timestamp, sessionId, jsonCallback )	// "to" and "cart" should be in the fields
 * shareCart( fields, jsonCallback )							// "to" and "cart" should be in the fields
 * shareCart( fields, sessionId, jsonCallback )				// "to" and "cart" should be in the fields
 */
Atheneum.API.prototype.shareCart = function (fields, emailAddress, cart, timestamp, sessionId, status, jsonCallback) {


    // if(this.Atheneum.User.permissions.canRegisterInterest)
    // {
    //     this.Atheneum.API.registerInterest(fields, emailAddress, cart, timestamp, sessionId, status, jsonCallback);
    //     return;
    // }

    // if(this.Atheneum.User.permissions.canMLR)
    // {
    //     this.Atheneum.API.mlrReview(fields, emailAddress, cart, timestamp, sessionId, status, jsonCallback);
    //     return;
    // }

    if (typeof fields === 'string' || (typeof fields === 'object' && Object.prototype.toString.call(fields) == "[object Array]")) {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = fields;
        fields = undefined;
    }

    if (typeof emailAddress === "object" && Object.prototype.toString.call(emailAddress) == "[object Array]") {

        for (var e = 0; e < emailAddress.length; e++) {
            if (typeof e !== 'string') {
                // it's not a valid email address, so must be the cart
                jsonCallback = status;
                status = sessionId;
                sessionId = timestamp;
                timestamp = cart;
                cart = emailAddress;
                emailAddress = undefined;
                break;
            }
        }
        emailAddress = emailAddress.join(",");
    }
    else if (typeof emailAddress !== "string") {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = undefined;
    }

    if (typeof cart !== 'object' || Object.prototype.toString.call(emailAddress) == "[object Array]" || typeof cart.success === 'function') {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || typeof status === 'function' || typeof status === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = status;
        status = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = sessionId;
        sessionId = undefined;
    }

    if (typeof timestamp === 'function' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (emailAddress !== undefined && typeof emailAddress !== "string") {
        throw new IllegalArgumentException("emailAddress must be a string or an array of strings");
    }

    var data = {};
    for (var field in fields) {
        if (fields.hasOwnProperty(field))
            data[field] = fields[field];
    }

    if (emailAddress != undefined) {
        data.to = emailAddress;
    }
    if (cart != undefined)
        data.cart = cart;

    if (sessionId) {
        data.sessionId = sessionId;
    }

    data.status = (status != undefined) ? status : Atheneum.Tracking.Status.ONLINE;

    data.shareTimeStamp = timestamp || new Date().getTime();

    var url = this.Atheneum.API.BASE_URL + "/share/email";

    if (this.Atheneum.Archive.autorecord) {
        jsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            jsonCallback,
            'SHARE_CART',
            data.shareTimeStamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

/**
 * registerInterest( emailAddress, cart, jsonCallback )
 * registerInterest( fields, emailAddress, cart, jsonCallback )
 *
 * registerInterest( emailAddresses, cart, jsonCallback )
 * registerInterest( fields, emailAddresses, cart, jsonCallback )
 *
 * registerInterest( fields, cart, timestamp, jsonCallback )		// "to" should be ones of the fields
 * registerInterest( fields, timestamp, jsonCallback )				// "to" and "cart" should be in the fields
 * registerInterest( fields, timestamp, sessionId, jsonCallback )	// "to" and "cart" should be in the fields
 * registerInterest( fields, jsonCallback )							// "to" and "cart" should be in the fields
 * registerInterest( fields, sessionId, jsonCallback )				// "to" and "cart" should be in the fields
 */
 Atheneum.API.prototype.registerInterest = function (fields, emailAddress, cart, timestamp, sessionId, status, jsonCallback) {

    if (typeof fields === 'string' || (typeof fields === 'object' && Object.prototype.toString.call(fields) == "[object Array]")) {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = fields;
        fields = undefined;
    }

    if (typeof emailAddress === "object" && Object.prototype.toString.call(emailAddress) == "[object Array]") {

        for (var e = 0; e < emailAddress.length; e++) {
            if (typeof e !== 'string') {
                // it's not a valid email address, so must be the cart
                jsonCallback = status;
                status = sessionId;
                sessionId = timestamp;
                timestamp = cart;
                cart = emailAddress;
                emailAddress = undefined;
                break;
            }
        }
        emailAddress = emailAddress.join(",");
    }
    else if (typeof emailAddress !== "string") {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = undefined;
    }

    if (typeof cart !== 'object' || Object.prototype.toString.call(emailAddress) == "[object Array]" || typeof cart.success === 'function') {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || typeof status === 'function' || typeof status === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = status;
        status = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = sessionId;
        sessionId = undefined;
    }

    if (typeof timestamp === 'function' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (emailAddress !== undefined && typeof emailAddress !== "string") {
        throw new IllegalArgumentException("emailAddress must be a string or an array of strings");
    }

    var data = {};
    for (var field in fields) {
        if (fields.hasOwnProperty(field))
            data[field] = fields[field];
    }

    if (emailAddress != undefined && emailAddress != '') {
        data.to = emailAddress;
    }
    if (cart != undefined)
        data.cart = cart;

    if (sessionId) {
        data.sessionId = sessionId;
    }

    data.status = (status != undefined) ? status : Atheneum.Tracking.Status.ONLINE;

    data.shareTimeStamp = timestamp || new Date().getTime();

    var url = this.Atheneum.API.BASE_URL + "/register-interest/cart";

    if (this.Atheneum.Archive.autorecord) {
        jsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            jsonCallback,
            'REGISTER_INTEREST',
            data.shareTimeStamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

/**
 * mlrReview( emailAddress, cart, jsonCallback )
 * mlrReview( fields, emailAddress, cart, jsonCallback )
 *
 * mlrReview( emailAddresses, cart, jsonCallback )
 * mlrReview( fields, emailAddresses, cart, jsonCallback )
 *
 * mlrReview( fields, cart, timestamp, jsonCallback )		// "to" should be ones of the fields
 * mlrReview( fields, timestamp, jsonCallback )				// "to" and "cart" should be in the fields
 * mlrReview( fields, timestamp, sessionId, jsonCallback )	// "to" and "cart" should be in the fields
 * mlrReview( fields, jsonCallback )							// "to" and "cart" should be in the fields
 * mlrReview( fields, sessionId, jsonCallback )				// "to" and "cart" should be in the fields
 */
Atheneum.API.prototype.mlrReview = function (fields, emailAddress, cart, timestamp, sessionId, status, jsonCallback) {

    if (typeof fields === 'string' || (typeof fields === 'object' && Object.prototype.toString.call(fields) == "[object Array]")) {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = fields;
        fields = undefined;
    }

    if (typeof emailAddress === "object" && Object.prototype.toString.call(emailAddress) == "[object Array]") {

        for (var e = 0; e < emailAddress.length; e++) {
            if (typeof e !== 'string') {
                // it's not a valid email address, so must be the cart
                jsonCallback = status;
                status = sessionId;
                sessionId = timestamp;
                timestamp = cart;
                cart = emailAddress;
                emailAddress = undefined;
                break;
            }
        }
        emailAddress = emailAddress.join(",");
    }
    else if (typeof emailAddress !== "string") {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = emailAddress;
        emailAddress = undefined;
    }

    if (typeof cart !== 'object' || Object.prototype.toString.call(emailAddress) == "[object Array]" || typeof cart.success === 'function') {
        jsonCallback = status;
        status = sessionId;
        sessionId = timestamp;
        timestamp = cart;
        cart = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || typeof status === 'function' || typeof status === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = status;
        status = undefined;
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = sessionId;
        sessionId = undefined;
    }

    if (typeof timestamp === 'function' || (typeof timestamp === 'object' && !(timestamp instanceof Date))) {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    if (emailAddress !== undefined && typeof emailAddress !== "string") {
        throw new IllegalArgumentException("emailAddress must be a string or an array of strings");
    }

    var data = {};
    for (var field in fields) {
        if (fields.hasOwnProperty(field))
            data[field] = fields[field];
    }

    if (emailAddress != undefined) {
        data.to = emailAddress;
    }
    if (cart != undefined)
        data.cart = cart;

    if (sessionId) {
        data.sessionId = sessionId;
    }

    data.status = (status != undefined) ? status : Atheneum.Tracking.Status.ONLINE;

    data.shareTimeStamp = timestamp || new Date().getTime();

    var url = this.Atheneum.API.BASE_URL + "/mlr/cart";

    if (this.Atheneum.Archive.autorecord) {
        jsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            jsonCallback,
            'MLR_REVIEW',
            data.shareTimeStamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.saveCart = function (cart, name, recipients, note, jsonCallback, formData = undefined, useShareLink = false) {

    let data = {};
    data.cart = cart;
    data.name = name

    if(recipients){
        data.recipients = recipients;
    }

    if(note){
        data.note = note;
    }

    if(useShareLink){
        data.shareLink = true;
    }

    if(!this.Atheneum.CrossPlatform.enabled){
        data.appDomainOverride = window.location.host;
    }

    if(formData){
        data.formData = formData;
    }

    let url = this.Atheneum.API.BASE_URL + "/carts";

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}


Atheneum.API.prototype.updateCart = function (cartId, cart, name, recipients, note, jsonCallback, formData = undefined, useShareLink = false) {

    let data = {};
    data.cart = cart;
    data.name = name

    if(recipients){
        data.recipients = recipients;
    }

    if(note){
        data.note = note;
    }

    if(useShareLink){
        data.shareLink = true;
    }

    if(!this.Atheneum.CrossPlatform.enabled){
        data.appDomainOverride = window.location.host;
    }
    
    if(formData){
        data.formData = formData;
    }
        
    let url = this.Atheneum.API.BASE_URL + "/carts/"+cartId;

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.deleteCart = function (cartId, jsonCallback) {

    let url = this.Atheneum.API.BASE_URL + "/carts/"+cartId;

    return this.Atheneum.HttpUtils.deleteJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getCarts = function (jsonCallback) {

    let params = { apikey: this.Atheneum.User.apikey };
    //Todo api paging
    params.itemsPerPage = 1000;
    params.pageIndex = 0;
   
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/carts", params, jsonCallback);
}

Atheneum.API.prototype.shareSavedCart = function (cartId, emails, note,  jsonCallback, formData = undefined, useShareLink = false) {
    let data = {};
    data.recipients = emails;
    data.note = note;
    let url = this.Atheneum.API.BASE_URL + "/carts/"+cartId+"/share";

    if(useShareLink){
        data.shareLink = true;
    }

    if(!this.Atheneum.CrossPlatform.enabled){
        data.appDomainOverride = window.location.host;
    }

    if(formData){
        data.formData = formData;
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.shareSavedCartAnonymousLink = function (cartId, jsonCallback) {
    let data = {};
    let url = this.Atheneum.API.BASE_URL + "/carts/"+cartId+"/share/anonymousLink";

    if(!this.Atheneum.CrossPlatform.enabled){
        data.appDomainOverride = window.location.host;
    }

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}


Atheneum.API.prototype.submitRemoteCompletionForm = function (formId = undefined, formType = 'VEND', assetIds = [], formData = {}, jsonCallback) {
    let data = {};
    if(formId)
        data.formId = formId;
    if(formType)
        data.formType = formType;
    if(assetIds && assetIds.length > 0)
        data.assetIds = assetIds;
    if(formData)
        data.formData = formData;

    //TODO actual URL
    let url = this.Atheneum.API.BASE_URL + "/remote-completion";

    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.pollRemoteCompletionStatus = function (requestId, callbacks){
     let url = this.Atheneum.API.BASE_URL + "/remote-completion/"+requestId;
    let queryParams = {};
    queryParams.requestId = requestId;

    return this.Atheneum.HttpUtils.getJSON(url, queryParams, callbacks);
}

/**
 * @param {object} shareFormData,
 * @param {function} jsonCallback
*/

Atheneum.API.prototype.sharePortalLink = function (shareFormData, jsonCallback) {
    var url = this.Atheneum.API.BASE_URL + "/share/portal-link";
    var data = {};
    for (var field in shareFormData) {
        if (!shareFormData.hasOwnProperty(field))
            continue;
        data[field] = shareFormData[field];
    }
    data.vendTimeStamp = new Date().getTime();
    data.timestamp = data.vendTimeStamp;
    if (this.Atheneum.Archive.autorecord) {
        jsonCallback = this.Atheneum.Archive.wrapJsonCallback(
            jsonCallback,
            'PORTAL_LINK',
            data.timestamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }
    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.sharelQRLink = function (shareFormData, jsonCallback) {
    var url = this.Atheneum.API.BASE_URL + "/share/qr-link";
    var data = {};
    for (var field in shareFormData) {
        if (!shareFormData.hasOwnProperty(field))
            continue;
        data[field] = shareFormData[field];
    }
    data.vendTimeStamp = new Date().getTime();
    data.timestamp = data.vendTimeStamp;
    
    return this.Atheneum.HttpUtils.postJSON(url, data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getShareSummary = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp != undefined)
        params.timestamp = timestamp;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/summary/all", params, jsonCallback);
}

//get list of meetings
Atheneum.API.prototype.getMeetings = function (collectionId, timestamp, jsonCallback) {

    if (typeof collectionId === 'number' || (collectionId != null && typeof collectionId !== 'string')) {
        jsonCallback = timestamp;
        timestamp = collectionId;
        collectionId = null;
    }

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp != undefined)
        params.timestamp = timestamp;

    params.includeParticipants = true;

    if (collectionId != null) {
        params.collectionId = collectionId;
    }

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/meetings/all", params, jsonCallback);
}

//get information for a specific meeting
Atheneum.API.prototype.getMeeting = function (meetingId, timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp != undefined)
        params.timestamp = timestamp;

    params.includeParticipants = true;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/meetings/" + meetingId, params, jsonCallback);
}

//get list of collections that have meetings
Atheneum.API.prototype.getCollectionsWithMeetings = function (timestamp, jsonCallback) {

    if (jsonCallback == undefined && typeof timestamp !== "number") {
        jsonCallback = timestamp;
        timestamp = undefined;
    }

    var params = { apikey: this.Atheneum.User.apikey };

    if (timestamp != undefined)
        params.timestamp = timestamp;

    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/meetings/collections", params, jsonCallback);
}

Atheneum.API.prototype.redeliverShare = function (shareId, emailAddress, sessionId, jsonCallback, shareGroupId) {

    if (jsonCallback == undefined && typeof sessionId !== "string") {
        jsonCallback = sessionId;
        sessionId = undefined;
    }

    if (jsonCallback == undefined && typeof emailAddress !== "string") {
        jsonCallback = emailAddress;
        emailAddress = undefined;
    }

    var data = (emailAddress != undefined) ? { "to": emailAddress } : {};

    if (shareGroupId != undefined)
        data.vendGroupId = shareGroupId;

    if (sessionId) {
        data.sessionId = sessionId;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/summary/" + shareId + "/redeliver", data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.cancelShare = function (shareId, shareGroupId, jsonCallback) {

    var data = {};

    if (arguments.length <= 2 && typeof shareGroupId !== 'string') {
        jsonCallback = shareGroupId;
        shareGroupId = undefined;
    }

    if (shareGroupId != undefined) {
        data.vendGroupId = shareGroupId;
    }

    return this.Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/summary/" + shareId + "/cancel", data, { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

Atheneum.API.prototype.getNotifications = function (jsonCallback) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/notifications/all", { apikey: this.Atheneum.User.apikey }, jsonCallback);
}

/**
 * Deletes a specific notification by its ID.
 * @param {string} notificationId - The ID of the notification to delete.
 * @param {function} jsonCallback - The callback function to handle the response.
 */
Atheneum.API.prototype.dismissNotification = function (notificationId, jsonCallback) {
    const url = this.Atheneum.API.BASE_URL + "/notifications/" + notificationId;
    const queryParams = { apikey: this.Atheneum.User.apikey };

    return this.Atheneum.HttpUtils.deleteJSON(
        url,
        null, 
        queryParams,
        null, 
        jsonCallback
    );
}

/**
 * Atheneum.API.trackGeneric( data, status, [timestamp], [callback] )
 * 
 * timestamp is mandatory if state = Atheneum.Tracking.Status.OFFLINE
 */
Atheneum.API.prototype.trackGeneric = function (data, status, timestamp, callback) {

    if (typeof status !== "string")
        throw new IllegalArgumentException("status is required and must be a string, and must be either \"ONLINE\" or \"OFFLINE\"");


    if (arguments.length == 3) {

        if (typeof timestamp === "function" || (typeof timestamp === "object" && !(timestamp instanceof Date))) {
            callback = timestamp;
            timestamp = undefined;
        }
    }

    if (timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if ((status === Atheneum.Tracking.Status.OFFLINE && typeof timestamp === "undefined")
        || (typeof timestamp !== "undefined" && typeof timestamp !== "number")) {
        throw new IllegalArgumentException("timestamp is required when state is \"OFFLINE\", and must be a long or a Date");
    }

    if (callback != undefined) {

        if (typeof callback === "function" || typeof callback === "object") {
            callback = Atheneum.Callbacks.parse(callback);
        } else {
            throw new IllegalArgumentException("if defined, callback must be a function or an object")
        }
    }

    if(typeof this.Atheneum.Forms.userDetails === 'object'){
        for (key in this.Atheneum.Forms.userDetails) {
            if(!this.Atheneum.Forms.userDetails.hasOwnProperty(key))
                continue;

            data[key] = this.Atheneum.Forms.userDetails[key];
        }
    }

    data.status = status;
    data.userName = this.Atheneum.User.username || "no_user";


    if (timestamp != undefined)
        data.timestamp = timestamp;
    else
        data.timestamp = new Date().getTime();

    // TODO: uncomment
    //if( typeof this.Atheneum.version === "string" )
    //	data.appVersion = this.Atheneum.version;

    //data.version = 

    var queryParams = {};

    if (this.Atheneum.User.apikey)
        queryParams.apikey = this.Atheneum.User.apikey;

    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/tracking/generic", data, queryParams, callback);
}

/**
 * Atheneum.API.trackCollectionView( collectionId, duration, status, [timestamp], [sessionId], [callback] )
 * 
 * timestamp is mandatory if state = Atheneum.Tracking.Status.OFFLINE
 */
Atheneum.API.prototype.trackCollectionView = function (collectionId, duration, status, timestamp, sessionId, callback) {

    if (typeof collectionId !== "string")
        throw new IllegalArgumentException("collectionId is required and must be a string");

    if (typeof duration !== "number" || Math.round(duration) != duration)
        throw new IllegalArgumentException("duration is required and must be a long");

    if (typeof status !== "string")
        throw new IllegalArgumentException("status is required and must be a string, and must be either \"ONLINE\" or \"OFFLINE\"");

    if (arguments.length == 5) {

        if (typeof sessionId !== "string") {
            callback = sessionId;
            sessionId = undefined;
        }
    }

    if (arguments.length == 4) {

        if (typeof timestamp === "function" || (typeof timestamp === "object" && !(timestamp instanceof Date))) {
            callback = timestamp;
            timestamp = undefined;
        }
    }

    if (timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if ((status === Atheneum.Tracking.Status.OFFLINE && typeof timestamp === "undefined")
        || (typeof timestamp !== "undefined" && typeof timestamp !== "number")) {
        throw new IllegalArgumentException("timestamp is required when state is \"OFFLINE\", and must be a long or a Date");
    }

    if (callback != undefined) {

        if (typeof callback === "function" || typeof callback === "object") {
            callback = Atheneum.Callbacks.parse(callback);
        } else {
            throw new IllegalArgumentException("if defined, callback must be a function or an object")
        }
    }

    if (!this.Atheneum.User.username)
        throw new IllegalArgumentException("Atheneum.User.username is required and must be a string and must not be empty")

    var data = {
        duration: duration,
        status: status,
        userName: this.Atheneum.User.username
    };

    if(typeof this.Atheneum.Forms.userDetails === 'object'){
        for (key in this.Atheneum.Forms.userDetails) {
            if(!this.Atheneum.Forms.userDetails.hasOwnProperty(key))
                continue;

            data[key] = this.Atheneum.Forms.userDetails[key];
        }
    }
    
    if (sessionId) {
        data.sessionId = sessionId;
    }

    if (timestamp != undefined)
        data.timestamp = timestamp;

    // TODO: uncomment
    //if( typeof this.Atheneum.version === "string" )
    //	data.appVersion = this.Atheneum.version;

    //data.version = 

    var queryParams = {};

    if (this.Atheneum.User.apikey)
        queryParams.apikey = this.Atheneum.User.apikey;

    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/tracking/stories/" + collectionId + "/view", data, queryParams, callback);
}

/**
 * Atheneum.API.trackAssetView( [collectionId], assetId, duration, status, [timestamp], [callback] )
 * 
 * timestamp is mandatory if state = Atheneum.Tracking.Status.OFFLINE
 */
Atheneum.API.prototype.trackAssetView = function (collectionId, assetId, duration, status, timestamp, sessionId, callback) {

    if (arguments.length > 3
        && typeof duration !== "string"
        && typeof assetId === "string"
        && typeof collectionId === "string") {
        // collectionId was specified
    } else {
        callback = sessionId;
        sessionId = timestamp;
        timestamp = status;
        status = assetId;
        assetId = collectionId;
        collectionId = undefined;
        arguments.length = arguments.length - 1;
    }

    if (typeof assetId !== "string")
        throw new IllegalArgumentException("assetId is required and must be a string");

    if (typeof duration !== "number" || Math.round(duration) != duration)
        throw new IllegalArgumentException("duration is required and must be a long");

    if (typeof status !== "string")
        throw new IllegalArgumentException("status is required and must be a string, and must be either \"ONLINE\" or \"OFFLINE\"");

    if (arguments.length == 5) {

        if (typeof collectionId !== "string") {
            callback = sessionId;
            sessionId = undefined;
        }
    }

    if (arguments.length == 4) {

        if (typeof timestamp === "function" || (typeof timestamp === "object" && !(timestamp instanceof Date))) {
            callback = timestamp;
            timestamp = undefined;
        }
    }

    if (timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if ((status === Atheneum.Tracking.Status.OFFLINE && typeof timestamp === "undefined")
        || (typeof timestamp !== "undefined" && typeof timestamp !== "number")) {
        throw new IllegalArgumentException("timestamp is required when state is \"OFFLINE\", and must be a long or a Date");
    }

    if (callback != undefined) {

        if (typeof callback === "function" || typeof callback === "object") {
            callback = Atheneum.Callbacks.parse(callback);
        } else {
            throw new IllegalArgumentException("if defined, callback must be a function or an object")
        }
    }

    if (typeof collectionId === "undefined") {
        var asset = this.Atheneum.Library.assets[assetId];
        if (asset) {
            collectionId = asset.containedBy;
        }
    }

    if (!this.Atheneum.User.username)
        throw new IllegalStateException("Atheneum.User.username is required and must be a string and must not be empty")

    var data = {
        duration: duration,
        status: status,
        userName: this.Atheneum.User.username
    };
    
    if(typeof this.Atheneum.Forms.userDetails === 'object'){
        for (key in this.Atheneum.Forms.userDetails) {
            if(!this.Atheneum.Forms.userDetails.hasOwnProperty(key))
                continue;

            data[key] = this.Atheneum.Forms.userDetails[key];
        }
    }

    if (sessionId) {
        data.sessionId = sessionId;
    }

    if (timestamp != undefined)
        data.timestamp = timestamp;

    // TODO: add this back in when atheneum is fixed
    //if( typeof this.Atheneum.version === "string" )
    //	data.version = this.Atheneum.version;

    var queryParams = {};

    var url = this.Atheneum.API.BASE_URL + "/tracking/stories/" + collectionId + "/assets/" + assetId + "/view";
    if (this.Atheneum.Archive.autorecord) {
        callback = this.Atheneum.Archive.wrapJsonCallback(
            callback,
            'TRACK_ASSET',
            data.timestamp,
            { method: 'POST', url: url, body: JSON.stringify(data) }
        );
    }

    if (this.Atheneum.User.apikey)
        queryParams.apikey = this.Atheneum.User.apikey;

    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/tracking/stories/" + collectionId + "/assets/" + assetId + "/view", data, queryParams, callback);
}

/**
 * Atheneum.API.trackNewsItemView( newsItemId, duration, status, [timestamp], [callback] )
 * 
 * timestamp is mandatory if state = Atheneum.Tracking.Status.OFFLINE
 */
Atheneum.API.prototype.trackNewsItemView = function (newsItemId, duration, status, timestamp, sessionId, callback) {

    if (typeof newsItemId !== "string")
        throw new IllegalArgumentException("newsItemId is required and must be a string");

    if (typeof duration !== "number" || Math.round(duration) != duration)
        throw new IllegalArgumentException("duration is required and must be a long");

    if (typeof status !== "string")
        throw new IllegalArgumentException("status is required and must be a string, and must be either \"ONLINE\" or \"OFFLINE\"");


    if (arguments.length == 5) {

        if (typeof sessionId !== "string") {
            callback = sessionId;
            sessionId = undefined;
        }
    }

    if (arguments.length == 4) {

        if (typeof timestamp === "function" || (typeof timestamp === "object" && !(timestamp instanceof Date))) {
            callback = timestamp;
            timestamp = undefined;
        }
    }

    if (timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if ((status === Atheneum.Tracking.Status.OFFLINE && typeof timestamp === "undefined")
        || (typeof timestamp !== "undefined" && typeof timestamp !== "number")) {
        throw new IllegalArgumentException("timestamp is required when state is \"OFFLINE\", and must be a long or a Date");
    }

    if (callback != undefined) {

        if (typeof callback === "function" || typeof callback === "object") {
            callback = Atheneum.Callbacks.parse(callback);
        } else {
            throw new IllegalArgumentException("if defined, callback must be a function or an object")
        }
    }

    if (!this.Atheneum.User.username)
        throw new IllegalStateException("Atheneum.User.username is required and must be a string and must not be empty")

    var data = {
        duration: duration,
        status: status,
        userName: this.Atheneum.User.username
    };

    if(typeof this.Atheneum.Forms.userDetails === 'object'){
        for (key in this.Atheneum.Forms.userDetails) {
            if(!this.Atheneum.Forms.userDetails.hasOwnProperty(key))
                continue;

            data[key] = this.Atheneum.Forms.userDetails[key];
        }
    }

    if (sessionId) {
        data.sessionId = sessionId;
    }

    if (timestamp != undefined)
        data.timestamp = timestamp;

    // TODO: add this back in when atheneum is fixed
    //if( typeof this.Atheneum.version === "string" )
    //	data.version = this.Atheneum.version;

    var queryParams = {};

    if (this.Atheneum.User.apikey)
        queryParams.apikey = this.Atheneum.User.apikey;

    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/feeds/items/" + newsItemId + "/view", data, queryParams, callback);
}

Atheneum.API.prototype.startSession = function (sessionVariables, callback) {
    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/session/start", sessionVariables || {}, { apikey: this.Atheneum.User.apikey }, callback);
}

Atheneum.API.prototype.getCurrentSession = function (callback) {
    return Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/session", { apikey: this.Atheneum.User.apikey }, callback);
}

Atheneum.API.prototype.keepSessionAlive = function (updatedSessionVariables, callback) {
    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/session/keep-alive", updatedSessionVariables || {}, { apikey: this.Atheneum.User.apikey }, callback);
}

Atheneum.API.prototype.endSession = function (callback) {
    return Atheneum.HttpUtils.postJSON(this.Atheneum.API.BASE_URL + "/session/end", {}, { apikey: this.Atheneum.User.apikey }, callback);
}

Atheneum.API.prototype.getAllForms = function (callbacks) {
    return this.Atheneum.HttpUtils.getJSON(this.Atheneum.API.BASE_URL + "/forms/all-forms", { apikey: this.Atheneum.User.apikey, version: "1.1.0" }, callbacks);
}

/**
 * Atheneum.API.submitForm( formData, callbacks )
 * Atheneum.API.submitForm( formId, formData, callbacks )
 * Atheneum.API.submitForm( formData, timestamp, callbacks )
 * Atheneum.API.submitForm( formId, formData, timestamp, callbacks )
 */
Atheneum.API.prototype.submitForm = function (formId, formData, timestamp, sessionId, callbacks) {

    if (typeof formId !== 'string') {
        callbacks = sessionId;
        sessionId = timestamp;
        timestamp = formData;
        formData = formId;
        formId = undefined;
    }

    if (typeof sessionId === 'object' && callbacks == undefined) {
        callbacks = sessionId;
        sessionId = undefined;
    }

    if (!(typeof timestamp === 'number' || (typeof timestamp === 'object' && timestamp instanceof Date))) {
        callbacks = timestamp;
        timestamp = undefined;
    }

    var requestBody = {};
    for (property in formData) {
        if (formData.hasOwnProperty(property)) {
            requestBody[property] = formData[property];
        }
    }

    if (formId !== undefined)
        requestBody.id = formId;

    requestBody.timestamp = (timestamp == undefined) ? new Date().getTime() : timestamp;

    if (sessionId) {
        requestBody.sessionId = sessionId;
    }

    var url = this.Atheneum.API.BASE_URL + "/forms/submit";
    if (this.Atheneum.Archive.autorecord) {
        callbacks = this.Atheneum.Archive.wrapJsonCallback(
            callbacks,
            'SUBMIT_FORM',
            requestBody.timestamp,
            { method: 'POST', url: url, body: JSON.stringify(requestBody) }
        );
    }

    return this.Atheneum.HttpUtils.postJSON(url, requestBody, { apikey: this.Atheneum.User.apikey }, callbacks);
}

Atheneum.API.prototype.getBadgeInfo = function ATHENEUMAPI_getBadgeInfo(badgeId, callbacks) {
    var url = this.Atheneum.API.BASE_URL + '/badges/info';
    return this.Atheneum.HttpUtils.getJSON(url, { badgeId: badgeId, apikey: this.Atheneum.User.apikey }, callbacks);
}

Atheneum.API.prototype.scanBusCard = function (base64, mode, callbacks) {
    var url = this.Atheneum.API.BASE_URL + '/badges/scan';
    return this.Atheneum.HttpUtils.getJSON(url, { mode: mode, base64Img: base64, apikey: this.Atheneum.User.apikey }, callbacks);
}

/**
 * makes a request to the main Atheneum instance
 */
Atheneum.API.prototype.lookupTheme = function AtheneumAPI_lookupTheme(accountRef, callbacks) {


    if (typeof accountRef !== 'string') {
        throw new IllegalArgumentException("accountRef is required and must be a string");
    }
    if (typeof callbacks != undefined
        && typeof callbacks !== 'object'
        && typeof callbacks !== 'function') {
        throw new IllegalArgumentException("callbacks must be an object or function");
    }

    var queryParams = { 'accountRef': accountRef };
    return Atheneum.HttpUtils.getJSON(this.SERVER_INSTANCE_BASE_URL + "/theme", queryParams, callbacks);

}

/**
 * Atheneum.API.getTheme( callbacks )
 * Atheneum.API.getTheme( timestamp, callbacks )
 */
Atheneum.API.prototype.getTheme = function AtheneumAPI_getTheme(timestamp, callbacks) {

    // TODO: parse callbacks

    if (arguments.length == 1) {
        callbacks = timestamp;
        timestamp = undefined;
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };
    if (timestamp != undefined) {
        if (typeof timestamp === 'number') {
            queryParams.timestamp = timestamp;
        }
        else if (typeof timestamp === 'object' && timestamp instanceof Date) {
            queryParams.timestamp = timestamp.getTime();
        }
        else {
            throw new IllegalArgumentException("timestamp must be a number or a date");
        }
    }
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/theme", queryParams, callbacks);
}

//#region ADMIN functions
/**
 * This call can be used to check if the API is enabled on a specific server instance and what version it is currently running.
 * If the API is not enabled on the specified server instance, you will be given a 404 HTTP status code.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.getAPIVersion = function (callback) {
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/info", { apikey: this.Atheneum.User.apikey }, callback);
}

//ACCOUNTS

/**
 * You can use this call to retrieve a list of all accounts (both communal and individual) available to the current user.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetAccounts = function (callback) {
    if (!this.Atheneum.User.permissions?.accounts_read && !this.Atheneum.User.permissions?.accounts_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/accounts", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a list of all communal accounts available to the current user. 
 * Communal accounts may contain multiple users and are usually used to share content between multiple users for an organisation.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetCommunalAccounts = function (callback) {
    if (!this.Atheneum.User.permissions?.accounts_read && !this.Atheneum.User.permissions?.accounts_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/accounts/communal", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a list of all individual accounts available to the current user. 
 * Individual accounts can be used by only a single user, this will be the "owner" field of the account.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetIndividualAccounts = function (callback) {
    if (!this.Atheneum.User.permissions?.accounts_read && !this.Atheneum.User.permissions?.accounts_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/accounts/individual", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a specific account by id.
 * @param {string} accountId account id to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.getAccount = function (accountId, callback) {
    if (!this.Atheneum.User.permissions?.accounts_read && !this.Atheneum.User.permissions?.accounts_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/accounts/" + accountId, { apikey: this.Atheneum.User.apikey }, callback);
}

//END ACCOUNTS
//TODO Jorge - Create the rest of the account admin apis - not needed for first release 

//GROUPS
/**
 * You can use this call to retrieve a list of all user groups available to the current user.
 * @param {string} accountId - Optional parameter to limit the response to only include user groups from the specified account.
 * @param {boolean} includeUserIds – Optional true/false parameter to set whether the response should include the list of userIds for each group.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserGroups = function (accountId, includeUserIds, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_read && !this.Atheneum.User.permissions?.userGroups_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }


    if (arguments.length == 1) {
        callback = accountId;
        accountId = undefined;
        includeUserIds = undefined;
    }

    if (arguments.length == 2) {
        if (typeof accountId === 'boolean') {
            callback = includeUserIds;
            includeUserIds = accountId;
            accountId = undefined;
        } else {
            callback = includeUserIds;
            includeUserIds = undefined;
        }
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };

    if (accountId != undefined) {
        queryParams.accountId = accountId;
    }

    if (includeUserIds != undefined) {
        queryParams.includeUserIds = includeUserIds;
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/user-groups", queryParams, callback);
}

/**
 * You can use this call to retrieve a specific user group by id.
 * @param {*} groupId id of the group to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserGroup = function (groupId, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_read && !this.Atheneum.User.permissions?.userGroups_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/user-groups/" + groupId, queryParams, callback);
}

/**
 * You can use this call to create a new user group.
 * @param {object} groupObj object containing group information - externalId (optional), name, description, priority (optional - not providing this will result in the group having the lowest priority), userIds (optional)
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminCreateUserGroup = function (groupObj, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_create) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }


    if (groupObj == undefined || typeof groupObj !== 'object')
        throw new IllegalArgumentException("groupObj must be an object containing information about the user group");


    var url = this.Atheneum.API.BASE_URL + "/admin/user-groups";

    return this.Atheneum.HttpUtils.postJSON(url, groupObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/** 
 * You can use this call to update an existing user group.
 * @param {string} groupId - id for the group to be updated
 * @param {object} groupObj object containing group information - externalId (optional), name, description, priority (optional - not providing this will result in the group having the lowest priority), userIds (optional)
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminEditUserGroup = function (groupId, groupObj, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_update && !this.Atheneum.User.permissions?.userGroups_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (groupObj == undefined || typeof groupObj !== 'object')
        throw new IllegalArgumentException("groupObj must be an object containing information about the user group");

    if (groupId == undefined || typeof groupId !== 'string')
        throw new IllegalArgumentException("groupId must be an string of the unique id of the group to be edited");


    var url = this.Atheneum.API.BASE_URL + "/admin/user-groups/" + groupId;

    return this.Atheneum.HttpUtils.postJSON(url, groupObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to deactivate an existing user group. The group will no longer be available to assign to users, and any library content licensed to this group may become unavailable.
 * @param {string} groupId id of the group to be deactivated
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminDeactivateUserGroup = function (groupId, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_delete && !this.Atheneum.User.permissions?.userGroups_deleteAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (groupId == undefined || typeof groupId !== 'string')
        throw new IllegalArgumentException("groupId must be an string of the unique id of the group to be deleted");


    var url = this.Atheneum.API.BASE_URL + "/admin/user-groups/" + groupId;

    return this.Atheneum.HttpUtils.deleteJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to add one or more users to a user group. Note, the user must first be added to the account if not already.
 * @param {string} groupId id for the group to be updated
 * @param {array} userIds array containing user ids to be added to the group
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminAddUsersToGroup = function (groupId, userIds, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_update && !this.Atheneum.User.permissions?.userGroups_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (userIds == undefined || !Array.isArray(userIds))
        throw new IllegalArgumentException("userIds must be an array containing user ids to be added to the group");

    if (groupId == undefined || typeof groupId !== 'string')
        throw new IllegalArgumentException("groupId must be an string of the unique id of the group to be edited");


    var url = this.Atheneum.API.BASE_URL + "/admin/user-groups/" + groupId + "/users/add";

    return this.Atheneum.HttpUtils.postJSON(url, { ids: userIds }, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * 
 * @param {string} groupId id for the group to be updated
 * @param {array} userIds array containing user ids to be removed from the group
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminRemoveUsersFromGroup = function (groupId, userIds, callback) {

    if (!this.Atheneum.User.permissions?.userGroups_update && !this.Atheneum.User.permissions?.userGroups_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (typeof userIds === 'undefined' || !Array.isArray(userIds))
        throw new IllegalArgumentException("userIds must be an array containing user ids to be removed from the group");

    if (typeof groupId !== 'string')
        throw new IllegalArgumentException("groupId must be an string of the unique id of the group to be edited");


    var url = this.Atheneum.API.BASE_URL + "/admin/user-groups/" + groupId + "/users/remove";

    return this.Atheneum.HttpUtils.postJSON(url, { ids: userIds }, { apikey: this.Atheneum.User.apikey }, callback);
}


//END GROUPS

//USER REGISTRATIONS
/**
 * You can use this call to retrieve a list of all user registrations.
 * @param {string} accountId - Optional parameter to limit the response to only include user registrations from the specified account.
 * @param {string} status  – Optional parameter to only return registrations of a particular status 
 * 
 * Self Registration Status	
 *  COMPLETE	Registration approval was not enabled at the time, so a user was created straight away.
 *	PREAPPROVED	This registration was pre-approved, so a user was created straight away.
 *	PENDING	    This registration is waiting for approval.
 *	APPROVED	This registration has been approved and a user has been created.
 *	REJECTED	This registration has been rejected.
 *
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserRegistrations = function (accountId, status, callback) {

    if (arguments.length == 1) {
        callback = accountId;
        accountId = undefined;
        status = undefined;
    }

    if (arguments.length == 2) {
        if (this.Atheneum.Admin.userRegistrationStatuses.indexOf(status) >= 0) {
            callback = status;
            status = accountId;
            accountId = undefined;
        } else {
            callback = includeUserIds;
            status = undefined;
        }
    }

    if (!this.Atheneum.User.permissions?.userRegistrations_read && !this.Atheneum.User.permissions?.userRegistrations_readAll) {
        if (typeof callback.failure === 'function')
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }


    var queryParams = { apikey: this.Atheneum.User.apikey };

    if (accountId != undefined) {
        queryParams.accountId = accountId;
    }

    if (status != undefined) {
        queryParams.status = status;
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/user-registrations", queryParams, callback);
}

/**
 * You can use this call to retrieve a specific registration by id.
 * @param {string} registrationId id of the registration to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserRegistration = function (registrationId, callback) {

    if (!this.Atheneum.User.permissions?.userRegistrations_read && !this.Atheneum.User.permissions?.userRegistrations_readAll) {
        if (typeof callback.failure === 'function')
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    var queryParams = { apikey: this.Atheneum.User.apikey };

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/user-registrations/" + registrationId, queryParams, callback);
}

/**
 * You can use this call to approve one or more user registration requests. Note, only registrations with status “PENDING” can be approved.
 * @param {array} registrationIds array of ids of the registrations to be approved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminApproveUserRegistration = function (registrationIds, callback) {

    if (!this.Atheneum.User.permissions?.userRegistrations_approve && !this.Atheneum.User.permissions?.userRegistrations_approveAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (typeof registrationIds === 'undefined' || !Array.isArray(registrationIds))
        throw new IllegalArgumentException("registrationIds must be an array containing registration ids to be approved");

    var url = this.Atheneum.API.BASE_URL + "/admin/user-registrations/approve";

    return this.Atheneum.HttpUtils.postJSON(url, { ids: registrationIds }, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to reject one or more user registration requests. Note, only registrations with status “PENDING” can be rejected.
 * @param {array} registrationIds array of ids of the registrations to be rejected
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminRejectUserRegistration = function (registrationIds, callback) {

    if (!this.Atheneum.User.permissions?.userRegistrations_approve && !this.Atheneum.User.permissions?.userRegistrations_approveAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (typeof registrationIds === 'undefined' || !Array.isArray(registrationIds))
        throw new IllegalArgumentException("registrationIds must be an array containing registration ids to be rejected");

    var url = this.Atheneum.API.BASE_URL + "/admin/user-registrations/reject";

    return this.Atheneum.HttpUtils.postJSON(url, { ids: registrationIds }, { apikey: this.Atheneum.User.apikey }, callback);
}
//END USER REGISTRATIONS


//USERS
/**
 * You can use this call to retrieve a list of existing users available to the current user.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUsers = function (callback) {

    if (!this.Atheneum.User.permissions?.users_read && !this.Atheneum.User.permissions?.users_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/users", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a specific user by id.
 * @param {string} userId id of the user to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserById = function (userId, callback) {

    if (!this.Atheneum.User.permissions?.users_read && !this.Atheneum.User.permissions?.users_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/users/" + userId, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a specific user by userName.
 * @param {string} userName username of the user to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserByName = function (userName, callback) {

    if (!this.Atheneum.User.permissions?.users_read && !this.Atheneum.User.permissions?.users_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/users/by_name", { apikey: this.Atheneum.User.apikey, userName: userName }, callback);
}


/**
 * You can use this call to create a new user.
 * User parameters
 * userName - type = String - The username this user will use to login with.
 * title - type = String - The user's title, eg Mr, Mrs, etc.
 * firstName - type = String - The user's first name.
 * middleName - type = String - The user's middle name.
 * lastName - type = String - The user's last name.
 * email - type = String - The user's email address.
 * startDate - type = Timestamp - Indicates the date/time the user will become enabled.
 * endDate - type = Timestamp - Indicates the date/time the user will expire.
 * permissionsSetId - type = String - Id of the permissions set currently assigned to this user.
 * userGroupIds - type = Array - An array of user group IDs this user belongs to.
 * 
 * Extra parameters - only password is required
 * password - type = String - required = TRUE - Password for new user to login with. Note an error may be thrown if the password is deemed to weak. There are no fixed rules for passwords so long as the system detects sufficient complexity. Therefore please avoid using the userName or common English words.
 * accountId - type = String - required = FALSE - The id of a communal account to add the new user to. If this is not provided and generateIndividualAccount is false, the new user will be added to the account the calling user belongs to. However, if the calling user belongs to multiple accounts, an error will be thrown prompting for a specific accountId.
 * generateIndividualAccount - type = Boolean - required = FALSE - If true, an individual account will be created for the new user. If not set, this will default to false.
 * sendUserWelcomeEmail - type = Boolean - required = FALSE - If true, a welcome email will sent to the new user. If not set, this will default to false.
 * includePasswordReset - type = Boolean - required = FALSE - If sendUserWelcomeEmail is true, this option can be used to specify whether a password reset link will be included in the email. This will default to false.

 * @param {object} userObj object containing information on the user to be created
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminCreateUser = function (userObj, callback) {

    if (!this.Atheneum.User.permissions?.users_create) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (userObj == undefined || typeof userObj !== 'object')
        throw new IllegalArgumentException("userObj must be an object containing all the required information");


    var url = this.Atheneum.API.BASE_URL + "/admin/users";

    return this.Atheneum.HttpUtils.postJSON(url, userObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to update a specific user.
 * User parameters
 * userName - type = String - The username this user will use to login with.
 * title - type = String - The user's title, eg Mr, Mrs, etc.
 * firstName - type = String - The user's first name.
 * middleName - type = String - The user's middle name.
 * lastName - type = String - The user's last name.
 * email - type = String - The user's email address.
 * startDate - type = Timestamp - Indicates the date/time the user will become enabled.
 * endDate - type = Timestamp - Indicates the date/time the user will expire.
 * permissionsSetId - type = String - Id of the permissions set currently assigned to this user.
 * userGroupIds - type = Array - An array of user group IDs this user belongs to.
 * 
 * Extra parameters - only password is required
 * password - type = String - required = TRUE - Password for new user to login with. Note an error may be thrown if the password is deemed to weak. There are no fixed rules for passwords so long as the system detects sufficient complexity. Therefore please avoid using the userName or common English words.
 * accountId - type = String - required = FALSE - The id of a communal account to add the new user to. If this is not provided and generateIndividualAccount is false, the new user will be added to the account the calling user belongs to. However, if the calling user belongs to multiple accounts, an error will be thrown prompting for a specific accountId.
 * generateIndividualAccount - type = Boolean - required = FALSE - If true, an individual account will be created for the new user. If not set, this will default to false.
 * sendUserWelcomeEmail - type = Boolean - required = FALSE - If true, a welcome email will sent to the new user. If not set, this will default to false.
 * includePasswordReset - type = Boolean - required = FALSE - If sendUserWelcomeEmail is true, this option can be used to specify whether a password reset link will be included in the email. This will default to false.
 * @param {string} userId id of the user to be modified
 * @param {object} userObj object containing information on the user to be created
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminEditUser = function (userId, userObj, callback) {

    if (!this.Atheneum.User.permissions?.users_update && !this.Atheneum.User.permissions?.users_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (userObj == undefined || typeof userObj !== 'object')
        throw new IllegalArgumentException("userObj must be an object containing all the required information");

    if (userId == undefined || typeof userId !== 'string')
        throw new IllegalArgumentException("userId must be an string of the unique id of the user to be edited");


    var url = this.Atheneum.API.BASE_URL + "/admin/users/" + userId;

    return this.Atheneum.HttpUtils.postJSON(url, userObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * 
 * @param {string} userId id of the user to be deactivated
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminDeactivateUser = function (userId, callback) {

    if (!this.Atheneum.User.permissions?.users_delete && !this.Atheneum.User.permissions?.users_deleteAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (userId == undefined || typeof userId !== 'string')
        throw new IllegalArgumentException("userId must be an string of the unique id of the user to be deactivated");

    var url = this.Atheneum.API.BASE_URL + "/admin/users/" + userId;

    return this.Atheneum.HttpUtils.deleteJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a list of available permissions sets that can be assigned to users.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserPermissionSets = function (callback) {

    if (!this.Atheneum.User.permissions?.users_read && !this.Atheneum.User.permissions?.users_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/permissionssets", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a specific permissions set by id.
 * @param {string} setId id of the permission set to be retrieved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminGetUserPermissionSet = function (setId, callback) {

    if (!this.Atheneum.User.permissions?.users_read && !this.Atheneum.User.permissions?.users_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/permissionssets/" + setId, { apikey: this.Atheneum.User.apikey }, callback);
}

//END USER
//TAGS
/**
 * You can use this call to retrieve a list of all available library tags.
 * @param {string} accountId Optional parameter to limit the response to only include user groups from the specified account.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminGetTags = function (accountId, callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_read && !this.Atheneum.User.permissions?.libraryTags_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (arguments.length == 1 && typeof accountId === 'object') {
        callback = accountId;
        accountId = undefined;
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/tags", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * Use this call to retrieve a list of tag + options assigned to an asset with {assetId} along with the reasons it was tagged (if available) 
 * @param {string} assetId unique id of the asset for the information you are requesting
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.admingGetAssetTagReasons = function (assetId, callback) {
    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/tags/applied-to-reprint/"+assetId, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve tagging history
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminUpdateTagHistory = function (callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_update && !this.Atheneum.User.permissions?.libraryTags_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/filters/history", { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to retrieve a specific tag by id.
 * @param {string} tagId id of the tag to retrieve
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminGetTag = function (tagId, callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_read && !this.Atheneum.User.permissions?.libraryTags_readAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    return Atheneum.HttpUtils.getJSON(this.BASE_URL + "/admin/tags/"+tagId, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to add a new library tag. 
 * Note, if a tag/option name is not provided, it will be auto generated from the label by removing all non alphanumeric characters and joining all words using camel case.
 * 
 * Tags - 
 * 
 * name	- String - The name for this tag. This is the key used in collections/assets properties map. If not specified when creating/updating tags, 
 *                  this will be auto generated from the label by removing non alphanumeric characters and joining words with camel case.	
 * label - String	- The display name for this tag.	
 * order - Integer	- An integer (starting from 1) indicating the display order of this tag.	
 * options - Array - An array of library tag options to appear beneath this tag. There is no limit to the number of option levels a tag can have.	
 * -----------------------------------------
 * Options - each option is an object that contains the same parameters as tags - name, label, order, and optionally a list of options in itself
 * 
 * 
 * @param {object} tagObj object containing tag information - see above
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminCreateTag = function (tagObj, callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_create) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }


    if (tagObj == undefined || typeof tagObj !== 'object')
        throw new IllegalArgumentException("tagObj must be an object containing information about the tag");


    var url = this.Atheneum.API.BASE_URL + "/admin/tags";

    return this.Atheneum.HttpUtils.postJSON(url, tagObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/** 
 * You can use this call to update an existing library tag.
 * @param {string} tagId - id for the tag to be updated
 * @param {object} tagObj object containing tag information -  see adminCreateTag function
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.adminEditTag = function (tagId, tagObj, callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_update && !this.Atheneum.User.permissions?.libraryTags_updateAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (tagObj == undefined || typeof tagObj !== 'object')
        throw new IllegalArgumentException("groupObj must be an object containing information about the user group");

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("groupId must be an string of the unique id of the group to be edited");


    var url = this.Atheneum.API.BASE_URL + "/admin/tags/" + tagId;

    return this.Atheneum.HttpUtils.postJSON(url, tagObj, { apikey: this.Atheneum.User.apikey }, callback);
}

/**
 * You can use this call to remove a tag. Note, tags that have already been applied to library content, can not be removed.
 
* @param {string} tagId id of the tag to be removed
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminRemoveTag = function (tagId, callback) {

    if (!this.Atheneum.User.permissions?.libraryTags_delete && !this.Atheneum.User.permissions?.libraryTags_deleteAll) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("tagId must be an string of the unique id of the tag to be deleted");


    var url = this.Atheneum.API.BASE_URL + "/admin/tags/" + tagId;

    return this.Atheneum.HttpUtils.deleteJSON(url, undefined, { apikey: this.Atheneum.User.apikey }, callback);
}

/** 
 * You can use this call to apply a tag to one or more collections/assets from the library. 
 * Note, tags must belong to the same account as the collections/assets you wish to tag. 
 * There may also be a small delay before the tags appear against the collections/assets in the library API call.
 * 
 * @param {string} tagId - id for the tag to be applied
 * @param {string} optionName option  within the tag to be applied
 * @param {array} assetIds array of ids for the reprints / assets to apply the tag  to
 * @param {array} collectionIds array of ids for the collections to apply the tag to
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminApplyTagToItems = function (tagId, optionName, assetIds, collectionIds, callback) {

    if (!this.Atheneum.User.permissions?.canTagLibraryContent) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (optionName == undefined || typeof optionName !== 'string')
        throw new IllegalArgumentException("optionName must be supplied for one of the tags options");

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("tagId must be an string of the unique id of the tag to be applied");

    var obj = {
        tagId : tagId,
        optionName: optionName,
        assetIds : (assetIds || []),
        collectionIds : (collectionIds || [])
    };


    var url = this.Atheneum.API.BASE_URL + "/admin/tags/apply";

    return this.Atheneum.HttpUtils.postJSON(url, obj, { apikey: this.Atheneum.User.apikey }, callback);
}

/** 
 * You can use this call to remove a tag from one or more collections/assets from the library. 
 * Note, there may be a small delay before the tags are removed from the collections/assets in the library API call.
 * 
 * @param {string} tagId - id for the tag to be applied
 * @param {string} optionName option  within the tag to be applied
 * @param {array} assetIds array of ids for the reprints / assets to apply the tag  to
 * @param {array} collectionIds array of ids for the collections to apply the tag to
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminRemoveTagFromItems = function (tagId, optionName, assetIds, collectionIds, callback) {

    if (!this.Atheneum.User.permissions?.canTagLibraryContent) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (optionName == undefined || typeof optionName !== 'string')
        throw new IllegalArgumentException("optionName must be supplied for one of the tags options");

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("tagId must be an string of the unique id of the tag to be removed");

    var obj = {
        tagId : tagId,
        optionName: optionName,
        assetIds : (assetIds || []),
        collectionIds : (collectionIds || [])
    };


    var url = this.Atheneum.API.BASE_URL + "/admin/tags/remove";

    return this.Atheneum.HttpUtils.postJSON(url, obj, { apikey: this.Atheneum.User.apikey }, callback);
}

/** 
 * You can use this call to assign one or more tags to a specific collection or asset from the library. 
 * Note, you must specify all tags that should be associated with the library item. 
 * Any previous tags that are not specified will be removed. 
 * The tags selected must belong to the same account as the collection/asset you wish to tag. 
 * There may also be a small delay before the tags appear against the collections/assets in the library API call.
 * 
 * @param {string} assetId - id for the tag to be applied
 * @param {object} tags object containing  {tagId : optionName} 
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.adminAssignTagsToItem = function (assetId, tags, callback) {

    if (!this.Atheneum.User.permissions?.canTagLibraryContent) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (tags == undefined || typeof tags !== 'object')
        throw new IllegalArgumentException("tags must be an array containing the tags to be aplied and their relevant optionName ");

    if (assetId == undefined || typeof assetId !== 'string')
        throw new IllegalArgumentException("assetId must be an string of the unique id of the asset that will have the tags applied to");

    var obj = {
        assetId : assetId,
        tags: tags
    };


    var url = this.Atheneum.API.BASE_URL + "/admin/tags/assign";

    return this.Atheneum.HttpUtils.postJSON(url, obj, { apikey: this.Atheneum.User.apikey }, callback);
}

//END TAGS

//RELATED ASSETS
/**
 * get related assets to an asset item 
 
* @param {string} assetId id of the asset to be updated
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.API.prototype.getRelatedAssets = function (assetId, callback) {

    if (assetId == undefined || typeof assetId !== 'string')
        throw new IllegalArgumentException("assetId must be an string of the unique id of the asset");


    var url = this.Atheneum.API.BASE_URL + "/admin/related";

    var params = { apikey: this.Atheneum.User.apikey }
    params.assetId = assetId;


    return this.Atheneum.HttpUtils.getJSON(url, params, callback);
}

/**
 * You can use this call to set related assets for a particular asset id
 * @param {string} assetId id of the asset to be modified
 * @param {Array} relatedAssets array of assets to be set as related to the assetId
 * @param {boolean} reciprocateAdds any new assetIds will go both ways
 * @param {boolean} reciprocateRemovals any removed items will be removed both ways
 * @param {boolean} reciprocateExisting any existing items will have the relationship updated to go both ways
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.API.prototype.setRelatedAssets = function (assetId, relatedAssets, reciprocateAdds, reciprocateRemovals, reciprocateExisting, callback) {

    if (!this.Atheneum.User.permissions?.canRelateLibraryContent) {
        if (callback.failure)
            return callback.failure(this.Atheneum.Translation.get('userMustBeAdmin', "User must be an admin to use this api call"));
        else
            throw new this.Exception("User must be an admin to use this api call");
    }

    if (relatedAssets == undefined || typeof relatedAssets !== 'object')
        throw new IllegalArgumentException("relatedAssets must be an array containing the assets to be related to the assetId given ");

    if (assetId == undefined || typeof assetId !== 'string')
        throw new IllegalArgumentException("assetId must be an string of the unique id of the asset that will have the relatedAssetsIds applied to");



    var obj = {
        assetId : assetId,
        relatedAssets: relatedAssets,
        reciprocateAdditions : (reciprocateAdds || false),
        reciprocateRemovals : (reciprocateRemovals || false),
        reciprocateExisting : (reciprocateExisting || false),
    };


    var url = this.Atheneum.API.BASE_URL + "/admin/related/set";

    return this.Atheneum.HttpUtils.postJSON(url, obj, { apikey: this.Atheneum.User.apikey }, callback);
}
//END RELATED ASSETS
////#endregion



Atheneum.Summary = function (atheneum) {

    if (!(this instanceof Atheneum.Summary))
        return new Atheneum.Summary(atheneum);

    this.Atheneum = atheneum;
    this.shares = [];
    this.sharesById = {};
    this.timestamp = undefined;

    this.loadFromStorage();
}

Atheneum.Summary.prototype.update = function (callback) {

    var atheneumSummary = this;

    if (this.Atheneum.CrossPlatform.enabled && !this.Atheneum.CrossPlatform.isOnline()) {
        var json = atheneumSummary.loadFromStorage();
        if (json != null) {
            if (typeof callback === "function")
                callback(json);
            else if (callback && typeof callback.success === "function")
                callback.success(json);
            return json;
        }
    }

    return this.Atheneum.API.getShareSummary(undefined /*this.timestamp*/, {

        success: function (json) {
            
            if(json.hasOwnProperty('vends')){
                let normalShares = json.vends.map( x => {
                    x.type = 'share';
                    return x
                    });
                atheneumSummary.shares = normalShares;
            }else{
                atheneumSummary.shares = [];
            }
           
            if(json.hasOwnProperty('registeredInterest')){
                var registeredInterestShares = json.registeredInterest.map( x => {
                    x.type = 'registeredInterest';
                    return x
                    });
                atheneumSummary.shares = atheneumSummary.shares.concat(registeredInterestShares);
            }

            if(json.hasOwnProperty('forms')){
                var formShares = json.forms.map( x => {
                    x.type = 'forms';
                    return x
                    });
                atheneumSummary.shares = atheneumSummary.shares.concat(formShares);
            }
    
            if(json.hasOwnProperty('mlr')){
                var mlrShares = json.mlr.map( x => {
                    x.type = 'mlr';
                    return x
                    });
                atheneumSummary.shares = atheneumSummary.shares.concat(mlrShares);
            }

            atheneumSummary.shares.sort(function (a, b) { 
                let aDate = a.dateVended || a.dateRegistered || a.dateReviewed;
                let bDate = b.dateVended || b.dateRegistered || a.dateReviewed;
                
                return bDate - aDate; 
            });
            atheneumSummary.timestamp = json.timestamp;
            atheneumSummary.sharesById = {};
            for (var i = 0; i < atheneumSummary.shares.length; i++) {
                atheneumSummary.sharesById[atheneumSummary.shares[i].id] = atheneumSummary.shares[i];
            }

            // TODO: add pending offline shares to the summary list
            atheneumSummary.saveToStorage(json);

            if (typeof callback === "function")
                callback(json);
            else if (callback && typeof callback.success === "function")
                callback.success(json);



        },

        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                var json = atheneumSummary.loadFromStorage();
                if (json != null) {
                    if (typeof callback === "function")
                        callback(json);
                    else if (callback && typeof callback.success === "function")
                        callback.success(json);
                    return;
                }
            }

            if (callback && typeof callback.failure === "function")
                callback.failure();
        }

    });
}

Atheneum.Summary.prototype.getShareById = function (shareId) {
    return this.sharesById[shareId];
}

Atheneum.Summary.prototype.setShareToSuccessful = function (shareId, emailAddress) {
    var shareGroupId = null;

    if (this.sharesById[shareId]) {
        this.sharesById[shareId].deliveryStatus = "success";
        if (typeof emailAddress !== 'undefined')
            this.sharesById[shareId].recipient = emailAddress;

        this.sharesById[shareId].dateVended = Date.now();
        shareGroupId = this.sharesById[shareId].vendGroupId || this.sharesById[shareId].requestGroupId;
    }
    for (var i = 0; i < this.shares.length; i++) {
        if (this.shares[i].id == shareId) {
            this.shares[i].deliveryStatus = "success";
            if (typeof emailAddress !== 'undefined')
                this.shares[i].recipient = emailAddress;
            this.shares[i].dateVended = Date.now();

        } else if (this.shares[i].vendGroupId != undefined && this.shares[i].vendGroupId == shareGroupId) {
            //Also update any shares in the group Id 
            this.shares[i].deliveryStatus = "success";
            if (typeof emailAddress !== 'undefined')
                this.shares[i].recipient = emailAddress;
            this.shares[i].dateVended = Date.now();

            var id = this.shares[i].id;
            if (this.sharesById[id]) {
                this.sharesById[id].deliveryStatus = "success";
                if (typeof emailAddress !== 'undefined')
                    this.sharesById[id].recipient = emailAddress;
                this.sharesById[id].dateVended = Date.now();
            }
        }  else if (this.shares[i].requestGroupId != undefined && this.shares[i].requestGroupId == shareGroupId) {
            //Also update any shares in the group Id 
            this.shares[i].deliveryStatus = "success";
            if (typeof emailAddress !== 'undefined')
                this.shares[i].recipient = emailAddress;
            if(this.shares[i].type === 'mlr')
                 this.shares[i].dateReviewed = Date.now();
            else
                 this.shares[i].dateRegistered = Date.now();
            
            var id = this.shares[i].id;
            if (this.sharesById[id]) {
                this.sharesById[id].deliveryStatus = "success";
                if (typeof emailAddress !== 'undefined')
                    this.sharesById[id].recipient = emailAddress;
                this.sharesById[id].dateShared = Date.now();
            }
        }
    }

    this.saveToStorage();
}

Atheneum.Summary.prototype.hasFailedShares = function () {
    var hasAtLeastOneFailedShare = false;
    for (var s = 0; s < this.shares.length; s++) {
        if (!this.shares[s].hasOwnProperty('deliveryStatus'))
            continue;
            
        if (this.shares[s].deliveryStatus == 'fail') {

            var asset = window.AtheneumInstance.Library.assets[this.shares[s].assetId];
            if (asset)
                hasAtLeastOneFailedShare = true;
            break;
        }
    }
    if (hasAtLeastOneFailedShare) {
        var filtered = this.shares.filter(function (share) {
            return share.deliveryStatus == 'fail';
        });
        var failedShares = false;
        for (var i = 0; i < filtered.length; i++) {
            var share = filtered[i];
            var asset = this.Atheneum.Library.assets[share.assetId];

            if (!asset)
                continue; // skip removed assets

            failedShares = true;
        }

        return failedShares;
    }
    return false;
}

Atheneum.Summary.prototype.saveToStorage = function (json) {
    if (this.Atheneum.CrossPlatform.enabled || this.Atheneum.Theme.getBooleanProperty('saveSummariesOnWeb', false))
        this.Atheneum.LocalStorage.set('atheneumSummaries', JSON.stringify(json));
    
    
} // don't save unless crossplatform enabled

Atheneum.Summary.prototype.loadFromStorage = function () {
    // only load if cross platform enabled
    if (!this.Atheneum.Theme.getBooleanProperty('saveSummariesOnWeb', false) && (!this.Atheneum.CrossPlatform || !this.Atheneum.CrossPlatform.enabled))
        return null;
    try {

        var json = JSON.parse(this.Atheneum.LocalStorage.get('atheneumSummaries') || "{}") || {};
        
        if(json.hasOwnProperty('vends')){
            let normalShares = json.vends.map( x => {
                x.type = 'share';
                return x
                });
            this.shares = normalShares;
        }else{
            this.shares = [];
        }
       
        if(json.hasOwnProperty('registeredInterest')){
            var registeredInterestShares = json.registeredInterest.map( x => {
                x.type = 'registeredInterest';
                return x
                });
            this.shares = this.shares.concat(registeredInterestShares);
        }

        if (json.hasOwnProperty('forms')) {
            var formShares = json.forms.map(x => {
                x.type = 'forms';
                return x
            });
            this.shares = this.shares.concat(formShares);
        }

        if(json.hasOwnProperty('mlr')){
            var mlrShares = json.mlr.map( x => {
                x.type = 'mlr';
                return x
                });
            this.shares = this.shares.concat(mlrShares);
        }

        this.shares.sort(function (a, b) { 
            let aDate = a.dateShared || a.dateRegistered || a.dateReviewed;
            let bDate = b.dateShared || b.dateRegistered || b.dateReviewed;
            return bDate - aDate; 
        });

        this.timestamp = json.timestamp;
        this.sharesById = {};
        for (var i = 0; i < this.shares.length; i++) {
            this.sharesById[this.shares[i].id] = this.shares[i];
        }

        return json;
    } catch (err) {
        return null;
    }
}

Atheneum.Summary.prototype.redeliverShare = function (shareId, emailAddress, callback, shareGroupId) {

    if (typeof emailAddress != 'string' && callback == undefined) {
        callback = emailAddress;
        emailAddress = undefined;
    }

    if (emailAddress == undefined) {
        emailAddress = (this.sharesById[shareId] || {}).recipient;
    }

    this.Atheneum.API.redeliverShare(shareId, emailAddress, null, callback, shareGroupId);
}

Atheneum.Summary.prototype.cancelShare = function (shareId, shareGroupId, callback) {
    this.Atheneum.API.cancelShare(shareId, shareGroupId, callback);
}

Atheneum.Language = function AtheneumLanguage(atheneum) {

    if (!(this instanceof Atheneum.Language))
        return new Atheneum.Language(atheneum);

    this.Atheneum = atheneum;
    this.list = [];
    this.loadFromStorage();
}
Atheneum.Language.prototype.saveToStorage = function () {
    this.Atheneum.LocalStorage.set('atheneumLanguages', JSON.stringify(this.list));
}
Atheneum.Language.prototype.loadFromStorage = function () {
    this.list = JSON.parse(this.Atheneum.LocalStorage.get('atheneumLanguages') || "[]") || [];
}

// updates the language list
Atheneum.Language.prototype.update = function (callback) {

    var atheneumLanguages = this;

    var successCallback = (typeof callback === "function") ? callback : (callback || {}).success;
    var failureCallback = (callback || {}).failure;

    return this.Atheneum.API.getLanguages({
        success: function (json) {

            if (window.location.href.indexOf("login.html") >= 0 && (atheneumLanguages.list && atheneumLanguages.list.length > 0 && atheneumLanguages.Atheneum.User && atheneumLanguages.Atheneum.User.preferences && typeof atheneumLanguages.Atheneum.User.preferences.language == "string") && atheneumLanguages.list.some(x => x.iso_code == atheneumLanguages.Atheneum.User.preferences.language)) {
                if (typeof successCallback === "function")
                    successCallback(json);

                return;
            }

            atheneumLanguages.list = json.languages;

            //Download all languages only if we dont have anything in the list
            json.languages.forEach(function (item, index) {
                if (atheneumLanguages.Atheneum.Translation.languages.hasOwnProperty(item.iso_code))
                    return;

                atheneumLanguages.Atheneum.API.getTranslation(item.iso_code, 0, {
                    success: function (translationJSON) {
                        atheneumLanguages.Atheneum.Translation.languages[item.iso_code] = translationJSON.values ? translationJSON.values : {};
                        atheneumLanguages.Atheneum.Translation.saveToStorage();
                        // atheneumTranslations.timestamp = json.timestamp; // commented out: don't update timestamp
                        if (typeof successCallback === "function")
                            successCallback(json);
                    }
                });
            });

            atheneumLanguages.saveToStorage();
            if (typeof successCallback === "function")
                successCallback(json);
        },

        failure: function (reason, httpStatus, errorCode) {
            if (typeof failureCallback === "function")
                failureCallback(reason, httpStatus, errorCode);
        }
    });
}

Atheneum.Language.prototype.getByIsoCode = function (isoCode) {
    if (isoCode == null) {
        return null;
    }
    for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].iso_code.toLowerCase() == isoCode.toLowerCase())
            return this.list[i];
    }

    try {
        if (isoCode && isoCode.indexOf('-') >= 0)
            return this.getByIsoCode(isoCode.substring(0, isoCode.indexOf("-")));
    } catch (err) { }


    return null;
}

Atheneum.Language.prototype.getNativeName = function (language) {

    if (typeof language === "string") {
        return this.getNativeName(this.getByIsoCode(language));
    }

    if (language == undefined)
        return null;

    if (language.translations != undefined) {
        for (var i = 0; i < language.translations.length; i++) {
            for (var j = 0; j < language.translations[i].languages.length; j++) {
                if (language.translations[i].languages[j].toLowerCase() == language.iso_code.toLowerCase())
                    return language.translations[i].name.charAt(0).toUpperCase() + language.translations[i].name.slice(1);
            }
        }
    }

    return language.name.charAt(0).toUpperCase() + language.name.slice(1).toLowerCase();
}

Atheneum.Language.prototype.getDefaultIsoCode = function () {
    return (this.getDefault() || { iso_code: "EN" }).iso_code;
}

Atheneum.Language.prototype.getBrowserPreferred = function () {
    var browserLanguagePreference = navigator.languages;

    var preferencesSansLocation = [];

    for (var i = 0; i < browserLanguagePreference.length; i++) {

        var isocode = browserLanguagePreference[i].toUpperCase().replace('_', '-');

        var exactMatch = this.getByIsoCode(isocode);
        if (exactMatch) {
            return exactMatch;
        }

        var languageOnlyIsoCode = isocode.replace(/-[A-Z]+$/, '');
        if (preferencesSansLocation.indexOf(languageOnlyIsoCode) == -1) {
            preferencesSansLocation.push(languageOnlyIsoCode);
        }
    }

    // if for whatever reason, the list of preferred locales doesn't include
    // any location independent languages (eg: EN), and instead only contains
    // things like (EN-GB), strip out all the location info and try for the
    // langauges on their own

    for (var i = 0; i < preferencesSansLocation.length; i++) {
        var languageOnlyIsoCode = preferencesSansLocation[i];
        var languageOnlyMatch = this.getByIsoCode(languageOnlyIsoCode);
        if (languageOnlyMatch) {
            return languageOnlyMatch;
        }
    }

    // if the browser supplied no languages at all, or if atheneum supports
    // none of the supplied languages, then fall back to the default language

    return this.getDefault();
}

Atheneum.Language.prototype.getDefault = function () {
    return this.getByIsoCode("EN") || { name: "English", iso_code: "EN", translations: [] };
}

Atheneum.Language.prototype.getUserLanguage = function () {
    return this.getByIsoCode(this.Atheneum.User.preferences.language) || this.Atheneum.Language.getBrowserPreferred();
}

Atheneum.Language.prototype.setUserLanguage = function (isoCode) {
    return this.Atheneum.User.setLanguage(isoCode);
}

Atheneum.Translation = function AtheneumTranslation(atheneum) {

    if (!(this instanceof Atheneum.Translation))
        return new Atheneum.Translation(atheneum);

    this.Atheneum = atheneum;
    this.list = {};
    this.languages = {};
    this.timestamp = undefined;
    this.loadFromStorage();
    this.debug = false;
}

Atheneum.Translation.prototype.saveToStorage = function () {
    this.Atheneum.LocalStorage.set('atheneumTranslation', JSON.stringify(this.languages));
}

Atheneum.Translation.prototype.loadFromStorage = function () {
    var stored = JSON.parse(this.Atheneum.LocalStorage.get('atheneumTranslation') || "{ }") || {};
    var currentLanguage = ((this.Atheneum.User && this.Atheneum.User.getLanguage()) || this.Atheneum.Language.getBrowserPreferred()).iso_code;

    if (stored.hasOwnProperty(currentLanguage)) {
        //already have the new setup
        this.languages = stored;
    } else {
        this.languages[currentLanguage] = stored;
    }

    this.list = this.languages[currentLanguage] || {};
}

// updates the translations
Atheneum.Translation.prototype.update = function (callback) {

    var atheneumTranslations = this;

    var currentLanguage = (this.Atheneum.User.getLanguage() || this.Atheneum.Language.getBrowserPreferred()).iso_code;

    var successCallback = (typeof callback === "function") ? callback : (callback || {}).success;
    var failureCallback = (callback || {}).failure;

    this.Atheneum.API.getTranslation(currentLanguage, this.timestamp, {
        success: function (json) {
            if (window.location.href.indexOf("login.html") >= 0 && typeof atheneumTranslations.list === 'object' && (!json.values || json.values.length == 0)) {
                if (typeof successCallback === "function")
                    successCallback({});

                return;
            }

            atheneumTranslations.list = json.values ? json.values : {};
            atheneumTranslations.languages[currentLanguage] = atheneumTranslations.list;
            atheneumTranslations.saveToStorage();
            // atheneumTranslations.timestamp = json.timestamp; // commented out: don't update timestamp
            if (typeof successCallback === "function")
                successCallback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if (atheneumTranslations.languages && atheneumTranslations.languages.hasOwnProperty(currentLanguage))
                atheneumTranslations.list = atheneumTranslations.languages[currentLanguage];

            if (typeof failureCallback === "function")
                failureCallback(reason, httpStatus, errorCode);

        }
    });
}


Atheneum.Translation.prototype.get = function (key, fallback) {
    return ((this.debug || (((this.Atheneum.User.preferences || {}).language || '').toLowerCase() == 'debug')) ? key : (this.list ? (this.list[key] != undefined ? this.list[key] : fallback) : fallback));
}

Atheneum.Translation.prototype.getOrGetThemeKey = function (key, fallback) {
    return ((this.debug || (((this.Atheneum.User.preferences || {}).language || '').toLowerCase() == 'debug')) ? key : (this.list ? (this.list[key] != undefined ? this.list[key] : (this.Atheneum.Theme.getCollectionProperty(this.Atheneum.Theme.overridingCollectionId || null, key, fallback))) : fallback));
}

/**
 * Atheneum.Translation.getFormatted( key, tlargs )
 * Atheneum.Translation.getFormatted( key, fallback, tlargs )
 */
Atheneum.Translation.prototype.getFormatted = function (key, fallback, tlargs) {
    if (fallback != undefined && (typeof fallback != 'string') && arguments.length == 2) {
        tlargs = fallback;
        fallback = undefined;
    }
    var template = this.getOrGetThemeKey(key, fallback);
    if (!template) {
        return template;
    }

    // TODO - maybe cover cases where %s has been used
    if (tlargs instanceof Array) {
        for (var a = 0; a < tlargs.length; a++) {
            template = template.replace(new RegExp("\\{" + a + "\\}", "g"), tlargs[a]);
            // TODO - find some way of doing this atomically.
            // otherwise a template in the args could cause issues.
            // '{0}{1}' formatted with ['{1}', 'x'] currently gives 'xx' rather than the '{1}x' it should
        }
    }
    else {
        for (var a in tlargs) {
            template = template.replace(new RegExp("\\{" + a + "\\}", "g"), tlargs[a]);
            // similarly for the object version
        }
    }

    return template;
}

Atheneum.Translation.prototype.getErrorMessageForErrorCode = function (errorCode, fallback) {

    if (typeof errorCode !== "number" || isNaN(errorCode) || (errorCode % 1) > 0)
        throw new IllegalArgumentException("errorCode must be an integer");

    var hexErrorCode = "00000000" + errorCode?.toString(16);
    hexErrorCode = hexErrorCode.substring(hexErrorCode.length - 8, hexErrorCode.length);
    hexErrorCode = hexErrorCode.toLowerCase();

    var genericError = this.getOrGetThemeKey('error00000001', 'Undefined Error');
    var translation = this.getOrGetThemeKey('error' + hexErrorCode, typeof fallback === 'string' ? fallback : genericError);
    return translation;
}

/** Holds information about the user, and performs functions related to it */
Atheneum.User = function AtheneumUser(atheneum) {

    if (!(this instanceof Atheneum.User))
        return new Atheneum.User(atheneum);

    this.Atheneum = atheneum;
    this.preferences = {};
    this.permissions = {};
    this.loadFromStorage();

    // the timestampPreferenceGroups variable can be overridden with a list of the form:
    // { timestampPreferenceKey: [array of preferences that rely on the timestamp] }

    // its primary use is to allow for the most recently modified preference group
    // to be accepted on update. If the incoming timestamp is before the local timestamp
    // any changes to the keys will be ignored, and an update will be triggered for the group
    // if the incoming timestamp is after (or equivalent to) the local timestamp, it will
    // replace the local copy like the reset of the normal preferences

    this.timestampPreferenceGroups = {}


    // request ratings?

}

Atheneum.User.prototype.startVisit = function() {
    localStorage["sessionStarted"] = new Date().getTime();
}
Atheneum.User.prototype.getVisit = function() {
   return   localStorage["sessionStarted"] || null;
}
Atheneum.User.prototype.endVisit = function() {   
    delete localStorage["sessionStarted"];
}

Atheneum.User.prototype.isAdmin = function () {
    if (!this.permissions)
        return false;

        return (this.permissions?.accounts_read 
            || this.permissions?.accounts_readAll 
            || this.permissions?.accounts_create 
            || this.permissions?.accounts_update 
            || this.permissions?.accounts_updateAll 
            || this.permissions?.accounts_delete 
            || this.permissions?.accounts_deleteAll 
            || this.permissions?.userGroups_read 
            || this.permissions?.userGroups_readAll 
            || this.permissions?.userGroups_create 
            || this.permissions?.userGroups_update 
            || this.permissions?.userGroups_updateAll 
            || this.permissions?.userGroups_delete 
            || this.permissions?.userGroups_deleteAll 
            || this.permissions?.users_read 
            || this.permissions?.users_readAll 
            || this.permissions?.users_create 
            || this.permissions?.users_update 
            || this.permissions?.users_updateAll 
            || this.permissions?.users_delete 
            || this.permissions?.users_deleteAll 
            || this.permissions?.libraryTags_read 
            || this.permissions?.libraryTags_readAll 
            || this.permissions?.libraryTags_create 
            || this.permissions?.libraryTags_update 
            || this.permissions?.libraryTags_updateAll 
            || this.permissions?.libraryTags_delete 
            || this.permissions?.libraryTags_deleteAll 
            || this.permissions?.canTagLibraryContent
            || this.permissions?.userRegistrations_read 
            || this.permissions?.userRegistrations_readAll 
            || this.permissions?.userRegistrations_approve 
            || this.permissions?.userRegistrations_approveAll 
            || this.permissions?.userRegistrations_reject 
            || this.permissions?.userRegistrations_rejectAll);
}

Atheneum.User.prototype.getLanguage = function () {
    return this.Atheneum.Language.getByIsoCode(this.preferences.language) || this.Atheneum.Language.getBrowserPreferred() || this.Atheneum.Language.getDefault();
}

Atheneum.User.prototype.setLanguage = function (isoCode, callback) {

    var atheneumUser = this;

    var successCallback = (typeof callback === "function") ? callback : (callback || {}).success;
    var failureCallback = (callback || {}).failure;

    if (typeof isoCode === "object" && isoCode.iso_code)
        isoCode = isoCode.iso_code;

    isoCode = isoCode.toUpperCase();

    atheneumUser.preferences.language = isoCode;
    atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));

   
    if (this.Atheneum.CrossPlatform.enabled && !this.Atheneum.CrossPlatform.isOnline()) {
        atheneumUser.changePreferences({ language: isoCode }, callback);
        return;
    }else{
        if (typeof successCallback === "function")
            successCallback();
    }

    this.Atheneum.API.setUserPreferences({ language: isoCode }, {
        success: function (json) {
            atheneumUser.preferences.language = isoCode;
            atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));

            if(json.apikey)
                atheneumUser.apikey = json.apikey;

            if (typeof successCallback === "function")
                successCallback(json);
        },

        failure: function (reason, httpStatus, errorCode) {
            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                atheneumUser.preferences.language = isoCode;
                atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));

                atheneumUser.changePreferences({ language: isoCode }, callback);
                return;
            }
            if (typeof failureCallback === "function")
                failureCallback(reason, httpStatus, errorCode);
        }
    });
}

Atheneum.User.prototype.getPreference = function (preference, fallback, checkTheme) {
    checkTheme = !!checkTheme;
    var preferenceValue = (this.preferences || {})[preference];
    if (preferenceValue != undefined) {
        return preferenceValue;
    }
    if (checkTheme) {
        return this.Atheneum.Theme.getStringProperty(preference, fallback);
    }
    else {
        return fallback;
    }
}

/** Loads the user data from local storage */
Atheneum.User.prototype.loadFromStorage = function () {
    this.isLoggedIn = this.Atheneum.LocalStorage.get('atheneumUserLoggedIn') === "true";
    this.isLocked = this.Atheneum.LocalStorage.get('atheneumUserLocked') === "true";
    this.apikey = this.Atheneum.LocalStorage.get('atheneumUserApiKey') || "";
    this.username = this.Atheneum.LocalStorage.get('atheneumUserName');
    this.id = this.Atheneum.LocalStorage.get('atheneumUserId');
    this.kioskMode = this.Atheneum.LocalStorage.get('atheneumUserKioskMode') === "true";
    this.startupCollection = this.Atheneum.LocalStorage.get('atheneumUserStartupCollection') || null;
    this.isPasswordChangeNeeded = this.Atheneum.LocalStorage.get('atheneumUserPasswordChangeNeeded') === "true";
    this.loggedInWithParams = this.Atheneum.LocalStorage.get('atheneumUserLoggedInWithParams') === "true";
    this.veevaUser = this.Atheneum.LocalStorage.get('atheneumVeevaUser') === "true";
    this.veevaID = this.Atheneum.LocalStorage.get('atheneumVeevaID') || undefined;

    this.baseUrl = this.Atheneum.LocalStorage.get('atheneumUserServerUrl');
    if (this.Atheneum.API.isGeneric && this.isLoggedIn && this.apikey && this.baseUrl) {
        this.Atheneum.API.BASE_URL = this.baseUrl;
        if (!this.Atheneum.Proxy.enabled) {
            this.Atheneum.API.BASE_URL_NO_PROXY = this.baseUrl;
        }
    }else if(!this.Atheneum.API.isGeneric){
        this.Atheneum.API.BASE_URL_NO_PROXY = this.baseUrl;
    }

    if (this.Atheneum.API.isGeneric && this.isLoggedIn && !this.baseUrl) {
        this.isLoggedIn = false;
        this.apikey = undefined;
        this.permissions = {
            canFavourite: true,
            canInvite: false,
            canRate: false,
            canShare: false,
            canVend: false
        }
    }

    this.preferences = JSON.parse(this.Atheneum.LocalStorage.get('atheneumUserPreferences') || "{}") || {};
    this.ratings = JSON.parse(this.Atheneum.LocalStorage.get('atheneumUserRatings') || "{}") || {};

    try {
        this.permissions = JSON.parse(this.Atheneum.LocalStorage.get('atheneumUserPermissions'));
        this.permissions.canShare = this.permissions.canVend || false;
    } catch (e) {
        this.permissions = {
            canFavourite: true,
            canInvite: false,
            canRate: false,
            canShare: false,
            canVend: false
        }
    }

    this.test = this.Atheneum.LocalStorage.get('atheneumUserTestUser') || false;
    this.logoUrl = this.Atheneum.LocalStorage.get('atheneumUserLogoUrl') || undefined;
    this.logoLastModified = parseInt(this.Atheneum.LocalStorage.get('atheneumUserLogoLastModified')) || 0;

    try {
        this.groups = JSON.parse(this.Atheneum.LocalStorage.get('atheneumUserGroups'));
    } catch (e) {
        this.groups = [];
    }
}

/** Saves the user data to local storage */
Atheneum.User.prototype.saveToStorage = function () {
    this.Atheneum.LocalStorage.set('atheneumUserLoggedIn', this.isLoggedIn);
    this.Atheneum.LocalStorage.set('atheneumUserLocked', this.isLocked);
    this.Atheneum.LocalStorage.set('atheneumUserApiKey', this.apikey);
    this.Atheneum.LocalStorage.set('atheneumUserPermissions', JSON.stringify(this.permissions));
    this.Atheneum.LocalStorage.set('atheneumUserLogoUrl', this.logoUrl);
    this.Atheneum.LocalStorage.set('atheneumUserLogoLastModified', this.logoLastModified);
    this.Atheneum.LocalStorage.set('atheneumUserGroups', JSON.stringify(this.groups));
    this.Atheneum.LocalStorage.set('atheneumUserName', this.username);
    this.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(this.preferences));
    this.Atheneum.LocalStorage.set('atheneumUserRatings', JSON.stringify(this.ratings));
    this.Atheneum.LocalStorage.set('atheneumUserId', this.id);
    this.Atheneum.LocalStorage.set('atheneumUserKioskMode', this.kioskMode);
    this.Atheneum.LocalStorage.set('atheneumUserStartupCollection', this.startupCollection || undefined);
    this.Atheneum.LocalStorage.set('atheneumUserServerUrl', this.baseUrl);

    if (!this.loggedInWithParams)
        this.loggedInWithParams = false;

    if (!this.veevaUser)
        this.veevaUser = false;

    this.Atheneum.LocalStorage.set('atheneumUserLoggedInWithParams', this.loggedInWithParams);
    this.Atheneum.LocalStorage.set('atheneumUserPasswordChangeNeeded', '' + !!(this.isPasswordChangeNeeded));
    this.Atheneum.LocalStorage.set('atheneumUserTestUser', this.test);
    this.Atheneum.LocalStorage.set('atheneumVeevaUser', this.veevaUser);

    if (this.veevaID)
        this.Atheneum.LocalStorage.set('atheneumVeevaID', this.veevaID);
    else
        this.Atheneum.LocalStorage.clear('atheneumVeevaID'); 
}

/**
    Attempts to log the user in, taking the user to the redirect page if successful.
    Note that uiCallbacks are called before the redirect is initiated.
    If the callback returns false, no redirect will take place.

    Atheneum.User.login( username, password, redirect )
    Atheneum.User.login( username, password, uiCallbacks )
    Atheneum.User.login( username, password, redirect, uiCallbacks )

*/
Atheneum.User.prototype.login = function (username, password, redirect, uiCallbacks, skipGenericCheck) {

    if (arguments.length < 4) {
        uiCallbacks = redirect;
        redirect = undefined;
    }

    var loggedInUserName = username;
    var atheneum = this.Atheneum;

    // if (!skipGenericCheck && !this.Atheneum.CrossPlatform.enabled && this.Atheneum.API.isGeneric) {
    //     return this.Atheneum.API.requestServerInstance(username, {
    //         success: function (json) {
    //             // couldn't locate the server for the user
    //             if (json.baseURL == undefined) {
    //                 // pretend we got an error code
    //                 return uiCallbacks.failure(
    //                     Atheneum.API.Problems.ERROR_CODE_PRESENT,
    //                     200,
    //                     Atheneum.API.ErrorCodes.ACCOUNT_INVALID_LOGIN,
    //                     "Atheneum.User.login"
    //                 );
    //             }
    //             if (atheneum.API.BASE_URL != json.baseURL) {
    //                 if (atheneum.Plugins) {
    //                     atheneum.Plugins.plugins = [];
    //                     atheneum.Plugins.activeElementId = null;
    //                     atheneum.Plugins.activePluginId = null;
    //                     atheneum.Plugins.activePluginParameters = null;
    //                     atheneum.Plugins.saveToStorage();
    //                     localStorage['ignoreTimestamp'] = true;
    //                 }
    //             }
    //             atheneum.API.BASE_URL = json.baseURL;
    //             atheneum.API.BASE_URL_NO_PROXY = json.baseURL;
    //             return atheneum.User.login(username, password, redirect, uiCallbacks, true);
    //         },
    //         failure: function (reason, httpStatus, errorCode) {
    //             // username not recognised
    //             uiCallbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.login");
    //         },
    //         offline: function (reason, httpStatus, errorCode) {
    //             var offlineData = JSON.parse(atheneum.LocalStorage.get('atheneumOfflineUserDataForUser_' + loggedInUserName) || "{}") || {};
    //             if (offlineData && offlineData.baseUrl) {
    //                 atheneum.API.BASE_URL = offlineData.baseUrl;
    //                 return atheneum.User.login(username, password, redirect, uiCallbacks, true);
    //             }
    //             // offline and no idea which server we need... give up
    //             uiCallbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.login");
    //         }
    //     });
    // }

    return this.Atheneum.API.login(username, password, {
        success: function (json) {
            
            if (json.hasOwnProperty('baseURL')) {
                if (atheneum.API.BASE_URL != json.baseURL) {
                    if (atheneum.Plugins) {
                        atheneum.Plugins.plugins = [];
                        atheneum.Plugins.activeElementId = null;
                        atheneum.Plugins.activePluginId = null;
                        atheneum.Plugins.activePluginParameters = null;
                        atheneum.Plugins.saveToStorage();
                        localStorage['ignoreTimestamp'] = true;
                    }
                }
    
                atheneum.API.BASE_URL = json.baseURL;
                atheneum.API.BASE_URL_NO_PROXY = json.baseURL;
            }
        

            // save the successful password hash

            atheneum.LocalStorage.set('atheneumHashedPasswordForUser_' + loggedInUserName, atheneum.Crypto.hash(password, username));
            var offline = JSON.parse(atheneum.LocalStorage.get('atheneumOfflineUserDataForUser_' + loggedInUserName) || "{}") || {};
            if (!offline)
                offline = {};

            var offlineData = {
                permissions: json.permissions || {},
                emailConfirmed: json.emailConfirmed || false,
                logoUrl: json.registrarLogo ? json.registrarLogo.url : null,
                logoLastModified: json.registrarLogo ? json.registrarLogo.modified : 0,
                groups: json.groups || [],
                userId: json.userId || "",
                startupCollection: json.startupCollection || null,
                baseUrl: atheneum.API.BASE_URL,
                kioskMode: json.kioskMode || false,
                test: json.test || false,
                preferences: offline.preferences || atheneum.User.preferences
            }

            var hashForApiKey = atheneum.Crypto.hash(password + '_apikey', username + '_apikey');
            var apikey = json.apikey || '';
            if (apikey) {
                offlineData.encryptedApiKey = Atheneum.Crypto.xor(apikey, hashForApiKey);
            }

            // atheneum.LocalStorage.clear('atheneumOfflineUserDataForUser_' + loggedInUserName);

            var stringifiedOfflineData = JSON.stringify(offlineData);
            atheneum.LocalStorage.set('atheneumOfflineUserDataForUser_' + loggedInUserName, stringifiedOfflineData);

            var savedProperly = stringifiedOfflineData == atheneum.LocalStorage.get('atheneumOfflineUserDataForUser_' + loggedInUserName);

            if (typeof json.baseUrl !== 'undefined')
                atheneum.API.BASE_URL = json.baseUrl;

            atheneum.User.isLoggedIn = true;
            atheneum.User.isLocked = false;
            atheneum.User.apikey = json.apikey || "";
            atheneum.User.permissions = json.permissions || {};
            atheneum.User.emailConfimed = json.emailConfirmed || false;
            atheneum.User.logoUrl = json.registrarLogo ? json.registrarLogo.url : undefined;
            atheneum.User.logoLastModfied = json.registrarLogo ? json.registrarLogo.modified : 0;
            atheneum.User.groups = json.groups || [];
            atheneum.User.username = loggedInUserName;
            atheneum.User.id = json.userId;
            atheneum.User.kioskMode = json.kioskMode || false;
            atheneum.User.isPasswordChangeNeeded = (json.changePassword == true);
            atheneum.User.startupCollection = json.startupCollection || null;
            atheneum.User.baseUrl = atheneum.API.BASE_URL;
            atheneum.User.preferences = offlineData.preferences || atheneum.User.preferences;
            atheneum.User.test = json.test || false;
            atheneum.User.veevaUser = json.veeva || false;
            atheneum.User.veevaID = json.veevaID || undefined;
            atheneum.User.saveToStorage();
          

            if (atheneum.UI && atheneum.UI.Notifications) {
                atheneum.UI.Notifications.hasNotPolledSinceLastLogin = true;
            }


            var loginJson = json;

            var onUpdateCompletionOrFailure = function () {

                if (typeof uiCallbacks === "function" && (uiCallbacks() === false))
                    return false;

                if (typeof uiCallbacks === "object" && typeof uiCallbacks.success === "function" && (uiCallbacks.success(loginJson) === false))
                    return false;

                if (redirect != undefined)
                    atheneum.Pages.redirectTo(redirect);
            }

            atheneum.User.update({
                success: onUpdateCompletionOrFailure,
                failure: function (reason, httpStatus, errorCode) {
                    Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.User.update');
                    onUpdateCompletionOrFailure();
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                var savedHash = atheneum.LocalStorage.get('atheneumHashedPasswordForUser_' + loggedInUserName);
                var loginHash = atheneum.Crypto.hash(password, username);

                if (savedHash && (loginHash == savedHash)) {

                    var offlineData = JSON.parse(atheneum.LocalStorage.get('atheneumOfflineUserDataForUser_' + loggedInUserName) || "{}") || {};

                    var wasLocked = atheneum.User.isLocked;

                    atheneum.User.isLoggedIn = true;
                    atheneum.User.isLocked = false;
                    atheneum.User.apikey = "offline";
                    atheneum.User.permissions = offlineData.permissions || {};
                    atheneum.User.emailConfimed = offlineData.emailConfirmed || false;
                    atheneum.User.logoUrl = offlineData.logoUrl || undefined,
                        atheneum.User.logoLastModfied = offlineData.logoLastModfied || 0;
                    atheneum.User.groups = offlineData.groups || [];
                    atheneum.User.username = loggedInUserName;
                    atheneum.User.id = offlineData.userId;
                    atheneum.User.kioskMode = offlineData.kioskMode || false;
                    atheneum.User.baseUrl = offlineData.baseUrl || atheneum.API.BASE_URL;
                    atheneum.User.startupCollection = offlineData.startupCollection || null;
                    atheneum.User.isPasswordChangeNeeded = false;
                    atheneum.User.preferences = offlineData.preferences;
                    atheneum.User.test = offlineData.test || false;

                    if (atheneum.User.baseApi) {
                        atheneum.API.BASE_URL = atheneum.User.baseApi;
                    }

                    if (wasLocked && offlineData.encryptedApiKey) {
                        var hashForApiKey = atheneum.Crypto.hash(password + '_apikey', username + '_apikey');
                        atheneum.User.apikey = Atheneum.Crypto.xor(offlineData.encryptedApiKey, hashForApiKey);
                    }

                    atheneum.User.saveToStorage();

                    if (typeof uiCallbacks === "function" && (uiCallbacks() === false))
                        return false;

                    if (typeof uiCallbacks === "object" && typeof uiCallbacks.success === "function" && (uiCallbacks.success() === false))
                        return false;

                    if (redirect != undefined)
                        atheneum.Pages.redirectTo(redirect);

                    // removed uiCallbacks.failure call as it shouldn't be called here
                    // - an offline login attempt was made
                    // - despite being offline, the login credentials matched the last known login credentials for some user
                    // - the script pretends the login succeeds and calls the success callback
                    // - the success callback doesn't return false (indicating that the redirect is allowed to happen)
                    // - but since no redirect was provided, no redirect takes place

                    return;

                } else if (savedHash) {
                    // pretend we managed to reach the server and it told us that our password was wrong
                    reason = Atheneum.API.Problems.ERROR_CODE_PRESENT;
                    httpStatus = 200;
                    errorCode = Atheneum.API.ErrorCodes.ACCOUNT_INVALID_LOGIN;
                }
            }

            if (typeof uiCallbacks === "object" && typeof uiCallbacks.failure === "function")
                uiCallbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.login");
        }
    });
}

Atheneum.User.prototype.getFullName = function () {
    if (this.preferences) {
        if (this.preferences.fullName) {
            return this.preferences.fullName;
        } else if (this.preferences.firstName && this.preferences.lastName) {
            return this.preferences.firstName + " " + this.preferences.lastName;
        } else if (this.preferences.firstName) {
            return this.preferences.firstName;
        } else if (this.preferences.title && this.preferences.lastName) {
            return this.preferences.title + " " + this.preferences.lastName;
        }
    }

    return this.username;
}

Atheneum.User.prototype.update = function (successCallbackOrCallbacks, failureCallback, offlineCallback) {

    var atheneumUser = this;

    var callbacks = Atheneum.Callbacks.parse(successCallbackOrCallbacks, failureCallback, offlineCallback);

    if (this.apikey == undefined)
        return;

    Atheneum.HttpUtils.await([

        this.Atheneum.API.getUserPreferences({
            success: function (json) {
                //TODO PREF MODIFIED -  implement once server side is updated
                //var ignoreServerPrefs = false;
                //if (json.modified && atheneumUser.preferences.modified) {
                //    var localModified = atheneumUser.preferences.modified * 1;
                //    if (isNaN(localModified)) {
                //        localModified = 0;
                //    }
                //    var serverModified = json.modified * 1;
                //    if (isNaN(serverModified)) {
                //        serverModified = 0;
                //    }

                //    if (serverModified < localModified) {
                //        ignoreServerPrefs = true;
                //    }
                //}

                //if (!ignoreServerPrefs) {
                var preferencesThatMustNotChange = {};

                if (atheneumUser.timestampPreferenceGroups) {
                    for (var timestampGroupPref in atheneumUser.timestampPreferenceGroups) {
                        var previousTimeStamp = atheneumUser.preferences[timestampGroupPref] * 1;
                        if (isNaN(previousTimeStamp)) {
                            previousTimeStamp = 0;
                        }
                        var newTimeStamp = json.preferences[timestampGroupPref] * 1;
                        if (isNaN(newTimeStamp)) {
                            newTimeStamp = 0;
                        }
                        if (newTimeStamp < previousTimeStamp) {
                            preferencesThatMustNotChange[timestampGroupPref] = atheneumUser.preferences[timestampGroupPref] || '0';
                            for (var p = 0; p < atheneumUser.timestampPreferenceGroups[timestampGroupPref].length; p++) {
                                var preferenceToKeep = atheneumUser.timestampPreferenceGroups[timestampGroupPref][p];
                                if (atheneumUser.preferences.hasOwnProperty(preferenceToKeep)) {
                                    preferencesThatMustNotChange[preferenceToKeep] = atheneumUser.preferences[preferenceToKeep];
                                }
                            }
                        }
                    }
                }

                // special case for profile image - set it to 1 if it's not already set
                if (!atheneumUser.preferences.profilePicLastUpdatedAt) {
                    preferencesThatMustNotChange.profilePicLastUpdatedAt = '1';
                }


                atheneumUser.preferences = json.preferences;
                //TODO PREF MODIFIED - atheneumUser.preferences.modified = json.modified || new Date().getTime();

                for (var pref in preferencesThatMustNotChange) {
                    if (preferencesThatMustNotChange.hasOwnProperty(pref)) {
                        atheneumUser.preferences[pref] = preferencesThatMustNotChange[pref];
                    }
                }

                var previousData = atheneumUser.Atheneum.LocalStorage.getJSON('atheneumOfflineUserDataForUser_' + atheneumUser.username);
                if(typeof previousData !== 'undefined' && typeof atheneumUser !== 'undefined' && atheneumUser.hasOwnProperty('preferences')){
                    previousData.preferences = atheneumUser.preferences;
                    atheneumUser.Atheneum.LocalStorage.set('atheneumOfflineUserDataForUser_' + atheneumUser.username, JSON.stringify(previousData));
    
                    atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));    
                }
               
                if (atheneumUser.Atheneum.UI && atheneumUser.Atheneum.UI.Notifications && atheneumUser.preferences['_atheneumNotificationHistory']) {

                    var notificationHistoryString = atheneumUser.preferences['_atheneumNotificationHistory'];
                    try {
                        atheneumUser.Atheneum.UI.Notifications.history = JSON.parse(notificationHistoryString || '[]');
                    }
                    catch (e) {
                        atheneumUser.Atheneum.UI.Notifications.history = [];
                    }
                }

                if (Object.keys(preferencesThatMustNotChange).length > 0) {
                    // the user has some keys which are more up to date
                    // force the server accept the user's more up to date version

                    atheneumUser.Atheneum.API.setUserPreferences(preferencesThatMustNotChange, {
                        success: function (json) {
                            if(json.apikey)
                                atheneumUser.apikey = json.apikey;

                            atheneumUser.saveToStorage();
                        },
                        failure: function (reason, httpStatus, errorCode) {
                            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.User.update");
                        }
                    });
                }
                //}
            },
            failure: function (reason, httpStatus, errorCode) {
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.User.update");
            }
        }),

        this.Atheneum.API.getUserPermissions({
            success: function (json) {
                if (json.userName) {
                    var previousData = atheneumUser.Atheneum.LocalStorage.getJSON('atheneumOfflineUserDataForUser_' + json.userName);
                    var newData = {
                        permissions: json.permissions || {},
                        emailConfirmed: json.emailConfirmed || false,
                        logoUrl: json.registrarLogo ? json.registrarLogo.url : null,
                        logoLastModified: json.registrarLogo ? json.registrarLogo.modified : 0,
                        groups: json.groups || [],
                        userId: json.userId || "",
                        baseUrl: atheneumUser.Atheneum.API.BASE_URL,
                        startupCollection: json.startupCollection || null,
                        preferences: atheneumUser.preferences || {},
                        test : json.test || false
                    };
                    if (previousData && previousData.encryptedApiKey) {
                        newData.encryptedApiKey = previousData.encryptedApiKey;
                    }
                    atheneumUser.Atheneum.LocalStorage.set('atheneumOfflineUserDataForUser_' + json.userName, JSON.stringify(newData));
                }
                atheneumUser.permissions = json.permissions || {};

                atheneumUser.permissions.canShare = atheneumUser.permissions.canVend || false;

                atheneumUser.emailConfimed = json.emailConfirmed || false;
                atheneumUser.logoUrl = json.registrarLogo ? json.registrarLogo.url : undefined;
                atheneumUser.logoLastModfied = json.registrarLogo ? json.registrarLogo.modified : 0;
                atheneumUser.groups = json.groups || [];
                atheneumUser.id = json.userId;
                atheneumUser.username = json.userName;
                atheneumUser.kioskMode = json.kioskMode || false;
                atheneumUser.isPasswordChangeNeeded = (json.changePassword == true);
                atheneumUser.startupCollection = json.startupCollection || null;
                atheneumUser.baseUrl = atheneumUser.Atheneum.API.BASE_URL;
                atheneumUser.test = json.test || false;
                atheneumUser.saveToStorage();
            },
            failure: function (reason, httpStatus, errorCode) {
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.User.update");
            }
        }),

        this.Atheneum.API.getUserRatingsWithComments({
            success: function (json) {
                atheneumUser.ratings = json.ratings;
                atheneumUser.Atheneum.LocalStorage.set('atheneumUserRatings', JSON.stringify(atheneumUser.ratings));
            },
            failure: function (reason, httpStatus, errorCode) {
				// ratings aren't that important
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.User.update - getUserRatingsWithComments");
				if(httpStatus == 404) {
					atheneumUser.Atheneum.API.getUserRatings({
			            success: function (json) {
			                atheneumUser.ratings = json.ratings;
			                atheneumUser.Atheneum.LocalStorage.set('atheneumUserRatings', JSON.stringify(atheneumUser.ratings));
			            },
            			failure: function (reason, httpStatus, errorCode) {
                			Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.User.update - getUserRatings");
						}
					});
				}
            }
        })

    ], callbacks);
}

Atheneum.User.prototype.sendPasswordResetEmail = function (username, uiCallbacks) {
    return this.Atheneum.API.sendPasswordResetEmail(username, uiCallbacks);
}

Atheneum.User.prototype.lock = function (uiCallbacks) {

    var atheneumUser = this;
    var callback = uiCallbacks;

    var successCallback = function () {
        atheneumUser.isLoggedIn = false;
        atheneumUser.permissions = {
            canFavourite: true,
            canInvite: false,
            canRate: false,
            canShare: false,
            canVend: false
        }
        atheneumUser.apikey = "";
        atheneumUser.emailConfirmed = false;
        atheneumUser.logoUrl = "";
        atheneumUser.logoLastModified = 0;
        atheneumUser.groups = [];
        atheneumUser.ratings = {};
        atheneumUser.isLocked = true;
        atheneumUser.kioskMode = false;
        atheneumUser.saveToStorage();
        if (typeof callback === "function")
            callback();
        else if (callback != undefined && typeof callback.success === "function")
            callback.success();
    }

    //this.Atheneum.API.logout({

    //	success: successCallback,

    //	failure: function( reason, httpStatus, errorCode ) {
    //		if( reason == Atheneum.API.Problems.ERROR_CODE_PRESENT ) {

    //			if([
    //				Atheneum.API.ErrorCodes.API_ERROR_AUTH,
    //				Atheneum.API.ErrorCodes.API_ERROR_AUTH_IP,
    //				Atheneum.API.ErrorCodes.API_ERROR_AUTH_KEY,
    //				Atheneum.API.ErrorCodes.ACCOUNT_ERROR,
    //				Atheneum.API.ErrorCodes.ACCOUNT_INVALID_LOGIN
    //			].indexOf( errorCode ) != -1) {
    //				// the apikey has already been invalidated - aka, we're already logged out
    //				return successCallback({ errorCode: 0 }); // pretend it was successful
    //			}
    //		}

    //		if (callback != undefined && typeof callback.failure === "function")
    //			callback.failure();
    //	}
    //});


    successCallback();
}

Atheneum.User.prototype.logout = function (uiCallbacks) {

    var atheneumUser = this;
    var callback = uiCallbacks;


    var clearLoginData = function () {
        atheneumUser.isLoggedIn = false;
        atheneumUser.apikey = "";
        atheneumUser.permissions = {
            canFavourite: true,
            canInvite: false,
            canRate: false,
            canShare: false
        }
        atheneumUser.emailConfirmed = false;
        atheneumUser.logoUrl = "";
        atheneumUser.logoLastModified = 0;
        atheneumUser.groups = [];
        atheneumUser.username = undefined;
        atheneumUser.preferences = { language: atheneumUser.preferences.language };
        atheneumUser.ratings = {};
        atheneumUser.id = undefined;
        atheneumUser.isLocked = false;
        atheneumUser.startupCollection = null;
        atheneumUser.kioskMode = false;
        atheneumUser.isPasswordChangeNeeded = false;
        atheneumUser.loggedInWithParams = false;
        atheneumUser.saveToStorage();
    }

    var successCallback = function (jsonResponse) {

        if (jsonResponse && jsonResponse.logout && jsonResponse.logout.type != "DEFAULT") {
            if (jsonResponse.logout.type == "OIDC") {
                var redirectUri = jsonResponse.logout.redirectUri;
                if (redirectUri.indexOf("?") >= 0)
                    redirectUri += "&openInApp=true";
                else
                    redirectUri += "?openInApp=true";

                window.location = redirectUri;
            } else if (jsonResponse.logout.type == "SAML") {
                if (jsonResponse.logout.redirectUri) {
                    var redirectUri = jsonResponse.logout.redirectUri;
                    if (redirectUri.indexOf("?") >= 0)
                        redirectUri += "&openInApp=true";
                    else
                        redirectUri += "?openInApp=true";

                    window.location = redirectUri;
                }else if (jsonResponse.logout.redirectUrl) {
                    var redirectUrl = jsonResponse.logout.redirectUrl;
                    if (redirectUrl.indexOf("?") >= 0)
                        redirectUrl += "&openInApp=true";
                    else
                        redirectUrl += "?openInApp=true";

                    window.location = redirectUrl;
                }else {
                   //TODO SAML request
                        var request = new XMLHttpRequest;
                        request.method = jsonResponse.logout.method.toLowerCase();
                        request.open(request.method, [jsonResponse.logout.url], true); //true is asynchronous

                        request.setRequestHeader("Content-type", jsonResponse.logout.contentType);
                    
                        var formBody = [];
                        for (var property in jsonResponse.logout.body) {
                            var encodedKey = encodeURIComponent(property);
                            var encodedValue = encodeURIComponent(jsonResponse.logout.body[property]);
                            formBody.push(encodedKey + "=" + encodedValue);
                        }
                        //formBody = formBody.join("&");

                        request.onreadystatechange = function() {
                            if (request.readyState == XMLHttpRequest.DONE) {
                                if (request.status >= 200 && request.status < 300) {
                                // Request was successful
                                var response = request.responseText;
                                // Check the response and decide whether to redirect
                                if (request.getResponseHeader('Location')) {
                                    // Handle the redirect
                                    window.location.href = request.getResponseHeader('Location');
                                } else {
                                    // Handle other responses as needed
                                    console.log(SalesToolkit.Translation.getOrGetThemeKey('logoutErrorSAMLRedirect302Error', 'Got a 302 redirect without Location header'));
                                }
                                } else if (request.status == 302) {
                                // Handle 302 redirect
                                if (request.getResponseHeader('Location')) {
                                    // Handle the redirect
                                    window.location.href = request.getResponseHeader('Location');
                                }else{
                                    console.log(SalesToolkit.Translation.getOrGetThemeKey('logoutErrorSAMLRedirect302Error', 'Got a 302 redirect without Location header'));
                                }
                                } else {
                                // Handle errors
                                if (xhr.status === 0 && xhr.responseURL !== "") {
                                    // If status is 0 and responseURL is not empty, it indicates a CORS issue and a possible redirection
                                    window.location.href = xhr.responseURL;
                                }else{
                                    console.log(SalesToolkit.Translation.getOrGetThemeKey('logoutErrorSAMLRedirectNoResponeURLError', 'Could not redirect to SAML login without a responseURL'));
                                }
                                }
                            }
                            };

                        request.onerror = function(){
                            console.log(SalesToolkit.Translation.getOrGetThemeKey('logoutErrorSAMLRedirectError', 'Could not redirect to SAML login'));
                        }

                        request.send(formBody); //send the post arguments here!
                }
            }

        }

        clearLoginData();

        if (typeof callback === "function")
            callback();
        else if (callback != undefined && typeof callback.success === "function")
            callback.success();

    };

    this.Atheneum.API.logout({

        success: successCallback,

        failure: function (reason, httpStatus, errorCode) {
            if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT) {

                if ([
                    Atheneum.API.ErrorCodes.API_ERROR_AUTH,
                    Atheneum.API.ErrorCodes.API_ERROR_AUTH_IP,
                    Atheneum.API.ErrorCodes.API_ERROR_AUTH_KEY,
                    Atheneum.API.ErrorCodes.ACCOUNT_ERROR,
                    Atheneum.API.ErrorCodes.ACCOUNT_INVALID_LOGIN
                ].indexOf(errorCode) != -1) {
                    return successCallback();
                }
            }

            clearLoginData();

            if (callback != undefined && typeof callback.failure === "function")
                callback.failure();
        }
    });
}

Atheneum.User.prototype.checkLoginStatus = function (uiCallbacks) {

    var atheneumUser = this;

    var successCallback = (typeof uiCallbacks == "function") ? uiCallbacks : ((uiCallbacks != undefined) ? uiCallbacks.success : undefined);
    var failureCallback = (typeof uiCallbacks == "object") ? uiCallbacks.failure : undefined;
    var offlineCallback = (typeof uiCallbacks == "object") ? uiCallbacks.offline : failureCallback;

    var callback = {

        success: function (json) {
            if (typeof successCallback === "function")
                successCallback(json);
        },

        failure: function (reason, httpStatus, errorCode) {

            if (httpStatus == 200 && (errorCode > 0)) {

                // TODO - figure out why this if statement exists

                if (!atheneumUser.isLocked) {
                    atheneumUser.username = undefined;
                    atheneumUser.id = undefined;
                    atheneumUser.isLocked = false;
                    atheneumUser.preferences = { language: atheneumUser.preferences.language };
                    console.log('Atheneum.User.checkLoginStatus - preferences changed');
                    console.log(atheneumUser.preferences);
                }

                atheneumUser.isLoggedIn = false;
                atheneumUser.apikey = "";
                atheneumUser.permissions = {
                    canFavourite: true,
                    canInvite: false,
                    canRate: false,
                    canShare: false,
                    canVend: false
                }
                atheneumUser.emailConfirmed = false;
                atheneumUser.logoUrl = "";
                atheneumUser.logoLastModified = 0;
                atheneumUser.groups = [];
                atheneumUser.ratings = {};
                atheneumUser.startupCollection = null;
                atheneumUser.kioskMode = false;

                atheneumUser.saveToStorage();
            }

            if (typeof failureCallback === "function")
                failureCallback();
        },

        offline: function (reason, httpStatus, errorCode) {
            if (typeof offlineCallback === "function")
                offlineCallback(reason, httpStatus, errorCode, "Atheneum.User.checkLoginStatus");
        }
    };

    if (this.apikey == undefined || this.apikey == "" && this.Atheneum.Pages && !this.Atheneum.Pages.CurrentPage.requiresLogin) {
        failureCallback(Atheneum.API.Problems.ERROR_CODE_PRESENT, 200, Atheneum.API.ErrorCodes.API_ERROR_AUTH, "Atheneum.User.checkLoginStatus");
        return null;
    }

    return this.Atheneum.API.checkUserLoginStatus(callback);
}

Atheneum.User.prototype.verifyPassword = function (password, callbacksOrSuccessCallback, failureCallback) {

    var callbacks = Atheneum.Callbacks.parse(callbacksOrSuccessCallback, failureCallback);
    var atheneumUser = this;

    var apiCallback = {

        success: callbacks.success,

        failure: function (reason, httpStatus, errorCode) {

            var savedHash = atheneum.LocalStorage.get('atheneumHashedPasswordForUser_' + atheneumUser.username);

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode) && savedHash) {

                if (savedHash == atheneum.Crypto.hash(password, atheneumUser.User.username)) {

                    return callbacks.success({ errorCode: 0 });

                } else {

                    // pretend that the api call worked, and resulted in an incorrect password response
                    reason = Atheneum.API.Problems.ERROR_CODE_PRESENT;
                    httpStatus = 200;
                    errorCode = Atheneum.API.ErrorCodes.API_ERROR_AUTH;
                }
            }

            callbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.verifyPassword");
        }
    }

    this.Atheneum.API.verifyUserPassword(password, callbacks);
}

Atheneum.User.prototype.getAssetRatingNumber = function(assetId) {
	if(assetId == null || this.ratings == null || this.ratings[assetId] == null) { 
		return null;
	}
	var rating = this.ratings[assetId];
	
	var numericRating = null;
	if(typeof rating == 'object') {
		numericRating = rating.rating;
	}
	else {
		numericRating = rating;
	}
	
	return parseInt(numericRating);
}

Atheneum.User.prototype.getAssetRatingComment = function(assetId) {
	if(assetId == null || this.ratings == null || this.ratings[assetId] == null) { 
		return null;
	}
	var rating = this.ratings[assetId];
	
	var comment = null;
	if(typeof rating == 'object') {
		comment = rating.comment;
	}
	
	return comment;
}

Atheneum.User.prototype.changePasswordViaPreferences = function (oldPassword, newPassword, callbacksOrSuccessCallback, failureCallback) {

    var callbacks = Atheneum.Callbacks.parse(callbacksOrSuccessCallback, failureCallback);

    var atheneum = this.Atheneum;
    var pw = newPassword;

    var oldSuccessCallback = callbacks.success || function () { };
    callbacks.success = function (response) {
        atheneum.User.isPasswordChangeNeeded = false;
        if(response.apikey)
            atheneum.User.apikey = response.apikey;

        atheneum.User.saveToStorage();
        oldSuccessCallback(response);
    }

    this.verifyPassword(oldPassword, {

        success: function (json) {
            // they can only change their password while online
            // otherwise they'd end up needing to login with their old password
            atheneum.API.setUserPreferences({ password: pw, passwordConf: pw }, callbacks);
        },

        failure: function (reason, httpStatus, errorCode) {
            if (typeof callbacks === "object" && typeof callbacks.failure === "function")
                callbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.changePassword");
        }
    });
}

Atheneum.User.prototype.changePassword = function (oldPassword, newPassword, callbacksOrSuccessCallback, failureCallback, ignoreVerifyOld = false) {

    var callbacks = Atheneum.Callbacks.parse(callbacksOrSuccessCallback, failureCallback);

    var atheneum = this.Atheneum;
    var pw = newPassword;

    var oldSuccessCallback = callbacks.success || function () { };
    callbacks.success = function (response) {
        atheneum.User.isPasswordChangeNeeded = false;
        if(response.apikey)
            atheneum.User.apikey = response.apikey;
        atheneum.User.saveToStorage();
        oldSuccessCallback(response);
    }

    if(ignoreVerifyOld){
        atheneum.API.setUserPreferences({ password: pw, passwordConf: pw }, callbacks);
        return;
    }

    this.verifyPassword(oldPassword, {

        success: function (json) {
            // they can only change their password while online
            // otherwise they'd end up needing to login with their old password
            atheneum.API.setUserPreferences({ password: pw, passwordConf: pw }, callbacks);
        },

        failure: function (reason, httpStatus, errorCode) {
            if (typeof callbacks === "object" && typeof callbacks.failure === "function")
                callbacks.failure(reason, httpStatus, errorCode, "Atheneum.User.changePassword");
        }
    });
}

Atheneum.User.prototype.checkEmailConfirmed = function (uiCallbacks) {

    // TODO: actually do something
    console.log("Atheneum.User.prototype.checkEmailConfirmed is incomplete");
}

Atheneum.User.prototype.changePreferences = function (preferences, callbacks) {

    var atheneumUser = this;

    var hash = null;

    if (preferences && preferences.password) {
        hash = this.Atheneum.Crypto.hash(password, this.username);
    }

    var successCallback = function (json) {

        if(json.apikey)
            atheneumUser.apikey = json.apikey;
        
        if (hash) {
            // password was successfully changed
            atheneum.LocalStorage.set('atheneumHashedPasswordForUser_' + atheneumUser.username, hash);
        }

        atheneumUser.Atheneum.API.getUserPreferences({
            success: function (json) {
                atheneumUser.preferences = json.preferences || {};
                //TODO PREF MODIFIED -  atheneumUser.preferences.modified = json.modified || new Date().getTime();
                var previousData = atheneumUser.Atheneum.LocalStorage.getJSON('atheneumOfflineUserDataForUser_' + atheneumUser.username);

                previousData.preferences = atheneumUser.preferences;
                atheneumUser.Atheneum.LocalStorage.set('atheneumOfflineUserDataForUser_' + atheneumUser.username, JSON.stringify(previousData));

                if (callbacks && typeof callbacks.success == "function")
                    callbacks.success(json);
                else if (typeof callbacks == "function")
                    callbacks(json);
            },
            failure: function (reason, httpStatus, errorCode) {
                // not sure what went wrong here, and don't really care
                // we know the previous call succeeded, so the user's preferences must have been updated properly
                // requesting the new data from the server was just a formality really

                // create copy of preferences, and update atomically
                var newPreferences = {};
                for (var pref in atheneumUser.preferences) {
                    if (atheneumUser.preferences.hasOwnProperty(pref)) {
                        newPreferences[pref] = atheneumUser.preferences[pref];
                    }
                }
                for (var pref in preferences) {
                    if (preferences.hasOwnProperty(pref) && pref != "profileImg" && pref != "password") {
                        newPreferences[pref] = preferences[pref];
                    }
                }

                //TODO PREF MODIFIED - newPreferences.modified = new Date().getTime();
                atheneumUser.preferences = newPreferences; // atomic update
                atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));
                console.log('Atheneum.User.changePreferences - preferences changed (after)');
                console.log(atheneumUser.preferences);

                if (callbacks && typeof callbacks.success == "function")
                    callbacks.success(json);
                else if (typeof callbacks == "function")
                    callbacks(json);
            }
        });
    }

    var failureCallback = function (reason, httpStatus, errorCode) {
        var isOffline = Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);

        if (hash && isOffline) {
            // can't change password while offline
            console.log("attempted password change while offline");

        } else if (isOffline && !preferences.syncAction) {
            // TODO: cache offline profile changes
            var action = {};
            action.name = "profile";
            action.timestamp = new Date().getTime();
            action.preferences = JSON.stringify(preferences);
            atheneumUser.Atheneum.Offline.recordUnsynchedAction(action);

            // create copy of preferences, and update atomically
            var newPreferences = {};
            for (var pref in atheneumUser.preferences) {
                if (atheneumUser.preferences.hasOwnProperty(pref)) {
                    newPreferences[pref] = atheneumUser.preferences[pref];
                }
            }
            for (var pref in preferences) {
                if (preferences.hasOwnProperty(pref) && pref != "profileImg" && pref != "password") {
                    newPreferences[pref] = preferences[pref];
                }
            }

            //TODO PREF MODIFIED - newPreferences.modified = new Date().getTime();

            atheneumUser.preferences = newPreferences; // atomic update
            atheneumUser.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumUser.preferences));
            console.log('Atheneum.User.changePreferences - preferences changed (after)');
            console.log(atheneumUser.preferences);

            var previousData = atheneumUser.Atheneum.LocalStorage.getJSON('atheneumOfflineUserDataForUser_' + atheneumUser.username);

            previousData.preferences = atheneumUser.preferences;
            atheneumUser.Atheneum.LocalStorage.set('atheneumOfflineUserDataForUser_' + atheneumUser.username, JSON.stringify(previousData));


            if (preferences.profileImg && atheneumUser.Atheneum.CrossPlatform.enabled) {
                atheneumUser.Atheneum.CrossPlatform.forceUpdateProfilePicPromise(preferences.profileImg).then(function () {
                    if (callbacks && typeof callbacks.success == "function")
                        callbacks.success(atheneumUser.preferences);
                    else if (typeof callbacks == "function")
                        callbacks(atheneumUser.preferences);
                });
            } else {
                if (callbacks && typeof callbacks.success == "function")
                    callbacks.success(atheneumUser.preferences);
                else if (typeof callbacks == "function")
                    callbacks(atheneumUser.preferences);
            }
        } else if (typeof callbacks === "object" && typeof callbacks.failure === "function") {
            callbacks.failure(reason, httpStatus, errorCode);
        }


    }

    if (this.Atheneum.CrossPlatform.enabled && !this.Atheneum.CrossPlatform.isOnline()) {
        failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, 408);
        return;
    }

    return this.Atheneum.API.setUserPreferences(preferences, { success: successCallback, failure: failureCallback });
}

Atheneum.User.prototype.rateAsset = function (assetId, rating, comment, callbacks) {
    if (callbacks == undefined && typeof comment !== "string") {
        callbacks = comment;
        comment = undefined;
    }

    var collectionId = (this.Atheneum.Library.assets[assetId] || {}).containedBy;

    return this.Atheneum.API.rateAsset(collectionId, assetId, rating, comment, callbacks);
}

Atheneum.User.prototype.canSee = function AtheneumUser_canSee(object) {

    if (typeof object !== "object" && typeof object !== "undefined")
        throw new IllegalArgumentxception("expected an object, got " + (typeof object));

    if (object == null)  // we can see it if it's nothing
        return true;

    if (object.hidden) // hidden assets / collections cannot be seen
        return false;

    if (object.visible != undefined && object.visible == false)
        return false;

    const now = new Date();

    // Check if visibleFromUtc exists and if the current time is *before* it
    if (object.visibleFromUtc) {
        const fromDate = new Date(object.visibleFromUtc);
        if (now < fromDate) {
            return false; // Not visible yet
        }
    }

    // Check if visibleToUtc exists and if the current time is *after* it
    if (object.visibleToUtc) {
        const toDate = new Date(object.visibleToUtc);
        if (now > toDate) {
            return false; // No longer visible
        }
    }

    if (this.Atheneum.Library.collections[object.id]) {  // sometimes collections don't cache properly

        // otherwise: recursively check its subcollections, assets and forms to figure out if it's meant to be visible

        // check if we can see any of its assets
        if (object.assets) {
            for (var a = 0; a < object.assets.length; a++) {
                if (this.canSee(object.assets[a])) {
                    return true;
                }
            }
        }

        // see if there's a form in the collection that we can see
        var collectionForms = this.Atheneum.Forms.getFormsAssociatedWithCollection(object);
        for (var f = 0; f < collectionForms.length; f++) {
            if (this.canSee(collectionForms[f])) {
                return true;
            }
        }

        // recursively check its subcollections
        if(object.stories){
            for (var s = 0; s < object.stories.length; s++) {
                if (this.canSee(object.stories[s])) {
                    return true;
                }
            }
        }
       

        // collection is empty of items that we can see, ergo we shouldn't see the collection
        return false;
    }

    if (object.allowedGroups) {
        for (var g = 0; g < object.allowedGroups.length; g++) {
            if (this.groups.contains(object.allowedGroups[g])) {
                return true;
            }
        }
    }
    else {
        return true;
    }

    return false;
}

/**
 * The user's filters for document / collection searching
 * @param {*} atheneum 
 */
Atheneum.Filters = function (atheneum) {
    if (!(this instanceof Atheneum.Filters))
        return new Atheneum.Filters(atheneum);

    this.Atheneum = atheneum;
    this.timestamp = 0;

    //Maps filters to current baseURL 
    this.filters = {};
    this.searchTerms = [];
    this.activeFilters = {};
    this.loadFromStorage();
   
}

Atheneum.Filters.prototype.getSearchTerms = function () {
    let basicSearchTerms = SalesToolkit.Theme.getStringProperty('basicSearchTerms', 'description,keywords,mimetype,name,views');
    basicSearchTerms = basicSearchTerms.split(',');
    return this.searchTerms.concat(basicSearchTerms.filter((item) => this.searchTerms.indexOf(item) < 0)).sort();
}

Atheneum.Filters.prototype.loadFromStorage = function () {
    let userName = this.Atheneum.User.username || ''; 
    this.filters = JSON.parse(this.Atheneum.LocalStorage.get("atheneumFilters"  + userName) || "{}") || {};
    this.specialTerms = JSON.parse(this.Atheneum.LocalStorage.get("atheneumSpecialTerms" + userName) || "{}") || {};
    this.timestamp = this.Atheneum.LocalStorage.get("atheneumFiltersTimestamp" + userName) || 0;

    if (!this.filters || typeof this.filters[this.Atheneum.API.BASE_URL] === 'undefined')
        this.searchTerms = [];
    else
        this.searchTerms = Array.from(this.filters[this.Atheneum.API.BASE_URL], x => x.name);

        try{
            this.activeFilters = JSON.parse(this.Atheneum.LocalStorage.get("atheneumActiveFilters"+userName) || {});
        }catch(err){
            this.activeFilters = {};
        }
   
}

Atheneum.Filters.prototype.saveToStorage = function () {

    let userName = this.Atheneum.User.username || ''; 
    this.Atheneum.LocalStorage.set("atheneumFilters" + userName, JSON.stringify(this.filters || {}));
    this.Atheneum.LocalStorage.set("atheneumSpecialTerms" + userName, JSON.stringify(this.specialTerms || {}));
    this.Atheneum.LocalStorage.set("atheneumActiveFilters" + userName, JSON.stringify(this.activeFilters || {}));
    this.Atheneum.LocalStorage.set("atheneumFiltersTimestamp" + userName, this.timestamp);
}

Atheneum.Filters.prototype.getFilters = function () {
    return this.filters[this.Atheneum.API.BASE_URL] || {};
}

Atheneum.Filters.prototype.update = function (callback) {
    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;

    var atheneumFilters = this;

    
    // don't use the timestamp because it just returns an array of ids
    return this.Atheneum.API.getFilters(atheneumFilters.timestamp, {

        success: function (json) {

           
            atheneumFilters.timestamp = json.filtersTimestamp; // save it anyway

            let current = atheneumFilters.filters[atheneumFilters.Atheneum.API.BASE_URL] || [];
        
            let i;
            for(i=0; i< json.filters.length; i++){
                let filter = json.filters[i];
                current = current.filter(x=> x.name != filter.name);
                current.push(filter);
            }

            current.sort((a,b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0));

            if(json.hasOwnProperty('deleted')){
                for(i=0; i<json.deleted; i++){
                    current = current.filter(x=> x.name != filter.name);
                }
            }
    

            atheneumFilters.filters[atheneumFilters.Atheneum.API.BASE_URL] = current;
            if (!atheneumFilters.filters || typeof atheneumFilters.filters[atheneumFilters.Atheneum.API.BASE_URL] === 'undefined')
                atheneumFilters.searchTerms = [];
            else
                atheneumFilters.searchTerms = Array.from(atheneumFilters.filters[atheneumFilters.Atheneum.API.BASE_URL], x => x.name);
            //for(var i=0; i < )

            atheneumFilters.saveToStorage();

            if (successCallback != undefined)
                successCallback(json);
        },

        failure: failureCallback
    });
}

/** The user's favourites */
Atheneum.Favourites = function (atheneum) {

    if (!(this instanceof Atheneum.Favourites))
        return new Atheneum.Favourites(atheneum);

    this.Atheneum = atheneum;


    this.timestamp = undefined;

    this.__realAssetIds = [];
    this.__realCollectionIds = [];

    this.assetIds = [];
    this.collectionIds = [];

    this.__pendingChanges = {};

    this.loadFromStorage();

    this.applyOfflineChanges(true);
}

Atheneum.Favourites.prototype.loadFromStorage = function () {

    // real assetIds
    this.__realAssetIds = JSON.parse(
        this.Atheneum.LocalStorage.get("atheneumFavouriteAssetsForUser_" + this.Atheneum.User.username) || "[]") || [];

    this.__realCollectionIds = JSON.parse(
        this.Atheneum.LocalStorage.get("atheneumFavouriteCollectionsForUser_" + this.Atheneum.User.username) || "[]") || [];


    this.__pendingChanges = JSON.parse(
        this.Atheneum.LocalStorage.get("atheneumFavouriteChangesPendingForUser_" + this.Atheneum.User.username) || "{}") || {};

    this.applyOfflineChanges(false);
}

/**
 * Applies the pending changes to the hidden real favourites, creating the
 * If actually set
 */
Atheneum.Favourites.prototype.applyOfflineChanges = function (updateServer) {

    updateServer = !!updateServer;

    this.assetIds = [];
    for (var i = 0; i < this.__realAssetIds.length; i++) {
        this.assetIds[i] = this.__realAssetIds[i];
    }

    this.collectionIds = [];
    for (var i = 0; i < this.__realCollectionIds.length; i++) {
        this.collectionIds[i] = this.__realCollectionIds[i];
    }

    var atheneumFavourites = this;
    var pendingChangeActions = [];
    var pendingChangeIds = [];

    // remove assets which have been deleted, or are no longer visible to the user

    for (var i = 0; i < this.assetIds.length; i++) {

        if (this.Atheneum.Library.assets[this.assetIds[i]] == undefined) {
            this.assetIds.splice(i, 1);
            i = i - 1;
            continue;
        }

        if (!this.Atheneum.User.canSee(this.Atheneum.Library.assets[this.assetIds[i]])) {
            this.assetIds.splice(i, 1);
            i = i - 1;
        }
    }

    for (var i = 0; i < this.collectionIds.length; i++) {

        if (this.Atheneum.Library.collections[this.collectionIds[i]] == undefined) {
            this.collectionIds.splice(i, 1);
            i = i - 1;
            continue;
        }

        if (!this.Atheneum.User.canSee(this.Atheneum.Library.collections[this.collectionIds[i]])) {
            this.collectionIds.splice(i, 1);
            i = i - 1;
        }
    }


    for (var id in this.__pendingChanges) {
        if (this.__pendingChanges.hasOwnProperty(id)) {
            var action = this.__pendingChanges[id];

            if (action == "addAsset") {

                if (!this.assetIds.contains(id))
                    this.assetIds[this.assetIds.length] = id;

                if (updateServer) {
                    this.addAsset(id);
                }
            }

            if (action == "removeAsset") {

                if (this.assetIds.contains(id))
                    this.assetIds.splice(this.assetIds.indexOf(id), 1);

                if (updateServer && id) {
                    this.removeAsset(id);
                }
            }

            if (action == "addCollection") {

                if (!this.collectionIds.contains(id))
                    this.collectionIds[this.collectionIds.length] = id;

                if (updateServer) {
                    //this.addCollection( id );
                }
            }


            if (action == "removeCollection") {

                if (this.collectionIds.contains(id))
                    this.collectionIds.splice(this.collectionIds.indexOf(id), 1);

                if (updateServer) {
                    //this.removeCollection( id );
                }
            }
        }
    }
}

Atheneum.Favourites.prototype.saveToStorage = function () {

    if (this.Atheneum.User.username == undefined)
        return;

    this.Atheneum.LocalStorage.set("atheneumFavouriteAssetsForUser_" + this.Atheneum.User.username,
        JSON.stringify(this.__realAssetIds || []));

    this.Atheneum.LocalStorage.set("atheneumFavouriteCollectionsForUser_" + this.Atheneum.User.username,
        JSON.stringify(this.__realCollectionIds || []));

    this.Atheneum.LocalStorage.set("atheneumFavouriteChangesPendingForUser_" + this.Atheneum.User.username,
        JSON.stringify(this.__pendingChanges || {}));
}

Atheneum.Favourites.prototype.update = function (callback) {

    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;

    var atheneumFavourites = this;

    // don't use the timestamp because it just returns an array of ids
    return this.Atheneum.API.getFavourites({

        success: function (json) {

            atheneumFavourites.timestamp = json.favouritesTimestamp; // save it anyway

            atheneumFavourites.__realCollectionIds = json.stories || [];
            atheneumFavourites.__realAssetIds = json.assets || [];
            atheneumFavourites.applyOfflineChanges(false);
            atheneumFavourites.saveToStorage();

            if (successCallback != undefined)
                successCallback(json);
        },

        failure: failureCallback
    });
}

Atheneum.Favourites.prototype.containsAsset = function (assetId) {
    return this.assetIds.contains(assetId);
}
Atheneum.Favourites.prototype.containsCollection = function (collectionId) {
    return this.collectionIds.contains(collectionId);
}

/**
 * Favourites.addAsset( assetId, callback )
 * Favourites.addAsset( collectionId, assetId, callbacks )
 * Favourites.addAsset( collectionId, assetId, successCallback )
 * Favourites.addAsset( collectionId, assetId, successCallback, failureCallback )
 *
 * you can save a little bit of calculation by passing the collectionId
 */
Atheneum.Favourites.prototype.addAsset = function (collectionId, assetId, callback, fc) {

    if (callback == undefined && typeof collectionId === "string" && typeof assetId !== "string") {
        // infer collectionId from Library
        callback = assetId;
        assetId = collectionId;
        var asset = this.Atheneum.Library.assets[assetId];
        collectionId = (asset == undefined) ? undefined : asset.containedBy;
    }

    var parsedCallbacks = Atheneum.Callbacks.parse(callback, fc);
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;

    var atheneumFavourites = this;

    var safeAssetId = assetId;

    if (typeof (trackAppClickForEntity) == 'function' && atheneumFavourites && atheneumFavourites.Atheneum.Translation)
        trackAppClickForEntity($('[data-atheneum-item-id="' + assetId + '"'), '[data-atheneum-item-id="' + assetId + '"', 'trackingAddToFavourites', atheneumFavourites.Atheneum.Translation.get('trackingAddToFavourites', 'trackingAddToFavourites'), assetId);


    if (this.Atheneum.CrossPlatform.enabled && !this.Atheneum.CrossPlatform.isOnline()) {
        atheneumFavourites.__pendingChanges[safeAssetId] = "addAsset";
        atheneumFavourites.applyOfflineChanges(false);
        atheneumFavourites.saveToStorage();

        failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, Atheneum.API.Problems.HTTP_STATUS_ERROR, -1);
        return;
    }

    this.Atheneum.API.addAssetToFavourites(collectionId, assetId, {
        success: function (json) {

            delete atheneumFavourites.__pendingChanges[safeAssetId];

            if (!atheneumFavourites.__realAssetIds.contains(safeAssetId))
                atheneumFavourites.__realAssetIds[atheneumFavourites.__realAssetIds.length] = safeAssetId;

            atheneumFavourites.applyOfflineChanges(false);
            atheneumFavourites.saveToStorage();

            if (typeof successCallback === "function")
                successCallback(json);
        },
        failure: function (reason, httpStatus, errorCode) {

            if (reason == Atheneum.API.Problems.CONNECTION_FAILED
                || (reason == Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {
                // we're in offline mode, save it as a pending change
                atheneumFavourites.__pendingChanges[safeAssetId] = "addAsset";
                atheneumFavourites.applyOfflineChanges(false);
                atheneumFavourites.saveToStorage();
            }

            failureCallback(reason, httpStatus, errorCode);
        }
    })
}

Atheneum.Favourites.prototype.removeAsset = function (collectionId, assetId, callback, fc) {

    if (callback == undefined && typeof collectionId === "string" && typeof assetId !== "string") {
        // infer collectionId from Library
        callback = assetId;
        assetId = collectionId;
        var asset = this.Atheneum.Library.assets[assetId];
        collectionId = (asset == undefined) ? undefined : asset.containedBy;
    }

    var parsedCallbacks = Atheneum.Callbacks.parse(callback, fc);
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;

    var atheneumFavourites = this;

    var safeAssetId = assetId;

    if (typeof (trackAppClickForEntity) == 'function' && atheneumFavourites && atheneumFavourites.Atheneum.Translation)
        trackAppClickForEntity($('[data-atheneum-item-id="' + assetId + '"'), '[data-atheneum-item-id="' + assetId + '"', 'trackingRemoveFromFavourites', atheneumFavourites.Atheneum.Translation.get('trackingRemoveFromFavourites', 'trackingRemoveFromFavourites'), assetId);

    try {
        if (atheneumFavourites.Atheneum.Library.assets[safeAssetId] == undefined || !atheneumFavourites.Atheneum.User.canSee(atheneumFavourites.Atheneum.Library.assets[safeAssetId])) {
            delete atheneumFavourites.__pendingChanges[safeAssetId];

            while (atheneumFavourites.__realAssetIds.contains(safeAssetId))
                atheneumFavourites.__realAssetIds.splice(atheneumFavourites.__realAssetIds.indexOf(safeAssetId), 1);

            atheneumFavourites.applyOfflineChanges(false);
            atheneumFavourites.saveToStorage();

            if (typeof successCallback === "function")
                successCallback(json);

            return;
        }
    } catch (err) {

    }


    if (this.Atheneum.CrossPlatform.enabled && !this.Atheneum.CrossPlatform.isOnline()) {
        atheneumFavourites.__pendingChanges[safeAssetId] = "removeAsset";
        atheneumFavourites.applyOfflineChanges(false);
        atheneumFavourites.saveToStorage();

        failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, Atheneum.API.Problems.HTTP_STATUS_ERROR, -1);
        return;
    }

    this.Atheneum.API.removeAssetFromFavourites(collectionId, assetId, {
        success: function (json) {

            delete atheneumFavourites.__pendingChanges[safeAssetId];

            while (atheneumFavourites.__realAssetIds.contains(safeAssetId))
                atheneumFavourites.__realAssetIds.splice(atheneumFavourites.__realAssetIds.indexOf(safeAssetId), 1);

            atheneumFavourites.applyOfflineChanges(false);
            atheneumFavourites.saveToStorage();

            if (typeof successCallback === "function")
                successCallback(json);
        },
        failure: function (reason, httpStatus, errorCode) {

            if (reason == Atheneum.API.Problems.CONNECTION_FAILED
                || (reason == Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {
                // we're in offline mode, save it as a pending change
                atheneumFavourites.__pendingChanges[safeAssetId] = "removeAsset";
                atheneumFavourites.applyOfflineChanges(false);
                atheneumFavourites.saveToStorage();
            }

            failureCallback(reason, httpStatus, errorCode);
        }
    })
}

/** The user's cart */
Atheneum.Cart = function (atheneum) {

    if (!(this instanceof Atheneum.Cart))
        return new Atheneum.Cart(atheneum);

    this.Atheneum = atheneum;

    this.assetIds = [];
    this.collectionIds = [];
    this.carts = [];
    this.loadedCartId = null;

    //TODO load carts from servers
    this.loadFromStorage();
}

Atheneum.Cart.prototype.getMyCartByName = function(cartName){
    return this.carts.find(x=> x.name === cartName &&  x.myCart === true);
}

Atheneum.Cart.prototype.getCarts = function(callback){
    let aThis = this;
    if(!this.Atheneum.User.permissions.canSaveCarts && !this.Atheneum.User.permissions.canViewCarts)
    {
        if(typeof callback === 'function')
            callback(true);
        return;
    }

    this.Atheneum.API.getCarts({  
        success: function (json) {
            let loadedCart = aThis.getLoadedCart();
            let index = -1;
           
            aThis.carts = json.items;

            if(loadedCart){
                index = aThis.carts.findIndex(x=> x.id === loadedCart.id);
            }

            if(index >= 0)
                aThis.carts[index] = loadedCart;
            
            if (json.deletedItems != undefined) {
               
                for (let i = 0; i < json.deletedItems.length; i++) {
                    let deletedId = json.deletedItems[i];
                    aThis.deleteLocalCart(deletedId);
                }
            }

            aThis.saveToStorage();

            if(typeof callback === 'function')
                callback(true);
        },
        failure: function (reason, httpStatus, errorCode) {
            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                if(typeof callback === 'function')
                callback(false, aThis.Atheneum.Translation.get('saveCartErrorOffline', 'Cart saving currently only available online. Please check your connection and try again.'));
            }else{
                if(typeof callback === 'function')
                    callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
            }
        }});
}

Atheneum.Cart.prototype.saveCart = function(cartName, rewrite = false, recipients = undefined, note = undefined, callback = undefined, formData = undefined, useShareLink = false){
    if(!this.Atheneum.User.permissions.canSaveCarts)
    {
        if(cartName === this.Atheneum.Translation.get('currentCart', 'Current Cart')){
            if(typeof this.currentCart === 'undefined'){
                this.currentCart = {};
                this.currentCart.name = this.Atheneum.Translation.get('currentCart', 'Current Cart');
            }
            this.currentCart.assetIds = this.assetIds;
            this.currentCart.collectionIds = this.collectionIds;
            this.currentCart.loaded = true;
    
            document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_REFRESHED));
    
            this.saveToStorage();
            if(typeof callback === 'function')
                callback(true);
    
            return;
        }else{
            this.saveToStorage();
            if(typeof callback === 'function')
                callback(true);
        }

        
        return;
    }

    if(typeof cartName !== "string" || cartName.trim() === ""){
        if(typeof callback === 'function')
            callback(false, this.Atheneum.Translation.get('saveCartErrorNoName', 'Please provide a name to save this cart. Names must be unique'));
        return;
    }

    let index = this.carts.findIndex(x=> x.name === cartName && x.myCart === true);
   
    let loadedCart = this.getLoadedCart();
    if(loadedCart?.name === cartName)
        rewrite = true;

    if(cartName === this.Atheneum.Translation.get('currentCart', 'Current Cart')){
        if(typeof this.currentCart === 'undefined'){
            this.currentCart = {};
            this.currentCart.name = this.Atheneum.Translation.get('currentCart', 'Current Cart');
        }
        this.currentCart.assetIds = this.assetIds;
        this.currentCart.collectionIds = this.collectionIds;
        this.currentCart.loaded = true;

        document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_REFRESHED));

        this.saveToStorage();
        if(typeof callback === 'function')
            callback(true);

        return;
    }

    if(!rewrite && index >= 0){
        if(typeof callback === 'function')
            callback(false, this.Atheneum.Translation.get('saveCartErrorNoNameUnique', 'Cart name already exists'), true);
        return;
    }

    let cart = {};
    if(index >= 0){
        cart = this.carts[index];
    }

    cart.name = cartName;
   
    let collectionSet = {};
    for (let i = 0; i < this.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.assetIds[i]];
        if (collectionSet[asset.containedBy] != "all") {

            if (collectionSet[asset.containedBy] == undefined)
                collectionSet[asset.containedBy] = [];

            collectionSet[asset.containedBy][collectionSet[asset.containedBy].length] = asset.id;
        }
    }

    let innerCart = [];
    for (let collectionId in collectionSet) {
        if (!collectionSet.hasOwnProperty(collectionId))
            continue;

        if (collectionSet[collectionId] == "all") {
            innerCart[innerCart.length] = { storyId: collectionId, assetIds: null };
        } else {
            innerCart[innerCart.length] = { storyId: collectionId, assetIds: collectionSet[collectionId] };
        }
    }

    cart.cart = innerCart;

    this.assetIds = [];
    this.collectionIds = [];
    //this.currentCart.assetIds = [];
    //this.currentCart.collectionIds = [];

    let aThis = this;

    if(cart.hasOwnProperty('id')){
        this.Atheneum.API.updateCart(cart.id, cart.cart, cart.name, recipients, note, {  
            success: function (json) {
                let cart = json;
                if(index >= 0){
                    aThis.carts[index] = cart;
                }else{
                    aThis.carts.push(cart);
                }
              
                aThis.saveToStorage();
                aThis.loadCart(cart.id);

                if(typeof callback === 'function')
                    callback(true, json);
            },
            failure: function (reason, httpStatus, errorCode) {
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    
                    // aThis.Atheneum.Offline.recordUnsynchedAction({
                    //     name: "updateCart",
                    //     data: data
                    // });
        
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('saveCartErrorOffline', 'Cart saving currently only available online. Please check your connection and try again.'));
                }else{
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
                }
            }}, formData, useShareLink);
    }else{
        this.Atheneum.API.saveCart(cart.cart, cart.name, recipients, note, {  
            success: function (json) {
                let cart = json;
                if(index >= 0){
                    aThis.carts[index] = cart;
                }else{
                    aThis.carts.push(cart);
                }
              
                aThis.saveToStorage();
    
                aThis.loadCart(cart.id);
                
                if(typeof callback === 'function')
                    callback(true, json);
            },
            failure: function (reason, httpStatus, errorCode) {
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    if(typeof callback === 'function')
                    callback(false, aThis.Atheneum.Translation.get('saveCartErrorOffline', 'Cart saving currently only available online. Please check your connection and try again.'));
                }else{
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
                }
            }}, formData, useShareLink);
    }
}

Atheneum.Cart.prototype.shareSavedCart = function(cartId, emails, note, callback, formData, useShareLink = false){
    if(!cartId || cartId === 'undefined'){
         if(typeof callback === 'function')
            callback(false, this.Atheneum.Translation.get('shareSavedCartErrorCurrent', 'Current cart can\'t be shared. Please save the cart and share the saved cart instead'));
        return;
    }

    let index = this.carts.findIndex(x=> x.id === cartId)
   
    if(index >= 0){
        let aThis = this;
        this.Atheneum.API.shareSavedCart(cartId, emails, note, {  
            success: function (json) {
                if(typeof callback === 'function')
                    callback(true, json);
            },
            failure: function (reason, httpStatus, errorCode) {
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('shareSavedCartErrorOffline', 'Cart sharing currently only available online. Please check your connection and try again.'));
                }else{
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
                }
           }}, formData, useShareLink);
    
    }else{
        callback(false, this.Atheneum.Translation.get('shareSavedCartErrorNocart', 'Cart sharing failed as the cart could not be found.'))
    }
}

Atheneum.Cart.prototype.shareSavedCartAnonymousLink = function(cartId, callback){
    if(!cartId || cartId === 'undefined'){
         if(typeof callback === 'function')
            callback(false, this.Atheneum.Translation.get('shareSavedCartErrorCurrent', 'Current cart can\'t be shared. Please save the cart and share the saved cart instead'));
        return;
    }

    let index = this.carts.findIndex(x=> x.id === cartId)
   
    if(index >= 0){
        let aThis = this;
        this.Atheneum.API.shareSavedCartAnonymousLink(cartId, {  
            success: function (json) {
                if(typeof callback === 'function')
                    callback(true, json);
            },
            failure: function (reason, httpStatus, errorCode) {
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('shareSavedCartErrorOffline', 'Cart sharing currently only available online. Please check your connection and try again.'));
                }else{
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
                }
           }}
        );
    
    }else{
        callback(false, this.Atheneum.Translation.get('shareSavedCartErrorNocart', 'Cart sharing failed as the cart could not be found.'))
    }
}

Atheneum.Cart.prototype.deleteLocalCart = function(cartId){
   
    if(!cartId || cartId === 'undefined'){
        return;
    }

    try{
        let index = this.carts.findIndex(x=> x.id === cartId)
   
        if(index >= 0){
            aThis.carts.splice(index, 1);
        }
    }catch(err){
        console.log(err);
    }
    
}

Atheneum.Cart.prototype.deleteCart = function(cartId, callback){
   
    if(!cartId || cartId === 'undefined'){
        if(typeof this.currentCart === 'undefined'){
            this.currentCart = {};
            this.currentCart.name = this.Atheneum.Translation.get('currentCart', 'Current Cart');
        }
        this.currentCart.assetIds = [];
        this.currentCart.collectionIds = [];
      
        this.loadCart(this.loadedCartId);
        this.saveToStorage();
        if(typeof callback === 'function')
            callback(true);

        return;
    }

    let index = this.carts.findIndex(x=> x.id === cartId)
   
    if(index >= 0){
        
        let aThis = this;
        this.Atheneum.API.deleteCart(cartId, {  
            success: function (json) {
                aThis.carts.splice(index, 1);
                aThis.loadCart(this.loadedCartId);
                aThis.saveToStorage();
                if(typeof callback === 'function')
                    callback(true);
       
            },
            failure: function (reason, httpStatus, errorCode) {
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    if(typeof callback === 'function')
                    callback(false, aThis.Atheneum.Translation.get('deleteCartErrorOffline', 'Cart deletion currently only available online. Please check your connection and try again.'));
                }else{
                    if(typeof callback === 'function')
                        callback(false, aThis.Atheneum.Translation.get('error0' + errorCode?.toString(16), aThis.Atheneum.API.ErrorCodes.getName(errorCode || httpStatus)));
                }
            }});
    
    }else{
        callback(false, this.Atheneum.Translation.get('deleteCartErrorNocart', 'Cart deletion failed as the cart could not be found.'))
    }
}

Atheneum.Cart.prototype.loadCart = function (cartId){
    if(!cartId || cartId === 'undefined'){
        this.assetIds = this.currentCart.assetIds;
        this.collectionIds = this.currentCart.collectionIds;
        this.currentCart.loaded = true;
        this.loadedCartId = null;
        document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_REFRESHED));

         document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_NEEDS_LOADING));

            this.saveToStorage();
        return true;
    }

    let cart = this.carts.find(x=> x.id === cartId);
    if(typeof cart === 'undefined')
   {
    this.assetIds = this.currentCart.assetIds;
        this.collectionIds = this.currentCart.collectionIds;
        this.currentCart.loaded = true;
        this.loadedCartId = null;
        document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_REFRESHED));

       
         document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_NEEDS_LOADING));

            this.saveToStorage();
        return true;
   }
    let assetIds = [];
    for (let i = 0; i < cart.cart.length; i++) {
        let cartItems = cart.cart[i];
        if(cartItems.assetIds === 'all'){
            let collection = this.Atheneum.Library.collections[cartItems.storyId];
            if(collection){
                assetIds = assetIds.concat(collection.assets);
            } 
        }else{
            assetIds = assetIds.concat(cartItems.assetIds);
        }
    }

    this.assetIds = assetIds;
    this.collectionIds = [];
    this.currentCart.loaded = false;
    this.loadedCartId = cart.id;

   document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_REFRESHED));

    document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.CART_NEEDS_LOADING));

    this.saveToStorage();
}

Atheneum.Cart.prototype.getCartAssetIds = function (cart){
    let currentCartName = this.Atheneum.Translation.get('currentCart', 'Current Cart');
    
    if(cart.name === currentCartName)
        return cart.assetIds;
    let assetIds = [];
    
    for (let i = 0; i < cart.cart.length; i++) {
        let cartItems = cart.cart[i];
        if(cartItems.assetIds === 'all'){
            let collection = this.Atheneum.Library.collections[cartItems.storyId];
            if(collection){
                assetIds = assetIds.concat(collection.assets);
            } 
        }else{
            assetIds = assetIds.concat(cartItems.assetIds);
        }
    }

    return assetIds;
}

Atheneum.Cart.prototype.moveCart = function (old_index, new_index){
    
    if(old_index)
        return false;

    if (new_index >= arr.length) {
        let cart = this.carts[old_index]
        this.carts.splice(old_index, 1);
        this.carts.push(cart);
    
        return true;
    }

    this.carts.splice(new_index, 0, this.carts.splice(old_index, 1)[0]);

    return true;
}

Atheneum.Cart.prototype.saveToStorage = function () {
    //this.Atheneum.LocalStorage.set('atheneumAssetsInCartForUser_' + this.Atheneum.User.username, JSON.stringify(this.assetIds || []));
    //this.Atheneum.LocalStorage.set('atheneumCollectionsInCartForUser_' + this.Atheneum.User.username, JSON.stringify(this.collectionIds || []));
    this.Atheneum.LocalStorage.set('atheneumCurrentCartsForUser_' + this.Atheneum.User.username, JSON.stringify(this.currentCart || []));
    this.Atheneum.LocalStorage.set('atheneumStoredCartsForUser_' + this.Atheneum.User.username, JSON.stringify(this.carts || []));
    this.Atheneum.LocalStorage.set('atheneumLoadedCartForUser_'+ this.Atheneum.User.username, this.loadedCartId);
}
Atheneum.Cart.prototype.loadFromStorage = function () {

    let currentCartName = this.Atheneum.Translation.get('currentCart', 'Current Cart');
    this.loadedCartId = this.Atheneum.LocalStorage.get('atheneumLoadedCartForUser_'+ this.Atheneum.User.username) || null;
    this.carts = JSON.parse(this.Atheneum.LocalStorage.get('atheneumStoredCartsForUser_' + this.Atheneum.User.username) || "[]");
    this.currentCart = this.Atheneum.LocalStorage.get('atheneumCurrentCartsForUser_' + this.Atheneum.User.username);

    if(typeof this.currentCart === 'undefined'){
        this.currentCart = {};
        this.currentCart.name = currentCartName;
        this.currentCart.loaded = true;
        this.currentCart.assetIds = [];
        this.currentCart.collectionIds = [];
    }else{
        this.currentCart = JSON.parse(this.currentCart);
        this.currentCart.name = currentCartName;
    }

    let loadedCart = this.getLoadedCart();
    if(!loadedCart || (!loadedCart.myCart && window.location.href.indexOf("/cart") < 0) || ((!this.Atheneum.User.permissions.canEditCarts && !(this.Atheneum.Theme.getBooleanProperty('simplifiedCartSavingSharingPermission', false) && this.Atheneum.User?.permissions?.canSaveCarts)) && window.location.href.indexOf("/cart") < 0))
        this.loadCart();
    else
        this.loadCart(this.loadedCartId);

    for (var i = 0; i < this.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.assetIds[i]];

        if (!asset || (!asset.shareByEmail && !this.Atheneum.User.permissions.canRegisterInterest && !this.Atheneum.User.permissions.canSaveCarts )) {
            // asset either doesn't exist, or cannot be shared
            // remove from cart
            this.assetIds.splice(i, 1);
            i = i - 1;
            continue;
        }

        if (!this.Atheneum.User.canSee(asset)) {
            // user does not have permission to view the asset: remove from cart
            this.assetIds.splice(i, 1);
            i = i - 1;
            continue;
        }
    }

    // TODO: collections in cart
}

Atheneum.Cart.prototype.getTotalItems = function () {
    return this.assetIds.length + this.collectionIds.length;
}

Atheneum.Cart.prototype.isEmpty = function () {
    return (this.getTotalItems() == 0);
}

Atheneum.Cart.prototype.containsAsset = function (assetId) {
    return this.assetIds.contains(assetId);
}
Atheneum.Cart.prototype.containsCollection = function (collectionId) {
    return this.collectionIds.contains(collectionId);
}

Atheneum.Cart.prototype.getLoadedCart = function(){
    return this.carts.find(x=> x.id === this.loadedCartId);
}
Atheneum.Cart.prototype.empty = function (callback, skipSave = false) {
    this.assetIds = [];
    this.collectionIds = [];

    let cart = this.getLoadedCart();

    if(skipSave)
        return;
    
    this.saveCart(cart?.name || this.Atheneum.Translation.get('currentCart', 'Current Cart'), true, undefined, undefined, function(success, message){
        if (typeof callback === "function")
            callback();
        else if (callback && typeof callback.success === "function")
            callback.success();
    });
}

Atheneum.Cart.prototype.addAssets = function (assetIds, callback) {

    for (var a = 0; a < assetIds.length; a++) {
        var assetId = assetIds[a];
        var asset = this.Atheneum.Library.assets[assetId];
        if (!asset || (!asset.shareByEmail && !this.Atheneum.User.permissions.canRegisterInterest && !this.Atheneum.User.permissions.canSaveCarts )) {
            if (typeof callback === "object" && typeof callback.failure === "function") {
                callback.failure("Asset does not exist, or cannot be shared", undefined, undefined);
            }
            return;
        }
    }

    for (var a = 0; a < assetIds.length; a++) {
        var assetId = assetIds[a];
        if (!this.assetIds.contains(assetId))
            this.assetIds[this.assetIds.length] = assetId;
    }
    
    let cart = this.getLoadedCart();

    this.saveCart(cart?.name || this.Atheneum.Translation.get('currentCart', 'Current Cart'), true, undefined, undefined, function(success, message){
        if (typeof callback === "function")
            callback();
        else if (callback && typeof callback.success === "function")
            callback.success();
    });
}

Atheneum.Cart.prototype.addAsset = function (assetId, callback) {

    // only allow asset to be added to cart if it is shareable
    var asset = this.Atheneum.Library.assets[assetId];
    if (!asset || (!asset.shareByEmail && !this.Atheneum.User.permissions.canRegisterInterest && !this.Atheneum.User.permissions.canSaveCarts )) {
        if (typeof callback === "object" && typeof callback.failure === "function") {
            callback.failure("Asset does not exist, or cannot be shared", undefined, undefined);
        }
        return;
    }

    if (typeof (trackAppClickForEntity) == 'function' && this.Atheneum && this.Atheneum.Translation)
        trackAppClickForEntity($('[data-atheneum-item-id="' + assetId + '"'), '[data-atheneum-item-id="' + assetId + '"', 'trackingAddToCart', this.Atheneum.Translation.get('trackingAddToCart', 'trackingAddToCart'), assetId);

    if (!this.assetIds.contains(assetId))
        this.assetIds[this.assetIds.length] = assetId;

    let cart = this.getLoadedCart();

    this.saveCart(cart?.name || this.Atheneum.Translation.get('currentCart', 'Current Cart'), true, undefined, undefined, function(success, message){
        if (typeof callback === "function")
            callback();
        else if (callback && typeof callback.success === "function")
            callback.success();
    });
}

Atheneum.Cart.prototype.removeAssets = function (assetIds, callback) {

    for (var a = 0; a < assetIds.length; a++) {
        var assetId = assetIds[a];
        while (this.assetIds.contains(assetId)) {
            this.assetIds.splice(this.assetIds.indexOf(assetId), 1);
        }
    }

    let cart = this.getLoadedCart();

    this.saveCart(cart?.name || this.Atheneum.Translation.get('currentCart', 'Current Cart'), true, undefined, undefined, function(success, message){
        if (typeof callback === "function")
            callback();
        else if (callback && typeof callback.success === "function")
            callback.success();
    });
}

Atheneum.Cart.prototype.removeAsset = function (assetId, callback) {
    while (this.assetIds.contains(assetId))
        this.assetIds.splice(this.assetIds.indexOf(assetId), 1);

    
    let cart = this.getLoadedCart();

    if (typeof (trackAppClickForEntity) == 'function' && this.Atheneum && this.Atheneum.Translation)
        trackAppClickForEntity($('[data-atheneum-item-id="' + assetId + '"'), '[data-atheneum-item-id="' + assetId + '"', 'trackingRemoveFromCart', this.Atheneum.Translation.get('trackingRemoveFromCart', 'trackingRemoveFromCart'), assetId);


    this.saveCart(cart?.name || this.Atheneum.Translation.get('currentCart', 'Current Cart'), true, undefined, undefined, function(success, message){
        if (typeof callback === "function")
            callback();
        else if (callback && typeof callback.success === "function")
            callback.success();
    });
}

Atheneum.Cart.prototype.shareRemoteCompletion = function(form, formData, callback){
    const formId = form.id;
    const formType = form.type? form.type : 'VEND';
    const assetIds = this.assetIds;

    this.Atheneum.API.submitRemoteCompletionForm(formId, formType, assetIds, formData, callback);
}

/**
    Cart.share( emailAddress,   callback )
    Cart.share( emailAddresses, callback )
    Cart.share( emailAddress,   fields,   callback )
    Cart.share( emailAddresses, fields,   callback )
*/
Atheneum.Cart.prototype.share = function (emailAddresses, fields, callback) {

    if (Object.prototype.toString.call(emailAddresses) !== "[object Array]") {
        emailAddresses = [emailAddresses];
    }

    if (callback == undefined) {
        callback = fields;
        fields = undefined;
    }

    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;

    if (fields == undefined)
        fields = {};

    var collectionSet = {};

    for (var i = 0; i < this.collectionIds.length; i++) {
        if (!collectionSet[this.collectionIds[i]]) {
            collectionSet[this.collectionIds[i]] = "all";
        }
    }

    for (var i = 0; i < this.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.assetIds[i]];
        if (collectionSet[asset.containedBy] != "all") {

            if (collectionSet[asset.containedBy] == undefined)
                collectionSet[asset.containedBy] = [];

            collectionSet[asset.containedBy][collectionSet[asset.containedBy].length] = asset.id;
        }
    }

    var cart = [];
    for (var collectionId in collectionSet) {
        if (!collectionSet.hasOwnProperty(collectionId))
            continue;

        if (collectionSet[collectionId] == "all") {
            cart[cart.length] = { storyId: collectionId, assetIds: null };
        } else {
            cart[cart.length] = { storyId: collectionId, assetIds: collectionSet[collectionId] };
        }
    }

    var atheneum = this.Atheneum;

    //var firstName = (atheneum.User.preferences || {}).firstName || "Unknown";
    //var lastName = (atheneum.User.preferences || {}).lastName || "Unknown";
    var timestamp = new Date().getTime();

    // TODO: count successful shares, then show a notification after a timeout ( or )

    var successes = 0;
    var failures = 0;
    var attempts = 0;
    var offlines = [];
    var total = emailAddresses.length;
    var complete = false;
    var failureDetails = undefined;

    let completeCallback = function (json) {

        if (offlines.length > 0) {
            var action = {};
            action.name = "shareCart";
            action.fields = fields;
            action.emailAddresses = offlines;
            action.timestamp = new Date().getTime();
            action.cart = JSON.parse(JSON.stringify(cart));
            atheneum.Offline.recordUnsynchedAction(action);
            failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined, "Atheneum.Cart.share");
            return;
        }

        if (successes == total) {
            successCallback(successes, json);
            return;
        }
        else if (failures == total) {
            // it all went wrong
            failureCallback(failureDetails.reason, failureDetails.httpStatus, failureDetails.errorCode, "Atheneum.Cart.share", failureDetails.json);
        }
        else { // partial success
            successCallback(successes, json);

            console.log("partial success"); // TODO
        }
    }

    let checkComplete = function (json) {
        if (attempts == total && !complete) {
            complete = true;
            completeCallback(json);
        }
    }

    for (var i = 0; i < emailAddresses.length; i++) {

        (function (index) {

            var fieldsToSend = fields;
            if (fieldsToSend.hasOwnProperty('CONTACT_ID_' + index)) {
                //it's using multiple contact ids, remove all keys then add contact_id back in
                var contactId = fieldsToSend['CONTACT_ID_' + index];

                for (var key in fieldsToSend) {
                    if (!fieldsToSend.hasOwnProperty(key))
                        continue;
                    if (key.indexOf("CONTACT_ID") >= 0)
                        delete fieldsToSend[key];
                }

                fieldsToSend["CONTACT_ID"] = contactId;

            }

           
                
            atheneum.API.shareCart(fieldsToSend, emailAddresses[index], cart, {

                success: function (json) {
                    attempts += 1;
                    successes += 1;
                    checkComplete(json);
                },

                failure: function (reason, httpStatus, errorCode, json) {

                    var offline = Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);

                    if (offline) {
                        offlines[offlines.length] = emailAddresses[index];
                    } else {
                        failures += 1;
                        failureDetails = { reason: reason, httpStatus: httpStatus, errorCode: errorCode, json: json };
                    }
                    attempts += 1;

                    Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Cart.share");
                    checkComplete(json);
                }
            });
           
        })(i);
    }

}

/**
    Cart.mlrReview( emailAddress,   callback )
    Cart.mlrReview( emailAddresses, callback )
    Cart.mlrReview( emailAddress,   fields,   callback )
    Cart.mlrReview( emailAddresses, fields,   callback )
*/
Atheneum.Cart.prototype.mlrReview = function (emailAddresses, fields, callback) {

    if (Object.prototype.toString.call(emailAddresses) !== "[object Array]") {
        emailAddresses = [emailAddresses];
    }

    if (callback == undefined) {
        callback = fields;
        fields = undefined;
    }

    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;

    if (fields == undefined)
        fields = {};

    var collectionSet = {};

    for (var i = 0; i < this.collectionIds.length; i++) {
        if (!collectionSet[this.collectionIds[i]]) {
            collectionSet[this.collectionIds[i]] = "all";
        }
    }

    for (var i = 0; i < this.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.assetIds[i]];
        if (collectionSet[asset.containedBy] != "all") {

            if (collectionSet[asset.containedBy] == undefined)
                collectionSet[asset.containedBy] = [];

            collectionSet[asset.containedBy][collectionSet[asset.containedBy].length] = asset.id;
        }
    }

    var cart = [];
    for (var collectionId in collectionSet) {
        if (!collectionSet.hasOwnProperty(collectionId))
            continue;

        if (collectionSet[collectionId] == "all") {
            cart[cart.length] = { storyId: collectionId, assetIds: null };
        } else {
            cart[cart.length] = { storyId: collectionId, assetIds: collectionSet[collectionId] };
        }
    }

    var atheneum = this.Atheneum;

    //var firstName = (atheneum.User.preferences || {}).firstName || "Unknown";
    //var lastName = (atheneum.User.preferences || {}).lastName || "Unknown";
    var timestamp = new Date().getTime();

    // TODO: count successful shares, then show a notification after a timeout ( or )

    var successes = 0;
    var failures = 0;
    var attempts = 0;
    var offlines = [];
    var total = emailAddresses.length;
    var complete = false;
    var failureDetails = undefined;

    var completeCallback = function () {

        if (offlines.length > 0) {
            var action = {};
            action.name = "mlrReview";
            action.fields = fields;
            action.emailAddresses = offlines;
            action.timestamp = new Date().getTime();
            action.cart = JSON.parse(JSON.stringify(cart));
            atheneum.Offline.recordUnsynchedAction(action);
            failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined, "Atheneum.Cart.mlrReview");
        }

        if (successes == total) {
            successCallback(successes);
            return;
        }
        else if (failures == total) {
            // it all went wrong
            failureCallback(failureDetails.reason, failureDetails.httpStatus, failureDetails.errorCode, "Atheneum.Cart.mlrReview");
        }
        else { // partial success
            successCallback(successes);

            console.log("partial success"); // TODO
        }
    }

    var checkComplete = function () {
        if (attempts == total && !complete) {
            complete = true;
            completeCallback();
        }
    }

    for (var i = 0; i < emailAddresses.length; i++) {

        (function (index) {

            var fieldsToSend = fields;
            if (fieldsToSend.hasOwnProperty('CONTACT_ID_' + index)) {
                //it's using multiple contact ids, remove all keys then add contact_id back in
                var contactId = fieldsToSend['CONTACT_ID_' + index];

                for (var key in fieldsToSend) {
                    if (!fieldsToSend.hasOwnProperty(key))
                        continue;
                    if (key.indexOf("CONTACT_ID") >= 0)
                        delete fieldsToSend[key];
                }

                fieldsToSend["CONTACT_ID"] = contactId;

            }

           
                
            atheneum.API.mlrReview(fieldsToSend, emailAddresses[index], cart, {

                success: function (json) {
                    attempts += 1;
                    successes += 1;
                    checkComplete();
                },

                failure: function (reason, httpStatus, errorCode, json) {

                    var offline = Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);

                    if (offline) {
                        offlines[offlines.length] = emailAddresses[index];
                    } else {
                        failures += 1;
                        failureDetails = { reason: reason, httpStatus: httpStatus, errorCode: errorCode, json:json };
                    }
                    attempts += 1;

                    Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Cart.mlrReview");
                    checkComplete();
                }
            });
           
        })(i);
    }

}

/**
    Cart.registerInterest( emailAddress,   callback )
    Cart.registerInterest( emailAddresses, callback )
    Cart.registerInterest( emailAddress,   fields,   callback )
    Cart.registerInterest( emailAddresses, fields,   callback )
*/
Atheneum.Cart.prototype.registerInterest = function (emailAddresses, fields, callback) {

    if (Object.prototype.toString.call(emailAddresses) !== "[object Array]") {
        emailAddresses = [emailAddresses];
    }

    if (callback == undefined) {
        callback = fields;
        fields = undefined;
    }

    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;

    if (fields == undefined)
        fields = {};

    var collectionSet = {};

    for (var i = 0; i < this.collectionIds.length; i++) {
        if (!collectionSet[this.collectionIds[i]]) {
            collectionSet[this.collectionIds[i]] = "all";
        }
    }

    for (var i = 0; i < this.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.assetIds[i]];
        if (collectionSet[asset.containedBy] != "all") {

            if (collectionSet[asset.containedBy] == undefined)
                collectionSet[asset.containedBy] = [];

            collectionSet[asset.containedBy][collectionSet[asset.containedBy].length] = asset.id;
        }
    }

    var cart = [];
    for (var collectionId in collectionSet) {
        if (!collectionSet.hasOwnProperty(collectionId))
            continue;

        if (collectionSet[collectionId] == "all") {
            cart[cart.length] = { storyId: collectionId, assetIds: null };
        } else {
            cart[cart.length] = { storyId: collectionId, assetIds: collectionSet[collectionId] };
        }
    }

    var atheneum = this.Atheneum;

    //var firstName = (atheneum.User.preferences || {}).firstName || "Unknown";
    //var lastName = (atheneum.User.preferences || {}).lastName || "Unknown";
    var timestamp = new Date().getTime();

    // TODO: count successful shares, then show a notification after a timeout ( or )

    var successes = 0;
    var failures = 0;
    var attempts = 0;
    var offlines = [];
    var total = emailAddresses.length;
    var complete = false;
    var failureDetails = undefined;

    var completeCallback = function () {

        if (offlines.length > 0) {
            var action = {};
            action.name = "registerInterest";
            action.fields = fields;
            action.emailAddresses = offlines;
            action.timestamp = new Date().getTime();
            action.cart = JSON.parse(JSON.stringify(cart));
            atheneum.Offline.recordUnsynchedAction(action);
            failureCallback(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined, "Atheneum.Cart.registerInterest");
        }

        if (successes == total) {
            successCallback(successes);
            return;
        }
        else if (failures == total) {
            // it all went wrong
            failureCallback(failureDetails.reason, failureDetails.httpStatus, failureDetails.errorCode, "Atheneum.Cart.registerInterest");
        }
        else { // partial success
            successCallback(successes);

            console.log("partial success"); // TODO
        }
    }

    var checkComplete = function () {
        if (attempts == total && !complete) {
            complete = true;
            completeCallback();
        }
    }

    if(emailAddresses.length == 0){
        var fieldsToSend = fields;
        if (fieldsToSend.hasOwnProperty('CONTACT_ID_0')) {
            //it's using multiple contact ids, remove all keys then add contact_id back in
            var contactId = fieldsToSend['CONTACT_ID_0'];

            for (var key in fieldsToSend) {
                if (!fieldsToSend.hasOwnProperty(key))
                    continue;
                if (key.indexOf("CONTACT_ID") >= 0)
                    delete fieldsToSend[key];
            }

            fieldsToSend["CONTACT_ID"] = contactId;
        }

        atheneum.API.registerInterest(fieldsToSend, '', cart, {

            success: function (json) {
                attempts = 1;
                total = 1;
                successes = 1;
                checkComplete();
            },

            failure: function (reason, httpStatus, errorCode, json) {

                var offline = Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);

                if (offline) {
                    offlines[offlines.length] = emailAddresses[index];
                } else {
                    failures += 1;
                    failureDetails = { reason: reason, httpStatus: httpStatus, errorCode: errorCode, json:json };
                }
                attempts = 1;
                total = 1;
                
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Cart.registerInterest");
                checkComplete();
            }
        });
        return;
    }

    for (var i = 0; i < emailAddresses.length; i++) {

        (function (index) {

            var fieldsToSend = fields;
            if (fieldsToSend.hasOwnProperty('CONTACT_ID_' + index)) {
                //it's using multiple contact ids, remove all keys then add contact_id back in
                var contactId = fieldsToSend['CONTACT_ID_' + index];

                for (var key in fieldsToSend) {
                    if (!fieldsToSend.hasOwnProperty(key))
                        continue;
                    if (key.indexOf("CONTACT_ID") >= 0)
                        delete fieldsToSend[key];
                }

                fieldsToSend["CONTACT_ID"] = contactId;

            }

           
                
            atheneum.API.registerInterest(fieldsToSend, emailAddresses[index], cart, {

                success: function (json) {
                    attempts += 1;
                    successes += 1;
                    checkComplete();
                },

                failure: function (reason, httpStatus, errorCode, json) {

                    var offline = Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);

                    if (offline) {
                        offlines[offlines.length] = emailAddresses[index];
                    } else {
                        failures += 1;
                        failureDetails = { reason: reason, httpStatus: httpStatus, errorCode: errorCode, json:json };
                    }
                    attempts += 1;

                    Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Cart.registerInterest");
                    checkComplete();
                }
            });
           
        })(i);
    }

}

/**
 * The User's asset library.
 * 
 * 
 * 		Properties:
 *  
 *  		assets					map { assetId: asset }
 *			collections				map { collectionId: collection }
 *
 *			topLevelCollections		map { collectionId : collection }
 *									(collections not contained by any other collection)
 *
 *			documents				map { documentId: [ assetId, assetId, ... ] }
 *
 *			timestamp				long
 *									(last time the library was updated)
 *
 *
 *		Methods:		* before a method indicates that it makes asynchronous requests to the server, and requires a callback
 *
 *	
 *		*	update( callbacks )
 *
 *				makes a request to the server to get the latest assets and collections
 *				uses the timestamp to reduce the amount of data transmitted
 *
 *
 *			getTopLevelCollections( )
 *
 *				returns an array of top level collections
 *				easier to iterate over than the topLevelCollections property
 *			
 *
 *			getSimilarAssets( assetOrAssetId, number )
 *
 *				returns an array of assets which are related to the specified asset
 *				the results are sorted by relevance, with element 0 being most related, and element (length-1) being least related
 *				the array will contain at most *number* elements
 *
 *			
 *		*	getAssetPreview( assetId, callbacks )
 *
 *				only works when running through the wrapper proxy
 *  
 *  
 *  	*	downloadAsset( assetId, callbacks )
 *  
 *  			starts downloading the asset from the download link provided
 *  			counts as shareing to your own email address
 */
Atheneum.Library = function (atheneum) {

    if (!(this instanceof Atheneum.Library))
        return new Atheneum.Library(atheneum);

    this.Atheneum = atheneum;

    this.timestamp = undefined;
    this.assets = {};
    this.collections = {};
    this.documents = {};
    this.topLevelCollections = {};

    this.groups = [];
    // groups which the current library data was requested with
    // if the user has a different set of groups from this, a full sync will be required

    this.loadFromStorage();

}

Atheneum.Library.prototype.handleAssetUpdate = function (asset, containedBy) {
    asset.containedBy = containedBy;
    delete asset.parentId;

    var existingAsset = this.assets[asset.id];
    if (existingAsset == undefined) {
        this.assets[asset.id] = asset;
        existingAsset = asset;
    }
    else {
        for (var prop in existingAsset) {
            if (!asset.hasOwnProperty(prop)) {
                delete existingAsset[prop];
            }
        }
        for (var prop in asset) {
            existingAsset[prop] = asset[prop];
        }
    }

    var container = this.collections[containedBy];
    if (container) {
        var alreadyInList = false;
        for (var i = 0; i < container.assets.length; i++) {
            if (container.assets[i].id == existingAsset.id) {
                container.assets[i] = existingAsset;
                alreadyInList = true;
                break;
            }
        }
        if (!alreadyInList) {
            container.assets[container.assets.length] = existingAsset;
        }
    }

    if (asset.docId != undefined) {

        var doc = this.documents[asset.docId];

        if (doc == undefined) {
            this.documents[asset.docId] = [asset.id];
        } else if (doc.indexOf(asset.id) == -1) {
            doc[doc.length] = asset.id;
        } else {
            // asset already in list and no need to update
        }
    }

    if (this.Atheneum && this.Atheneum.User && this.Atheneum.User.permissions) {
        if ((!asset.shareByEmail && !this.Atheneum.User.permissions.canRegisterInterest && !this.Atheneum.User.permissions.canSaveCarts ) && this.Atheneum.Cart && this.Atheneum.Cart.assetIds.contains(asset.id)) {
            this.Atheneum.Cart.assetIds.splice(this.Atheneum.Cart.assetIds.indexOf(asset.id), 1);
            this.Atheneum.Cart.saveToStorage();
        }
    }
}

Atheneum.Library.prototype.handleCollectionUpdate = function (collection, containedBy) {
    delete collection.parentId;

    var existingCollection = this.collections[collection.id];
    if (existingCollection == undefined) {
        this.collections[collection.id] = collection;
        collection.containedBy = containedBy;
        var parent = this.collections[collection.containedBy];
        
        for (var i = 0; i < collection.stories.length; i++) {
            this.handleCollectionUpdate(collection.stories[i], collection.id);
        }

        for (var i = 0; i < collection.assets.length; i++) {
            this.handleAssetUpdate(collection.assets[i], collection.id);
        }
        existingCollection = this.collections[collection.id];
    }
    else {
        // update existing collection while preserving references

        for (var prop in existingCollection) {
            if (!existingCollection.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof existingCollection[prop] !== 'object') {
                delete existingCollection[prop];
            }
            else if (!collection.hasOwnProperty(prop)) {
                if (prop == 'stories') {
                    if (existingCollection.stories == undefined) {
                        existingCollection.stories = [];
                    }
                    while (existingCollection.stories.length > 0) {
                        existingCollection.stories.pop();
                    }
                }
                else if (prop == 'assets') {
                    if (existingCollection.assets == undefined) {
                        existingCollection.assets = [];
                    }
                    while (existingCollection.assets.length > 0) {
                        existingCollection.assets.pop();
                    }
                }
                else if (existingCollection[prop] instanceof Array) {
                    while (existingCollection[prop].length > 0) {
                        existingCollection[prop].pop();
                    }
                }
                else {
                    // it's an object
                    delete existingCollection[prop];
                }
            }
        }
        if (existingCollection.stories == null) {
            existingCollection.stories = [];
        }
        if (existingCollection.assets == null) {
            existingCollection.assets = [];
        }
        for (var prop in collection) {
            if (!collection.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof collection[prop] !== 'object') {
                existingCollection[prop] = collection[prop];
            }
            else if (prop != 'assets' && prop != 'stories' && (collection[prop] instanceof Array)) {
                if (existingCollection[prop] == undefined) {
                    existingCollection[prop] = [];
                }
                while (existingCollection[prop].length > 0) {
                    existingCollection[prop].pop();
                }
                for (var i = 0; i < collection[prop].length; i++) {
                    existingCollection[prop].push(collection[prop][i]);
                }
            }
            else if (prop != 'assets' && prop != 'stories') {
                // it's an object map
                if (existingCollection[prop] == undefined) {
                    existingCollection[prop] = {};
                }
                for (var prop2 in existingCollection[prop]) {
                    if (existingCollection[prop].hasOwnProperty(prop2)) {
                        delete existingCollection[prop][prop2];
                    }
                }
                for (var prop2 in collection[prop]) {
                    existingCollection[prop] = collection[prop];
                }
            }
            else if (prop == 'stories') {
                if (existingCollection.stories == undefined) {
                    existingCollection.stories = [];
                }
                var storyIdMap = {};
                for (var i = 0; i < collection.stories.length; i++) {
                    storyIdMap[collection.stories[i].id] = collection.stories[i];
                }
                // remove subcollections from parent if they are no longer present
                var i = 0;
                while (i < existingCollection.stories.length) {
                    if (!storyIdMap[existingCollection.stories[i].id]) {
                        // the collection is no longer a subcollection of this one
                        existingCollection.stories.splice(i, 1)
                        continue;
                    }
                    i++;
                }
                for (var i = 0; i < collection.stories.length; i++) {
                    this.handleCollectionUpdate(collection.stories[i], collection.id);
                }
            }
            else if (prop == 'assets') {
                if (existingCollection.assets == undefined) {
                    existingCollection.assets = [];
                }
                var assetIdMap = {};
                for (var i = 0; i < collection.assets.length; i++) {
                    assetIdMap[collection.assets[i].id] = collection.assets[i];
                }
                var i = 0;
                while (i < existingCollection.assets.length) {
                    if (!assetIdMap[existingCollection.assets[i].id]) {
                        // the asset is no logner contained in this collection
                        existingCollection.assets.splice(i, 1)
                        continue;
                    }
                    i++;
                }
                for (var i = 0; i < collection.assets.length; i++) {
                    this.handleAssetUpdate(collection.assets[i], collection.id);
                }
            }
        }

    }

    if (containedBy == null) {
        if (this.topLevelCollections[collection.id] == undefined) {
            this.topLevelCollections[collection.id] = existingCollection;
        }
    } else {
        var container = this.collections[containedBy];
        if (container) {
            var alreadyInList = false;
            for (var i = 0; i < container.stories.length; i++) {
                if (container.stories[i].id == existingCollection.id) {
                    container.stories[i] = existingCollection;
                    alreadyInList = true;
                    break;
                }
            }
            if (!alreadyInList) {
                container.stories[container.stories.length] = existingCollection;
            }
        }
        if (this.topLevelCollections[collection.id]) {
            delete this.topLevelCollections[collection.id];
        }
    }

    if (this.Atheneum) {
        if (!collection.shareByEmail && this.Atheneum.Cart && this.Atheneum.Cart.collectionIds.contains(collection.id)) {
            this.Atheneum.Cart.collectionIds.splice(this.Atheneum.Cart.collectionIds.indexOf(collection.id), 1);
            this.Atheneum.Cart.saveToStorage();
        }
    }

    existingCollection.containedBy = containedBy;
}

Atheneum.Library.prototype.handleAssetItemUpdate = function (asset) {
    let containedBy = asset.parentId || asset.containedBy;
    asset.containedBy = containedBy;

    delete asset.parentId;

    var existingAsset = this.assets[asset.id];
    if (existingAsset == undefined) {
        existingAsset = asset;
        existingAsset.containedBy = containedBy;
    }
    else {
        for (var prop in asset) {
            existingAsset[prop] = asset[prop];
        }

        existingAsset.containedBy = containedBy;
    }

    this.assets[asset.id] = existingAsset;
    
    var container = this.collections[containedBy];
    if (container) {
        if(container.assets == undefined)
            container.assets = [];
        var alreadyInList = false;
        for (var i = 0; i < container.assets.length; i++) {
            if (container.assets[i].id == existingAsset.id) {
                container.assets[i] = existingAsset;
                alreadyInList = true;
                break;
            }
        }
        if (!alreadyInList) {
            container.assets[container.assets.length] = existingAsset;
        }

        this.collections[containedBy] = container;
    }

    if (asset.docId != undefined) {

        var doc = this.documents[asset.docId];

        if (doc == undefined) {
            this.documents[asset.docId] = [asset.id];
        } else if (doc.indexOf(asset.id) == -1) {
            doc[doc.length] = asset.id;
        } else {
            // asset already in list and no need to update
        }
    }

    if (this.Atheneum && this.Atheneum.User && this.Atheneum.User.permissions) {
        if ((!asset.shareByEmail && !this.Atheneum.User.permissions.canRegisterInterest && !this.Atheneum.User.permissions.canSaveCarts ) && this.Atheneum.Cart && this.Atheneum.Cart.assetIds.contains(asset.id)) {
            this.Atheneum.Cart.assetIds.splice(this.Atheneum.Cart.assetIds.indexOf(asset.id), 1);
            this.Atheneum.Cart.saveToStorage();
        }
    }
}

Atheneum.Library.prototype.handleItemUpdate = function (item) {
    let parentId = item.parentId || item.containedBy;
    let itemType = item.itemType;
    if(itemType === 'REPRINT'){
        this.handleAssetItemUpdate(item);
        return;
    }

    var existingCollection = this.collections[item.id];
    if (existingCollection == undefined) {
        item.containedBy = parentId;
        if(item.stories == undefined)
            item.stories = [];
        if(item.assets == undefined)
            item.assets = [];
        this.collections[item.id] = item;

        var parent = parentId != null? this.collections[parentId] : null;
        if(parent != undefined){
            //Update parent with new stories 
            if(parent.stories == undefined)
                parent.stories = [];
            
            parent.stories.push(item);
            this.collections[parentId] = parent;
        }
        
        
        existingCollection = this.collections[item.id];
    }
    else {
        // update existing collection while preserving references
        if (existingCollection.stories == null) {
            existingCollection.stories = [];
        }
        if (existingCollection.assets == null) {
            existingCollection.assets = [];
        }
        for (var prop in item) {
            if (!item.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof item[prop] !== 'object') {
                existingCollection[prop] = item[prop];
            }
            else if (prop != 'assets' && prop != 'stories' && (item[prop] instanceof Array)) {
                existingCollection[prop] = item[prop];
            }
            else if (prop != 'assets' && prop != 'stories') {
                // it's an object map
                if (existingCollection[prop] == undefined) {
                    existingCollection[prop] = {};
                }
                for (var prop2 in existingCollection[prop]) {
                    if (existingCollection[prop].hasOwnProperty(prop2)) {
                        delete existingCollection[prop][prop2];
                    }
                }
                for (var prop2 in item[prop]) {
                    existingCollection[prop] = item[prop];
                }
            }
        }
    }

    if (parentId == undefined) {
        if (this.topLevelCollections[item.id] == undefined) {
            this.topLevelCollections[item.id] = existingCollection;
        }
    } else {
        var container = this.collections[parentId];
        if (container) {
            var alreadyInList = false;
            for (var i = 0; i < container.stories.length; i++) {
                if (container.stories[i].id == existingCollection.id) {
                    container.stories[i] = existingCollection;
                    alreadyInList = true;
                    break;
                }
            }
            if (!alreadyInList) {
                container.stories[container.stories.length] = existingCollection;
            }

            this.collections[parentId] = container;
        }
        if (this.topLevelCollections[item.id]) {
            delete this.topLevelCollections[item.id];
        }
    }

    if (this.Atheneum) {
        if (!item.shareByEmail && this.Atheneum.Cart && this.Atheneum.Cart.collectionIds.contains(item.id)) {
            this.Atheneum.Cart.collectionIds.splice(this.Atheneum.Cart.collectionIds.indexOf(item.id), 1);
            this.Atheneum.Cart.saveToStorage();
        }
    }

    existingCollection.containedBy = parentId;
    this.collections[existingCollection.id] = existingCollection;
}

Atheneum.Library.prototype.handleAssetDeletion = function (assetId) {

    var asset = this.assets[assetId];

    if (asset == undefined)
        return; // yay, nothing to do

    asset.deleted = true;

    if (this.documents[asset.docId].length == 1) {
        delete this.documents[asset.docId];
    } else {
        this.documents[asset.docId].splice(this.documents[asset.docId].indexOf(assetId), 1);
    }

    var container = this.collections[this.assets[asset.id].containedBy];

    if (container != undefined) {
        for (var i = 0; i < container.assets.length; i++) {
            if (container.assets[i].id == assetId) {
                container.assets.splice(i, 1);
                break;
            }
        }
    }

    if (this.Atheneum) {
        if (this.Atheneum.Cart && this.Atheneum.Cart.assetIds.contains(assetId)) {
            this.Atheneum.Cart.assetIds.splice(this.Atheneum.Cart.assetIds.indexOf(assetId), 1);
            this.Atheneum.Cart.saveToStorage();
        }
        if (this.Atheneum.Favourites && this.Atheneum.Favourites.assetIds.contains(assetId)) {
            this.Atheneum.Favourites.assetIds.splice(this.Atheneum.Favourites.assetIds.indexOf(assetId), 1);
            this.Atheneum.Favourites.saveToStorage();
        }
    }

    delete this.assets[assetId];
}

Atheneum.Library.prototype.handleCollectionDeletion = function (collectionId) {

    var collection = this.collections[collectionId];

    if (collection == undefined)
        return; // nothing to do

    collection.deleted = true;

    for (var c in this.topLevelCollections) {
        if (c == collectionId) {
            delete this.topLevelCollections[c];
            break;
        }
    }

    // delete the collection's assets
    if (collection.assets) {
        var assetIdsToDelete = Array.prototype.slice.call(collection.assets).map(function (asset) { return asset.id; });
        for (var a = 0; a < assetIdsToDelete.length; a++) {
            this.handleAssetDeletion(assetIdsToDelete);
        }
    }

    // delete the collection's subcollections
    if (collection.stories) {
        var subcollectionIdsToDelete = Array.prototype.slice.call(collection.stories).map(function (subcol) { return subcol.id; });
        for (var s = 0; s < subcollectionIdsToDelete.length; s++) {
            this.handleCollectionDeletion(subcollectionIdsToDelete[s]);
        }
    }

    var container = this.collections[collection.containedBy];

    if (container != undefined) {
        for (var i = 0; i < container.stories.length; i++) {
            if (container.stories[i].id == collectionId) {
                container.stories.splice(i, 1);
                break;
            }
        }
    }

    if (this.Atheneum) {
        if (this.Atheneum.Cart && this.Atheneum.Cart.collectionIds.contains(collectionId)) {
            this.Atheneum.Cart.collectionIds.splice(this.Atheneum.Cart.collectionIds.indexOf(collectionId), 1);
            this.Atheneum.Cart.saveToStorage();
        }
        if (this.Atheneum.Favourites && this.Atheneum.Favourites.collectionIds.contains(collectionId)) {
            this.Atheneum.Favourites.collectionIds.splice(this.Atheneum.Favourites.collectionIds.indexOf(collectionId), 1);
            this.Atheneum.Favourites.saveToStorage();
        }
    }

    delete this.collections[collectionId];
}


Atheneum.Library.prototype.__getAncestorId = function(collection) {
	if(typeof collection === 'string') {
		var collectionId = collection;
		collection = this.collections[collection];
		if(collection == null) {
			return collectionId;
		}
	}
	if(collection.containedBy == null) {
		return collection.id;
	}
	return this.__getAncestorId(collection.containedBy);
}

Atheneum.Library.prototype.__incrementalUpdate = function( timestamp, itemsPerPage, pageIndex, callbacks, useTimestamp, combinedJSON, initialTopLevelIds, encounteredTopLevelIds) {
	
    var atheneumLibrary = this;
	var isFirst = (pageIndex == 0);
	
	if(combinedJSON == undefined) {
		combinedJSON = { };
	}
	
	if(initialTopLevelIds == undefined) {
		initialTopLevelIds = atheneumLibrary.getTopLevelCollections().map(function(x) { return x.id });
	}
	
	if(encounteredTopLevelIds == undefined) {
		encounteredTopLevelIds = [ ];
	}

    if(isFirst && callbacks && callbacks.progress) {
        callbacks.progress("progressStart");
    }
	
	var resumable = this.Atheneum.Theme.getBooleanProperty('libraryApiResumable', true);
	if(resumable) {
		var resumeInfo = { };
		resumeInfo.requestTimestamp = (timestamp || null);
		resumeInfo.pageIndex = pageIndex || 0;
		if(itemsPerPage != undefined) {
			resumeInfo.itemsPerPage = itemsPerPage;
		}
		resumeInfo.lastTimestamp = new Date().getTime();
		resumeInfo.initialTopLevelIds = initialTopLevelIds;
		resumeInfo.encounteredTopLevelIds = encounteredTopLevelIds;
		atheneumLibrary.Atheneum.LocalStorage.setJSON('libraryApiResumeInfo', resumeInfo);
	}
	
	var delayRemovalOfOldUntilEnd = atheneumLibrary.Atheneum.Theme.getBooleanProperty('libraryApiDelayRemovalUntilEnd', false);
	
    var incrementalFailCallback = function (reason, errorCode, httpstatus){
        console.log("ERROR IN INCREMENTAL LIBRARY CALL");
        if(callbacks.failure){
            callbacks.failure(reason, errorCode, httpstatus);
        }
    };

	var incrementalSuccessCallback = function(json) {

		var startTime = new Date().getTime();
		
		var modifiedTopLevelCollectionIds = [ ];

		if(timestamp == null && isFirst && !delayRemovalOfOldUntilEnd) {
			atheneumLibrary.assets = { };
			atheneumLibrary.collections = { };
			atheneumLibrary.documents = { };
			atheneumLibrary.topLevelCollections = { };
			atheneumLibrary.groups = atheneumLibrary.Atheneum.User.groups;
		}

        if(json.hasOwnProperty('timestamp')){
            json.libraryTimestamp = json.timestamp;
            json.deletedAssets = json.deletedReprintIds;
            json.deletedStories = json.deletedCollectionIds;
        }
		
		if(json.libraryTimestamp && !combinedJSON.libraryTimestamp) {
			combinedJSON.libraryTimestamp = json.libraryTimestamp;
		}
		if(json.itemsPerPage) {
			combinedJSON.itemsPerPage = json.itemsPerPage;
		}
		if(json.totalPages) {
			combinedJSON.totalPages = json.totalPages;
		}
		if(json.totalStoryCount) {
			combinedJSON.totalStoryCount = json.totalStoryCount;
		}

        if(json.totalCollections){
            combinedJSON.totalStoryCount = json.totalCollections;
            json.totalStoryCount = json.totalCollections;
        }

		if(json.pageIndex) {
			combinedJSON.pageIndex = json.pageIndex;
		}
		if(json.nextPageIndex) {
			combinedJSON.nextPageIndex = json.nextPageIndex;
		}
		else {
			delete combinedJSON['nextPageIndex'];
		}
        var useFlatLibrary = window.AtheneumInstance.Theme.getBooleanProperty('useFlatLibrary', false);
        let changes = false;
		if(!useFlatLibrary && json.stories) {
			if(combinedJSON.stories == undefined) {
				combinedJSON.stories = [ ];
			}
			for(var i=0; i<json.stories.length; i++) {
				encounteredTopLevelIds.push(json.stories[i].id);
				modifiedTopLevelCollectionIds.push(json.stories[i].id);
				atheneumLibrary.handleCollectionUpdate(json.stories[i], null);
				var alreadyPresent = false;
				for(var s=0; s<combinedJSON.stories.length; s++) {
					if(combinedJSON.stories[s].id == json.stories[i].id) {
						alreadyPresent = true;
						break;
					}
				}
				if(!alreadyPresent) {
					combinedJSON.stories[combinedJSON.stories.length] = json.stories[i];
				}
			}
		}else if(useFlatLibrary && json.items ){
            if(combinedJSON.items == undefined) {
				combinedJSON.items = [ ];
			}
			for(var i=0; i<json.items.length; i++) {
                changes = true;
                if(!json.items[i].hasOwnProperty('parentId')){
                    encounteredTopLevelIds.push(json.items[i].id);
				    modifiedTopLevelCollectionIds.push(json.items[i].id);
                }
				    
				atheneumLibrary.handleItemUpdate(json.items[i]);
                
                var alreadyPresent = false;
				for(var s=0; s<combinedJSON.items.length; s++) {
					if(combinedJSON.items[s].id == json.items[i].id) {
						alreadyPresent = true;
						break;
					}
				}
				if(!alreadyPresent) {
					combinedJSON.items[combinedJSON.items.length] = json.items[i];
				}
			}
        }
		
		if (json.deletedStories) {
			if(combinedJSON.deletedStories == undefined) {
				combinedJSON.deletedStories = [ ];
			}
			for (var i = 0; i < json.deletedStories.length; i++) {
				var topLevelCollectionId = atheneumLibrary.__getAncestorId(json.deletedStories[i]);
                var collection = atheneumLibrary.collections[json.deletedStories[i]];
                if(collection == undefined)
                    continue;

                changes = true;
				if(topLevelCollectionId != null) {
					modifiedTopLevelCollectionIds.push(topLevelCollectionId);
				}
				atheneumLibrary.handleCollectionDeletion(json.deletedStories[i]);
				if(combinedJSON.deletedStories.indexOf(json.deletedStories[i]) == -1) {
					combinedJSON.deletedStories[combinedJSON.deletedStories.length] = json.deletedStories[i];
				}
			}
		}

		if (json.deletedAssets != undefined) {
			if(combinedJSON.deletedAssets == undefined) {
				combinedJSON.deletedAssets = [ ];
			}
			for (var i = 0; i < json.deletedAssets.length; i++) {
				var asset = atheneumLibrary.assets[json.deletedAssets[i]];
                if(asset == undefined)
                    continue;

                changes = true;

				var topLevelCollectionId = atheneumLibrary.__getAncestorId(asset.containedBy);
                if(topLevelCollectionId != null) {
                    modifiedTopLevelCollectionIds.push(topLevelCollectionId);
                }
				atheneumLibrary.handleAssetDeletion(json.deletedAssets[i]);
				if(combinedJSON.deletedAssets.indexOf(json.deletedAssets[i]) == -1) {
					combinedJSON.deletedAssets[combinedJSON.deletedAssets.length] = json.deletedAssets[i];
				}
			}
		}

		if(callbacks && callbacks.progress) {
			var progressStartTime = new Date().getTime();
			callbacks.progress(json);
			var progressEndTime = new Date().getTime();
			var progressDuration = progressEndTime - progressStartTime;
			console.log('progress took ' + progressDuration + 'ms');
		}
		
		var saveToStorage = atheneumLibrary.Atheneum.Theme.getBooleanProperty('libraryApiPersistAfterProgress', true);
//		if(saveToStorage) {
//			try {
//				var saveStartTime = new Date().getTime();
//				atheneumLibrary.saveToStorage();
//				var saveEndTime = new Date().getTime();
//				var saveDuration = saveEndTime - saveStartTime;
//				console.log('saving to storage took ' + saveDuration + 'ms');
//			}
//			catch(e) {
//				// that's a lot of documents
//				console.error("library is too large to persist")
//			}
//		}

		if(json.nextPageIndex) {
			if(saveToStorage) {
				var saveStartTime = new Date().getTime();
				var modifiedTopLevelCollections = [ ];
				for(var i=0; i<modifiedTopLevelCollectionIds.length; i++) {
					if(modifiedTopLevelCollectionIds[i] == null) {
						continue;
					}
					var collection = atheneumLibrary.collections[modifiedTopLevelCollectionIds[i]];
					if(collection) {
						modifiedTopLevelCollections.push(collection);
					}
				}
				return atheneumLibrary.__saveAllCollectionsToStorageAsync(modifiedTopLevelCollections, 0, null, function() {
					var saveEndTime = new Date().getTime();
					var saveDuration = saveEndTime - saveStartTime;
					//console.log('save took ' + saveDuration + 'ms');
					var endTime = new Date().getTime();
					var duration = endTime - startTime;
					console.log('incremental update took ' + duration + 'ms');
					return atheneumLibrary.__incrementalUpdate(timestamp, itemsPerPage, json.nextPageIndex, callbacks, useTimestamp, combinedJSON, initialTopLevelIds, encounteredTopLevelIds);

				});
			}
			else {
				var endTime = new Date().getTime();
				var duration = endTime - startTime;
				console.log('incremental update took ' + duration + 'ms');
				return atheneumLibrary.__incrementalUpdate(timestamp, itemsPerPage, json.nextPageIndex, callbacks, useTimestamp, combinedJSON, initialTopLevelIds, encounteredTopLevelIds);

			}
		}
		
		var delayAllUpdatesUntilEnd = atheneumLibrary.Atheneum.Theme.getBooleanProperty('libraryApiDelayAllUpdatesUntilEnd', false);
        
		if(delayAllUpdatesUntilEnd) {
			if(timestamp == null) {
				atheneumLibrary.assets = { };
				atheneumLibrary.collections = { };
				atheneumLibrary.documents = { };
				atheneumLibrary.topLevelCollections = { };
				atheneumLibrary.groups = atheneumLibrary.Atheneum.User.groups;
			}
			if(combinedJSON.stories) {
				for(var i=0; i<combinedJSON.stories.length; i++) {
					atheneumLibrary.handleCollectionUpdate(combinedJSON.stories[i], null);
				}
			}
			if(combinedJSON.deletedStories) {
				for (var i = 0; i < combinedJSON.deletedStories.length; i++) {
					atheneumLibrary.handleCollectionDeletion(combinedJSON.deletedStories[i]);
				}
			}
			if(combinedJSON.deletedAssets) {
				for (var i = 0; i < combinedJSON.deletedAssets.length; i++) {
					atheneumLibrary.handleAssetDeletion(combinedJSON.deletedAssets[i]);
				}
			}

            if(combinedJSON.items){
                for(var i=0; i<combinedJSON.items.length; i++) {
					atheneumLibrary.handleItemUpdate(combinedJSON.items[i]);
				}
            }

			if(json.libraryTimestamp) {
				atheneumLibrary.timestamp = json.libraryTimestamp;
                localStorage['ignoreTimestamp'] = false;
			}
			var saveStartTime = new Date().getTime();
			return atheneumLibrary.saveToStorageAsync(function() {
				var saveEndTime = new Date().getTime();
				var saveDuration = saveEndTime - saveStartTime;
				console.log('saving took ' + saveDuration + 'ms');
				atheneumLibrary.Atheneum.LocalStorage.setJSON('libraryApiResumeInfo', null);
				if(callbacks.success) {
					var callbackStartTime = new Date().getTime();
					callbacks.success(combinedJSON);
					var callbackEndTime = new Date().getTime();
					var callbackDuration = callbackEndTime - callbackStartTime;
					console.log('success callback took ' + callbackDuration + 'ms');
				}
				
				var endTime = new Date().getTime();
				var duration = endTime - startTime;
				console.log('final update took ' + duration + 'ms');
                
			});
			
		}
        //LIBRARY TIMESTAMPS FIX
		else if(!useFlatLibrary && delayRemovalOfOldUntilEnd && (typeof timestamp !== 'number' || timestamp == 0 || Object.values(atheneumLibrary.collections).length != (json.totalStoryCount || json.totalCollections))) {
			var idsNoLongerPresent = initialTopLevelIds.filter(function(id) {
				return (encounteredTopLevelIds.indexOf(id) == -1);
			});
			for(var s=0; s<idsNoLongerPresent.length; s++) {
				if(modifiedTopLevelCollectionIds.indexOf(idsNoLongerPresent[s]) == -1) {
					modifiedTopLevelCollectionIds.push(idsNoLongerPresent[s]);
				}
			}
			for(var i=0; i<idsNoLongerPresent.length; i++) {
				atheneumLibrary.handleCollectionDeletion(idsNoLongerPresent[i]);
				atheneumLibrary.__removeCollectionFromStorage(idsNoLongerPresent[i]);
			}
		}
		
		if(json.libraryTimestamp) {
			atheneumLibrary.timestamp = json.libraryTimestamp;
            localStorage['ignoreTimestamp'] = false;
		}
		
		var saveStartTime = new Date().getTime();
		var modifiedTopLevelCollections = [ ];
		for(var i=0; i<modifiedTopLevelCollectionIds.length; i++) {
			if(modifiedTopLevelCollectionIds[i] == null) {
				continue;
			}
			var collection = atheneumLibrary.collections[modifiedTopLevelCollectionIds[i]];
			if(collection) {
				modifiedTopLevelCollections.push(collection);
			}
		}

        if(useFlatLibrary){
            if(!changes || !atheneumLibrary.fullyLoaded){
                var saveEndTime = new Date().getTime();
				var saveDuration = saveEndTime - saveStartTime;
				console.log('saving took ' + saveDuration + 'ms');
				atheneumLibrary.Atheneum.LocalStorage.setJSON('libraryApiResumeInfo', null);
				if(callbacks.success) {
					var callbackStartTime = new Date().getTime();
					callbacks.success(combinedJSON);
					var callbackEndTime = new Date().getTime();
					var callbackDuration = callbackEndTime - callbackStartTime;
					console.log('success callback took ' + callbackDuration + 'ms');
				}
				
				var endTime = new Date().getTime();
				var duration = endTime - startTime;
				console.log('final update took ' + duration + 'ms');

                return;
            }

            //TODO look into saving only collections that have been modified 
            //Save all when using flat library
            setTimeout(function(){
                atheneumLibrary.saveToStorageAsync(function() {
                    var saveEndTime = new Date().getTime();
                    var saveDuration = saveEndTime - saveStartTime;
                    console.log('saving took ' + saveDuration + 'ms');
                    atheneumLibrary.Atheneum.LocalStorage.setJSON('libraryApiResumeInfo', null);
                    if(callbacks.success) {
                        var callbackStartTime = new Date().getTime();
                        callbacks.success(combinedJSON);
                        var callbackEndTime = new Date().getTime();
                        var callbackDuration = callbackEndTime - callbackStartTime;
                        console.log('success callback took ' + callbackDuration + 'ms');
                    }
                    
                    var endTime = new Date().getTime();
                    var duration = endTime - startTime;
                    console.log('final update took ' + duration + 'ms');
                    
                });
            },500);

            return
        }

		return atheneumLibrary.__saveAllCollectionsToStorageAsync(modifiedTopLevelCollections, 0, null, function() {
			var saveEndTime = new Date().getTime();
			var saveDuration = saveEndTime - saveStartTime;
			console.log('save took ' + saveDuration + 'ms');
			
			// api call completed
			atheneumLibrary.Atheneum.LocalStorage.setJSON('libraryApiResumeInfo', null);
			
			var endTime = new Date().getTime();
			var duration = endTime - startTime;
			
			
			if(callbacks.success) {
				var callbackStartTime = new Date().getTime();
				callbacks.success(combinedJSON);
				var callbackEndTime = new Date().getTime();
				var callbackDuration = callbackEndTime - callbackStartTime;
				console.log('success callback took ' + callbackDuration + 'ms');
			}

			var endTime = new Date().getTime();
			var duration = endTime - startTime;

            atheneumLibrary.Atheneum.LocalStorage.set('atheneumLibraryTimestamp' + atheneumLibrary.Atheneum.User.username, JSON.stringify(atheneumLibrary.timestamp));
	
			console.log('final update took ' + duration + 'ms');
		});
	}
	
	var incrementalCallbacks = {
		success: incrementalSuccessCallback,
        failure: incrementalFailCallback
	}

	if(callbacks.offline) {
		incrementalCallbacks.offline = callbacks.offline;
	}
	
    if (this.Atheneum.CrossPlatform.enabled) {
        //TODO flat library crossplatform implementation
        return this.Atheneum.CrossPlatform.updateLibrary(callbacks, useTimestamp, timestamp, itemsPerPage, pageIndex, incrementalCallbacks);
	}
	if (this.Atheneum.Proxy.enabled) {
		return this.Atheneum.HttpUtils.getJSON("/restful/library", { apikey: this.Atheneum.User.apikey }, itemsPerPage, pageIndex, incrementalCallbacks);
	}

	this.Atheneum.API.getLibrary(timestamp, itemsPerPage, pageIndex, incrementalCallbacks);
}

Atheneum.Library.prototype.update = function (callback, useTimestamp) {
	
	if(this.onUpdateStart) {
		try {
			this.onUpdateStart();
		}
		catch(e) {
			log.error(e);
		}
	}
	
    var atheneumLibrary = this;

	var providedSuccessCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);

    var successCallback = function() {
		if(this.onUpdateComplete) {
			try {
				this.onUpdateComplete();
			}
			catch(e) {
				log.error(e);
			}
		}
		if(providedSuccessCallback) {
			providedSuccessCallback();
		}
	};
    var failureCallback = (typeof callback == "object") ? callback.failure : undefined;
    var progressCallback = (typeof callback == "object") ? callback.progress : undefined;
    var offlineCallback = (typeof callback == "object" && typeof callback.offline == "function") ? callback.offline : failureCallback;


    
	var updateIncrementally = this.Atheneum.Theme.getBooleanProperty('libraryApiIncremental', false);
	var itemsPerPage = this.Atheneum.Theme.getIntegerProperty('libraryApiItemsPerPage', 20);
    if(this.Atheneum.Theme.getBooleanProperty('useFlatLibrary', false)){
        itemsPerPage = this.Atheneum.Theme.getIntegerProperty('libraryFlatApiItemsPerPage', 1000);
        if(itemsPerPage > 10000)
            itemsPerPage = 10000;

            //10k is the max at the moment on the server
    }
       
    
    if(!atheneumLibrary.Atheneum.CrossPlatform.enabled && updateIncrementally) {
		var timestampToUse = atheneumLibrary.timestamp;
		if(useTimestamp === false) {
			timestampToUse = null;
		}
		else if(useTimestamp !== true && this.ignoreTimestamp) {
			timestampToUse = null;
		}
        
		if(Object.values(atheneumLibrary.collections).length == 0)
            timestampToUse = null;

		var pageIndex = 0;
		var initialTopLevelIds = undefined;
		var encounteredTopLevelIds = [ ];
		
		var resumable = this.Atheneum.Theme.getBooleanProperty('libraryApiResumable', true);
		if(resumable) {
			var resumeInfo = this.Atheneum.LocalStorage.getJSON('libraryApiResumeInfo');
			var resumeInfoTimestampThreshold = this.Atheneum.Theme.getIntegerProperty('libraryApiResumeThreshold', 30000);
			if(resumeInfo == null) {
				// can't resume - no existing info
				console.log('starting library update. cannot resume - no resumeInfo');
			}
			else if(resumeInfo.itemsPerPage != itemsPerPage) {
				// can't resume - last sync used different itemsPerPage
				console.log('starting library update. cannot resume - last sync used different itemsPerPage');
			}
			else if(resumeInfo.requestTimestamp != timestampToUse) {
				// can't resume - last sync used different timestamp
				console.log('starting library update. cannot resume - last sync used different timestamp');
			}
			else if((new Date().getTime() - resumeInfo.lastTimestamp) > resumeInfoTimestampThreshold) {
				// can't resume - last sync too old
				console.log('starting library update. cannot resume - last sync too old');
			}
			else {
				pageIndex = resumeInfo.pageIndex;
				initialTopLevelIds = resumeInfo.initialTopLevelIds;
				encounteredTopLevelIds = resumeInfo.encounteredTopLevelIds;
				console.log(
					'resumed library update at page ' + pageIndex
					+ '. initial TLCs: ' + (initialTopLevelIds || []).length
					+ '. encountered TLCs: ' + (encounteredTopLevelIds || []).length
				);
			}
		}
		
		var callbacks = {
			success: function(json) {
				if(successCallback) {
					successCallback(json);
				}
			}
		}
		if(failureCallback) {
			callbacks.failure = failureCallback;
		}
		if(offlineCallback) {
			callbacks.offline = offlineCallback;
		}
		if(progressCallback) {
			callbacks.progress = progressCallback;
		}
		return this.__incrementalUpdate(timestampToUse, itemsPerPage, pageIndex, callbacks, useTimestamp, undefined, initialTopLevelIds, encounteredTopLevelIds);
	}

    if (this.Atheneum.CrossPlatform.enabled) {
        var callbacks = {
            success: function (json) {

                //// don't update the timestamp, as we don't get given one
                //// we just get the full list of stories
                if (json.libraryTimestamp)
                    atheneumLibrary.timestamp = json.libraryTimestamp;

                localStorage['ignoreTimestamp'] = false;

                if (useTimestamp !== true) {
                    atheneumLibrary.assets = {};
                    atheneumLibrary.collections = {};
                    atheneumLibrary.documents = {};
                    atheneumLibrary.topLevelCollections = {};
                }

                for (var i = 0; i < json.stories.length; i++) {
                    atheneumLibrary.handleCollectionUpdate(json.stories[i], null);
                }

                if(json.items){
                    for (var i = 0; i < json.items.length; i++) {
                        atheneumLibrary.handleItemUpdate(json.items[i]);
                    }    
                }
                
                atheneumLibrary.saveToStorage();

                if (typeof successCallback == "function")
                    successCallback(json);
            },

            failure: failureCallback,

            offline: offlineCallback
        }

        return this.Atheneum.CrossPlatform.updateLibrary(callbacks, useTimestamp);
    }

    if (this.Atheneum.Proxy.enabled) {
        return this.Atheneum.HttpUtils.getJSON("/restful/library", { apikey: this.Atheneum.User.apikey }, {
            success: function (json) {

                //// don't update the timestamp, as we don't get given one
                //// we just get the full list of stories
                if (json.libraryTimestamp)
                    atheneumLibrary.timestamp = json.libraryTimestamp;

                atheneumLibrary.assets = {};
                atheneumLibrary.collections = {};
                atheneumLibrary.documents = {};
                atheneumLibrary.topLevelCollections = {};

                for (var i = 0; i < json.stories.length; i++) {
                    atheneumLibrary.handleCollectionUpdate(json.stories[i], null);
                }

                if(json.items){
                    for (var i = 0; i < json.items.length; i++) {
                        atheneumLibrary.handleItemUpdate(json.items[i]);
                    }    
                }

                atheneumLibrary.saveToStorage();

                if (typeof successCallback == "function")
                    successCallback(json);
            },

            failure: failureCallback,
            offline: offlineCallback
        });
    }

    var userGroupsHaveChanged = false;
    if (this.groups.length != this.Atheneum.User.groups.length) {
        userGroupsHaveChanged = true;
    }
    else {
        for (var g = 0; g < this.groups.length; g++) {
            if (this.Atheneum.User.groups.indexOf(this.groups[g]) == -1) {
                userGroupsHaveChanged = true;
            }
        }
    }

    if (userGroupsHaveChanged) {
        this.timestamp = undefined;
    }

    return this.Atheneum.API.getLibrary((this.ignoreTimestamp ? undefined : this.timestamp), {

        success: function (json) {

            if (atheneumLibrary.timestamp == undefined) {
                // it was a full sync, and we need to purge the library of everything
                atheneumLibrary.topLevelCollections = {};
                atheneumLibrary.collections = {};
                atheneumLibrary.assets = {};
                atheneumLibrary.documents = {};
                atheneumLibrary.groups = atheneumLibrary.Atheneum.User.groups;
            }

            // remove deleted assets

            atheneumLibrary.timestamp = json.libraryTimestamp;
            localStorage['ignoreTimestamp'] = false;
            
            if (json.deletedStories != undefined)
                for (var i = 0; i < json.deletedStories.length; i++)
                    atheneumLibrary.handleCollectionDeletion(json.deletedStories[i]);

            if (json.deletedAssets != undefined)
                for (var i = 0; i < json.deletedAssets.length; i++)
                    atheneumLibrary.handleAssetDeletion(json.deletedAssets[i]);

            for (var i = 0; i < json.stories.length; i++) {
                atheneumLibrary.handleCollectionUpdate(json.stories[i], null);
            }

            if(json.items){
                for (var i = 0; i < json.items.length; i++) {
                    atheneumLibrary.handleItemUpdate(json.items[i]);
                }    
            }

            atheneumLibrary.saveToStorage();

            if (successCallback != undefined)
                successCallback(json);
        },

        failure: function (reason, httpStatus, errorCode) {

            console.log("ERROR GETING LIBRARY");
            console.log(reason);
            console.log(httpStatus);
            console.log(errorCode);


            if (failureCallback != undefined)
                failureCallback(reason, httpStatus, errorCode);

        },

        offline: function (reason, httpStatus, errorCode) {

            console.log("ERROR GETING LIBRARY");
            console.log(reason);
            console.log(httpStatus);
            console.log(errorCode);


            if (offlineCallback != undefined)
                offlineCallback(reason, httpStatus, errorCode);

        }

    });
}

Atheneum.Library.prototype.getTopLevelCollections = function AtheneumLibrary_getTopLevelCollections() {

    var array = [];

    for (var collectionId in this.topLevelCollections) {
        if (this.topLevelCollections.hasOwnProperty(collectionId)) {
            array[array.length] = this.collections[collectionId];
        }
    }

    return array;
}

Atheneum.Library.prototype.saveToStorage = function () {
	
	var atheneumLibrary = this;
	
	/**
    this.Atheneum.LocalStorage.set('atheneumLibraryTimestamp', JSON.stringify(this.timestamp));
	var stringifyStart = new Date().getTime();
    let jsonToStore = JSON.stringify(this.topLevelCollections);
	var stringifyEnd = new Date().getTime();
	var sizePreCompression = jsonToStore.length * 2;
	var compressionStart = new Date().getTime();
    if (!this.Atheneum.CrossPlatform.enabled && window.LZString) {
        jsonToStore = LZString.compress(jsonToStore);
	}
	var compressionEnd = new Date().getTime();
	var sizePostCompression = jsonToStore.length * 2;
	var storageStart = new Date().getTime();
    this.Atheneum.LocalStorage.set('atheneumLibraryData', jsonToStore);
	var storageEnd = new Date().getTime();
	console.log(
		'stringify: ' + (stringifyEnd - stringifyStart)
		+ 'ms, compression: ' + (compressionEnd - compressionStart)
		+ 'ms, storage:' + (storageEnd - storageStart) + 'ms');
	var compressionRatio = (sizePostCompression / (sizePreCompression || 1));
	console.log(
		'pre compression: ', + sizePreCompression
		+ 'b, post compression: ' + sizePostCompression
		+ 'b, rato:' + (100 - (compressionRatio * 100)) + '%');
	*/
	
	// remove legacy format
	this.Atheneum.LocalStorage.clear('atheneumLibraryData');
	
	var topLevelCollections = this.getTopLevelCollections();
	for(var i=0; i<topLevelCollections.length; i++) {
		atheneumLibrary.__saveCollectionToStorage(topLevelCollections[i]);
	}
	
    this.Atheneum.LocalStorage.set('atheneumLibraryTimestamp' + atheneumLibrary.Atheneum.User.username, JSON.stringify(this.timestamp));
}

Atheneum.Library.prototype.saveToStorageAsync = function(callback) {
	// remove legacy format
	this.Atheneum.LocalStorage.clear('atheneumLibraryData');
	var topLevelCollections = this.getTopLevelCollections();
    var atheneumLibrary = this;
	this.__saveAllCollectionsToStorageAsync(topLevelCollections, 0, null, function() {
    	atheneumLibrary.Atheneum.LocalStorage.set('atheneumLibraryTimestamp' + atheneumLibrary.Atheneum.User.username, JSON.stringify(atheneumLibrary.timestamp));
		if(callback) {
			callback();
		}
	});
}
Atheneum.Library.prototype.__saveAllCollectionsToStorageAsync = function(collectionArray, index, progressCallback, doneCallback) {
	var atheneumLibrary = this;
	if(index >= collectionArray.length) {
		if(doneCallback) {
			doneCallback();
		}
		return;
	}
	var collection = collectionArray[index];
	var callback = function() {
		if(progressCallback) {
			progressCallback();
		}
		atheneumLibrary.__saveAllCollectionsToStorageAsync(collectionArray, index+1, progressCallback, doneCallback);
	}
    
	this.__saveCollectionToStorageAsync(collection, callback);
}
Atheneum.Library.prototype.__saveCollectionToStorageAsync = function(collection, callback) {
	var atheneumLibrary = this;
	// TODO - make use of async-lz-string
	setTimeout(function() {
		atheneumLibrary.__saveCollectionToStorage(collection, callback);
	}, 0);
}

Atheneum.Library.prototype.__stripOutKeywords = function(obj, dl){
    let atheneumLibrary = this;
    if (Array.isArray(obj)) {
        // if array iterate over the elment
        obj.forEach(function(v) {
          // do recursion
          atheneumLibrary.__stripOutKeywords(v, dl);
        });
      // check element is an object
      } else if (typeof obj == 'object' && obj !== null) {
        // iterate over the object keys
        try{
            Object.keys(obj).forEach(function(k) {
                // check key is in the delete list or not
                if (!dl[k])
                  delete obj[k];
                else
                  // otherwise do recursion
                  atheneumLibrary.__stripOutKeywords(obj[k], dl);
              })
        }catch(err){
           
        }
        
      }
}

Atheneum.Library.prototype.__saveCollectionToStorage = function(collection, callback) {

    let collectionData = "";
    if(this.Atheneum.LocalStorage.db){
        //Why is this needed?
        let strippedCollection = jQuery.extend(true, {}, collection); //JSON.parse(JSON.stringify(collection));
        let toKeep = { 
            id:true,
            name:true,
            docId:true,
            modified:true,
            containedBy:true,
            stories: true,
            assets: true,
            canPreview: true,
            mimetype:true,
            thumb:true,
            icon:true,
            url:true,
            storyOrder: true,
            order:true,
            assetOrder: true,
            shareByEmail: true,
            allowedGroups: true,
            html: true,
            highPriorityAssets: true,
            volume: true,
            issue: true,
            authors: true,
            streamingLocations: true,
        }
        this.__stripOutKeywords(strippedCollection, toKeep);
        collectionData = JSON.stringify(strippedCollection);
    }else{
        collectionData = JSON.stringify(collection);
    }
   
    var atheneumLibrary = this;
    setTimeout(function (){ 
        atheneumLibrary.__saveStringifiedCollectionDataToStorage(collection.id, collectionData, collection, callback);
    }, 0);
	
}
Atheneum.Library.prototype.__saveStringifiedCollectionDataToStorage = function(collectionId, collectionData, collection, callback) {
	if(this.__index == undefined) {
		this.__index = { };
	}
	this.__index[collectionId] = new Date().getTime();
    
    this.Atheneum.LocalStorage.setJSON("atheneumLibraryCollectionIndex", this.Atheneum.Library.__index);
	this.Atheneum.LocalStorage.set("atheneumLibraryCollectionData-" + collectionId, collectionData);
    
	if(callback) {
		callback();
	}

    if(this.Atheneum.LocalStorage.db){
        var atheneumLibrary = this;
        setTimeout(function (){ 
            atheneumLibrary.__saveStringifiedCollectionDataToDB(collectionId, collection);
        }, 0);
        
     }
}

Atheneum.Library.prototype.__saveStringifiedCollectionDataToDB = async function(collectionId, collection) {
    let atheneumLibrary = this;
    return new Promise((resolve, reject) =>{
        var collectionData = JSON.stringify(collection);
        /*if (window.LZString) {
            collectionData = LZString.compress(collectionData);
        }*/

        let db = atheneumLibrary.Atheneum.LocalStorage.db;
        db.json.put({key: "atheneumLibraryCollectionData-" + collectionId, data: collectionData}).then(function(data){
            resolve();
        }).catch(function(error){
            atheneumLibrary.Atheneum.LocalStorage.set("atheneumLibraryCollectionData-" + collectionId, collectionData);
        });
      
    });
}

Atheneum.Library.prototype.__loadAllCollectionsFromStorageAsync = function(collectionIdArray, index, progressCallback, doneCallback) {
	var atheneumLibrary = this;
	if(index >= collectionIdArray.length) {
		if(doneCallback) {
			doneCallback();
		}
		return;
	}
	var collectionId = collectionIdArray[index];
	var callback = function() {
		if(progressCallback) {
			progressCallback();
		}
		atheneumLibrary.__loadAllCollectionsFromStorageAsync(collectionIdArray, index+1, progressCallback, doneCallback);
	}
	this.__loadCollectionFromStorageAsync(collectionId, callback);
}
Atheneum.Library.prototype.__loadCollectionFromStorageAsync = function(collectionId, callback) {
	var atheneumLibrary = this;
	// TODO - make use of async-lz-string
	setTimeout(function() {
		atheneumLibrary.__loadCollectionFromStorage(collectionId, callback);
	}, 0);
}
Atheneum.Library.prototype.__loadCollectionFromStorage = function(collectionId, callback) {
	var collectionData = this.__loadStringifiedCollectionDataFromStorage(collectionId);
	try{
        var collection = JSON.parse(collectionData);
        if(collection != null) {
            this.handleCollectionUpdate(collection, null);
        }
    }catch(err){
        if(callback) {
            callback(collection);
        }
    }

	
}

Atheneum.Library.prototype.__loadStringifiedCollectionDataFromStorage = function(collectionId, callback) {
	var collectionData = this.Atheneum.LocalStorage.get("atheneumLibraryCollectionData-" + collectionId);
	if(callback) {
		callback(collectionData);
	}
	return collectionData;
}


Atheneum.Library.prototype.__loadFullCollectionsFromStorage = function() {

    console.time('loadFullCollectionsFromStorage');
          
	if(this.__index != null) {
        let promises = [];
		for(var collectionId in this.__index) {
			promises.push(this.__loadFullCollectionDataFromStorage(collectionId));
		}

        Promise.all(promises).then((values) => {
              console.timeEnd('loadFullCollectionsFromStorage');
              
              if(typeof libraryFullCollectionsLoaded === 'function'){
                
                libraryFullCollectionsLoaded();
                this.fullyLoaded = true;
              }
          });
	}else{
        console.log('INDEX NOT AVAILABLE')
        libraryFullCollectionsLoaded();
        this.fullyLoaded = true;
    }
}

Atheneum.Library.prototype.__loadFullCollectionDataFromStorage = async function(collectionId) {
    let atheneumLibrary = this;

    return new Promise((resolve, reject) => {

        let db =  atheneumLibrary.Atheneum.LocalStorage.db;
        db.json.get("atheneumLibraryCollectionData-" + collectionId).then(function(entry){
            try{
                let collectionData = entry.data;
                /*if (window.LZString) {
                    collectionData = LZString.decompress(collectionData);
                }*/
    
                let collection = JSON.parse(collectionData);
                if(collection != null) {
                    atheneumLibrary.handleCollectionUpdate(collection, null);
                }
                
                resolve(true);
            }catch(err){
                console.log(err);
            }
            resolve(false)
        }).catch(function callback (error) {
            // Handle error
            //console.log(error);
            resolve(false);
        });
      });
}


Atheneum.Library.prototype.loadFromStorage = function () {
    this.timestamp = JSON.parse(this.Atheneum.LocalStorage.get('atheneumLibraryTimestamp' + this.Atheneum.User.username) || 'null') || undefined;
    this.assets = {};
    this.documents = {};
    this.collections = {};
    this.topLevelCollections = {};
    this.fullyLoaded = false;
    try {
        this.groups = JSON.parse(this.Atheneum.LocalStorage.get('atheneumLibraryGroups') || '[ ]') || [];
    }
    catch (e) {
        this.groups = [];
    }

	this.__index = this.Atheneum.LocalStorage.getJSON("atheneumLibraryCollectionIndex");
	if(this.__index != null) {
        
		for(var collectionId in this.__index) {
			this.__loadCollectionFromStorage(collectionId);
		}
        
        if (this.Atheneum.LocalStorage.db) {
            this.__loadFullCollectionsFromStorage();
        } else {
            this.fullyLoaded = true;
            libraryFullCollectionsLoaded();
        }

        return;
	}
	else {
		this.__index = { };
        if(this.Atheneum.LocalStorage.db)
        {
            this.__loadFullCollectionsFromStorage();      
        }   
	}


    var libraryStringData = this.Atheneum.LocalStorage.get('atheneumLibraryData')
   
    if (libraryStringData === undefined) {
        this.timestamp = undefined;
    }
    else {

        var libraryData = JSON.parse(libraryStringData || "{ }");

        for (var id in libraryData) {
            if (libraryData.hasOwnProperty(id))
                this.handleCollectionUpdate(libraryData[id], null);
        }

    }

    this.fullyLoaded = true;

	if (!this.Atheneum.CrossPlatform.enabled) {
		this.saveToStorage();
	}
}

Atheneum.Library.prototype.__removeCollectionFromStorage = function(collectionId, callback) {
	this.Atheneum.LocalStorage.clear("atheneumLibraryCollectionData-" + collectionId);
    //TODO remove from the db as well
	delete this.__index[collectionId];
	this.Atheneum.LocalStorage.setJSON("atheneumLibraryCollectionIndex", this.__index);
	if(callback) {
		callback();
	}
}

Atheneum.Library.prototype.__loadCollectionFromStorageAsync = function(collectionId, callback) {
	var atheneumLibrary = this;
	setTimeout(function() {
		atheneumLibrary.__removeCollectionFromStorage(collectionId, callback);
	}, 0);
}

Atheneum.Library.prototype.filter = function AtheneumLibrary_filter(filters, options) {

    var defaults = {

        collection: null,
        recursive: true,

        includeAssets: true,
        includeCollections: true,

        asynchronous: false,
        searchProgressCallback: undefined,
        searchCompletionCallback: undefined
    };

    var results = {};
    results.assets = [];
    results.collections = [];

    // TODO - merge options with defaults

    var collection = null;
    if (options.collection) {
        if (typeof options.collection == 'string') {

        }
        else if (typeof options.collection == 'object') {
            options.collection
        }
    }
    if (!collection) {
        collection = { assets: [], collections: this.getTopLevelCollections() };
    }

    this._filterCollectionContents(collection, filters, options, results);

    if (!options.asynchronous && options.filterCompletionCallback) {
        options.filterCompletionCallback(results);
    }

    return results;
}

Atheneum.Library.prototype._filterCollectionContents = function (collection, filters, options, results) {

    var assetsAdded = [];
    if (collection.assets && options.includeAssets) {
        for (var a = 0; a < collection.assets.length; a++) {
            var asset = collection.assets[a];
            this._filterItem(asset, 'asset', filters, options, { collections: [], assets: assetsAdded });
        }
    }
    for (var a = 0; a < assetsAdded.length; a++) {
        results.assets.push(assetsAdded[a]);
    }
    if (options.filterProgressCallback) {
        options.filterProgressCallback({ collections: [], assets: assetsAdded }, results);
    }

    var collectionsAdded = [];
    if (collection.stories && options.includeCollections) {
        for (var s = 0; s < collection.stories.length; s++) {
            var subcollection = collection.stories[s];
            this._filterItem(subcollection, 'collection', filters, options, { collections: collectionsAdded, assets: [] });
        }
    }
    for (var c = 0; c < collectionsAdded.length; c++) {
        results.collections.push(collectionsAdded[c]);
    }
    if (options.filterProgressCallback) {
        options.filterProgressCallback({ collections: collectionsAdded, assets: [] }, results);
    }

    if (options.recursive) {
        for (var s = 0; s < collection.stories.length; s++) {
            var subcollection = collection.stories[s];
            this._filterCollectionContents(subcollection, filters, options, results);
        }
    }

}

Atheneum.Library.prototype._filterItem = function (item, itemType, filters, options, results) {

    if (!this.Atheneum.User.canSee(item)) {
        return;
    }
    for (var filter in filters) {
        if (item.properties) {
            if (!item.hasOwnProperty(filter) || item.properties[filter] != filters[filter]) {
                return;
            }
        }
    }
    if (itemType == 'collection') {
        results.collections.push(item);
        if (options.recursive) {
            this._filterCollectionContents(item);
        }
    }
    else if (itemType == 'asset') {
        results.assets.push(item);
    }
}

Atheneum.Library.prototype.SearchMode = Atheneum.Library.SearchMode = {


    EXACT_MATCH: 'exact-match',
    // text must match search term exactly


    CONTIGUOUS_FROM_START: 'contiguous-from-start',
    // search term must be present as a contiguous substring beginning at the start of the text
    //
    // if the search term is "test", then the following text would match: "testing"


    CONTIGUOUS_FROM_WORD_BOUNDARY: 'contiguous-from-word-boundary',
    // search term must be present as a contiguous substring beginning after a word boundary in the text
    //
    // if the search term is "test", then the following text would match:
    // "testing", "this is a test", "object.testing", "tests of search"


    CONTIGUOUS_ANYWHERE_IN_TEXT: 'contiguous-anywhere-in-text',
    // search term must be present as a contiguous substring anywhere in the text
    // if the search term is "test mode", then the following text would match: "contest modern"


    ORDERED_WORDS: 'ordered-words',
    // the search term is split into words, and is considered to match if:
    //     the words appear in the text, in order (but not necessarily sequentially)
    //	   all but the final word use EXACT_MATCH, the final word uses CONTIGUOUS_FROM_START
    //
    // if the search term is "test of", then the following text would match: "test of", "test and plan often"


    ORDERED_PARTIAL_WORDS: 'ordered-partial-words',
    // as ORDERED_WORDS, except CONTIGUOUS_FROM_START is used for checking every word in the search term
    //
    // if the search term is "test of search", then the following text would match:
    // "testing often is better than searching for bugs at the last minute" 


    UNORDERED_WORDS: 'unordered-words',
    // as ORDERED_WORDS, except the words may appear in any order
    //
    // if the search term is "test of search", then the following text would match:
    // "search test" would match "testing the search functionality"


    UNORDERED_PARTIAL_WORDS: 'unordered-partial-words',
    // as UNORDERED_WORDS, except CONTIGUOUS_FROM_START is used for checking every word in the search term
    //
    // if the search term is "test of search", then the following text would match:
    // "search test" would match "testing the search functionality"


    FUZZY: 'fuzzy',
    // as UNORDERED_PARTIAL_WORDS except CONTIGUOUS_ANYWHERE_IN_TEXT is used for checking every word in the search term

}


/**
 * @returns
 * {
 * 		assets: [ ],
 * 		collections: [ ]
 * }
 * 
 */
Atheneum.Library.prototype.search = function (searchTerm, options) {

    var defaultCriteria = {
        mode: Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT,
        caseSensitive: false,
        ignorePunctuation: true,
        treatUnicodeAsAscii: true
    };

    if (options != null) {
        for (var dcprop in defaultCriteria) {
            if (options.hasOwnProperty(dcprop)) {
                defaultCriteria[dcprop] = options[dcprop];
            }
        }
    }

    // remove zero width spaces from the search term
    searchTerm = (searchTerm || '').replace('\u200B', '');

    var defaults = {

        /**
         * collection to search within
         * null indicates a top level search of the entire library
         * ie, a pseudo collection containing no assets and only the collections in the top level
         */
        collection: null,

        /**
         * if false, only matches assets or collections in the top level "collection"
         * if true, also checks subcollections recursively, adding their assets and collections to the results
         */
        recursive: true,

        /**
         * things to search and how to search them
         * see Atheneum.Library.SearchMode for more information
         */
        criteria: {
            'name': {
                mode: Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT,
                caseSensitive: defaultCriteria.caseSensitive,
                ignorePunctuation: defaultCriteria.ignorePunctuation,
                treatUnicodeAsAscii: defaultCriteria.treatUnicodeAsAscii
            },
            'keywords': {
                mode: Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT,
                caseSensitive: defaultCriteria.caseSensitive,
                ignorePunctuation: defaultCriteria.ignorePunctuation,
                treatUnicodeAsAscii: defaultCriteria.treatUnicodeAsAscii
            },
            'fullTitle': {
                mode: Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT,
                caseSensitive: defaultCriteria.caseSensitive,
                ignorePunctuation: defaultCriteria.ignorePunctuation,
                treatUnicodeAsAscii: defaultCriteria.treatUnicodeAsAscii
            },
            'doiNumber': {
                mode: Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT,
                caseSensitive: defaultCriteria.caseSensitive,
                ignorePunctuation: defaultCriteria.ignorePunctuation,
                treatUnicodeAsAscii: defaultCriteria.treatUnicodeAsAscii
            }
        },

        /**
         * If a collection doesn't match the criteria but something inside it does,
         * treat the collection as matching. relatively slow
         */
        collectionsMatchIfTheirAssetsOrSubcollectionsMatch: false,

        includeAssets: true,
        includeCollections: true,


        /**
         * if the library contains a large number of items, searching may be rather slow
         * in which case you may want to call it asynchronously
         * 
         * in asynchronous mode, search will return immediately with an empty results object
         * then the callbacks provided will trigger as the search proceeds
         * 
         * searchProgressCallback will be called multiple times
         * its first argument will be the new results found since the last time the callback was called
         * its second argument will be an object containing all results found so far
         *   
         *   searchProgressCallback( newResultsSinceLastProgressUpdate, resultsSoFar ) {
         *   	var newAssetsFound = newResultsSinceLastProgressUpdate.assets;
         *   	var newCollectionsFound = newResultsSinceLastProgressUpdate.collections;
         *   	var allAssetsFoundSoFar = resultsSoFar.assets;
         *   	var newCollectionsFound = resultsSoFar.collections;
         *   }
         *   
         *   searchCompletionCallback( completeSearchResults ) {
         *   	var allAssetsFound = completeSearchResults.assets;
         *   	var allCollectionsFound = completeSearchResults.collections;
         *   }
         */
        asynchronous: false,
        searchProgressCallback: undefined,
        searchCompletionCallback: undefined

    };

    var searchOptions = defaults;
    if (options != null) {
        for (var prop in defaults) {
            if (prop != 'criteria' && options.hasOwnProperty(prop)) {
                searchOptions[prop] = options[prop];
            }
            else if (prop == 'criteria' && options.hasOwnProperty(prop)) {
                searchOptions.criteria = {};
                for (var cprop in options.criteria) {
                    searchOptions.criteria[cprop] = options.criteria[cprop];
                    for (var d in defaultCriteria) {
                        if (!options.criteria[cprop].hasOwnProperty(d)) {
                            options.criteria[cprop][d] = defaultCriteria[d];
                        }
                    }
                }
            }
        }
    }

    var collectionToSearchWithin = null;
    if (searchOptions.collection) {
        if (typeof searchOptions.collection == 'string') {
            collectionToSearchWithin = this.collections[options.collection];
        }
        else if (typeof searchOptions.collection == 'object') {
            collectionToSearchWithin = options.collection;
        }
    }
    if (collectionToSearchWithin == null) {
        collectionToSearchWithin = {
            assets: [],
            stories: this.Atheneum.Library.getTopLevelCollections()
        }
    }

    var results = {};
    results.assets = [];
    results.collections = [];

    this._searchCollection(collectionToSearchWithin, searchTerm, searchOptions, results);

    // TODO - maybe add in result sorting

    if (searchOptions.asynchronous) {
        if (searchOptions.searchCompletionCallback) {
            searchCompletionCallback(results);
        }
    }

    return results;
}


Atheneum.Library.prototype._searchCollection_internal = function (collection, searchTerm, searchOptions, results, asyncCompletionCallback) {

    var assetsFoundInThisCollection = [];
    var collectionsFoundInThisCollection = [];

    if (searchOptions.includeAssets) {
        for (var a = 0; a < collection.assets.length; a++) {
            var asset = collection.assets[a];
            if (this._checkIfItemMatches(asset, searchTerm, searchOptions, results)) {
                assetsFoundInThisCollection.push(asset);
            }
        }
    }
    assetsFoundInThisCollection.sort(function (assetA, assetB) {
        var assetA_sortOrder = (assetA.order == undefined) ? ((assetA.assetOrder == undefined) ? 99999 : assetA.assetOrder) : assetA.order;
        var assetB_sortOrder = (assetB.order == undefined) ? ((assetB.assetOrder == undefined) ? 99999 : assetB.assetOrder) : assetB.order
        return (assetA_sortOrder < assetB_sortOrder) ? 1 : -1;
    });
    for (var a = 0; a < assetsFoundInThisCollection.length; a++) {
        results.assets.push(assetsFoundInThisCollection[a]);
    }

    if (searchOptions.includeCollections) {
        for (var c = 0; c < collection.stories.length; c++) {
            var subcollection = collection.stories[c];
            if (this._checkIfItemMatches(subcollection, searchTerm, searchOptions, results)) {
                collectionsFoundInThisCollection.push(subcollection);
            }
        }
    }
    assetsFoundInThisCollection.sort(function (collectionA, collectionB) {
        var collectionA_sortOrder = (collectionA.order == undefined) ? ((collectionA.storyOrder == undefined) ? 99999 : collectionA.storyOrder) : collectionA.order;
        var collectionB_sortOrder = (collectionB.order == undefined) ? ((collectionB.storyOrder == undefined) ? 99999 : collectionB.storyOrder) : collectionB.order
        return (collectionA_sortOrder < collectionB_sortOrder) ? 1 : -1;
    });
    for (var c = 0; c < collectionsFoundInThisCollection.length; c++) {
        results.collections.push(collectionsFoundInThisCollection[c]);
    }

    if (searchOptions.asynchronous && searchOptions.searchProgressCallback) {
        searchOptions.searchProgressCallback({ assets: assetsFoundInThisCollection, collections: collectionsFoundInThisCollection }, results);
    }

    if (searchOptions.recursive) {
        if (searchOptions.asynchronous) {
            if (collection.stories && collection.stories.length > 0) {
                var atheneum = this.Atheneum;
                var c = 0;
                var searchNextCollectionOrCallAsyncCompletionCallback = function () {
                    if (c < collection.stories.length) {
                        var subcollection = collection.stories[c];
                        c += 1;
                        this._searchCollection(subcollection, searchTerm, searchOptions, results, searchNextCollectionOrCallAsyncCompletionCallback);
                    }
                    else if (asyncCompletionCallback) {
                        asyncCompletionCallback();
                    }
                }
            }
            else if (asyncCompletionCallback) {
                asyncCompletionCallback();
            }
        }
        else {
            for (var c = 0; c < collection.stories.length; c++) {
                var subcollection = collection.stories[c];
                this._searchCollection(subcollection, searchTerm, searchOptions, results);
            }
        }
    }
    return results;
}

Atheneum.Library.prototype._searchCollection = function (collection, searchTerm, searchOptions, results) {

    if (searchOptions.asynchronous) {
        var atheneum = this.Atheneum;
        setTimeout(function () {
            atheneum.Library._searchCollection_internal(collection, searchTerm, searchOptions, results, true);
        }, 1);
    }
    else {
        this._searchCollection_internal(collection, searchTerm, searchOptions, results);
    }

    return results;
}
Atheneum.Library.prototype._checkIfItemMatches = function (collectionOrAsset, searchTerm, searchOptions, results) {
    if (!this.Atheneum.User.canSee(collectionOrAsset)) {
        return false;
    }

    if (searchTerm && searchTerm.indexOf(':') > 0 && this.Atheneum.Theme.getBooleanProperty('allowSearchTerms', true)) {

        var searchPairs = searchTerm.split(/([^ :]*[:])/)
        if (searchPairs && searchPairs[0].trim().length == 0)
            searchPairs.shift();

        if(collectionOrAsset.id == 'ed29803283c1ba5b01851217b8e0395a')
            console.log('debug');
        for (var i = 0; i < searchPairs.length; i += 2) {
            var searchTag = searchPairs[i] || '';
            searchTag = searchTag.slice(0, -1).trim();

            searchTag = this.Atheneum.Translation.get('searchTagValue_'+searchTag, searchTag);

            var searchValue = searchPairs[i + 1] || '';
            searchValue = searchValue.trim();
            if (searchValue == '' || searchTag == '')
                return false;

            if (this.Atheneum.Filters.searchTerms.indexOf(searchTag) >= 0) {
                if(!collectionOrAsset.hasOwnProperty('properties'))
                    return false;
                if (!collectionOrAsset.properties.hasOwnProperty(searchTag)) {
                    return false;
                }
               
               let tag = this.Atheneum.Filters.filters[this.Atheneum.API.BASE_URL].filter(x=> x.name ==  searchTag)[0];
               let option = tag?.options.filter(x=> collectionOrAsset.properties[searchTag].indexOf(x.name) >= 0);
               
               if(option.length > 0){
                option = option.filter(x=> x.label.toLowerCase().replace(/\s/g, '').indexOf(searchValue.replace(/\s/g, '')) >= 0);
               }
               if(option.length > 0) 
                option = option[0];
               else{
                //check if suboption
                let suboption = tag?.options.filter(x=> x.hasOwnProperty('options') && x.options.filter(y=> collectionOrAsset.properties[searchTag].indexOf(y.name) >= 0).length > 0);
                if(suboption.length > 0){
                    suboption = suboption.filter(x=> x.hasOwnProperty('options') && x.options.filter(y=> collectionOrAsset.properties[searchTag].indexOf(y.name) >= 0 &&  y.label.toLowerCase().replace(/\s/g, '').indexOf(searchValue.toLowerCase().replace(/\s/g, '')) >= 0).length > 0);
                    if(suboption.length > 0) {
                        option = suboption[0].options.find(x=> x.label.toLowerCase().replace(/\s/g, '').indexOf(searchValue.toLowerCase().replace(/\s/g, '')) >= 0);
                    }
                    else 
                        option = null;
                }else{
                    option = null;
                }
               }
            
               let optionLabel = option?.label || '';

                if(collectionOrAsset.properties[searchTag].toLowerCase().indexOf(searchValue.toLowerCase()) < 0 
                && optionLabel.toLowerCase().replace(/\s/g, '').indexOf(searchValue.toLowerCase().replace(/\s/g, '')) < 0)
                    return false;
            } else if (collectionOrAsset.hasOwnProperty(searchTag)) {
                try {

                    if (collectionOrAsset[searchTag].hasOwnProperty('length') && searchValue.length > 1 && searchValue.startsWith('>')) {
                        if (collectionOrAsset[searchTag].length <= parseFloat(searchValue.substr(1, searchValue.length)))
                            return false;
                    } else if(searchTag.indexOf('Date') >= 0){
                        let dateString = searchValue; // Oct 23
                        var dateParts = dateString.split("/");
                        // month is 0-based, that's why we need dataParts[1] - 1
                        var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
                        dateObject.setHours(0,0,0);
                        dateObject = dateObject.getTime() - (dateObject.getTimezoneOffset() * 1000 * 60);

                        let collectionDate = new Date(collectionOrAsset[searchTag]);
                        collectionDate.setHours(0,0,0);
                        collectionDate = collectionDate.getTime() - (collectionDate.getTimezoneOffset() * 1000 * 60);
                        
                        if(collectionDate !== dateObject)
                            return false;

                    } else if (collectionOrAsset[searchTag].hasOwnProperty('length') && searchValue.length > 1 && searchValue.startsWith('<')) {
                        if (collectionOrAsset[searchTag].length >= parseFloat(searchValue.substr(1, searchValue.length)))
                            return false;
                    } else if (typeof collectionOrAsset[searchTag] === 'number' && searchValue.length > 1 && searchValue.startsWith('>')) {
                        if (collectionOrAsset[searchTag] <= parseFloat(searchValue.substr(1, searchValue.length)))
                            return false;
                    } else if (typeof collectionOrAsset[searchTag] === 'number' && searchValue.length > 1 && searchValue.startsWith('<')) {
                        if (collectionOrAsset[searchTag] >= parseFloat(searchValue.substr(1, searchValue.length)))
                            return false;
                    } else {
                        let tagValue = collectionOrAsset[searchTag].toString().toLowerCase();
                        tagValue = tagValue.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');
                        searchValue = searchValue.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');

                        if (tagValue.indexOf(searchValue.toLowerCase()) < 0)
                            return false;
                    }
                } catch (err) {
                    console.log(err);
                    return false;
                }
            } else {
                return false;
            }
        }

        return true;

    }

    for (var p in searchOptions.criteria) {
        var propertyName = p;
        var propertySearchCriteria = searchOptions.criteria[p];
        var matches = this._checkIfItemPropertyMatches(collectionOrAsset, searchTerm, propertyName, propertySearchCriteria, results);
        if (matches) {
            return true;
        }
    }

    if (searchOptions.collectionsMatchIfTheirAssetsOrSubcollectionsMatch) {
        var pseudoResults = { assets: [], collection: [] };
        for (var a = 0; a < collectionOrAsset.assets; a++) {
            var asset = collectionOrAsset.assets[a];
            if (this._checkIfItemMatches(asset, searchTerm, searchOptions, pseudoResults)) {
                return true;
            }
        }
        for (var c = 0; c < collectionOrAsset.stories; c++) {
            var subcollection = collectionOrAsset.stories[c];
            if (this._checkIfItemMatches(collectionOrAsset, searchTerm, searchOptions, pseudoResults)) {
                return true;
            }
        }
        // TODO - forms
    }

    return false;
}
Atheneum.Library.prototype._checkIfItemPropertyMatches = function (collectionOrAsset, searchTerm, propertyName, propertySearchCriteria, results) {
    if (propertyName == 'keywords') {
        var keywords = collectionOrAsset.keywords ? collectionOrAsset.keywords.toLowerCase().split(",") : [];
        for (var k = 0; k < keywords.length; k++) {
            var keyword = keywords[k];
            var matches = this._checkIfItemPropertyValueMatches(searchTerm, keyword, propertySearchCriteria, results);
            if (matches) {
                return true;
            }
        }
        return false;
    }
    else {
        var propertyValue = collectionOrAsset[propertyName] || '';
        return this._checkIfItemPropertyValueMatches(searchTerm, propertyValue, propertySearchCriteria, results);
    }
}

Atheneum.Library.prototype._replaceUnicodeWithAscii = function (text) {
	
	if(text == null) {
		return text;
	}
	
    var replacementMap = {

        '²': '2',
        '³': '3',
        '¼': '1/4',
        '½': '1/2',
        '¾': '3/4',
        'µ': 'u',

        'À': 'A',
        'Á': 'A',
        'Â': 'A',
        'Ã': 'A',
        'Å': 'A',
        'Æ': 'AE',
        'Ç': 'C',
        'È': 'E',
        'É': 'E',
        'Ê': 'E',
        'Ë': 'E',
        'Ì': 'I',
        'Í': 'I',
        'Î': 'I',
        'Ï': 'I',
        'Ĳ': 'IJ',
        'Ð': 'D',
        'Ñ': 'N',
        'Ò': 'O',
        'Ó': 'O',
        'Ô': 'O',
        'Õ': 'O',
        'Ö': 'O',
        'Ő': 'O',
        'Ø': 'O',
        'Ǿ': 'O',
        'Œ': 'OE',
        'Š': 'S',
        'ẞ': 'SS',
        'Ù': 'U',
        'Ú': 'U',
        'Û': 'U',
        'Ü': 'U',
        'Ű': 'U',
        'Ẁ': 'W',
        'Ẃ': 'W',
        'Ŵ': 'W',
        'Ý': 'Y',
        'Ŷ': 'Y',
        'Ÿ': 'Y',
        'Ž': 'Z',

        'à': 'a',
        'á': 'a',
        'â': 'a',
        'ã': 'a',
        'ä': 'a',
        'å': 'a',
        'æ': 'ae',
        'ç': 'c',
        'è': 'e',
        'é': 'e',
        'ê': 'e',
        'ë': 'e',
        'ì': 'i',
        'í': 'i',
        'î': 'i',
        'ï': 'i',
        'ĳ': 'ij',
        'j́': 'j',
        'ð': 'd',
        'ñ': 'n',
        'ò': 'o',
        'ó': 'o',
        'ô': 'o',
        'õ': 'o',
        'ö': 'o',
        'ő': 'o',
        'ø': 'o',
        'ǿ': 'o',
        'œ': 'oe',
        'š': 's',
        'ß': 'ss',
        'ù': 'u',
        'ú': 'u',
        'û': 'u',
        'ü': 'u',
        'ű': 'u',
        'ẁ': 'w',
        'ẃ': 'w',
        'ŵ': 'w',
        'ý': 'y',
        'ŷ': 'y',
        'ÿ': 'y',
        'ž': 'z',
    };

    if(typeof text === 'undefined')
    return '';

    return text.replace(/./g, function (match) {
        var replacement = replacementMap[match];
        if (replacement) {
            return replacement;
        }
        return match;
    });
}

Atheneum.Library.prototype._checkIfItemPropertyValueMatches = function (searchTerm, propertyValue, propertySearchCriteria, results) {

    var searchMode = propertySearchCriteria.mode;

    if (propertySearchCriteria.treatUnicodeAsAscii) {
        searchTerm = this._replaceUnicodeWithAscii(searchTerm);
        propertyValue = this._replaceUnicodeWithAscii(propertyValue);
    }

    if (!propertySearchCriteria.caseSensitive) {
        searchTerm = searchTerm.toLowerCase();
        propertyValue = propertyValue.toLowerCase();
    }

    searchTerm = searchTerm.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');
    propertyValue = propertyValue.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');

    if (propertySearchCriteria.ignorePunctuation) {
        var punctuationRegex = new RegExp("[`~<>{}\[\]|\u3000-\u303F!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]+", "g");
        searchTerm = searchTerm.replace(punctuationRegex, '');
    }

    if (searchMode == Atheneum.Library.SearchMode.EXACT_MATCH) {
        return (propertyValue == searchTerm);
    }
    else if (searchMode == Atheneum.Library.SearchMode.CONTIGUOUS_FROM_START) {
        return (propertyValue.indexOf(searchTerm) == 0);
    }
    else if (searchMode == Atheneum.Library.SearchMode.CONTIGUOUS_FROM_WORD_BOUNDARY) {
        searchTerm = searchTerm.trim();
        var index = propertyValue.indexOf(searchTerm);
        if (index == -1) {
            return false;
        }
        if (index == 0) {
            return true;
        }
        return !!(/\W\w/.test((propertyValue.substring(index - 1, index))));
    }
    else if (searchMode == Atheneum.Library.SearchMode.CONTIGUOUS_ANYWHERE_IN_TEXT) {
        return (propertyValue.indexOf(searchTerm) != -1);
    }

    // if program flow reaches here, search mode requires the searchTerm and propertyValue to be treated as individual words

    var searchTermWords = searchTerm.split(/\b/) || [];
    var w = 0;
    while (w < searchTermWords.length) {
        var word = searchTermWords[w];
        if (word.trim() == '') {
            searchTermWords.splice(w, 1);
            continue;
        }
        w++;
    }


    var propertyValueWords = propertyValue.split(/\b/) || [];
    var p = 0;
    while (p < propertyValueWords.length) {
        var propertyValueWord = propertyValueWords[p];
        if (propertyValueWord.trim() == '') {
            propertyValueWords.splice(p, 1);
            continue;
        }
        p++;
    }


    var propertyValueWordsAlreadyMatched = {}; // to ensure the same word can't match twice

    var lastKeywordToMatch = -1;

    var matchesAllWords = true;
    for (var w = 0; w < searchTermWords.length; w++) {
        var word = searchTermWords[w];
        var isLastWord = (w == (searchTermWords.length - 1));

        var matchIndex = -1;
        for (var p = (lastKeywordToMatch + 1); p < propertyValueWords.length; p++) {
            var propertyValueWord = propertyValueWords[p];

            if (propertyValueWordsAlreadyMatched[p]) {
                // this word has already been used for a match
                continue;
            }

            var matches = false;

            if (searchMode == Atheneum.Library.SearchMode.FUZZY) {
                // fuzzy match - anywhere within the word is fine.  "test" matches "contested" 
                matches = (propertyValueWord.indexOf(word) != -1);
            }
            else if (isLastWord
                || searchMode == Atheneum.Library.SearchMode.ORDERED_PARTIAL_WORDS
                || searchMode == Atheneum.Library.SearchMode.UNORDERED_PARTIAL_WORDS) {
                // partial match - must begin at start of word. "test" matches "testing"
                matches = (propertyValueWord.indexOf(word) == 0);
            }
            else {
                // exact match - must match word exactly. "test" matches "test" and nothing else
                matches = (propertyValueWord == word);
            }

            if (matches) {
                matchIndex = p;
                propertyValueWordsAlreadyMatched[p] = true;
                break;
            }

        }

        if (matchIndex == -1) {
            // word did not match
            matchesAllWords = false;
            break;
        }

        if (searchMode == Atheneum.Library.SearchMode.ORDERED_WORDS
            || searchMode == Atheneum.Library.SearchMode.ORDERED_PARTIAL_WORDS) {
            lastKeywordToMatch = matchIndex;
        }

    }

    return matchesAllWords;
}

/** Returns an array of assets that are considered "related" to the asset in some way */
Atheneum.Library.prototype.getSimilarAssets = function (assetOrAssetId, number) {

    var asset = (typeof assetOrAssetId === "string") ? this.assets[assetOrAssetId] : assetOrAssetId;
    number = (typeof number !== "number" || number >= 0) ? 10 : number;

    if (asset == undefined || number == 0)
        return [];

    // contained in same collection: 	+ 2
    // similar words in title: 			+ 1 per word (over 5 characters)
    // shared keywords: 				+ 3 per keyword
    // same doc_id						- infinity

    var rankings = {};

    var assetKeywords = asset.keywords ? asset.keywords.toLowerCase().split(",") : [];
    var assetTitleImportantWords = asset.name.toLowerCase().split(" ").filter(function (word) { return (word.length > 5); });

    for (var assetId in this.assets) {
        if (!(this.assets.hasOwnProperty(assetId)))
            continue;

        var other = this.assets[assetId];

        if (asset.docId && asset.docId == other.docId) // don't include itself or duplicates
            continue;

        if (!this.Atheneum.User.canSee(other)) {
            continue; // skip assets the user is not meant to see
        }

        var similarity = (asset.containedBy == other.containedBy) ? 2 : 0;

        var otherKeywords = other.keywords ? other.keywords.toLowerCase().split(",") : [];
        for (var i = 0; i < otherKeywords.length; i++) {
            if (assetKeywords.contains(otherKeywords[i]))
                similarity += 3;
        }

        var otherTitleImportantWords = other.name.toLowerCase().split(" ").filter(function (word) { return word.length > 5; });
        for (var i = 0; i < otherTitleImportantWords.length; i++) {
            if (assetTitleImportantWords.contains(otherTitleImportantWords[i]))
                similarity += 1;
        }

        if (similarity > 0)
            rankings[assetId] = similarity;
    }

    array = [];
    for (var assetId in rankings) {
        if (!(rankings.hasOwnProperty(assetId)))
            continue;

        array[array.length] = { asset: this.assets[assetId], similarity: rankings[assetId] };
    }


    array.sort(function (a, b) { return b.similarity - a.similarity; });

    // optional:
    for (var i = 0; i < array.length; i++) {
        // ensure there is only one asset per document id in the list

        var docs = this.documents[array[i].asset.docId];

        if (docs.length <= 1)
            continue;

        var dupesFound = 0;

        for (var j = i + 1; j < array.length; j++) {

            if (docs.contains(array[j].asset.id)) {
                dupesFound += 1;
                array.splice(j, 1);
                if (dupesFound + 1 == docs.length)
                    break;
            }
        }

        if (dupesFound > 0)
            i = i - 1;
    }

    return array.slice(0, number).map(function (thing) { return thing.asset; });
}

Atheneum.Library.prototype.getRelatedAssets = function(assetId, callback) {
    let asset = this.assets[assetId];
    if(!asset || !this.Atheneum.User.canSee(asset))
        return [];

    let library = this;
    this.Atheneum.API.getRelatedAssets(assetId, {
        success: function(json){
            let relatedAssets = typeof asset.relatedAssets === 'string' ? asset.relatedAssets?.split(',') : asset.relatedAssets;
            let initialRelatedAssets = json.relatedAssets || relatedAssets || [];
            callback(library._getRelatedAssets(assetId, initialRelatedAssets));
        },
        failure: function (reason, httpStatus, errorCode){
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Library.getRelatedAssets");

            let relatedAssets = typeof asset.relatedAssets === 'string' ? asset.relatedAssets?.split(',') : asset.relatedAssets;
            let initialRelatedAssets = relatedAssets || [];
            callback(library._getRelatedAssets(assetId, initialRelatedAssets));
            return 
        }
    });
}

Atheneum.Library.prototype._getRelatedAssets = function(assetId, initialRelatedAssets){
   
    let asset = this.assets[assetId];
    let atheneum = this.Atheneum;
    if(!asset || !this.Atheneum.User.canSee(asset))
        return [];

    if(!initialRelatedAssets)
    initialRelatedAssets = [];
    
    //Priority 1 - Siblings
    let relatedAssets = [];
    let collection = this.collections[asset.containedBy];
    if(collection){
        relatedAssets = collection.assets;
    }

    if(this.Atheneum.Theme.getIntegerProperty("relatedAssetsMaxSiblings", 20) > relatedAssets.length){
        relatedAssets = relatedAssets.slice(0, this.Atheneum.Theme.getIntegerProperty("relatedAssetsMaxSiblings", 20));
    }

    relatedAssets = relatedAssets.sort(function (assetA, assetB) {
        var assetA_sortOrder = (assetA.order == undefined) ? ((assetA.assetOrder == undefined) ? 99999 : assetA.assetOrder) : assetA.order;
        var assetB_sortOrder = (assetB.order == undefined) ? ((assetB.assetOrder == undefined) ? 99999 : assetB.assetOrder) : assetB.order
        return (assetA_sortOrder > assetB_sortOrder) ? 1 : -1;
    });

    let i;
    let highPrioritySiblings = [];
    let siblingRelatedAssets = [];
    let highPrioritySiblingNames = this.Atheneum.Theme.getStringProperty('highPrioritySiblingNames', '').split(',');

    for(i=0; i<relatedAssets.length; i++){
        if(highPrioritySiblingNames.indexOf(relatedAssets[i].name) >= 0){
            let ra = relatedAssets[i];
            ra.highPriority = true;
            ra.description = SalesToolkit.Translation.get('highPriortySiblingDescription'+relatedAssets[i].name, '');
            ra.title = SalesToolkit.Translation.get('highPriortySiblingTitle'+relatedAssets[i].name, '');
            highPrioritySiblings.push(ra);
        }else{
            siblingRelatedAssets.push(relatedAssets[i]);
        }
    }
    
    let manuallyRelated = [];
    let highPriorityManuallyRelated = [];

    //Priority 2 - Manually rleated assets
    for(i = 0; i < initialRelatedAssets?.length; i++){
        let relatedAssetId = typeof initialRelatedAssets[i] === 'string'? initialRelatedAssets[i] : initialRelatedAssets[i].id;
        if(relatedAssets.some(x=> x.id === relatedAssetId))
            continue;
        
        let relatedAsset = this.assets[relatedAssetId];

         //adding new fields 
         if(initialRelatedAssets[i].title){
            relatedAsset.title = initialRelatedAssets[i].title;
        }
        if(initialRelatedAssets[i].highPriority){
            relatedAsset.highPriority = initialRelatedAssets[i].highPriority;
        }else{
            relatedAsset.highPriority = false;
        }
        if(initialRelatedAssets[i].description){
            relatedAsset.description = initialRelatedAssets[i].description;
        }

        if(!relatedAsset || !this.Atheneum.User.canSee(relatedAsset)){
            continue;
        }

        relatedAsset.manuallyRelated = true;
      
        if(initialRelatedAssets[i].highPriority){
            highPriorityManuallyRelated.push(relatedAsset);
        }else{
            manuallyRelated.push(relatedAsset);
        }

    }

    highPriorityManuallyRelated = highPriorityManuallyRelated.sort(function (a, b) {
        if (a.name && !b.name)
        return 1;
        if (!a.name && b.name)
            return -1;

        if (!a.name && !b.name)
            return 0;

        let aName = $("<div>"+a.name+"</div>").text();
        let bName = $("<div>"+b.name+"</div>").text();
        if(a.fullTitle && atheneum.Theme.getBooleanProperty('collectionBrowserUseFullTitle', true)){
            aName = $("<div>"+a.name + " - " + a.fullTitle+"</div>").text();
        }

        if(b.fullTitle && atheneum.Theme.getBooleanProperty('collectionBrowserUseFullTitle', true)){
            bName = $("<div>"+b.name + " - " + b.fullTitle+"</div>").text();
        }

        if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
        if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
        return 0;
});


    manuallyRelated = manuallyRelated.sort(function (a, b) {
        if (a.name && !b.name)
            return 1;
        if (!a.name && b.name)
            return -1;

        if (!a.name && !b.name)
            return 0;

        let aName = $("<div>"+a.name+"</div>").text();
        let bName = $("<div>"+b.name+"</div>").text();
        if(a.fullTitle && atheneum.Theme.getBooleanProperty('collectionBrowserUseFullTitle', true)){
            aName = $("<div>"+a.name + " - " + a.fullTitle+"</div>").text();
        }

        if(b.fullTitle && atheneum.Theme.getBooleanProperty('collectionBrowserUseFullTitle', true)){
            bName = $("<div>"+b.name + " - " + b.fullTitle+"</div>").text();
        }


        if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
        if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
        return 0;
    });

    relatedAssets = highPrioritySiblings;
    relatedAssets = relatedAssets.concat(highPriorityManuallyRelated);
    relatedAssets = relatedAssets.concat(siblingRelatedAssets);
    relatedAssets = relatedAssets.concat(manuallyRelated)
    relatedAssets = relatedAssets.filter(x=> x.id !== assetId);
    //Priority 3 - Tags ONLY IF NO ITEMS 

    if(this.Atheneum.Theme.getBooleanProperty('onlyShowTagRelatedIfNoOthers', true) && relatedAssets.length > 0)
        return relatedAssets;

    let maxTagRelated = this.Atheneum.Theme.getIntegerProperty('maximumTagRelatedAssets', 10);

    let assets = Object.values(this.assets).filter(x => this.Atheneum.User.canSee(x));
    assets = assets.filter(x=> x.hasOwnProperty('properties'));
    if(asset.hasOwnProperty('properties'))
        assets = assets.filter(x=> Object.keys(x.properties).filter(obj1item =>  Object.keys(asset.properties).indexOf(obj1item) !== -1 ));
    
    let tagRelatedAssets = [];
    assets.forEach(element => {
        if(this.doAssetsShareProperties(asset, element)){
            tagRelatedAssets.push(element);
        }
    });

    if(tagRelatedAssets.length < maxTagRelated)
        maxTagRelated = tagRelatedAssets.length;

 //   tagRelatedAssets = tagRelatedAssets.filter(x=> this.doAssetsShareProperties(asset, x));
    let tagRelatedCount = 0;
    for(i = 0; i < maxTagRelated; i++){
        
        let tagRelatedAsset = tagRelatedAssets[i];
        if(!tagRelatedAsset || !this.Atheneum.User.canSee(tagRelatedAsset)){
            continue;
        }

        if(relatedAssets.some(x=> x.id === tagRelatedAsset.id))
            continue;
        
        relatedAssets.push(tagRelatedAsset);
        tagRelatedCount += 1;
        if(tagRelatedCount > maxTagRelated)
            break;
    }
   
    return relatedAssets.filter(x=> x.id !== assetId);
}

Atheneum.Library.prototype.clear = function(){
    this.assets = {};
    this.collections = {};
    this.documents = {};
    this.topLevelCollections = {};
    this.timestamp = 0;

    localStorage.removeItem("atheneumLibraryCollectionIndex");
    localStorage.removeItem("atheneumLibraryData");

    Object.keys(localStorage)
 .filter(x =>
    x.startsWith('atheneumLibraryCollectionData-'))
 .forEach(x => 
    localStorage.removeItem(x))
    
    this.saveToStorageAsync();
    this.saveToStorage();
  
}

Atheneum.Library.prototype.doAssetsShareProperties = function(assetA, assetB){
    if(!assetA || typeof assetA !== 'object')
        return false;
    
    if(!assetB || typeof assetB !== 'object')
        return false;

    let assetAProperties = assetA.properties;
    let assetBProperties = assetB.properties;

    if(!assetAProperties || !assetBProperties)
        return false;

    let keysA = Object.keys(assetAProperties);

    for(var i=0; i<keysA.length; i++){
        let keyA = keysA[i];
        if(assetBProperties.hasOwnProperty(keyA)){
            let aSplit = assetAProperties[keyA].split(',');
            let bSplit = assetBProperties[keyA].split(',');

            // checks whether an element is even
            if(aSplit.some((element) => bSplit.indexOf(element) >= 0)){
                return true;
            }
        }
    }

    return false;
}

Atheneum.Library.prototype.getAssetPreview = function (assetId, callback) {

    if (this.Atheneum.CrossPlatform.enabled) {
        var successCallback = ((typeof callback == "function") ? callback : callback.success);
        var previewCallbacks = {
            success: successCallback,
            failure: ((typeof callback == "object") ? callback.failure : function () { successCallback({ responseText: "<p>Unable to load Asset Preview</p>", status: 200 }); }),
        }

        this.Atheneum.CrossPlatform.getAssetPreview(assetId, previewCallbacks);

    } else if (this.Atheneum.Proxy.enabled) {

        var successCallback = ((typeof callback == "function") ? callback : callback.success);

        var previewCallbacks = {
            success: successCallback,
            failure: ((typeof callback == "object") ? callback.failure : function () { successCallback({ responseText: "<p>Unable to load Asset Preview</p>", status: 200 }); }),
        }

        this.Atheneum.HttpUtils.makeRequest(
            "GET",
            "restful/library/" + assetId + "/preview",
            { apikey: this.Atheneum.User.apikey },
            previewCallbacks
        );

    } else {

        let atheneum = this.Atheneum;
        var asset = this.Atheneum.Library.assets[assetId];
        var failed = false;

        if (asset == undefined || asset.containedBy == undefined) {
            return callback.failure({ status: 404, responseText: "" });
        }

        if (asset) {
            var collectionId = asset.containedBy;

            if (asset.canPreview === false) {
                if (typeof callback == "object" && callback.failure) {
                    callback.failure({ status: 404, responseText: "" });
                } else {
                    ((typeof callback == "function") ? callback : callback.success)({ responseText: "<p>Asset Preview Not Allowed</p>", status: 200 });
                }
            }
            var result = "";
            var src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "?apikey=" + this.Atheneum.User.apikey;
            if( !atheneum.Theme.getBooleanProperty('ignoreStreamingLocations', false)
                && asset.streamingLocations
                && asset.streamingLocations.length > 0
                && asset.streamingLocations.filter(function(s) { return s.type == 'JWPlayer' || s.type == 'JW Player'; }).length > 0 ) {
            
            delete window.jwplayer;
            
            var streamingLocation = asset.streamingLocations.filter(function(s) { return s.type == 'JWPlayer' || s.type == 'JW Player'; })[0];
            
            var jwPlayerVideoKey = streamingLocation.videoKey || (streamingLocation.properties || { }).videoKey || '';
            var jwPlayerPlayerKey = streamingLocation.playerKey || (streamingLocation.properties || { }).playerKey || '';
            
            var jwPlayerStreamKey = streamingLocation.key || (streamingLocation.properties || { }).key || (jwPlayerVideoKey + '-' + jwPlayerPlayerKey);
            
            var jwPlayerDivId = 'botr_' + jwPlayerVideoKey + '_' + jwPlayerPlayerKey + '_div';
            
            var jwPlayerPlayerScriptSrc = 'https://cdn.jwplayer.com/libraries/' + jwPlayerPlayerKey + '.js';
            
            var jwPlayerVideoPlaylistUrl = 'https://cdn.jwplayer.com/v2/media/' + jwPlayerVideoKey;
            
            // NOTE: jwplayer has a bug in their default embed script that causes the player to fail to load
            // with an error about being unable to parse an rss feed. That was fun to discover a workaround for
            
            //var jwPlayerEmbedScriptSrc = 'https://cdn.jwplayer.com/players/' + jwPlayerStreamKey + '.js';

            result =   '<div class="assetPreviewVideoStream assetPreviewMedia">'
            +	'<div class="jwplayer-container">'
            +		'<div id="' + jwPlayerDivId + '" class="jwplayer-replacement"></div>'
            +	'</div>'
            + '</div>'
            var jwPlayerScript = document.createElement('SCRIPT');
            jwPlayerScript.addEventListener('load', function() {
                // wait for script to run to avoid race conditions
                Atheneum.HttpUtils.getJSON(jwPlayerVideoPlaylistUrl, function(json) {
                    
                    if(!window.jwplayer) {
                        return;
                    }
                    var playlist = json.playlist;
                    if(!playlist) {
                        return;
                    }
                    var jwplayerInstance = jwplayer(document.getElementById(jwPlayerDivId));
                    if(!jwplayerInstance) {
                        return;
                    }
                    jwplayerInstance.setup({
                        "playlist": playlist
                    });
                    
                    if(jwplayerInstance.onReady) {
                        jwplayerInstance.onReady(function() {
                            
                            if(atheneum.Theme.getBooleanProperty('playVideosOnce', true)) {
                                jwplayerInstance.onComplete(showCertificateFormIfExistsOrTriggerBackButtonClick);
                            }
                            else {
                                // jwplayer doesn't have a nice way of looping, need to do it manually
                                jwplayerInstance.onBeforeComplete(function() {
                                    jwplayerInstance.seek(0);
                                    jwplayerInstance.play();
                                });
                            }
                            
                            jwplayerInstance.onPlay(onVideoPlaying);
                            jwplayerInstance.onTime(onVideoPlaying);
                            jwplayerInstance.onFirstFrame(onVideoPlaying);
                            
                            jwplayerInstance.onComplete(onVideoPausedOrStopped);
                            jwplayerInstance.onPause(onVideoPausedOrStopped);
                            //jwplayerInstance.on('idle', onVideoPausedOrStopped);
                            //jwplayerInstance.on('error', onVideoPausedOrStopped);
                        });
                    }
                    else {
                        jwplayerInstance.on('ready', function() {

                            jwplayerInstance.on('firstFrame', function(){
                                atheneum.currentTrackedPreview = atheneum.Tracking.startTrackingAssetView( assetId );
                                $('#videoSection').data('previewLoadTime', ''+(new Date().getTime()));
                                onVideoPlaying();
                            });
                            
                            if(atheneum.Theme.getBooleanProperty('playVideosOnce', true)) {
                                jwplayerInstance.on('complete', showCertificateFormIfExistsOrTriggerBackButtonClick);
                            }
                            else {
                                // jwplayer doesn't have a nice way of looping, need to do it manually
                                jwplayerInstance.on('beforeComplete', function() {
                                    jwplayerInstance.seek(0);
                                    jwplayerInstance.play();
                                });
                            }
                            
                            jwplayerInstance.on('play', onVideoPlaying);
                            jwplayerInstance.on('time', onVideoPlaying);
                            
                            jwplayerInstance.on('complete', onVideoPausedOrStopped);
                            jwplayerInstance.on('pause', onVideoPausedOrStopped);
                            //jwplayerInstance.on('idle', onVideoPausedOrStopped);
                            //jwplayerInstance.on('error', onVideoPausedOrStopped);
                        });
                    }
                });
            });
            jwPlayerScript.setAttribute('src', jwPlayerPlayerScriptSrc);
            if (typeof callback == "object" && callback.success)
                callback.success({ responseText: result, script: jwPlayerScript, status: 200 });
            else
                failed = true;
            return;
          
        } else if (asset.mimetype == "application/pdf") {

                //            	result = '<div><iframe src="plugins/pdfjs/web/viewer.html?file=' + encodeURIComponent(src) + '"></iframe></div>';
                //                //result = "<embed width='100%' height='100%' name='plugin' style='z-index: 0;' wmode='opaque' data='" + src + "#toolbar=0&amp;navpanes=1&amp;scrollbar=1' type='application/pdf' />";
                //                //result = "<div><object width='100%' height='100%' style='z-index: 0;' wmode='opaque' data='" + src + "#toolbar=0&navpanes=0&scrollbar=1'><param name=\"wmode\" value=\"opaque\" /><p>Previewing this Asset requires </p></object></div>"; // download.pdf -> browser attempts to download it and breaks the preview
                result = "<div class='assetPreviewPDF'><iframe width='100%' height='100%'  style='z-index: 0; border:none;' wmode='opaque' src='plugins/pdfjs/web/viewer.html?file=" + encodeURIComponent(src) + "' /></div>";
            }
            else if (asset.mimetype == "image/vnd.dwg" || asset.mimetype == "image/x-dwg") {
                //Cad files not available for preview in web app
                failed = true;
            }
            else if (asset.mimetype.startsWith("image")) {
                result = "<img class='assetPreviewImage' src='" + src + "' />";
            }
            else if (asset.mimetype.startsWith("audio")) {

                let audioPlay = this.Atheneum.Theme.getBooleanProperty('audioAutoPlayIfPossible', true);
                result = "<audio controlsList='nodownload' "+(audioPlay? "autoplay" : "")+" controls>"+
                "<source src='"+src+"' type='"+asset.mimetype+"'>"+
                this.Atheneum.Translation.get('audioNotSupported', 'Your browser does not support audio files')+
                "</audio>"
                
            }
            else if (asset.mimetype == "video/x-ms-wmv") {

                var networkInfo = (navigator) ? navigator.connection : null;
                var quality = "HIGH";
                if (networkInfo) {
                    if (networkInfo.type == "cellular" || networkInfo.type == "bluetooth") {
                        if (network.effectiveType != "4g" && network.effectiveType != "5g")
                            quality = "LOW";
                    }
                }

                src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "/stream/" + quality + "?apikey=" + this.Atheneum.User.apikey;

                result = "<object "
                    + "width=\"100%\" "
                    + "height=\"100%\" "
                    + "classid=\"CLSID:22d6f312-b0f6-11d0-94ab-0080c74c7e95\" "
                    + "codebase=\"http://activex.microsoft.com/activex/controls/mplayer/en/nsmp2inf.cab#Version=5,1,52,701\" "
                    + "standby=\"Loading Microsoft Windows Media Player components...\" "
                    + "type=\"application/x-oleobject\"> "
                    + "<param name=\"fileName\" value=\"" + src + "\"> "
                    + "<param name=\"animationatStart\" value=\"true\"> "
                    + "<param name=\"transparentatStart' value=\"true\"> "
                    + "<param name=\"autoStart' value=\"false\"> "
                    + "<param name=\"showControls' value=\"true\"> "
                    + "<param name=\"loop\" value=\"false\"> "
                    + "<embed type=\"application/x-mplayer2\" "
                    + "pluginspage=\"http://microsoft.com/windows/mediaplayer/en/download/\" "
                    + "showcontrols=\"true\" "
                    + "width=\"100%\" "
                    + "height=\"100%\" "
                    + "src=\"" + src + "\" autostart=\"true\" designtimesp='5311' loop=\"true\"> "
                    + "</embed> "
                    + "</object>";
            } 
            else if (asset.mimetype.startsWith("video")) {
                var networkInfo = (navigator) ? navigator.connection : null;
                var quality = "HIGH";
                if (networkInfo) {
                    if (networkInfo.type == "cellular" || networkInfo.type == "bluetooth") {
                        if (network.effectiveType != "4g" && network.effectiveType != "5g")
                            quality = "LOW";
                    }
                }

                let backupsrc = src;
                src = this.Atheneum.API.BASE_URL_NO_PROXY + "/stories/" + collectionId + "/assets/" + assetId + "/stream/" + quality + "?apikey=" + this.Atheneum.User.apikey;

                result = '<div class="assetPreviewVideo assetPreviewMedia"><video controls autoplay oncontextmenu="return false;" controlsList="nodownload"><source src="'+src+'" type="'+asset.mimetype+'"><source src="'+backupsrc+'" type="'+asset.mimetype+'"></video></div>'
            }
            else if (asset.mimetype == "asset/url") {
                if (asset.url) {
                    result = '<div class="assetPreviewURL"><iframe allowfullscreen="true" allow="fullscreen" src="' + asset.url + '" /></div>';
                } else {
                    failed = true;
                }

            }
            else if (asset.mimetype == "text/html") { // not sure there are actually any of these,but just in case
                result = "<iframe src='" + src + "' width='100%' height='100%'/>";
            }
            else if (asset.mimetype == "text/plain") {
                result = "<iframe src='" + src + "' width='100%' height='100%'/>";
            }
            else if (asset.mimetype == "application/zip") {
               
                let zipSrc = this.Atheneum.API.BASE_URL + "/stories/" + collectionId + "/assets/" + assetId + "/zip/index.html?apikey=" + this.Atheneum.User.apikey;
               
                let useStaticPresentationUrl = atheneum.Theme.getBooleanProperty('useStaticPresentationUrl', true);
                if(useStaticPresentationUrl){
                    rc_base_url = window.location.origin;
                    zipSrc = rc_base_url + "/static/presentations/" + assetId + "/index.html";
                    //zipSrc = "http://localhost:3000//presentations/hivisdatamapvisualizationhtml/src/index.html";
                    //zipSrc = "http://localhost:3000/presentations/sdlPresentation/index.html";
                }
             
                result = "<iframe data-assetId= '"+assetId+"' src='" + zipSrc + "' width='100%' height='100%' scrolling='YES' class='presentation' />";

            }
            else {
                failed = true;
            }

            if (failed === false && callback.success) {
                if (typeof callback == "object" && callback.success)
                    callback.success({ responseText: result, status: 200 });
                else
                    callback({ responseText: result, status: 200 });
            }

        }
        if (failed === true) {
            if (typeof callback == "object" && callback.failure) {
                callback.failure({ status: 404, responseText: "" });
            } else {
                ((typeof callback == "function") ? callback : callback.success)({ responseText: "<p>Asset Preview Unavailable</p>", status: 200 });
            }
        }
    }
}

Atheneum.Library.prototype.downloadAsset = function (assetId, buttonElement, callback, failureCallback) {
    var atheneumLibrary = this;

    var callbacks = Atheneum.Callbacks.parse(callback, failureCallback);

    var asset = this.assets[assetId];
    if (asset == undefined)
        return; // TODO: throw an error or call failure callback

    var collectionId = asset.containedBy;

    if (this.Atheneum.Proxy.enabled) {
        this.Atheneum.Cache.downloadAsset(assetId, callbacks);
        return;
    }

    this.Atheneum.API.getAssetDownloadLink(collectionId, assetId, {

        success: function (json) {

            var fileUrl = json.link + "?apikey=" + atheneumLibrary.Atheneum.User.apikey;
            var fileName = (atheneumLibrary.assets[assetId] || {}).name || ("asset" + assetId);

            // TODO: prompt to download file with correct filename

            if (atheneumLibrary.Atheneum.CrossPlatform.enabled) {

                var buttonRect = { x: 0, y: 0, width: 0, height: 0 };
                if (buttonElement && buttonElement.getBoundingClientRect) {
                    buttonRect = buttonElement.getBoundingClientRect() || { x: 0, y: 0, width: 0, height: 0 };
                }

                atheneumLibrary.Atheneum.CrossPlatform.shareDocument(
                    fileUrl,
                    buttonRect.x,
                    buttonRect.y,
                    buttonRect.width,
                    buttonRect.height,
                    asset.realFileMimetype || asset.mimetype || 'application/octet-stream',
                    fileName,
                    callbacks
                );
                return;
            }

            var oReq = new XMLHttpRequest();

            oReq.open("GET", fileUrl, true);

            oReq.responseType = "blob";

            oReq.onload = function () {

                var file = new Blob([oReq.response], {
                    type: oReq.getResponseHeader('Content-Type') || 'application/octet-stream'
                });

                var downloadurl = window.URL.createObjectURL(file);

                var downloadLink = document.createElement("A");
                downloadLink.setAttribute("download", fileName);
                downloadLink.href = downloadurl;
                document.querySelector("body").appendChild(downloadLink);
                downloadLink.click();
                document.querySelector("body").removeChild(downloadLink);

                callbacks.success();

            };
            oReq.send();

        },

        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Library.downloadAsset");

            return callbacks.failure(reason, httpStatus, errorCode);
        }
    });
}

Atheneum.NewsFeed = function (atheneum) {

    if (!(this instanceof Atheneum.NewsFeed))
        return new Atheneum.NewsFeed(atheneum);

    this.Atheneum = atheneum;

    this.timestamp = undefined;
    this.__realItems = {};
    this.items = {};

    this.__pendingComments = [];

    this.loadFromStorage();

    this.applyOfflineChanges(true);

}

Atheneum.NewsFeed.prototype.applyOfflineChanges = function (updateServer) {

    updateServer = !!updateServer;

    this.items = JSON.parse(JSON.stringify(this.__realItems));

    for (var i = 0; i < this.__pendingComments.length; i++) {
        var pendingComment = this.__pendingComments[i];

        var article = this.items[pendingComment.newsItemId];

        if (article) {
            if (article.comments && article.comments.length > 0) {

                var found = false;
                for (var j = 0; j < article.comments.length; j++) {
                    if (article.comments[j].id == pendingComment.id)
                        found = true;
                }

                if (!found)
                    article.comments[article.comments.length] = pendingComment;

            } else {
                article.comments = [pendingComment];
            }
        }
    }

    if (updateServer && this.Atheneum.User.apikey) {
        this.submitOfflineComments();
    }
}

Atheneum.NewsFeed.prototype.submitOfflineComments = function () {

    var atheneumNewsFeed = this;

    if (!this.__pendingComments || this.__pendingComments.length == 0) {
        return atheneumNewsFeed.onAllOfflineCommentsSubmitted();
    }

    var pendingComment = this.__pendingComments[0];

    atheneumNewsFeed.postComment(pendingComment.newsItemId, pendingComment.comment, {

        success: function () {

            atheneumNewsFeed.__pendingComments.splice(0, 1);
            atheneumNewsFeed.Atheneum.LocalStorage.set('atheneumNewsFeedPendingCommentsByUser_' + atheneumNewsFeed.Atheneum.User.username, JSON.stringify(atheneumNewsFeed.__pendingComments));
            atheneumNewsFeed.applyOfflineChanges(false);
            atheneumNewsFeed.submitOfflineComments();
        },

        failure: function (reason, httpStatus, errorCode) {

            if (reason == atheneumNewsFeed.Atheneum.API.Problems.CONNECTION_FAILED
                || (reason == atheneumNewsFeed.Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {

                // oops, we're still offline. stop so we keep comments in the correct order
                // delete the newly added comment, as otherwise we'd double the number of offline comments every page load
                atheneumNewsFeed.__pendingComments.splice(atheneumNewsFeed.__pendingComments.length - 1, 1);
                atheneumNewsFeed.Atheneum.LocalStorage.set('atheneumNewsFeedPendingCommentsByUser_' + atheneumNewsFeed.Atheneum.User.username, JSON.stringify(atheneumNewsFeed.__pendingComments));
                atheneumNewsFeed.applyOfflineChanges();
            }
        }
    });

}

Atheneum.NewsFeed.prototype.onAllOfflineCommentsSubmitted = function () { };

Atheneum.NewsFeed.prototype.saveToStorage = function () {

    if (this.Atheneum.User.username)
        this.Atheneum.LocalStorage.set('atheneumNewsFeedPendingCommentsByUser_' + this.Atheneum.User.username, JSON.stringify(this.__pendingComments));

    this.Atheneum.LocalStorage.set('atheneumNewsFeedData', JSON.stringify(this.__realItems));
    this.Atheneum.LocalStorage.set('atheneumNewsFeedTimestamp', this.timestamp);
}

Atheneum.NewsFeed.prototype.loadFromStorage = function () {

    this.__pendingComments = JSON.parse(this.Atheneum.LocalStorage.get('atheneumNewsFeedPendingCommentsByUser_' + this.Atheneum.User.username) || "[]") || [];

    var feedItemsString = this.Atheneum.LocalStorage.get('atheneumNewsFeedData');
    if (feedItemsString != undefined) {
        this.__realItems = JSON.parse(feedItemsString);
        this.timestamp = this.Atheneum.LocalStorage.get('atheneumNewsFeedTimestamp');
    } else {
        this.__realItems = {};
        this.items = {};
        this.timestamp = undefined;
    }

    this.applyOfflineChanges(false);
}

Atheneum.NewsFeed.prototype.updateUnreadReplies = function (timestamp, callback) {

    // update the replies
    var atheneumNewsFeed = this;
    if(this.Atheneum.Theme.getBooleanProperty("disableFeatureNews", false)){
        return;
    }

    var unreadReplyIds = JSON.parse(atheneumNewsFeed.Atheneum.User.preferences['_unreadReplies'] || '[]')
    var newUnreadReplies = atheneumNewsFeed.getCommentsByOthers(timestamp);

    for (var i = 0; i < newUnreadReplies.length; i++) {
        if (!unreadReplyIds.contains(newUnreadReplies[i].id))
            unreadReplyIds[unreadReplyIds.length] = newUnreadReplies[i].id;
    }

    return atheneumNewsFeed.Atheneum.User.changePreferences({ '_unreadReplies': JSON.stringify(unreadReplyIds) }, {
        success: function () {

            // atheneumNewsFeed.Atheneum.User.preferences['_unreadReplies'] = JSON.stringify(unreadReplyIds);
            // ^ just to make absolutely sure it's updated

            if (typeof atheneumNewsFeed.onReplyUpdate === 'function') {
                atheneumNewsFeed.onReplyUpdate();
            }
        },

        failure: function (reason, httpStatus, errorCode) {
            // TODO: try again until it works
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode);
        }
    });
}

Atheneum.NewsFeed.prototype.update = function AtheneumNewsFeed_update(callback) {

    var successCallback = (typeof callback == "function") ? callback : ((callback != undefined) ? callback.success : undefined);
    var failureCallback = (typeof callback == "object") ? callback.failure : function () { };

    var atheneumNewsFeed = this;

    if (this.Atheneum.CrossPlatform.enabled) {
        var callbacks = {

            success: function (json) {
                if (json.deletedItems) {
                    for (var i = 0; i < json.deletedItems.length; i++) {
                        atheneumNewsFeed.handleItemDeletion(json.deletedItems[i]);
                    }
                }

                atheneumNewsFeed.__realItems = {};
                if (json.items) {
                    for (var i = 0; i < json.items.length; i++) {
                        atheneumNewsFeed.handleItemUpdate(json.items[i]);
                    }
                }
                var lastTimestamp = atheneumNewsFeed.timestamp;
                atheneumNewsFeed.timestamp = json.timestamp;
                atheneumNewsFeed.applyOfflineChanges(false);
                atheneumNewsFeed.saveToStorage();

                atheneumNewsFeed.updateUnreadReplies(lastTimestamp);

                if (typeof successCallback === "function")
                    successCallback();
            },

            failure: failureCallback
        };

        return this.Atheneum.CrossPlatform.updateNewsFeed(callbacks);
    }
    else {
        return this.Atheneum.API.getFeedItems(null, undefined, {

            success: function (json) {
                if (json.deletedItems) {
                    for (var i = 0; i < json.deletedItems.length; i++) {
                        atheneumNewsFeed.handleItemDeletion(json.deletedItems[i]);
                    }
                }

                atheneumNewsFeed.__realItems = {};
                if (json.items) {
                    for (var i = 0; i < json.items.length; i++) {
                        atheneumNewsFeed.handleItemUpdate(json.items[i]);
                    }
                }
                var lastTimestamp = atheneumNewsFeed.timestamp;
                atheneumNewsFeed.timestamp = json.timestamp;
                atheneumNewsFeed.applyOfflineChanges(false);
                atheneumNewsFeed.saveToStorage();

                atheneumNewsFeed.updateUnreadReplies(lastTimestamp);

                if (typeof successCallback === "function")
                    successCallback();
            },

            failure: failureCallback
        });
    }
}

Atheneum.NewsFeed.prototype.enableAutoUpdate = function AtheneumNewsFeed_enableAutoUpdate(frequency, callback) {

    if (SalesToolkit.Theme.getBooleanProperty("disableFeatureNews", false))
        return;
    
    if (typeof frequency !== "number" && callback == undefined) {
        callback = frequency;
        frequency = undefined;
    }

    var atheneumNewsFeed = this;

    setInterval(function () {
        atheneumNewsFeed.update(callback);
    }, (frequency === undefined ? 60000 : frequency));
}

Atheneum.NewsFeed.prototype.handleItemUpdate = function (item) {
    this.__realItems[item.id] = item;
    if (this.items === undefined || this.items === null)
        this.items = {};
    this.items[item.id] = JSON.parse(JSON.stringify(item));
}
Atheneum.NewsFeed.prototype.handleItemDeletion = function (itemId) {
    delete this.__realItems[itemId];
    delete this.items[itemId];
}

Atheneum.NewsFeed.prototype.getFeedNames = function () {

    var feedNames = [];

    for (var itemId in this.items) {
        if (this.items.hasOwnProperty(itemId)) {
            var feedName = this.items[itemId].feedName;
            if (feedName && !feedNames.contains(feedName))
                feedNames[feedNames.length] = feedName;
        }
    }

    feedNames.sort();  // sort feed names alphabetically

    return feedNames;
}

/** 
    Returns an array of the most recently posted news items, sorted by increasing post date.
    If number is not specified, returns all items.

 */
Atheneum.NewsFeed.prototype.getLatest = function AtheneumNewsFeed_getLatest(number) {

    var itemArray = [];

    for (var itemId in this.items) {
        if (this.items.hasOwnProperty(itemId)) {
            itemArray[itemArray.length] = this.items[itemId];
        }
    }

    itemArray.sort(function (a, b) {
        return b.publishedDate - a.publishedDate;
    });

    return number == undefined ? itemArray : itemArray.slice(0, number);
}

Atheneum.NewsFeed.prototype.getLatestFromFeed = function AtheneumNewsFeed_getLatestFromFeed(feedName, number) {

    var itemArray = [];

    for (var itemId in this.items) {
        if (this.items.hasOwnProperty(itemId) && feedName == this.items[itemId].feedName) {
            itemArray[itemArray.length] = this.items[itemId];
        }
    }

    itemArray.sort(function (a, b) {
        return b.publishedDate - a.publishedDate;
    });

    return number == undefined ? itemArray : itemArray.slice(0, number);
}

Atheneum.NewsFeed.prototype.postComment = function AtheneumNewsFeed_postComment(itemId, comment, callback) {

    var atheneum = this.Atheneum;

    var successCallback = (typeof callback === "function") ? callback : ((typeof callback.success === "function") ? callback.success : (function () { }));
    var failureCallback = (typeof callback.failure === "function") ? callback.failure : (function (reason, httpStatus, errorCode) { });

    this.Atheneum.API.postFeedItemComment(itemId, comment, {

        success: successCallback,

        failure: function (reason, httpStatus, errorCode) {

            if (reason == atheneum.API.Problems.CONNECTION_FAILED ||
                (reason == atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {

                // we're offline, so save the comment and submit it later

                var newComment = {
                    newsItemId: itemId,
                    id: "new" + (Math.random() + "").substring(2) + new Date().getTime(),
                    postedAt: new Date().getTime(),
                    comment: comment,
                    user: {
                        id: atheneum.User.id,
                        firstName: atheneum.User.preferences.firstName,
                        lastName: atheneum.User.preferences.lastName,
                        fullName: atheneum.User.preferences.fullName
                    }
                };

                atheneum.NewsFeed.__pendingComments[atheneum.NewsFeed.__pendingComments.length] = newComment;

                if (atheneum.User.username) {
                    atheneum.LocalStorage.set('atheneumNewsFeedPendingCommentsByUser_' + atheneum.User.username, JSON.stringify(atheneum.NewsFeed.__pendingComments));
                }

                var item = atheneum.NewsFeed.items[itemId];
                if (item) {
                    if (item.comments && item.comments.length > 0) {
                        item.comments[item.comments.length] = newComment;
                    } else {
                        item.comments = [newComment];
                    }
                }

                failureCallback(reason, httpStatus, errorCode);
            }
        }
    });
}

Atheneum.NewsFeed.prototype.CommentFilters = Atheneum.NewsFeed.CommentFilters = {
    ALL: 0,
    EXCLUDE_MY_COMMENTS: 1,
    REPLIES_ONLY: 2
};

/**	Returns a list of comments posted after the timestamp. "comment.newsItemId" contains the id of the newsItem */
Atheneum.NewsFeed.prototype.getComments = function AtheneumNewsFeed_getComments(timestamp) {
    return this._get_comments(timestamp, this.CommentFilters.ALL);
}

Atheneum.NewsFeed.prototype.getReplies = function AtheneumNewsFeed_getReplies(timestamp) {
    return this._get_comments(timestamp, this.CommentFilters.REPLIES_ONLY);
}

Atheneum.NewsFeed.prototype.getCommentsByOthers = function AtheneumNewsFeed_getCommentsByOthers(timestamp) {
    return this._get_comments(timestamp, this.CommentFilters.EXCLUDE_MY_COMMENTS);
}

/**	As a Atheneum.NewsFeed.getComments, but only returns comments by others on articles that the user has commented on */
Atheneum.NewsFeed.prototype._get_comments = function AtheneumNewsFeed__get_comments(timestamp, filter) {

    var postsByOthers = (filter !== undefined) && (filter == Atheneum.NewsFeed.CommentFilters.REPLIES_ONLY || filter == Atheneum.NewsFeed.CommentFilters.EXCLUDE_MY_COMMENTS);
    var repliesOnly = (filter !== undefined) && filter == Atheneum.NewsFeed.CommentFilters.REPLIES_ONLY;

    var comments = [];

    if (timestamp == undefined)
        timestamp = 0;

    for (var itemId in this.items) {
        if (this.items.hasOwnProperty(itemId)) {

            var newsItem = this.items[itemId];

            var earliestUserPost = Infinity;

            if (!newsItem.comments)
                continue;

            if (repliesOnly) {
                for (var i = 0; i < newsItem.comments.length; i++) {
                    if (newsItem.comments[i].postedAt < earliestUserPost && newsItem.comments[i].user.id == this.Atheneum.User.id)
                        earliestUserPost = newsItem.comments[i].postedAt;
                }
            }

            for (var i = 0; i < newsItem.comments.length; i++) {

                if (postsByOthers && newsItem.comments[i].user.id == this.Atheneum.User.id)
                    continue; // only want comments by other users, 

                if (repliesOnly && newsItem.comments[i].postedAt <= earliestUserPost)
                    continue; // and after our earliest comment

                if (timestamp !== undefined && timestamp > newsItem.comments[i].postedAt)
                    continue;

                this.items[itemId].comments[i].newsItemId = itemId;
                comments[comments.length] = this.items[itemId].comments[i];
            }
        }
    }

    comments.sort(function (a, b) { return b.postedAt - a.postedAt; });

    return comments;

}

Atheneum.NewsFeed.prototype.getUnreadReplies = function AtheneumNewsFeed_getUnreadReplies() {
    var comments = this.getComments();
    var unreadReplies = JSON.parse(this.Atheneum.User.preferences['_unreadReplies'] || '[]');
    return comments.filter(function (comment) {
        return unreadReplies.contains(comment.id);
    });
}

Atheneum.NewsFeed.prototype.markReplyAsRead = function AtheneumNewsFeed_markReplyAsRead(commentId, callback) {
    var unreadReplies = JSON.parse(this.Atheneum.User.preferences['_unreadReplies'] || '[]');
    if (unreadReplies.contains(commentId)) {
        this.Atheneum.User.changePreferences({
            '_unreadReplies': JSON.stringify(unreadReplies.filter(function (reply) { reply.id != commentId }))
        }, callback);
    }
    else {
        if (typeof callback == "function") {
            callback({ errorCode: 0 });
        }
        else if (callback && typeof callback.success == "function") {
            callback.success({ errorCode: 0 });
        }
    }
}

Atheneum.NewsFeed.prototype.markAllCommentsOnNewsItemAsRead = function (newsItemId, callback) {
    var unreadReplies = JSON.parse(this.Atheneum.User.preferences['_unreadReplies'] || '[]')
    var newsItem = this.items[newsItemId];

    var didSomething = false;
    if (newsItem.comments) {
        for (var i = 0; i < newsItem.comments.length; i++) {
            if (unreadReplies.contains(newsItem.comments[i].id)) {
                unreadReplies.splice(unreadReplies.indexOf(newsItem.comments[i].id), 1);
                didSomething = true;
            }
        }
    }

    if (didSomething) {
        this.Atheneum.User.changePreferences({ '_unreadReplies': JSON.stringify(unreadReplies) }, callback);
    }
    else {
        if (typeof callback == "function") {
            callback({ errorCode: 0 });
        }
        else if (callback && typeof callback.success == "function") {
            callback.success({ errorCode: 0 });
        }
    }
}

Atheneum.NewsFeed.prototype.markAllUnreadRepliesAsRead = function (callback) {
    var atheneumNewsFeed = this;
    var unreadReplies = JSON.parse(this.Atheneum.User.preferences['_unreadReplies'] || '[]')
    if (unreadReplies.length > 0) {
        this.Atheneum.User.changePreferences({ '_unreadReplies': '[]' }, {
            success: function (json) {
                atheneumNewsFeed.Atheneum.User.preferences['_unreadReplies'] = '[]';
                atheneumNewsFeed.Atheneum.LocalStorage.set('atheneumUserPreferences', JSON.stringify(atheneumNewsFeed.Atheneum.User.preferences));
                atheneumNewsFeed.onReplyUpdate();
                if (typeof callback == "function")
                    callback(json);
                else if (callback && typeof callback.success == "function")
                    callback.success(json);
            },
            failure: function (reason, httpStatus, errorCode) {
                if (callback && typeof callback.failure == "function") {
                    callback.failure(reason, httpStatus, errorCode);
                }
            }
        });
    }
    else if (typeof callback == "function") {
        callback({ errorCode: 0 });
    }
    else if (callback && typeof callback.success == "function") {
        callback.success({ errorCode: 0 });
    }
}

Atheneum.NewsFeed.prototype.getComment = function (commentId) {
    var comments = this.getComments();
    for (var i = 0; i < comments.length; i++) {
        if (comments[i].id == commentId)
            return comments[i];
    }
    return null;
}

Atheneum.Callbacks = function AtheneumCallbacks(atheneum) {

    if (!(this instanceof Atheneum.Callbacks))
        return new Atheneum.Callbacks();

    this.Atheneum = atheneum;
}

// built-in callbacks

// called whenever the user's apikey becomes invalid
Atheneum.Callbacks.loginExpiry = function AtheneumCallbacks_loginExpiry() {

    this.Atheneum.User.username = undefined;
    this.Atheneum.User.isLoggedIn = false;
    this.Atheneum.User.apikey = "";
    this.Atheneum.User.permissions = {
        canFavourite: true,
        canInvite: false,
        canRate: false,
        canShare: false,
        canVend: false
    }
    this.Atheneum.User.emailConfirmed = false;
    this.Atheneum.User.imageUrl = "";
    this.Atheneum.User.imageLastModified = 0;
    this.Atheneum.User.groups = [];
    this.Atheneum.User.preferences = { language: this.Atheneum.User.preferences.language };
    this.Atheneum.User.id = undefined;

    this.Atheneum.User.saveToStorage();

    if (this.Atheneum.CrossPlatform.enabled) {
        this.Atheneum.CrossPlatform.logMessage("LOGOUT FROM LOGIN EXPIRY");
    }
    this.Atheneum.Pages.redirectToLoginPage();
};

Atheneum.Callbacks.logFailureDetails = function AtheneumCallbacks_logFailureDetails(reason, httpStatus, errorCode, source) {
    console.log(
        (source || "API call") + " Failed: "
        + reason
        + ((httpStatus != undefined && httpStatus != 200) ? (" = " + httpStatus) : "")
        + ((errorCode != undefined && errorCode > 0) ? (" = 0x" + ("00000000" + errorCode?.toString(16).toUpperCase()).slice(-8) + " (" + Atheneum.API.ErrorCodes.getName(errorCode) + ")") : "")
    );
}

Atheneum.Callbacks.isOffline = function (reason, httpStatus, errorCode) {
    if (httpStatus === 408)
        return true;

    return (typeof errorCode === "undefined" || errorCode === -1) && (reason == Atheneum.API.Problems.CONNECTION_FAILED
        || (reason == Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus > 500));
}

Atheneum.Callbacks.prototype.isOffline = function(reason, httpStatus, errorCode) {
    return Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode);
}

Atheneum.UI = function AtheneumUI(atheneum) {
    if (!(this instanceof Atheneum.UI))
        return new Atheneum.UI(atheneum);

    this.Atheneum = atheneum;

    this.Notifications = new Atheneum.UI.Notifications(atheneum, null);
}

Atheneum.UI.Element = function AtheneumUIElement(atheneum, element) {

    if (!(this instanceof Atheneum.UI.Element))
        return new Atheneum.UI.Element(atheneum, element);

    this.Atheneum = atheneum;
    this.element = element;
    this.callbacks = {};
}

Atheneum.UI.Element.prototype.unbind = function AtheneumUIElement_unbind(eventType) {
    if (eventType != undefined) {
        this.callbacks[eventType] = [];
    }

}

Atheneum.UI.Element.prototype.on = function AtheneumUIElement_on(eventType, callback) {
    if (eventType != undefined) {
        if (this.callbacks[eventType] == undefined) {
            this.callbacks[eventType] = [callback];
        } else {
            this.callbacks[eventType][this.callbacks[eventType].length] = callback;
        }
    }
}

Atheneum.UI.Element.prototype.trigger = function AtheneumUIElement_trigger(eventType) {
    if (typeof eventType == "string") {
        var toCall = this.callbacks[eventType];
        if (toCall != undefined) {
            for (var i = 0; i < toCall.length; i++) {
                var args = Array.prototype.slice.apply(arguments, [1]);
                if (toCall[toCall.length - i - 1].apply(this, args) == false)
                    return false;
            }
        }
    }
}

/**
 * The various events that can be triggered / listened for:
 * 
 * itemGroupDisplay.trigger( event, args... )
 * itemGroupDisplay.on( event, callback )
 * 
 * 
 * "item-added"					( item )
 * 
 * 		triggered after a new item has been added to the ItemGroupDisplay
 * 
 * "item-removed				( item )
 * 
 * 		triggered after a new item has been removed from the ItemGroupDisplay
 * 
 * item-*ed-to-*
 * 
 * 		triggered after the corresponding action completes:
 * 
 * 		item-added-to-cart
 * 		item-removed-from-cart
 * 		item-added-to-favourites
 * 		item-removed-from-favourites
 * 
 * 
 * "item-click"					( item )
 * 
 * 		triggered whenever a descendant with the class ".atheneum-item" is clicked
 * 		triggered AFTER the "item-action-click"
 * 
 * 
 * "item-action-click"			( item, action )
 * 
 * 		triggered whenever a descendant with the class ".atheneum-item-action" is clicked
 * 		returning false will prevent the corresponding "item-action-*-click" event from triggering
 * 		otherwise, it triggers the "item-action-*-click" corresponding to its "data-atheneum-item-action" attribute.
 * 
 * 
 * "item-action-failure"		( item, action, details )
 * 
 * 		triggered whenever an action on an item fails to complete
 * 		details is an object containing { "reason": string, "httpStatus": number, "errorCode": number }
 * 
 * 
 * "item-action-*-click"		( item )
 * 
 * 		triggered by clicking on a ".atheneum-item-action" with the corresponding "data-atheneum-item-action" attribute.
 * 		built-in action names:
 * 
 * 			view
 * 			rate
 * 			download
 * 			add-to-cart 		/  remove-from-cart			/  toggle-cart
 * 			add-to-favourites	/  remove-from-favourites	/  toggle-favourite
 */

// class Atheneum.UI.ItemGroupDisplay extends Atheneum.UI.Element
Atheneum.UI.ItemGroupDisplay = function AtheneumUIItemGroupDisplay(atheneum, element) {

    if (!(this instanceof Atheneum.UI.ItemGroupDisplay))
        return new Atheneum.UI.ItemGroupDisplay(atheneum, element);

    Atheneum.UI.Element.call(this, atheneum, element);
    this.Atheneum = atheneum;
    var itemGroupDisplay = this;

    this.itemTemplate = this.getDefaultItemTemplate();
    this.favouritesActionInProgress = false;
    this.ratingMaxStars = this.constructor.defaultRatingMaxStars;
    this.ratingStarEmptyTemplate = this.constructor.defaultRatingStarEmptyTemplate;
    this.ratingStarHalfTemplate = this.constructor.defaultRatingStarHalfTemplate;
    this.ratingStarFullTemplate = this.constructor.defaultRatingStarFullTemplate;
    this.unratedTemplate = this.constructor.defaultUnratedTemplate;

    if (this.element != null) {

        this.element.addEventListener("click", function (event) {

            var actionsClicked = [];
            for (var target = event.target; target && target != itemGroupDisplay.element; target = target.parentNode) {

                if (target.matches(".atheneum-item-action")) {
                    actionsClicked[actionsClicked.length] = target;
                }

                if (target.matches(".atheneum-item")) {
                    let itemData = null;
                    let legacyItemDataString = target.getAttribute("data-atheneum-item");

                    if (legacyItemDataString) {
                        // If legacy data exists, parse it directly.
                        itemData = JSON.parse(legacyItemDataString.replace(/&quot;/g, "\""));
                    } else {
                        // 2. If not, fall back to the new 'data-atheneum-item-id' logic.
                        let itemId = target.getAttribute("data-atheneum-item-id");
                        let itemType = null;

                        if (itemId) {
                            if (itemGroupDisplay.Atheneum.Library.collections && itemGroupDisplay.Atheneum.Library.collections[itemId]) {
                                itemData = itemGroupDisplay.Atheneum.Library.collections[itemId];
                                itemType = 'collection';
                            } else if (itemGroupDisplay.Atheneum.Library.assets && itemGroupDisplay.Atheneum.Library.assets[itemId]) {
                                itemData = itemGroupDisplay.Atheneum.Library.assets[itemId];
                                itemType = 'asset';
                            } else if (itemGroupDisplay.Atheneum.Forms.formList && itemGroupDisplay.Atheneum.Forms.formList[itemId]) {
                                itemData = itemGroupDisplay.Atheneum.Forms.formList[itemId];
                                itemType = 'form';
                            }

                            // Assign the type only if we found data via the new method and the type is missing.
                            if (itemData && !itemData.type) {
                                itemData.type = itemType;
                            }
                        }
                    }
                   if (itemData) {
                        for (var i = 0; i < actionsClicked.length; i++) {
                            itemGroupDisplay.trigger("item-action-click", itemData, actionsClicked[i].getAttribute("data-atheneum-item-action"));
                        }

                        itemGroupDisplay.trigger("item-click", itemData);
                    }
                    break;
                }
            }
        });
    }

    this.on("item-action-click", function (item, action) {
        itemGroupDisplay.trigger("item-action-" + action + "-click", item);
    });

    this.on("item-action-toggle-info-click", function(item){
        itemGroupDisplay.trigger("info-requested", item);
    });

    this.on("item-action-add-to-favourites-click", function (item) {
         if (itemGroupDisplay.favouritesActionInProgress) {
            return false; // Return false to stop further event processing
        }
        itemGroupDisplay.favouritesActionInProgress = true;
        
        var itemDup = item;
        var callback = {
            success: function (json) {
                itemGroupDisplay.favouritesActionInProgress = false; 
                itemGroupDisplay.trigger("item-added-to-favourites", itemDup);
                var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationFavouritesAdded', 'Added {0} to Favourites', [itemDup.name]);
                itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("favourites", notificationBody);
            },
            failure: function (reason, httpStatus, errorCode) {
                itemGroupDisplay.favouritesActionInProgress = false; 
                if (reason == Atheneum.API.Problems.CONNECTION_FAILED
                    || (reason == Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {
                    itemGroupDisplay.trigger("item-added-to-favourites", itemDup);
                    var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationFavouritesAdded', 'Added {0} to Favourites', [itemDup.name]);
                    itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("favourites", notificationBody);
                }
                itemGroupDisplay.trigger("item-action-failure", itemDup, "add-to-favourites", { reason: reason, httpStatus: httpStatus, errorCode: errorCode });
            }
        }

        if (item.type == "collection")
            itemGroupDisplay.Atheneum.Favourites.addCollection(item.id, callback);
        else if (item.type == "asset")
            itemGroupDisplay.Atheneum.Favourites.addAsset(item.containedBy, item.id, callback);
    });

    this.on("item-action-remove-from-favourites-click", function (item) {
         if (itemGroupDisplay.favouritesActionInProgress) {
            return false; // Return false to stop further event processing
        }
        itemGroupDisplay.favouritesActionInProgress = true;

        var itemDup = item;
        var callback = {
            success: function (json) {
                itemGroupDisplay.favouritesActionInProgress = false; 
                itemGroupDisplay.trigger("item-removed-from-favourites", itemDup);
                var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationFavouritesRemoved', 'Removed {0} from Favourites', [itemDup.name]);
                itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("favourites", notificationBody);
            },
            failure: function (reason, httpStatus, errorCode) {
                itemGroupDisplay.favouritesActionInProgress = false; 
                if (reason == Atheneum.API.Problems.CONNECTION_FAILED
                    || (reason == Atheneum.API.Problems.HTTP_STATUS_ERROR && httpStatus == 503)) {
                    itemGroupDisplay.trigger("item-removed-from-favourites", itemDup);
                    var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationFavouritesRemoved', 'Removed {0} from Favourites', [itemDup.name]);
                    itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("favourites", notificationBody);
                }
                itemGroupDisplay.trigger("item-action-failure", itemDup, "remove-from-favourites", { reason: reason, httpStatus: httpStatus, errorCode: errorCode });
            }
        }

        if (item.type == "collection")
            itemGroupDisplay.Atheneum.Favourites.removeCollection(item.id, callback);
        else if (item.type == "asset")
            itemGroupDisplay.Atheneum.Favourites.removeAsset(item.containedBy, item.id, callback);
    });

    this.on("item-action-add-to-cart-click", function (item) {

        var itemDup = item;

        var callback = {
            success: function (json) {
                itemGroupDisplay.trigger("item-added-to-cart", itemDup);
                var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationCartAdded', 'Added {0} to Cart', [itemDup.name]);
                itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("cart", notificationBody);
            },
            failure: function (reason, httpStatus, errorCode) {
                itemGroupDisplay.trigger("item-action-failure", itemDup, "add-to-cart", { reason: reason, httpStatus: httpStatus, errorCode: errorCode });
            }
        }

        if (item.type == "collection")
            itemGroupDisplay.Atheneum.Cart.addCollection(item.id, callback);
        else if (item.type == "asset")
            itemGroupDisplay.Atheneum.Cart.addAsset(item.id, callback);
    });

    this.on("item-action-remove-from-cart-click", function (item) {

        var itemDup = item;
        var callback = {
            success: function (json) {
                itemGroupDisplay.trigger("item-removed-from-cart", itemDup);
                var notificationBody = itemGroupDisplay.Atheneum.Translation.getFormatted('notificationCartRemoved', 'Removed {0} from Cart', [itemDup.name]);
                itemGroupDisplay.Atheneum.UI.Notifications.showCustomNotification("cart", notificationBody);
            },
            failure: function (reason, httpStatus, errorCode) {
                itemGroupDisplay.trigger("item-action-failure", itemDup, "remove-from-cart", { reason: reason, httpStatus: httpStatus, errorCode: errorCode });
            }
        }

        if (item.type == "collection")
            itemGroupDisplay.Atheneum.Cart.removeCollection(item.id, callback);
        else if (item.type == "asset")
            itemGroupDisplay.Atheneum.Cart.removeAsset(item.id, callback);
    });

    this.on("item-action-toggle-favourite-click", function (item) {

        if ((item.type == "asset" && itemGroupDisplay.Atheneum.Favourites.assetIds.contains(item.id))
            || (item.type == "collection" && itemGroupDisplay.Atheneum.Favourites.collectionIds.contains(item.id))) {

            this.trigger("item-action-remove-from-favourites-click", item);

        } else if (item.type == "asset" || item.type == "collection") {

            this.trigger("item-action-add-to-favourites-click", item);

        } else {
            console.log("unexpected item-type: " + item.type);
            itemGroupDisplay.favouritesActionInProgress = false;
        }

    });

    this.on("item-action-toggle-cart-click", function (item) {

        if ((item.type == "asset" && itemGroupDisplay.Atheneum.Cart.assetIds.contains(item.id))
            || (item.type == "collection" && itemGroupDisplay.Atheneum.Cart.collectionIds.contains(item.id))) {

            this.trigger("item-action-remove-from-cart-click", item);

        } else if (item.type == "asset" || item.type == "collection") {

            this.trigger("item-action-add-to-cart-click", item);

        } else {
            console.log("unexpected item-type: " + item.type);
        }
    });

    this.on("item-action-download-click", function (item) {
        // TODO: download	
    });

    this.on("item-action-rate-click", function (item) {
        // TODO: rate asset
    });

    this.on("item-action-view-click", function (item) {
        if(item.type == "asset" && !itemGroupDisplay.Atheneum.Library.assets[item.id].canPreview)
            return false;

         if(window.location.href.indexOf('/index.html') >= 0 && SalesToolkitApplication.navigator.getCurrentPage() == "index" ) {
            if (item.type === "asset" && SalesToolkit.Pages.PreviewAssetPage.url) {
                if(itemGroupDisplay.inboxMode)
                     SalesToolkitApplication.navigator.loadAssetScreen(item.id, "?from=inbox");
                else
                     SalesToolkitApplication.navigator.loadAssetScreen(item.id, "?from=home");
            } else if (item.type === "collection" && SalesToolkit.Pages.ExploreCollectionPage.url) {
                SalesToolkitApplication.navigator.loadIndexScreen(false, false, item.id, false);
            }
        return;
        }

        if(SalesToolkitApplication.navigator.getCurrentPage() !== "previewAsset") {
            return;
        }
        
        if (item.type == "asset"){
            document.dispatchEvent(new CustomEvent(parent.SalesToolkitApplication.Events.LOAD_ASSET, {
                            detail: {
                                assetId: item.id
                            }
                        }));
        }else if (item.type == "collection"){
             document.dispatchEvent(new CustomEvent(parent.SalesToolkitApplication.Events.COLLECTION_BROWSER_LOAD_COLLECTION, {
                            detail: {
                                collectionId: item.id
                            }
                        }));
        }
    });

    this.on("item-action-failure", function (item, action, details) {
        Atheneum.Callbacks.logFailureDetails(details.reason, details.httpStatus, details.errorCode, item.name + " " + action);
    });
}

Atheneum.UI.ItemGroupDisplay.prototype = Object.create(Atheneum.UI.Element.prototype);
Atheneum.UI.ItemGroupDisplay.prototype.constructor = Atheneum.UI.ItemGroupDisplay;
Atheneum.UI.ItemGroupDisplay.defaultRatingMaxStars = 5;
Atheneum.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate = '&nbsp;';
Atheneum.UI.ItemGroupDisplay.defaultRatingStarHalfTemplate = '*';
Atheneum.UI.ItemGroupDisplay.defaultRatingStarFullTemplate = '*';
Atheneum.UI.ItemGroupDisplay.defaultUnratedTemplate = 'unrated';

// redraws the ItemGroupDisplay. Overridden by subclasses
Atheneum.UI.ItemGroupDisplay.prototype.refresh = function () { };

// destroys the ItemGroupDisplay, unbinding all events
// this will typically be used to free memory and avoid event handler clashes
Atheneum.UI.ItemGroupDisplay.prototype.destroy = function () {
    for (var eventType in this.callbacks) {
        if (!this.callbacks.hasOwnProperty(eventType)) {
            continue;
        }
        this.unbind(eventType);
    }
};

Atheneum.UI.prototype.ItemGroupDisplay = function (element) {
    return new Atheneum.UI.ItemGroupDisplay(this.Atheneum, element);
}

Atheneum.UI.ItemGroupDisplay.defaultItemTemplate = '<div class="atheneum-item" data-atheneum-item="{item}">'
    + '<img class="atheneum-item-image" src="{@item.imageUrl} />'
    + '<a>{item.name}</a>'
    + '</div>';

Atheneum.UI.ItemGroupDisplay.prototype.getDefaultItemTemplate = function () {
    return this.constructor.defaultItemTemplate;
}

Atheneum.UI.ItemGroupDisplay.prototype.setDefaultItemTemplate = function (template) {
    this.constructor.defaultItemTemplate = template;
}

Atheneum.UI.prototype.ItemGroupDisplay.setDefaultItemTemplate = function (template) {
    this.defaultItemTemplate = template;
}

// NOTE: rated, inCart, and inFavourites currently are always false
Atheneum.UI.ItemGroupDisplay.Item = function AtheneumUIItemGroupDisplayItem(

    type, id, name, description,
    imageUrl, imageLastModified, containedBy, subCollections,
    assets, inCart, inFavourites, rated,
    shareable, rating, realType

) {

    if (!(this instanceof Atheneum.UI.ItemGroupDisplay.Item))
        return new Atheneum.UI.ItemGroupDisplay.Item(
            type, id, name, description,
            imageUrl, imageLastModified, containedBy, subCollections,
            assets, inCart, inFavourites, rated,
            shareable, rating, realType
        );

    this.type = type;
    this.id = id;
    this.name = name;
    this.description = description;
    this.collections = subCollections;
    this.containedBy = containedBy;
    this.imageUrl = imageUrl;
    this.imageLastModified = imageLastModified;
    this.inFavourites = inFavourites;
    this.inCart = inCart;
    this.rated = rated;
    this.shareable = shareable;
    this.rating = rating;
    this.realType = realType;

}

Atheneum.UI.ItemGroupDisplay.Item.fromCollection = function (collection) {

    var subCollectionIds = [];
    for (var i = 0; i < collection.stories.length; i++) {
        subCollectionIds[subCollectionIds.length] = collection.stories[i].id;
    }

    var assetIds = [];
    for (var i = 0; i < collection.assets.length; i++) {
        assetIds[assetIds.length] = collection.assets[i].id;
    }

    return new Atheneum.UI.ItemGroupDisplay.Item(
        "collection",
        collection.id,
        collection.name,
        collection.description,
        collection.image ? collection.image.url : Atheneum.DefaultImages.Collection,
        collection.image ? collection.image.modified : undefined,
        collection.containedBy,
        subCollectionIds,
        assetIds,
        false,
        false,
        false,
        collection.shareByEmail,
        null,
        "collection"
    );
}

Atheneum.UI.ItemGroupDisplay.Item.fromForm = function (form) {
    
    let formTitle = form.title;
    if(typeof getTranslatedTitle === 'function'){
        formTitle = getTranslatedTitle(form);
    }

    formTitle = window.AtheneumInstance.Translation.get(formTitle, formTitle);

    return new Atheneum.UI.ItemGroupDisplay.Item(
        "collection",
        form.id,
        formTitle,
        "",
        form.thumb ? form.thumb.url : Atheneum.DefaultImages.Form,
        form.thumb ? form.thumb.modified : undefined,
        form.containedBy,
        undefined,
        undefined,
        false,
        false,
        false,
        false,
        null,
        "form"
    );
}

Atheneum.UI.ItemGroupDisplay.Item.fromAsset = function (asset, atheneum, cb) {

    let assetName = asset.name;
    if(asset.fullTitle && atheneum.Theme.getBooleanProperty('collectionBrowserUseFullTitle', true)){
        assetName = asset.name + " - " + asset.fullTitle;
    }

    var item = new Atheneum.UI.ItemGroupDisplay.Item(
        "asset",
        asset.id,
        assetName,
        asset.summary,
        asset.thumb ? asset.thumb.url : Atheneum.DefaultImages.getForAssetWithMimeType(asset.mimetype),
        asset.thumb ? asset.thumb.modified : undefined,
        asset.containedBy,
        undefined,
        undefined,
        false,
        false,
        !!asset.avgRating,
        (asset.shareByEmail || atheneum.User.permissions.canRegisterInterest) && atheneum.Theme.getCollectionProperty(asset.containedBy, 'disallowSharesOverride', 'false') != 'true',
        !asset.avgRating ? null : (Math.round(asset.avgRating * 100) / 100),
        "asset"
    );

    if(typeof asset.highPriority !== 'undefined'){
        item.highPriority = asset.highPriority;
    }else{
        item.highPriority = false;
    }

    if(typeof asset.manuallyRelated !== 'undefined'){
        item.manuallyRelated = asset.manuallyRelated;
    }else{
        item.manuallyRelated = false;
    }

    let showOnSearchOnly = atheneum.Theme.getBooleanProperty('collectionPathOnlyOnSearch', true);
    let isSearching = (typeof cb !== 'undefined' && typeof cb.searchTerm !== 'undefined');

    if(atheneum.Theme.getBooleanProperty('useCollectionPath', true) && (!showOnSearchOnly || (showOnSearchOnly && isSearching))){
        item.collectionPath = "";
        let col = asset;
        if(window.AtheneumInstance.Theme.getBooleanProperty('collectionPathIgnoreImmediateParent', true))
            col = window.AtheneumInstance.Library.collections[col.containedBy];
        while (col && col.containedBy != null) {
            col = window.AtheneumInstance.Library.collections[col.containedBy];
            if (col) {
               if(item.collectionPath.length == 0)
                item.collectionPath = col.name;
               else
                item.collectionPath = col.name + window.AtheneumInstance.Translation.getOrGetThemeKey('collectionPathSeparator', ' - ') + item.collectionPath;    
            }
        }

        item.noPath = item.collectionPath.length == 0;
    }else{
        item.noPath = true;
    }
   

    item.publishDate = asset.publishDate;
    item.approvalDate = asset.approvalDate;
    if (asset.hasOwnProperty('freeText')) {
        item.freeText = asset.freeText;
    }
    if (asset.hasOwnProperty('references')) {
        item.references = asset.references;
    }
    if (asset.hasOwnProperty('authors')) {
        item.authors = asset.authors;
    }
    item.copyright = asset.copyright;

    return item;
}

/**

Accepts a html template string which will be used to generate the collection items.
Placeholders for item attributes can be set by enclosing them in curly brackets.
If you attempt to include the item itself, it will be converted to a JSON string.

some text			=> "some text"
{ item } 			=> JSON.stringify(item)			(implies @)
{ item.property } 	=> item.property
{ item.property:5 }	=> at most 5 characters of item.property
{ @item.property }	=> prevents zero width spaces being inserted in item.property (useful for urls or ids)
{ @@item.property } => As above, but also redirects the url through the proxy if necessary.

    @ and : can technically be combined, eg: { @item.property:22 }, but you should never have a need for that

{ if (item.property) }					(only output if item.property is defined and non-empty)
{ if (item.property == value) }			(only output if item.property equals the value)
{ else if (...) }
{ else }
{ end if }


{ XXXX:default("value") }		sytactically equivalent to { if (XXXX) }{ XXXX }{ else }value{ end if }

{ XXXX:format(boolean) }		any falsey value (or if no default value) becomes false, any truthy value becomes true, mainly for theme keys
{ XXXX:format(json) }			JSON.stringify(XXXX)
{ XXXX:format(url) }			equivalent to @@XXXX
{ XXXX:format(nowrap) }			prevents the text auto-wrapping
{ XXXX:format(date) }			treated as a date and rendered accordingly

{ XXXX:limit(n) }				at most n characters of XXXX allowed

{ theme.key }
{ translation.key:format(date) }

*/
Atheneum.UI.ItemGroupDisplay.prototype.setItemTemplate = function AtheneumUIItemGroupDisplay_setItemTemplate(html) {
    this.itemTemplate = html;
}

Atheneum.UI.ItemGroupDisplay.Item.buildItem = function (item, itemTemplate) {
    if (item == undefined) {
        return;
    }

    var atheneum = window.AtheneumInstance;
    var template = itemTemplate || "";

    var theItem = item;
    var replacementFunction = function (match, source, key, format, defaultValue, maxLength, contains) {

        var value;


        if (typeof defaultValue === 'string' && defaultValue.match(/^"[^"]*(?:(?:\\")[^"]*)?"$/)) {
            defaultValue = defaultValue.substring(1, defaultValue.length - 1);
        }


        if (source == 'translation') {
            value = atheneum.Translation.getOrGetThemeKey(key, defaultValue);
        }
        else if (source == 'theme') {
            value = atheneum.Theme.getStringProperty(key, defaultValue);
        }
        else if (source == 'item') {
            if (key == undefined) {
                value = theItem;
                if (format == undefined) {
                    format = 'json';
                }
            }
            else {
                if (theItem.hasOwnProperty(key)) {
                    value = theItem[key];
                }
                else {
                    value = defaultValue;
                }
                if (key == 'id' && format == undefined) {
                    format = 'id';
                }
            }
        }


        if (contains && value == undefined) {
            format = 'boolean';
            value = 'false';
        }
        else if (contains) {
            format = 'boolean';
            value = (value.indexOf(JSON.parse(contains)) != -1) + '';
        }


        if (format == 'json') {
            value = (value == undefined ? 'null' : JSON.stringify(value));
        }
        else if (format == 'url') {
            value = atheneum.Proxy.rewriteURL(value);
        }
        else if (format == 'date' || format == 'date-iso' || format == 'date-uk' || format == 'date-us'
            || format == 'datetime' || format == 'datetime-iso' || format == 'datetime-uk' || format == 'datetime-iso'
            || format == 'time') {

            if (value != undefined) {

                //var date = new Date(value|0); 
                var date = new Date(value || 0);

                if (!(!date || isNaN(date.getDate()))) {

                    var day = (date.getDate() <= 9 ? '0' : '') + date.getDate();
                    var month = ((date.getMonth() + 1) <= 9 ? '0' : '') + (date.getMonth() + 1);
                    var year = (date.getFullYear() <= 9 ? '0' : '') + date.getFullYear();

                    var hours = (date.getHours() <= 9 ? '0' : '') + date.getHours();
                    var minutes = (date.getMinutes() <= 9 ? '0' : '') + date.getMinutes();

                    var string = '';

                    if (format == 'date-uk' || format == 'datetime-uk') {
                        string += day + '/' + month + '/' + year;
                    }
                    else if (format == 'date-us' || format == 'datetime-us') {
                        string += month + '/' + day + '/' + year;
                    }
                    else if (format == 'date' || format == 'date-iso' || format == 'datetime' || format == 'datetime-iso') {
                        string += year + '-' + month + '-' + day;
                    }

                    if (format == 'datetime' || format == 'datetime-uk' || format == 'datetime-us') {
                        string += ' ';
                    }
                    else if (format == 'datetime-iso') {
                        string += 'T';
                    }

                    if (format == 'time' || format == 'datetime' || format == 'datetime-iso' || format == 'datetime-uk' || format == 'datetime-us') {
                        string += hours + ':' + minutes;
                    }

                    value = string;
                }
            }
        }
        else if (format == 'colour') {
            var colour = new Atheneum.Colour(value);
            value = colour.toRGBAString();
        }
        else if (format == 'boolean') {
            if (value) {
                if (Atheneum.Theme.TRUE_VALUES.indexOf(value.toLowerCase()) != -1) {
                    value = 'true';
                }
                else if (Atheneum.Theme.FALSE_VALUES.indexOf(value.toLowerCase()) != -1) {
                    value = 'false';
                }
            }
            else {
                value = 'false';
            }
        } else if (format == "exists") {
            if (value) {
                value = 'true';
            } else {
                value = 'false';
            }
        }

        if (maxLength && maxLength > 7 && value && value.length > 7) {
            var lastSpace = value.indexOf(' ', maxLength - 7);
            if (lastSpace == -1)
                lastSpace = value.indexOf('_', maxLength - 7);
            if (lastSpace == -1)
                lastSpace = maxLength - 3;
            value = value.substring(0, lastSpace) + "...";
        }

        if (value != undefined && format != 'boolean') {
            value = "" + value;
        }

        return value;

    }

    var flowRegex = /((?:\{\s*(?:else\s*)?if\s*\((?:\s*(?:item|theme|translation)\.(?:[a-zA-Z][a-zA-Z0-9]*)(?::format\((?:url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((?:true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((?:0|[1-9][0-9]*)\))?(?::contains\((?:(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?:(?:\s*(?:==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}))|(?:\{\s*else\s*\})|(?:\{\s*end\s*if\s*\})))/g;

    var ifRegex = /\{\s*if\s*\(\s*(item|theme|translation)\.([a-zA-Z][a-zA-Z0-9]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\(((?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(\s*(:?==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}/;
    var elseifRegex = /\{\s*else\s*if\s*\(\s*(item|theme|translation)\.([a-zA-Z][a-zA-Z0-9]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\(((?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?:\s*(:?==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}/;
    var elseRegex = /\{\s*else\s*\}/;
    var endifRegex = /\{\s*end\s*if\s*\}/;

    var templateParts = template.split(flowRegex);
    var nesting = [];
    var flowAdjustedTemplate = "";

    var ratingStars = '';
    if (item.rating != undefined && item.rating > 0) {

        var rating = item.rating;

        var maxStars = (this.ratingMaxStars != undefined) ? this.ratingMaxStars : 5;

        var ratingStarsAdded = 0;

        var emptyStar = (this.ratingStarEmptyTemplate != undefined) ? this.ratingStarEmptyTemplate : '&nbsp;';
        var halfStar = (this.ratingStarHalfTemplate != undefined) ? this.ratingStarHalfTemplate : '*';
        var fullStar = (this.ratingStarFullTemplate != undefined) ? this.ratingStarFullTemplate : '*';

        for (var r = 0; r < (rating | 0); r++) {
            ratingStars += fullStar;
            ratingStarsAdded += 1;
        }
        var ratingRemainder = rating - (rating | 0);
        if (ratingRemainder > 0.25 && ratingRemainder < 0.75) {
            // add half stars
            ratingStars += halfStar;
            ratingStarsAdded += 1;
        }
        else if (ratingRemainder >= 0.75) {
            ratingStars += fullStar;
            ratingStarsAdded += 1;
        }
        for (var r = ratingStarsAdded; r < maxStars; r++) {
            ratingStars += emptyStar;
        }
    }
    else {
        ratingStars = (this.unratedTemplate != undefined) ? this.unratedTemplate : 'unrated';
    }

    item.rating = item.rating
    item.starRating = ratingStars;
    if (item.type == 'asset') {
        item.inFavourites = atheneum.Favourites.containsAsset(item.id);
    }
    else {
        item.inFavourites = false;
    }

    if (item.type == 'asset') {
        item.inCart = atheneum.Cart.containsAsset(item.id);
    }
    else {
        item.inCart = false;
    }

    for (var i = 0; i < templateParts.length; i++) {

        var match = templateParts[i].match(ifRegex);
        if (match && match.length > 0) {

            if (nesting.length > 0 && (nesting[nesting.length - 1].value == false || nesting[nesting.length - 1].skip == true)) {
                nesting[nesting.length] = { encounteredElse: false, executed: false, value: false, skip: true };
                continue;
            }


            var result;
            var resultValueAfterSubstitution = replacementFunction(match[0], match[1], match[2], match[3], match[4], match[5], match[6]);


            try {
                result = eval(resultValueAfterSubstitution + (match[7] || ''));
            }
            catch (e) {
                throw new Error("template error on evaluating " + templateParts[i]);
            }

            if (typeof result === "object" && Object.prototype.toString.call(result) == "[object Array]" && result.length == 0) {
                result = false;
            }
            result = !!result;

            nesting[nesting.length] = { encounteredElse: false, executed: result, value: result, skip: false };
            continue;
        }

        if (elseifRegex.test(templateParts[i]) && nesting.length == 0) {
            throw new Error("template contained unexpected invalid { else if } block.");
        }

        match = templateParts[i].match(elseifRegex);
        if (match && match.length > 0) {

            if (nesting[nesting.length - 1].encounteredElse)
                throw new Error("template contained { else if } after { else }");

            if (nesting[nesting.length - 1].skip == true) {
                continue;
            }

            // if the "if" or a previous "else if" further up has already been executed, skip
            if (nesting[nesting.length - 1].executed) {
                nesting[nesting.length - 1] = { encounteredElse: false, executed: true, value: false, skip: true };
                continue;
            }

            var result;
            var resultValueAfterSubstitution = replacementFunction(match[0], match[1], match[2], match[3], match[4], match[5], match[6]);


            try {
                result = eval(resultValueAfterSubstitution + (match[7] || ''));
            }
            catch (e) {
                throw new Error("template error on evaluating " + templateParts[i]);
            }

            if (typeof result === "object" && Object.prototype.toString.call(result) == "[object Array]" && result.length == 0) {
                result = false;
            }
            result = !!result;

            nesting[nesting.length - 1] = { encounteredElse: false, executed: result, value: result, skip: false };
            continue;
        }

        if (elseRegex.test(templateParts[i])) {

            if (nesting.length > 0) {

                if (nesting[nesting.length - 1].encounteredElse)
                    throw new Error("template contained multiple { else } for the same { if }");

                nesting[nesting.length - 1].encounteredElse = true;
                if (!nesting[nesting.length - 1].executed && !nesting[nesting.length - 1].skip) {
                    nesting[nesting.length - 1].value = true;
                    nesting[nesting.length - 1].executed = true;
                } else {
                    nesting[nesting.length - 1].skip = true;
                    nesting[nesting.length - 1].executed = true;
                    nesting[nesting.length - 1].value = false;
                }
                continue;

            } else {
                throw Exception("template contained unexpected { else }");
            }
        }

        if (endifRegex.test(templateParts[i])) {
            if (nesting.length > 0) {
                nesting.splice(nesting.length - 1, 1);
                continue;
            } else {
                throw new Error("template contained unexpected invalid { end if }");
            }
        }

        // if it didn't match any of the parts, it must be part of the template
        if (nesting.length == 0 || nesting[nesting.length - 1].value) {
            flowAdjustedTemplate += templateParts[i];
        }
    }
    if (nesting.length != 0) {
        throw new Error("expected { end if } block but reached end of template.");
    }
    template = flowAdjustedTemplate;


    var thingToReplaceRegex = /\{\s*(?:(?:(item|translation|theme)\.([a-zA-Z][a-zA-Z0-9_]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\((?:(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?)|(?:item))\s*\}/;

    var thingMatch = template.match(thingToReplaceRegex);
    var remaining = template;

    while (thingMatch != null) {

        var replacement;

        if (thingMatch[0].match(/\{\s*item\s*\}/)) {
            replacement = JSON.stringify(item);
        }
        else {
            replacement = replacementFunction(thingMatch[0], thingMatch[1], thingMatch[2], thingMatch[3], thingMatch[4], thingMatch[5], thingMatch[6]);
        }

        if (replacement == undefined) {
            replacement = '';
        }
        if (replacement.match(/^".*"$/)) {
            replacement = replacement.substring(1, replacement.length - 1);
        }

        template = template.replace(thingToReplaceRegex, replacement.replace(/"/g, "&quot;"));

        // TODO - match from end of last replacement to avoid re-replacing
        thingMatch = template.match(thingToReplaceRegex);
        //					
        //					var unbrokenSpaces = /([^\s\u200B-\u200D]{14}[^\s\u200B-\u200D]*)/g;
        //					var zeroWidthSpace = String.fromCharCode(8203);
        //
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //					var matches = replacement.match( unbrokenSpaces );
        //					
        //					// add zero width spaces around any underscores
        //					if(replacement.contains("_")) {
        //						if( matches ) {
        //							for(var m=0; m<matches.length; m++) {
        //								replacement = replacement.replace( matches[m], matches[m].replace(/[_]/g, zeroWidthSpace + "_" + zeroWidthSpace ))
        //							}
        //						}
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //
        //					// add zero width spaces around any hyphens
        //					if(replacement.contains("-")) {
        //						if( matches ) {
        //							for(var m=0; m<matches.length; m++) {
        //								replacement = replacement.replace( matches[m], matches[m].replace(/-/g, zeroWidthSpace + "-" + zeroWidthSpace ))
        //							}
        //						}
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //					
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //					// TODO - add 0 width space characters around other punctuation
        //					
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //						// add 0 width space characters every 13 characters
        //					while( matches && matches.length > 0 ) {
        //						
        //						replacement = replacement.replace( matches[0], matches[0].substring(0,13) + zeroWidthSpace + matches[0].substring(13) );
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //				}

    }

    var temp = document.createElement('template');
    template = template.trim(); // Never return a text node of whitespace as the result
    temp.innerHTML = template;

    return temp.content;
}

Atheneum.UI.ItemGroupDisplay.prototype.addItem = function AtheneumUIItemGroupDisplay_addItem(item) {

    if (!this.element)
        return;

    if (item == undefined) {
        return;
    }

    var atheneum = this.Atheneum;
    var template = this.itemTemplate || "";

    var theItem = item;
    var replacementFunction = function (match, source, key, format, defaultValue, maxLength, contains) {

        var value;


        if (typeof defaultValue === 'string' && defaultValue.match(/^"[^"]*(?:(?:\\")[^"]*)?"$/)) {
            defaultValue = defaultValue.substring(1, defaultValue.length - 1);
        }


        if (source == 'translation') {
            value = atheneum.Translation.getOrGetThemeKey(key, defaultValue);
        }
        else if (source == 'theme') {
            value = atheneum.Theme.getStringProperty(key, defaultValue);
        }
        else if (source == 'item') {
            if (key == undefined) {
                value = theItem;
                if (format == undefined) {
                    format = 'json';
                }
            }
            else {
                if (theItem.hasOwnProperty(key)) {
                    value = theItem[key];
                }
                else {
                    value = defaultValue;
                }
                if (key == 'id' && format == undefined) {
                    format = 'id';
                }
            }
        }


        if (contains && value == undefined) {
            format = 'boolean';
            value = 'false';
        }
        else if (contains) {
            format = 'boolean';
            value = (value.indexOf(JSON.parse(contains)) != -1) + '';
        }


        if (format == 'json') {
            value = (value == undefined ? 'null' : JSON.stringify(value));
        }
        else if (format == 'url') {
            value = atheneum.Proxy.rewriteURL(value);
        }
        else if (format == 'date' || format == 'date-iso' || format == 'date-uk' || format == 'date-us'
            || format == 'datetime' || format == 'datetime-iso' || format == 'datetime-uk' || format == 'datetime-iso'
            || format == 'time') {

            if (value != undefined) {

                //var date = new Date(value|0); 
                var date = new Date(value || 0);

                if (!(!date || isNaN(date.getDate()))) {

                    var day = (date.getDate() <= 9 ? '0' : '') + date.getDate();
                    var month = ((date.getMonth() + 1) <= 9 ? '0' : '') + (date.getMonth() + 1);
                    var year = (date.getFullYear() <= 9 ? '0' : '') + date.getFullYear();

                    var hours = (date.getHours() <= 9 ? '0' : '') + date.getHours();
                    var minutes = (date.getMinutes() <= 9 ? '0' : '') + date.getMinutes();

                    var string = '';

                    if (format == 'date-uk' || format == 'datetime-uk') {
                        string += day + '/' + month + '/' + year;
                    }
                    else if (format == 'date-us' || format == 'datetime-us') {
                        string += month + '/' + day + '/' + year;
                    }
                    else if (format == 'date' || format == 'date-iso' || format == 'datetime' || format == 'datetime-iso') {
                        string += year + '-' + month + '-' + day;
                    }

                    if (format == 'datetime' || format == 'datetime-uk' || format == 'datetime-us') {
                        string += ' ';
                    }
                    else if (format == 'datetime-iso') {
                        string += 'T';
                    }

                    if (format == 'time' || format == 'datetime' || format == 'datetime-iso' || format == 'datetime-uk' || format == 'datetime-us') {
                        string += hours + ':' + minutes;
                    }

                    value = string;
                }
            }
        }
        else if (format == 'colour') {
            var colour = new Atheneum.Colour(value);
            value = colour.toRGBAString();
        }
        else if (format == 'boolean') {
            if (value) {
                if (Atheneum.Theme.TRUE_VALUES.indexOf(value.toLowerCase()) != -1) {
                    value = 'true';
                }
                else if (Atheneum.Theme.FALSE_VALUES.indexOf(value.toLowerCase()) != -1) {
                    value = 'false';
                }
            }
            else {
                value = 'false';
            }
        } else if (format == "exists") {
            if (value) {
                value = 'true';
            } else {
                value = 'false';
            }
        }

        if (maxLength && maxLength > 7 && value && value.length > 7) {
            var lastSpace = value.indexOf(' ', maxLength - 7);
            if (lastSpace == -1)
                lastSpace = value.indexOf('_', maxLength - 7);
            if (lastSpace == -1)
                lastSpace = maxLength - 3;
            value = value.substring(0, lastSpace) + "...";
        }

        if (value != undefined && format != 'boolean') {
            value = "" + value;
        }

        return value;

    }

    var flowRegex = /((?:\{\s*(?:else\s*)?if\s*\((?:\s*(?:item|theme|translation)\.(?:[a-zA-Z][a-zA-Z0-9]*)(?::format\((?:url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((?:true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((?:0|[1-9][0-9]*)\))?(?::contains\((?:(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?:(?:\s*(?:==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}))|(?:\{\s*else\s*\})|(?:\{\s*end\s*if\s*\})))/g;

    var ifRegex = /\{\s*if\s*\(\s*(item|theme|translation)\.([a-zA-Z][a-zA-Z0-9]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\(((?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(\s*(:?==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}/;
    var elseifRegex = /\{\s*else\s*if\s*\(\s*(item|theme|translation)\.([a-zA-Z][a-zA-Z0-9]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|exists|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*"))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\(((?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?:\s*(:?==|>=|<=|>|<)\s*(?:true|false|null|undefined|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*')|[0-9]+|0x[0-9A-Fa-f]+))?\s*\)\s*\}/;
    var elseRegex = /\{\s*else\s*\}/;
    var endifRegex = /\{\s*end\s*if\s*\}/;

    var templateParts = template.split(flowRegex);
    var nesting = [];
    var flowAdjustedTemplate = "";

    var ratingStars = '';
    if (item.rating != undefined && item.rating > 0) {

        var rating = item.rating;

        var maxStars = (this.ratingMaxStars != undefined) ? this.ratingMaxStars : 5;

        var ratingStarsAdded = 0;

        var emptyStar = (this.ratingStarEmptyTemplate != undefined) ? this.ratingStarEmptyTemplate : '&nbsp;';
        var halfStar = (this.ratingStarHalfTemplate != undefined) ? this.ratingStarHalfTemplate : '*';
        var fullStar = (this.ratingStarFullTemplate != undefined) ? this.ratingStarFullTemplate : '*';

        for (var r = 0; r < (rating | 0); r++) {
            ratingStars += fullStar;
            ratingStarsAdded += 1;
        }
        var ratingRemainder = rating - (rating | 0);
        if (ratingRemainder > 0.25 && ratingRemainder < 0.75) {
            // add half stars
            ratingStars += halfStar;
            ratingStarsAdded += 1;
        }
        else if (ratingRemainder >= 0.75) {
            ratingStars += fullStar;
            ratingStarsAdded += 1;
        }
        for (var r = ratingStarsAdded; r < maxStars; r++) {
            ratingStars += emptyStar;
        }
    }
    else {
        ratingStars = (this.unratedTemplate != undefined) ? this.unratedTemplate : 'unrated';
    }

    item.rating = item.rating
    item.starRating = ratingStars;
    if (item.type == 'asset') {
        item.inFavourites = this.Atheneum.Favourites.containsAsset(item.id);
    }
    else {
        item.inFavourites = false;
    }

    if (item.type == 'asset') {
        item.inCart = this.Atheneum.Cart.containsAsset(item.id);
    }
    else {
        item.inCart = false;
    }

    for (var i = 0; i < templateParts.length; i++) {

        var match = templateParts[i].match(ifRegex);
        if (match && match.length > 0) {

            if (nesting.length > 0 && (nesting[nesting.length - 1].value == false || nesting[nesting.length - 1].skip == true)) {
                nesting[nesting.length] = { encounteredElse: false, executed: false, value: false, skip: true };
                continue;
            }


            var result;
            var resultValueAfterSubstitution = replacementFunction(match[0], match[1], match[2], match[3], match[4], match[5], match[6]);


            try {
                result = eval(resultValueAfterSubstitution + (match[7] || ''));
            }
            catch (e) {
                throw new Error("template error on evaluating " + templateParts[i]);
            }

            if (typeof result === "object" && Object.prototype.toString.call(result) == "[object Array]" && result.length == 0) {
                result = false;
            }
            result = !!result;

            nesting[nesting.length] = { encounteredElse: false, executed: result, value: result, skip: false };
            continue;
        }

        if (elseifRegex.test(templateParts[i]) && nesting.length == 0) {
            throw new Error("template contained unexpected invalid { else if } block.");
        }

        match = templateParts[i].match(elseifRegex);
        if (match && match.length > 0) {

            if (nesting[nesting.length - 1].encounteredElse)
                throw new Error("template contained { else if } after { else }");

            if (nesting[nesting.length - 1].skip == true) {
                continue;
            }

            // if the "if" or a previous "else if" further up has already been executed, skip
            if (nesting[nesting.length - 1].executed) {
                nesting[nesting.length - 1] = { encounteredElse: false, executed: true, value: false, skip: true };
                continue;
            }

            var result;
            var resultValueAfterSubstitution = replacementFunction(match[0], match[1], match[2], match[3], match[4], match[5], match[6]);


            try {
                result = eval(resultValueAfterSubstitution + (match[7] || ''));
            }
            catch (e) {
                throw new Error("template error on evaluating " + templateParts[i]);
            }

            if (typeof result === "object" && Object.prototype.toString.call(result) == "[object Array]" && result.length == 0) {
                result = false;
            }
            result = !!result;

            nesting[nesting.length - 1] = { encounteredElse: false, executed: result, value: result, skip: false };
            continue;
        }

        if (elseRegex.test(templateParts[i])) {

            if (nesting.length > 0) {

                if (nesting[nesting.length - 1].encounteredElse)
                    throw new Error("template contained multiple { else } for the same { if }");

                nesting[nesting.length - 1].encounteredElse = true;
                if (!nesting[nesting.length - 1].executed && !nesting[nesting.length - 1].skip) {
                    nesting[nesting.length - 1].value = true;
                    nesting[nesting.length - 1].executed = true;
                } else {
                    nesting[nesting.length - 1].skip = true;
                    nesting[nesting.length - 1].executed = true;
                    nesting[nesting.length - 1].value = false;
                }
                continue;

            } else {
                throw Exception("template contained unexpected { else }");
            }
        }

        if (endifRegex.test(templateParts[i])) {
            if (nesting.length > 0) {
                nesting.splice(nesting.length - 1, 1);
                continue;
            } else {
                throw new Error("template contained unexpected invalid { end if }");
            }
        }

        // if it didn't match any of the parts, it must be part of the template
        if (nesting.length == 0 || nesting[nesting.length - 1].value) {
            flowAdjustedTemplate += templateParts[i];
        }
    }
    if (nesting.length != 0) {
        throw new Error("expected { end if } block but reached end of template.");
    }
    template = flowAdjustedTemplate;


    var thingToReplaceRegex = /\{\s*(?:(?:(item|translation|theme)\.([a-zA-Z][a-zA-Z0-9_]*)(?::format\((url|date(?:time)?(?:-(?:uk|us|iso))?|time|boolean|json|id|colour)\))?(?::default\((true|false|(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?(?::(?:limit|max-length)\((0|[1-9][0-9]*)\))?(?::contains\((?:(?:"[^"]*(?:\\"[^"]*)*")|(?:'[^']*(?:\\'[^']*)*'))\))?)|(?:item))\s*\}/;

    var thingMatch = template.match(thingToReplaceRegex);
    var remaining = template;

    while (thingMatch != null) {

        var replacement;

        if (thingMatch[0].match(/\{\s*item\s*\}/)) {
            replacement = JSON.stringify(item);
        }
        else {
            replacement = replacementFunction(thingMatch[0], thingMatch[1], thingMatch[2], thingMatch[3], thingMatch[4], thingMatch[5], thingMatch[6]);
        }

        if (replacement == undefined) {
            replacement = '';
        }
        if (replacement.match(/^".*"$/)) {
            replacement = replacement.substring(1, replacement.length - 1);
        }

        template = template.replace(thingToReplaceRegex, replacement.replace(/"/g, "&quot;"));

        // TODO - match from end of last replacement to avoid re-replacing
        thingMatch = template.match(thingToReplaceRegex);
        //					
        //					var unbrokenSpaces = /([^\s\u200B-\u200D]{14}[^\s\u200B-\u200D]*)/g;
        //					var zeroWidthSpace = String.fromCharCode(8203);
        //
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //					var matches = replacement.match( unbrokenSpaces );
        //					
        //					// add zero width spaces around any underscores
        //					if(replacement.contains("_")) {
        //						if( matches ) {
        //							for(var m=0; m<matches.length; m++) {
        //								replacement = replacement.replace( matches[m], matches[m].replace(/[_]/g, zeroWidthSpace + "_" + zeroWidthSpace ))
        //							}
        //						}
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //
        //					// add zero width spaces around any hyphens
        //					if(replacement.contains("-")) {
        //						if( matches ) {
        //							for(var m=0; m<matches.length; m++) {
        //								replacement = replacement.replace( matches[m], matches[m].replace(/-/g, zeroWidthSpace + "-" + zeroWidthSpace ))
        //							}
        //						}
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //					
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //					// TODO - add 0 width space characters around other punctuation
        //					
        //					// if there's a block of unbroken 14+ characters without any spaces:
        //						// add 0 width space characters every 13 characters
        //					while( matches && matches.length > 0 ) {
        //						
        //						replacement = replacement.replace( matches[0], matches[0].substring(0,13) + zeroWidthSpace + matches[0].substring(13) );
        //						matches = replacement.match( unbrokenSpaces );
        //					}
        //				}

    }

    var holder = document.createElement("DIV");
    holder.innerHTML = template;
    while (holder.firstChild) {
        this.element.appendChild(holder.firstChild);
    }

    var itemElement = document.querySelector('#atheneum-home-page [data-atheneum-item-id="' + item.id + '"]');
    if (itemElement) {

        var infoIconElement = itemElement.querySelector('.atheneum-item .asset-style .info-btn img');
        if (infoIconElement) {
            if (SalesToolkit.Theme.getBooleanProperty('hideAssetInformationButton', false))
                infoIconElement.style.display = 'none';
            else {
                applyImageToElement(infoIconElement, 'assetInformationIcon', 'img/default/info_icon.svg')
                infoIconElement.style.display = 'block';
            }
        }

        var thumbnailElement = itemElement.querySelector('.atheneum-item[data-atheneum-item-type="collection"] .collection-style .thumbnail-image, .atheneum-item[data-atheneum-item-type="asset"] .asset-style .thumbnail');
        if (thumbnailElement && !thumbnailElement.style.backgroundImage) {
            var bgImageURL = thumbnailElement.getAttribute('data-background-image-url');
            if (bgImageURL && !thumbnailElement.classList.contains('data-background-update-queued')) {
                thumbnailElement.classList.add('data-background-update-queued');
                addUrlToRewriteQueue(bgImageURL, function (rewrittenURL) {
                    if (rewrittenURL != null && rewrittenURL.href)
                        rewrittenURL = rewrittenURL.href;
                    // console.log('setting item ' + item.id + '\'s thumbnail to ' + rewrittenURL);

                    if (rewrittenURL !== null && rewrittenURL.contains("https:") && !rewrittenURL.contains("keepRatio=true&shouldCrop=false&width=800&height=450")) {
                        rewrittenURL = rewrittenURL + "?keepRatio=true&shouldCrop=false&width=800&height=450";
                    }

                    if(!rewrittenURL.contains('apikey')){
                        if(rewrittenURL.contains('?'))
                            rewrittenURL += "&apikey="+window.AtheneumInstance.User.apikey;
                        else
                            rewrittenURL += "?apikey="+window.AtheneumInstance.User.apikey;
                    }

                    if(!bgImageURL.contains('apikey')){
                        if(bgImageURL.contains('?'))
                            bgImageURL += "&apikey="+window.AtheneumInstance.User.apikey;
                        else
                            bgImageURL += "?apikey="+window.AtheneumInstance.User.apikey;
                    }

                    

                    if (rewrittenURL !== null && (rewrittenURL.contains(".index") || !rewrittenURL.contains("file:"))) {
                        thumbnailElement.style.backgroundImage = 'url(\'' + bgImageURL + '\')';
                    }
                    else
                        thumbnailElement.style.backgroundImage = 'url(\'' + rewrittenURL + '\')';

                    thumbnailElement.style.opacity = 1;
                });
            }
        }
    }

    this.trigger("item-added", item);
}

Atheneum.UI.ItemGroupDisplay.prototype.removeItem = function AtheneumUIItemGroupDisplay_removeItem(item) {

    if (!this.element)
        return;

    var removed = false;
    var items = this.element.querySelectorAll(".atheneum-item");
    for (var i = 0; i < items.length; i++) {
        var containingChild = items[i];
        while (containingChild.parentNode != this.element)
            containingChild = containingChild.parentNode;

        var itemData = JSON.parse((items[i].getAttribute("data-atheneum-item") || "").replace(/&quot/g, "\""));
        if (itemData.id == item.id) {
            this.element.removeChild(containingChild);
            removed = true;
        }
    }

    if (removed)
        this.trigger("item-removed");
}

Atheneum.UI.ItemGroupDisplay.prototype.removeAllItems = function AtheneumUIItemGroupDisplay_removeAllItems() {

    if (this.element == null)
        return;

    while (this.element.firstChild) {

        if (!this.element.firstChild.getAttribute || this.element.firstChild.getAttribute("data-atheneum-item") == undefined) {
            this.element.removeChild(this.element.firstChild);
            continue;
        }

        if (this.trigger("item-removed", JSON.parse(this.element.firstChild.getAttribute("data-atheneum-item").replace(/&quot;/g, "\""))) !== false)
            this.element.removeChild(this.element.firstChild);
    }
}

// class Atheneum.UI.CollectionBrowser extends Atheneum.UI.ItemGroupDisplay
Atheneum.UI.CollectionBrowser = function AtheneumUICollectionBrowser(atheneum, element, topLevelCollection, sectionedMode = false) {

    if (!(this instanceof Atheneum.UI.CollectionBrowser))
        return new Atheneum.UI.CollectionBrowser(atheneum, element);

    Atheneum.UI.ItemGroupDisplay.call(this, atheneum, element);

    
    if(atheneum.Theme.getStringProperty('customLibraryUIHTML', atheneum.DefaultCustomLibraryUI).length > 0){
        this.customUIMode = true;
    }else{
        this.customUIMode = false;
    }

    this.topLevelSectioned = sectionedMode;
    
    //FOR TESTING ONLY
    if(atheneum.Theme.getBooleanProperty('collectionBrowserStressTesting', false)){
        this.stressTestMode = true;
        this.stressTestLevel = 10;    
    }else{
        this.stressTestMode = false;
        this.stressTestLevel = 1;    
    }
   
    this.path = [];
    this.topLevelCollection = topLevelCollection || null;
    this.threshold = 30;
    this.activeTopLevelFilter = "";

    // selector to get the element corresponding to an item on the page
    this.itemSelector = '.atheneum-item';

    this.paginate = true;
    this.pageSize = 60;
    this.assetPageSize = 60;
    this.currentPage = 1;
    if(atheneum.Theme.getBooleanProperty('attemptLoadingLastPageOnNav', false))
        this.currentPage = localStorage['currentCBPage'];
    this.totalPages = 1;
    //0 - default, 1 - alpha descending, 2 - alpha ascending
    this.sortMode = localStorage.sortMode || 0;
    // selector to get the top-most item, useful for pagination
    this.paginatedItemSelector = '.atheneum-item';

    this.ratingMaxStars = this.constructor.defaultRatingMaxStars != undefined ? this.constructor.defaultRatingMaxStars : atheneum.UI.ItemGroupDisplay.defaultRatingMaxStars;
    this.ratingStarEmptyTemplate = this.constructor.defaultRatingStarEmptyTemplate != undefined ? this.constructor.defaultRatingStarEmptyTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate;
    this.ratingStarHalfTemplate = this.constructor.defaultRatingStarHalfTemplate != undefined ? this.constructor.defaultRatingStarHalfTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarHalfTemplate;
    this.ratingStarFullTemplate = this.constructor.defaultRatingStarFullTemplate != undefined ? this.constructor.defaultRatingStarFullTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarFullTemplate;
    this.unratedTemplate = this.constructor.defaultUnratedTemplate != undefined ? this.constructor.defaultUnratedTemplate : atheneum.UI.ItemGroupDisplay.defaultUnratedTemplate;

    var collectionBrowser = this;

    this.on("item-click", function (item) {
        if (item.realType && item.realType == 'form') {
            loadForm(item.id);
            return;
        }
        if (item.type == "collection") {
            var path = [];
            for (var p = 0; p < collectionBrowser.path.length; p++) {
                path[p] = collectionBrowser.path[p];
            }
            path[collectionBrowser.path.length] = item.id;
            if(collectionBrowser.topLevelSectioned && path.indexOf(collectionBrowser.topLevelSectionId) < 0){
                path.unshift(collectionBrowser.topLevelSectionId);
            }
            collectionBrowser.setPath(path);
        }
    });

    this.on("path-change", function (path) {
        collectionBrowser.refresh();
        if(collectionBrowser.ignoreLastPathStorage){
            collectionBrowser.ignoreLastPathStorage = false;
            return;
        }
        if(window.location.href.indexOf('index.html') >= 0 || window.location.pathname == "/")
            localStorage.setItem('lastCBPath', JSON.stringify(path));
    });
}

Atheneum.UI.CollectionBrowser.prototype = Object.create(Atheneum.UI.ItemGroupDisplay.prototype);
Atheneum.UI.CollectionBrowser.prototype.constructor = Atheneum.UI.CollectionBrowser;

Atheneum.UI.prototype.CollectionBrowser = function (element, topLevelCollection, sectionMode = false) {
    return new Atheneum.UI.CollectionBrowser(this.Atheneum, element, topLevelCollection, sectionMode);
}
Atheneum.UI.prototype.CollectionBrowser.setDefaultItemTemplate = function (template) {
    Atheneum.UI.CollectionBrowser.defaultItemTemplate = template;
}

Atheneum.UI.CollectionBrowser.prototype.loadStoredPath = function () {
    var lastPath = localStorage.getItem("lastCBPath");
    if (lastPath) {
        var storedPath = JSON.parse(lastPath);
        this.setPath(storedPath);
    }
}

Atheneum.UI.CollectionBrowser.prototype.viewFirstPage = function () {
    return this.viewPage(1);
}
Atheneum.UI.CollectionBrowser.prototype.viewNextPage = function () {
    return this.viewPage(Math.max(1, Math.min(this.currentPage + 1, this.totalPages)));
}
Atheneum.UI.CollectionBrowser.prototype.viewPreviousPage = function () {
    return this.viewPage(Math.max(this.currentPage - 1, 1));
}
Atheneum.UI.CollectionBrowser.prototype.viewLastPage = function () {
    return this.viewPage(Math.max(1, this.totalPages));
}
Atheneum.UI.CollectionBrowser.prototype.viewPage = function (pageNumber) {
    this.currentPage = pageNumber;
    localStorage['currentCBPage'] = pageNumber;
    let pSize = this.assetPageSize;
    
    if (this.searchTerm) {
        pSize = this.pageSize;
    }else if(this.filtered == undefined && (this.path.length == 0 || (this.path.length == 1 && this.topLevelSectioned))){
        pSize = 9999;
    }

    var allItems = this.element.querySelectorAll(this.paginatedItemSelector);
    let allItemsArr = Array.from(allItems);
    
    this.totalPages = 1 + Math.max(0, ((allItems.length - 1) / pSize) | 0);
    if(!this.searchTerm && allItemsArr.filter(x=> x.dataset.atheneumItemType == 'asset').length == 0)
    {
        this.currentPage = 1;
        localStorage['currentCBPage'] = 1;
        this.element.querySelectorAll('atheneum-item-pagination-shown').forEach(item => {
            item.classList.remove('atheneum-item-pagination-hidden');
            item.classList.add('atheneum-item-pagination-shown');
          });
        this.trigger('page-change');
        return;
    }
    
    for (var i = 0; i < allItems.length; i++) {
        var item = allItems[i];
        var itemPageNumber = 1 + Math.max(0, (i / pSize) | 0);
        if (this.currentPage == itemPageNumber) {
            item.classList.remove('atheneum-item-pagination-hidden');
            item.classList.add('atheneum-item-pagination-shown');
        }
        else {
            item.classList.remove('atheneum-item-pagination-shown');
            item.classList.add('atheneum-item-pagination-hidden');
        }
    }
    this.trigger('page-change');
}

Atheneum.UI.CollectionBrowser.prototype.viewCollection = function AtheneumUICollectionBrowser_viewCollection(collectionId, onlyIfDifferentId = false, ignoreTracking = false) {

    var array = [];

    try{
        if(onlyIfDifferentId && collectionId === (this.path[this.path.length - 1] || null)){
            return;
        }
    }catch(err){

    }
    
    var collection = { containedBy: collectionId };
    while (collection.containedBy != null) {
        collection = this.Atheneum.Library.collections[collectionId];
        if (collection != undefined) {
            array[array.length] = collectionId;
            collectionId = collection.containedBy;
        } else {
            this.setPath([]);
            return;
        }
    }
    array.reverse();
    this.setPath(array, ignoreTracking);
    this.trigger('view-collection');
}

Atheneum.UI.CollectionBrowser.prototype.setPath = function AtheneumUICollectionBrowser_setPath(path, ignoreTracking = false) {

    if(this.Atheneum.Theme.getBooleanProperty('goToTopLevelOnFilters', false) && path.length > 0 && this.filtered){
        return;
    }
    
    // depp copy path
    this.path = [];
    for (var p = 0; p < path.length; p++) {
        this.path[p] = path[p];
    }

    // check we can see the item
    var p = 0;
    while (p < this.path.length) {
        var collection = this.Atheneum.Library.collections[this.path[this.path.length - p - 1]];
        if (!collection || !this.Atheneum.User.canSee(collection)) {
            this.path.pop();
            continue;
        }
        p += 1;
    }

    // check if it's a descendent of the topLevelCollection
    var topLevelCollection = this.topLevelCollection ? this.Atheneum.Library.collections[this.topLevelCollection] : null;
    if (topLevelCollection && this.Atheneum.User.canSee(topLevelCollection)) {

        // remove all items from the path that are not descendents of the topLevelCollection
        p = 0;
        while (p < this.path.length) {
            var decendedFromTopLevelCollection = false;
            var collection = this.Atheneum.Library.collections[this.path[this.path.length - 1 - p]];
            if (collection.id == topLevelCollection.id) {
                this.path.splice(this.path.length - 1 - p, 1);
                continue;
            }
            while (collection && collection.containedBy) {
                if (collection.id == topLevelCollection.id) {
                    decendedFromTopLevelCollection = true;
                    break;
                }
                collection = this.Atheneum.Library.collections[collection.containedBy];
            }
            if (collection.id == topLevelCollection.id) {
                decendedFromTopLevelCollection = true;
            }
            if (decendedFromTopLevelCollection) {
                p += 1;
            }
            else {
                this.path.splice(this.path.length - 1 - p, 1);
            }
        }

        //        // if the path is empty, view the topLevelCollection
        //        if (this.path.length == 0) {
        //            this.path.push(this.topLevelCollection);
        //        }
    }

    

     this.trigger('path-change', this.path, ignoreTracking);
}

Atheneum.UI.CollectionBrowser.prototype.clearSearch = function AtheneumUICollectionBrowser_clearSearch() {
    this.currentPage = 1;
    this.searchTerm = undefined;
    if(this.searchGroup)   {
        try{
            this.searchGroup.clear();
        }catch(err){}
    }
    this.searchGroup = null;
    this.refresh();
}

Atheneum.UI.CollectionBrowser.prototype.search = function AtheneumUICollectionBrowser_search(text) {
    if(this.searchTerm === text)
        return;

    if(window._searchTimeout){
        window.clearTimeout(this._searchTimeout);
        this.stopSearchRender = true;
        let cb =this;
        setTimeout(function(){
            cb.currentPage = 1;
            cb.stopSearchRender = false;
            cb._search(text, true);
        }, 260);
    }else{
        this.currentPage = 1;
        this.stopSearchRender = false;
        this._search(text, true);
    }
}

Atheneum.UI.CollectionBrowser.prototype._search = function (text, triggerSearchEvent) {

    var atheneum = this.Atheneum;

    var searchOptions = {};

    if (this.searchOptions && typeof this.searchOptions === 'object') {
        for (var prop in this.searchOptions) {
            if (this.searchOptions.hasOwnProperty(prop)) {
                searchOptions[prop] = this.searchOptions[prop];
            }
        }
    }

    if (!searchOptions.hasOwnProperty('collection')) {

        var collection = null;
        if (this.path.length == 0) {
            collection = this.Atheneum.Library.collections[this.topLevelCollection];
        }
        else {
            // TODO add search toggle mode to search either from top always or from where you are
            collection = this.Atheneum.Library.collections[this.topLevelCollection];
            //collection = this.path[this.path.length - 1];
        }
        searchOptions.collection = collection;
    }

    var searchResults = this.Atheneum.Library.search(text, searchOptions);
   //TODO getting rid of collections as its bugged with the 
   searchResults.collections = [];

    if (searchResults) {

        if (this.sortMode == 1 && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        } else if (this.sortMode == 2 && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return -1;
                if (!a.name && b.name)
                    return 1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                return 0;
            });
        } else if (atheneum.Theme.getBooleanProperty('orderSearchAssetsAlphabetically', true) && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        }

        if (this.sortMode == 1 && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        } else if (this.sortMode == 2 && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return -1;
                if (!a.name && b.name)
                    return 1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                return 0;
            });
        } else if (atheneum.Theme.getBooleanProperty('orderSearchCollectionsAlphabetically', true) && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        }


    }

    if (this._searchTimeout) {
        window.clearTimeout(this._searchTimeout);
        this._searchTimeout = null;
    }
    this.removeAllItems();


    this.searchTerm = text;
    this._searchTimeout = null;

    if(this.Atheneum.Theme.getBooleanProperty('useGroupsForSearchResults', false)){
        let searchGroups = this.Atheneum.Theme.getStringProperty('searchGroupsTemplate', '{"id":"0", "collectionLevel":1, "group":{"id":"1", "collectionLevel":-2, "pageNumberStyle" : "font-size:1.5rem; line-height:3rem;", "pageControlStyle":"font-weight:bold; color:#FF3300;", "headerButtonOpenStyle" : "line-height:45px;", "headerH1Style" : "", "headerStyle" : "color:#FF3300;", "filterType":"string","filterProperty":"name"}, "headerButtonOpenStyle" : "line-height:45px;", "headerH1Style" : "font-weight:bold;", "headerStyle" : "background-color:#F6F2EF; color:#FF3300;", "shouldSortReverse":true, "filterType":"dateYear", "filterProperty":"published"}');
        searchGroups = JSON.parse(searchGroups);

        let aThis = this;

        let spinnerId = "collectionBrowserSpinner";
        let spinner = document.getElementById(spinnerId);
        if(spinner == null){
           spinner = this.element.appendChild(htmlToElement('<div style="position:relative; transform:scale(0.6); left:calc(50% - 40px);" id="'+spinnerId+'"class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>'));
        }
    
        this.spinner = spinner;
      
        setTimeout(function(){
            if(aThis.searchGroup)   {
                try{
                    aThis.searchGroup.clear();
                }catch(err){}
            }
          
            aThis.searchGroup = new Atheneum.UI.CollectionBrowser.Group(aThis.Atheneum, aThis, searchResults.assets, searchGroups, aThis.element);
            aThis.spinner.style.display = "none";
        },0);

        return;
    }
    
    if (this.threshold && searchResults.collections.length + searchResults.assets.length > this.threshold) {
        // if there's a significant number of items to add at once, (enough to cause ui lag),
        // then do it in several steps



        if (triggerSearchEvent) {
            this.trigger('search');
        }
        var itemGroupDisplay = this;
        var itemsAddedSoFarContainer = { count: 0 };
        var allCollectionsAdded = true;
        for (var c = 0; c < searchResults.collections.length; c++) {
            if (itemsAddedSoFarContainer.count >= itemGroupDisplay.threshold) {
                var allCollectionsAdded = false;
                break;
            }
            itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
            itemsAddedSoFarContainer.count += 1;
        }
        for (var a = 0; itemsAddedSoFarContainer.count < itemGroupDisplay.threshold && a < searchResults.assets.length; a++) {
            itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
            itemsAddedSoFarContainer.count += 1;
        }
        // at this point, exactly this.threshold items will have been added
        var addNextItemsAfterShortDelay = function () {
            
            if (itemGroupDisplay._searchTimeout) {
                window.clearTimeout(itemGroupDisplay._searchTimeout);
                itemGroupDisplay._searchTimeout = null;
            }

            if(!itemGroupDisplay.searchTerm && !itemGroupDisplay.filtered)
                return;

            itemGroupDisplay._searchTimeout = window.setTimeout(function () {

                // check to see if the searchTerm has changed
                if(itemGroupDisplay.stopSearchRender)
                {
                    return;
                }
                var itemsAddedThisIteration = 0;
                if (!allCollectionsAdded) {
                    // check collections
                    allCollectionsAdded = true;
                    for (var c = itemsAddedSoFarContainer.count; c < searchResults.collections.length; c++) {
                        if (itemsAddedThisIteration >= itemGroupDisplay.threshold) {
                            allCollectionsAdded = false;
                            break;
                        }

                        if (!itemGroupDisplay.searchTerm && !itemGroupDisplay.filtered)
                            return;
                        itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
                        itemsAddedThisIteration += 1;
                        itemsAddedSoFarContainer.count += 1;
                    }
                }
                if (itemsAddedThisIteration < itemGroupDisplay.threshold) {
                    // check assets
                    var assetsAddedSoFar = itemsAddedSoFarContainer.count - searchResults.collections.length;   
                    for (var a = assetsAddedSoFar; a < searchResults.assets.length; a++) {
                        if (itemsAddedThisIteration >= itemGroupDisplay.threshold) {
                            break;
                        }

                        if (!itemGroupDisplay.searchTerm && !itemGroupDisplay.filtered)
                            return;
                        itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
                        itemsAddedThisIteration += 1;
                        itemsAddedSoFarContainer.count += 1;
                    }
                }
                itemGroupDisplay.viewPage(itemGroupDisplay.currentPage || 1);
                // javascript? excuse me what the hell?
                if (itemsAddedSoFarContainer.count == searchResults.collections.length + searchResults.assets.length) {
                    // we're done
                    if (triggerSearchEvent) {
                        itemGroupDisplay.trigger('search');
                    }
                    itemGroupDisplay.trigger('refresh');
                }
                else {
                    addNextItemsAfterShortDelay();
                }
            }, 250);
        };
        addNextItemsAfterShortDelay();
    }
    else {
        for (var c = 0; c < searchResults.collections.length; c++) {
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
        }
        for (var a = 0; a < searchResults.assets.length; a++) {
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
        }
        this.viewPage(this.currentPage || 1);
        if (triggerSearchEvent) {
            this.trigger('search');
        }
        this.trigger('refresh');
    }

}

Atheneum.UI.CollectionBrowser.prototype.clearFilters = function AtheneumUICollectionBrowser_clearFilters() {
    this.currentPage = 1;
    this.filtered = undefined;
    this.filterResults = undefined;
    this.keys = undefined;
    
    if(this.filterGroup)   {
        try{
            this.filterGroup.clear();
        }catch(err){}
    }
    this.filterGroup = null;

    this.refresh();
    this.suspendFilter = false;
}

Atheneum.UI.CollectionBrowser.prototype.filter = function AtheneumUICollectionBrowser_filter() {
    this.currentPage = 1;

    if(this.filtered){
        window.clearTimeout(this._searchTimeout);
        this.suspendFilter = true;
        let cb =this;
        setTimeout(function(){
            cb.suspendFilter = false;
            cb._filter();
        }, 260);
    }else{
        this.suspendFilter = false;
        this._filter();
    }

   
}

Atheneum.UI.CollectionBrowser.prototype.suspendFilter = function AtheneumUICollectionBrowser_suspendFilter(){
    this.suspendFilter = false;
}

Atheneum.UI.CollectionBrowser.prototype.resumeFilter = function AtheneumUICollectionBrowser_resumeFilter(){
    this.suspendFilter = false;
}

Atheneum.UI.CollectionBrowser.prototype._filter = function () {

    var atheneum = this.Atheneum;
    const keys = Object.keys(atheneum.Filters.activeFilters);
    if (keys.length == 0) {
        this.clearFilters();
        return;
    }



    var collections = Object.values(atheneum.Library.collections).filter(x => atheneum.User.canSee(x));
    var assets = Object.values(atheneum.Library.assets).filter(x => atheneum.User.canSee(x));

   //Hidden filters forces multi select
    if (!document.body.classList.contains('hiddenFilters') && atheneum.Theme.getBooleanProperty('allowFiltersMultiSelection', false)) {
        keys.forEach((key, index) => {
            var filterArr = atheneum.Filters.activeFilters[key];
            collections = collections.filter(x => x.properties && x.properties[key] && filterArr.filter(y=> x.properties[key].split(',').indexOf(y) >= 0).length > 0);
            assets = assets.filter(x => x.properties && x.properties[key] && filterArr.filter(y=> x.properties[key].split(',').indexOf(y) >= 0).length > 0);
        });
    } else {
        keys.forEach((key, index) => {
            var filterValue = atheneum.Filters.activeFilters[key];
            collections = collections.filter(x => x.properties && x.properties[key]  && x.properties[key].split(',').indexOf(filterValue) >= 0);
            assets = assets.filter(x => x.properties && x.properties[key] && x.properties[key].split(',').indexOf(filterValue) >= 0);
        });
    }

    if(this.filtered && this.keys && this.keys.toString() === keys.toString() && this.filterResults.assets.length == assets.length)
        return;

    this.filtered = true;
    this.keys = keys;
    var searchResults = {};
    //searchResults.collections = collections; Do we need collection for this?
    searchResults.collections = [];
    searchResults.assets = assets;
    if (searchResults) {

        if (this.sortMode == 1 && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        } else if (this.sortMode == 2 && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return -1;
                if (!a.name && b.name)
                    return 1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                return 0;
            });
        } else if (atheneum.Theme.getBooleanProperty('orderFilterAssetsAlphabetically', true) && searchResults.assets && searchResults.assets.length > 0) {
            searchResults.assets = searchResults.assets.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        }

        if (this.sortMode == 1 && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        } else if (this.sortMode == 2 && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return -1;
                if (!a.name && b.name)
                    return 1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                return 0;
            });
        } else if (atheneum.Theme.getBooleanProperty('orderFilterCollectionsAlphabetically', true) && searchResults.collections && searchResults.collections.length > 0) {
            searchResults.collections = searchResults.collections.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
        }

    }

    this.removeAllItems();
    this.filterResults = searchResults;


    if(this.Atheneum.Theme.getBooleanProperty('useGroupsForFilterResults', false)){
        let filterGroups = this.Atheneum.Theme.getStringProperty('filterGroupsTemplate', '{"id":"0", "collectionLevel":1, "group":{"id":"1", "collectionLevel":-2, "pageNumberStyle" : "font-size:1.5rem; line-height:3rem;", "pageControlStyle":"font-weight:bold; color:#FF3300;", "headerButtonOpenStyle" : "line-height:45px;", "headerH1Style" : "", "headerStyle" : "color:#FF3300;", "fullArticleOnly":true,  "filterType":"string","filterProperty":"name"}, "fullArticleOnly":true, "headerButtonOpenStyle" : "line-height:45px;", "headerH1Style" : "font-weight:bold;", "headerStyle" : "background-color:#F6F2EF; color:#FF3300;", "shouldSortReverse":true, "filterType":"dateYear", "filterProperty":"published"}');
        filterGroups = JSON.parse(filterGroups);
        let aThis = this;

        let spinnerId = "collectionBrowserSpinner";
        let spinner = document.getElementById(spinnerId);
        if(spinner == null){
           spinner = this.element.appendChild(htmlToElement('<div style="position:relative; transform:scale(0.6); left:calc(50% - 40px);" id="'+spinnerId+'"class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>'));
    
        }
    
        this.spinner = spinner;
       
        setTimeout(function(){
            aThis.filterGroup = new Atheneum.UI.CollectionBrowser.Group(aThis.Atheneum, aThis, searchResults.assets, filterGroups, aThis.element);
            aThis.spinner.style.display = "none";
        },0);
        
        return;
    }

    if (this.threshold && searchResults.collections.length + searchResults.assets.length > this.threshold) {
        // if there's a significant number of items to add at once, (enough to cause ui lag),
        // then do it in several steps
        this.trigger('filterPageAdded');

        var itemGroupDisplay = this;
        var itemsAddedSoFarContainer = { count: 0 };
        var allCollectionsAdded = true;
        for (var c = 0; c < searchResults.collections.length; c++) {
            if (itemsAddedSoFarContainer.count >= itemGroupDisplay.threshold) {
                var allCollectionsAdded = false;
                break;
            }
            itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
            itemsAddedSoFarContainer.count += 1;
        }
        for (var a = 0; itemsAddedSoFarContainer.count < itemGroupDisplay.threshold && a < searchResults.assets.length; a++) {
            itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
            itemsAddedSoFarContainer.count += 1;
        }
        // at this point, exactly this.threshold items will have been added
        var addNextItemsAfterShortDelay = function () {
            if (itemGroupDisplay._searchTimeout) {
                window.clearTimeout(itemGroupDisplay._searchTimeout);
                itemGroupDisplay._searchTimeout = null;
            }

            if(itemGroupDisplay.searchTerm)
                return;

            if(!itemGroupDisplay.filtered)
                return;

            itemGroupDisplay._searchTimeout = window.setTimeout(function () {

                if(itemGroupDisplay.suspendFilter){
                    itemGroupDisplay.suspendFilter = false;
                    return;
                }

                var itemsAddedThisIteration = 0;
                if (!allCollectionsAdded) {
                    // check collections
                    allCollectionsAdded = true;
                    for (var c = itemsAddedSoFarContainer.count; c < searchResults.collections.length; c++) {
                        if (itemsAddedThisIteration >= itemGroupDisplay.threshold) {
                            allCollectionsAdded = false;
                            break;
                        }

                        if(itemGroupDisplay.suspendFilter){
                            itemGroupDisplay.suspendFilter = false;
                            return;
                        }

                        if(itemGroupDisplay.searchTerm)
                            return;
                        
                        if(!itemGroupDisplay.filtered)
                            return;
                        itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
                        itemsAddedThisIteration += 1;
                        itemsAddedSoFarContainer.count += 1;
                    }
                }
                if (itemsAddedThisIteration < itemGroupDisplay.threshold) {
                    // check assets
                    var assetsAddedSoFar = itemsAddedSoFarContainer.count - searchResults.collections.length;
                    for (var a = assetsAddedSoFar; a < searchResults.assets.length; a++) {
                        if (itemsAddedThisIteration >= itemGroupDisplay.threshold) {
                            break;
                        }

                        if(itemGroupDisplay.suspendFilter){
                            itemGroupDisplay.suspendFilter = false;
                            return;
                        }

                        if(itemGroupDisplay.searchTerm)
                            return;
                        
                        if(!itemGroupDisplay.filtered)
                            return;

                        itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
                        itemsAddedThisIteration += 1;
                        itemsAddedSoFarContainer.count += 1;
                    }
                }
                itemGroupDisplay.viewPage(itemGroupDisplay.currentPage || 1);
                // javascript? excuse me what the hell?
                if (itemsAddedSoFarContainer.count == searchResults.collections.length + searchResults.assets.length) {
                    // we're done
                    itemGroupDisplay.trigger('filterPageAdded');
                    itemGroupDisplay.trigger('refresh');
                }
                else {
                    itemGroupDisplay.trigger('filterPageAdded');
                    addNextItemsAfterShortDelay();
                }
            }, 250);
        };
        addNextItemsAfterShortDelay();
    }
    else {
        for (var c = 0; c < searchResults.collections.length; c++) {
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(searchResults.collections[c]));
        }
        for (var a = 0; a < searchResults.assets.length; a++) {
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(searchResults.assets[a], atheneum, this));
        }
        this.viewPage(this.currentPage || 1);
        this.trigger('refresh');
    }

}

Atheneum.UI.CollectionBrowser.prototype.refresh = function AtheneumUICollectionBrowser_refresh() {

    var atheneum = this.Atheneum;
    var homepage = this;

    var collections = [];
    var assets = [];
    var forms = [];

    if (this.searchTerm) {
        this._search(this.searchTerm, false);
        return;
    }

    if (this.filtered) {
        this._filter();
        return;
    }

    let aopFilterName = this.Atheneum.Translation.get('aopFilterName', 'AOP');

    this.removeAllItems();
    if(this.path.length === 1 && this.topLevelSectioned && this.path[0] === this.topLevelSectionId)
        {
            this.setPath([]);
            return;
        }

    let isTopLevel = false;
    if (this.path.length == 0) {

        isTopLevel = true;
        // looking at top level
        if(this.topLevelSectioned){
            collections = this.Atheneum.Library.getTopLevelCollections();
            collection = this.Atheneum.Library.collections[this.topLevelSectionId] || collections[0];
            if (collection == undefined) {
                // this shouldn't happen, except in the case that the library hasn't scynced the top level collection yet
                // in which case there's nothing we can do
                return;
            }
            this.topLevelSectionId = collection.id;
            collections = collection.stories;

            forms = this.Atheneum.Forms.getHomeScreenForms();

            if(typeof this.activeTopLevelFilter === 'string' && this.activeTopLevelFilter.length > 0){

                if(this.activeTopLevelFilter === aopFilterName){
                    let aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
                    collections = collections.filter(x=> x.name == aopCollectionName);
                }else{
                    collections = collections.filter(x=> x.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  >= 0);
                }
            }
        }else if (this.topLevelCollection) {
            collection = this.Atheneum.Library.collections[this.topLevelCollection];
            if (collection == undefined) {
                // this shouldn't happen, except in the case that the library hasn't scynced the top level collection yet
                // in which case there's nothing we can do
                return;
            }
            if (this.Atheneum.User.canSee(collection)) {
               
                collections = collection.stories;
                assets = collection.assets;
                forms = this.Atheneum.Forms.getFormsAssociatedWithCollection(collection.id);
                if(typeof this.activeTopLevelFilter === 'string' && this.activeTopLevelFilter.length > 0){
                    if(this.activeTopLevelFilter === aopFilterName){
                        let aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
                        collections = collections.filter(x=> x.name == aopCollectionName);
                    }else{
                        collections = collections.filter(x=> x.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  >= 0);
                    }
                }
            }
        }
        else {
            collections = this.Atheneum.Library.getTopLevelCollections();
            forms = this.Atheneum.Forms.getHomeScreenForms();

            if(typeof this.activeTopLevelFilter === 'string' && this.activeTopLevelFilter.length > 0){
                if(this.activeTopLevelFilter === aopFilterName){
                    let aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
                    collections = collections.filter(x=> x.name == aopCollectionName);
                }else{
                    collections = collections.filter(x=> x.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  >= 0);
                }
            }
        }

    } else {
        // looking at a collection

        var collectionId;
        var collection;

        // if we can't see the collection, back up until we can
        while (this.path.length > 0) {
            collectionId = this.path[this.path.length - 1];
            collection = this.Atheneum.Library.collections[collectionId];
            if (collection && this.Atheneum.User.canSee(collection)) {
                break;
            }
            this.path.pop();
        }
        if (this.path.length > 0) {
            collections = collection.stories;
            assets = collection.assets;
            forms = this.Atheneum.Forms.getFormsAssociatedWithCollection(collectionId);
        }
        else {
            collections = this.Atheneum.Library.getTopLevelCollections();
            forms = this.Atheneum.Forms.getHomeScreenForms();
        }
    }

    if(SalesToolkit.Theme.getBooleanProperty('prependFormsInLibrary', false)){
        this.addForms(forms, this);
    }

    var sortedCollections = {};

    if (this.sortMode <= 0) {
        for (var i = 0; i < collections.length; i++) {
            var sortIndex = collections[i].storyOrder != undefined ? collections[i].storyOrder : 9999;
            if (sortedCollections[sortIndex]) {
                sortedCollections[sortIndex][sortedCollections[sortIndex].length] = collections[i];
            } else {
                sortedCollections[sortIndex] = [collections[i]];
            }
        }


        var sortIndexes = [];
        for (var i in sortedCollections) {
            if (!sortedCollections.hasOwnProperty(i))
                continue;

            sortIndexes[sortIndexes.length] = i;
        }
        sortIndexes.sort(function (a, b) { return a - b; });

        this.collections = [];
        for (var s = 0; s < sortIndexes.length; s++) {
            var i = sortIndexes[s];
            for (var j = 0; j < sortedCollections[i].length; j++) {
                if(this.customUIMode){
                    this.collections.push(sortedCollections[i][j]);
                }else if (this.Atheneum.User.canSee(sortedCollections[i][j])) {
                    this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(sortedCollections[i][j]));
                }
            }
        }
    } else if (this.sortMode == 1) {
        collections.sort(function (a, b) {
            if (a.name && !b.name)
                return 1;
            if (!a.name && b.name)
                return -1;

            if (!a.name && !b.name)
                return 0;

            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        });

        this.collections = [];
        for (var i = 0; i < collections.length; i++) {
            var collection = collections[i];
            if(this.customUIMode){
                this.collections.push(collection);
            }else if (atheneum.User.canSee(collection)) {
                this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(collection));
            }
        }
    } else {
        collections.sort(function (a, b) {
            if (a.name && !b.name)
                return -1;
            if (!a.name && b.name)
                return 1;

            if (!a.name && !b.name)
                return 0;

            if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
            return 0;
        });

        this.collections = [];
        for (var i = 0; i < collections.length; i++) {
            var collection = collections[i];
            if(this.customUIMode){
                this.collections.push(collection);
            }else if (atheneum.User.canSee(collection)) {
                this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(collection));
            }
        }
    }


    var sortedAssets = {};

    if (this.sortMode <= 0) {
        for (var i = 0; i < assets.length; i++) {
            var sortIndex = assets[i].assetOrder != undefined ? assets[i].assetOrder : 9999;
            if (sortedAssets[sortIndex]) {
                sortedAssets[sortIndex][sortedAssets[sortIndex].length] = assets[i];
            } else {
                sortedAssets[sortIndex] = [assets[i]];
            }
        }

        sortIndexes = [];
        for (var i in sortedAssets) {
            if (!sortedAssets.hasOwnProperty(i))
                continue;

            sortIndexes[sortIndexes.length] = i;
        }
        sortIndexes.sort(function (a, b) { return a - b; });

        this.assets = [];
        for (let s = 0; s < sortIndexes.length; s++) {
            let i = sortIndexes[s];
            for (let j = 0; j < sortedAssets[i].length; j++) {
                let asset = sortedAssets[i][j];
                let permitted = true;
                if (asset.allowedGroups && asset.allowedGroups.length > 0) {
                    permitted = false;
                    for (let k = 0; k < asset.allowedGroups.length; k++) {
                        if (this.Atheneum.User.groups && this.Atheneum.User.groups.contains(asset.allowedGroups[k])) {
                            permitted = true;
                            break;
                        }
                    }
                }
                
                if (permitted)
                {
                    this.assets.push(asset);
                }
            }
        }
    } else if (this.sortMode == 1) {
        assets.sort(function (a, b) {
            if (a.name && !b.name)
                return 1;
            if (!a.name && b.name)
                return -1;

            if (!a.name && !b.name)
                return 0;

            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        });

        this.assets = [];
        for (let i = 0; i < assets.length; i++) {
            let asset = assets[i];
            if (atheneum.User.canSee(asset)) {
                this.assets.push(asset);
            }
        }
    } else {
        assets.sort(function (a, b) {
            if (a.name && !b.name)
                return -1;
            if (!a.name && b.name)
                return 1;

            if (!a.name && !b.name)
                return 0;

            if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
            return 0;
        });

        this.assets = [];
        for (let i = 0; i < assets.length; i++) {
            let asset = assets[i];
            if (atheneum.User.canSee(asset)) {
                this.assets.push(asset);
            }
        }
    }



    if(!this.customUIMode && this.stressTestMode === true && this.assets.length > 0){
        while(this.assets.length < (this.threshold * this.stressTestLevel)){
            this.assets = this.assets.concat(this.assets);
        }
    }

    if (!this.customUIMode && this.threshold && this.assets.length > this.threshold) {
        // if there's a significant number of items to add at once, (enough to cause ui lag),
        // then do it in several steps
        var itemGroupDisplay = this;
        var itemsAddedSoFarContainer = { count: 0 };
        
        itemGroupDisplay.totalPages = 1 + Math.max(0, ((this.assets.length - 1) / this.assetPageSize) | 0);

        for (var a = 0; itemsAddedSoFarContainer.count < itemGroupDisplay.threshold && a < itemGroupDisplay.assets.length; a++) {
            itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(itemGroupDisplay.assets[a], atheneum, itemGroupDisplay));
            itemsAddedSoFarContainer.count += 1;
        }
        // at this point, exactly this.threshold items will have been added
        var addNextItemsAfterShortDelay = function () {
            if (itemGroupDisplay._renderTimeout) {
                window.clearTimeout(itemGroupDisplay._renderTimeout);
                itemGroupDisplay._renderTimeout = null;
            }
            itemGroupDisplay._renderTimeout = window.setTimeout(function () {
    
                // check to see if the searchTerm has changed
                let collectionId = homepage.path.slice(-1)[0];
               
                
                var itemsAddedThisIteration = 0;
               
                if (itemsAddedThisIteration < itemGroupDisplay.threshold) {
                    // check assets
                    var assetsAddedSoFar = itemsAddedSoFarContainer.count;   
                    for (var a = assetsAddedSoFar; a < itemGroupDisplay.assets.length; a++) {
                        if(typeof collectionId === 'undefined' || collectionId !== itemGroupDisplay.assets[a].containedBy)
                            return;
                        if (itemsAddedThisIteration >= itemGroupDisplay.threshold) {
                            break;
                        }

                        if(itemGroupDisplay.searchTerm || itemGroupDisplay.filtered)
                            break;

                        itemGroupDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(itemGroupDisplay.assets[a], atheneum, itemGroupDisplay));
                        itemsAddedThisIteration += 1;
                        itemsAddedSoFarContainer.count += 1;
                    }
                }
                itemGroupDisplay.viewPage(itemGroupDisplay.currentPage || 1);
                // javascript? excuse me what the hell?
                if (itemsAddedSoFarContainer.count < itemGroupDisplay.assets.length) {
                    addNextItemsAfterShortDelay();
                }else{
                    if(!SalesToolkit.Theme.getBooleanProperty('prependFormsInLibrary', false)){
                        itemGroupDisplay.addForms(forms, itemGroupDisplay);
                    }

                    itemGroupDisplay.trigger("refresh");
                }
            }, 250);
        };
        addNextItemsAfterShortDelay();
    }
    else {
       
        this.totalPages = 1;

        for (var a = 0; a < this.assets.length; a++) {
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(this.assets[a], atheneum, this));
        }
        this.viewPage(this.currentPage || 1);
    

        if(!SalesToolkit.Theme.getBooleanProperty('prependFormsInLibrary', false)){
            this.addForms(forms, this);
        }
        
        this.trigger("refresh");
    }

    let html = this.Atheneum.Theme.getStringProperty('collectionBrowserBottomHtml', '');
    if( isTopLevel ){
        html = this.Atheneum.Theme.getStringProperty('collectionBrowserBottomHtmlTopLevel', '');
    }

    if(this.element && html.length > 0){
        let bottomHtmlEl = htmlToElement("<div class='collection-browser-bottom-html-wrapper'>"+ html +"</div>");
        this.element.appendChild(bottomHtmlEl);
    }
   
}

Atheneum.UI.CollectionBrowser.prototype.addForms = function(forms, collectionView){
    var TRUE_VALUES = ['on', 'true', 'y', 'yes'];

    if (TRUE_VALUES.contains(collectionView.Atheneum.Theme.getCollectionProperty(collectionView.topLevelCollection || null, 'showFormsInLibrary', 'off'))) {
        //TODO FORMS

        if (forms == undefined)
            forms = [];

        if(collectionView.Atheneum.Theme.getBooleanProperty('excludeShareFormsFromLibrary', true))
            forms = forms.filter(x=> x.type !== 'VEND');

        if (collectionView.sortMode <= 0) {
            var sortedForms = {};
            for (var i = 0; i < forms.length; i++) {
                var sortIndex = forms[i].order != undefined ? forms[i].order : 9999;
                if (sortedForms[sortIndex]) {
                    sortedForms[sortIndex][sortedForms[sortIndex].length] = forms[i];
                } else {
                    sortedForms[sortIndex] = [forms[i]];
                }
            }

            sortIndexes = [];
            for (var i in sortedForms) {
                if (!sortedForms.hasOwnProperty(i))
                    continue;

                sortIndexes[sortIndexes.length] = i;
            }
            sortIndexes.sort(function (a, b) { return a - b; });

            collectionView.forms = [];
            for (var s = 0; s < sortIndexes.length; s++) {
                var i = sortIndexes[s];
                for (var j = 0; j < sortedForms[i].length; j++) {
                    if (collectionView.Atheneum.User.canSee(sortedForms[i][j])) {
                        let formToAdd = sortedForms[i][j];
                        if (!formToAdd || !formToAdd.id)
                            continue;
                        
                            if(collectionView.customUIMode){
                                collectionView.forms.push(sortedForms[i][j]);
                            }else{
                                collectionView.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromForm(sortedForms[i][j]));
                            }
                       
                    }
                }
            }
        } else if (collectionView.sortMode == 1) {
            forms.sort(function (a, b) {
                if (a.name && !b.name)
                    return 1;
                if (!a.name && b.name)
                    return -1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });

            collectionView.forms = [];
            for (var i = 0; i < forms.length; i++) {
                var form = forms[i];
                if (collectionView.Atheneum.User.canSee(form)) {
                    if(collectionView.customUIMode){
                        collectionView.forms.push(sortedForms[i][j]);
                    }else{
                        collectionView.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromForm(form));
                    }
                }
            }
        } else {
            forms.sort(function (a, b) {
                if (a.name && !b.name)
                    return -1;
                if (!a.name && b.name)
                    return 1;

                if (!a.name && !b.name)
                    return 0;

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                return 0;
            });

            collectionView.forms = [];
            for (var i = 0; i < forms.length; i++) {
                var form = forms[i];
                if (collectionView.Atheneum.User.canSee(form)) {
                    if(collectionView.customUIMode){
                        collectionView.forms.push(sortedForms[i][j]);
                    }else{
                        collectionView.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromForm(form));
                    }
                }
            }
        }
    }
}

Atheneum.UI.CollectionBrowser.prototype.mirror = function (uiElement) {

    var cb = this;

    cb.topLevelCollection = uiElement.topLevelCollection;
    cb.activeTopLevelFilter = uiElement.activeTopLevelFilter;
    cb.topLevelSectioned = uiElement.topLevelSectioned;
    cb.topLevelSectionId = uiElement.topLevelSectionId;
    // note: item-click is not mirrored

    if(cb.mirrored === true)
        return;

    uiElement.on("path-change", function (path) {
        cb.topLevelCollection = uiElement.topLevelCollection;
        cb.setPath(path);
    });

    uiElement.on("add-item", function (item) {
        cb.addItem(item);
    });

    uiElement.on("remove-item", function (item) {
        cb.removeItem(item);
    });

    uiElement.on("refresh", function () {
        cb.refresh();
    });

    cb.mirrored = true;
}

Atheneum.UI.CollectionBrowser.Group = function AtheneumUICollectionBrowserGroup(atheneum, collectionBrowser, assets, groupInfo, uiElement = undefined, parentId = "") {
// this.groupsInfo = this.Atheneum.Theme.getStringProperty('collectionBrowserGroups', '{id:"0", group:{id:"10", collectionLevel: 1, filterType:"dateYear", filterProperty: "published"} collectionLevel:0, filterType:"string", filterProperty:"name"}');
   
    if (!(this instanceof Atheneum.UI.CollectionBrowser.Group))
        return new Atheneum.UI.CollectionBrowser.Group(atheneum, collectionBrowser, assets, groupInfo, uiElement);

    this.Atheneum = atheneum;
    this.stopRendering = false;
    this.CollectionBrowser = collectionBrowser;
    this.assets = assets;
    this.maxAssetsPerPage = this.Atheneum.Theme.getIntegerProperty('maxAssetsPerCBGroup', 10);
    this.items = {};
    this.groupInfo = groupInfo;
    this.id = parentId + "collectionBrowser-groups-"+this.groupInfo.id;
    this.groupUI = htmlToElement("<div class='collectionBrowser-group-wrapper' id='"+this.id+"'></div>");
   this.parentId = parentId;
    if(uiElement == undefined)
        uiElement = this.CollectionBrowser.element;
    
    uiElement.appendChild(this.groupUI);
   
    if(!window.cbGroups)
        window.cbGroups = {};

    window.cbGroups[this.id] = this;
  
    this.renderGroup();
   
}

Atheneum.UI.CollectionBrowser.Group.prototype.clear = function(){
    this.stopRendering = true;
    this.groupUI.innerHtml = "";
    $(this.groupUI).empty();
    window.cbGroups[this.id] = null;
}

Atheneum.UI.CollectionBrowser.Group.prototype.renderGroup = function () {
    if(this.stopRendering)
    {
        this.groupUI.innerHtml = "";
        return;
    }
    this.groupUI.innerHtml = "";
    
    let collections = this.getCollectionsAtLevel(this.groupInfo.collectionLevel);
   let showAssetCountInHeader = this.Atheneum.Theme.getBooleanProperty('showAssetCountInHeader', true);
    let groupItems = this.getGroupsFromProperty(collections);
    

    for (let gIndex = 0; gIndex < groupItems.length; gIndex++) {
        if(this.stopRendering)
        {
            this.groupUI.innerHtml = "";
            return;
        }
        let groupItem = groupItems[gIndex];
        let groupItemUI = htmlToElement("<div class='cbGroup' id='"+groupItem.id+"'></div>");
        
        let assetCountText = "";
        if(showAssetCountInHeader){
            assetCountText = " ("+Object.values(groupItem.assets).length+")";
        }
        let groupHeaderUI = htmlToElement("<div class='cbGroupHeader' style='"+this.groupInfo.headerStyle+"'><h1 style='"+this.groupInfo.headerH1Style+"'>"+groupItem.name +assetCountText+"</h1><span class='toggleAccordionButton collapsed' style='"+this.groupInfo.headerButtonCollapsedStyle+"'>+</span><span class='toggleAccordionButton active opened' style='"+this.groupInfo.headerButtonOpenStyle+"'>-</span></div>");
        groupHeaderUI.onclick = function(){
           let itemsElement =  this.parentElement.querySelector('.cbGroupItems');
           $(itemsElement).toggle();
           let pageControls =  this.parentElement.querySelector('.pageControls');
           $(pageControls).toggle();

           this.querySelector('.active').classList.remove('active');
           if(itemsElement.style.display === 'none'){
                this.querySelector('.collapsed').classList.add('active');
           }else{
            this.querySelector('.opened').classList.add('active');
           }
        }
        let groupItemSection = htmlToElement("<div class='cbGroupItems'></div>");

       
        if(!groupItem.hasGroups && Object.values( groupItem.assets).length == 0)
        {
            this.visible = false;
            continue;
        }else{
            this.visible = true;
        }

        groupItemUI.appendChild(groupHeaderUI);
        groupItemUI.appendChild(groupItemSection);
        
        groupItem.groupUI = groupItemUI;
        groupItem.pageIndex = 0;

        if(!groupItem.hasGroups){
            let pageControls = htmlToElement("<div class='pageControls'></div>");
            let firstPage = htmlToElement("<div class='first' style='"+this.groupInfo.pageControlStyle+"'>"+this.Atheneum.Translation.get("firstPage", "&laquo;")+"</div>");
            let previousPage = htmlToElement("<div class='previous' style='"+this.groupInfo.pageControlStyle+"'>"+this.Atheneum.Translation.get("previousPage", "&lsaquo;")+"</div>");
            let currentPage = htmlToElement("<div class='current' style='"+this.groupInfo.pageNumberStyle+"'>1</div>");
            let nextPage = htmlToElement("<div class='next' style='"+this.groupInfo.pageControlStyle+"'>"+this.Atheneum.Translation.get("nextPage", "&rsaquo;")+"</div>");
            let lastPage = htmlToElement("<div class='last' style='"+this.groupInfo.pageControlStyle+"'>"+this.Atheneum.Translation.get("lastPage", "&raquo;")+"</div>");
            
            firstPage.onclick = function(){
                let groupItemId = this.parentElement.parentElement.id;
                let groupId = this.parentElement.parentElement.parentElement.id;
                let group = window.cbGroups[groupId];
    
                if(group){
                    let groupItem = group.items[groupItemId];
                    let pageIndex = 0;
    
                    groupItem.pageIndex = pageIndex;
                    group.items[groupItemId] = groupItem;
                    window.cbGroups[groupId] = group;
                    
                    group.renderGroupPage(groupItemId, pageIndex);
                }
            }

            lastPage.onclick = function(){
                let groupItemId = this.parentElement.parentElement.id;
                let groupId = this.parentElement.parentElement.parentElement.id;
                let group = window.cbGroups[groupId];
    
                if(group){
                    let groupItem = group.items[groupItemId];
                    let groupItemAssetsCount = Object.values(groupItem.assets).length;
                    let maxPage = Math.ceil(groupItemAssetsCount / group.maxAssetsPerPage);
                    let pageIndex = maxPage - 1;
                    
    
                    groupItem.pageIndex = pageIndex;
                    group.items[groupItemId] = groupItem;
                    window.cbGroups[groupId] = group;
                    
                    group.renderGroupPage(groupItemId, pageIndex);
                }
            }
            
            previousPage.onclick = function(){
                let groupItemId = this.parentElement.parentElement.id;
                let groupId = this.parentElement.parentElement.parentElement.id;
                let group = window.cbGroups[groupId];
    
                if(group){
                    let groupItem = group.items[groupItemId];
                    let currentPageIndex = groupItem.pageIndex;
                    let pageIndex = currentPageIndex - 1;
                    if(pageIndex < 0){
                        pageIndex = 0;
                    }
    
                    groupItem.pageIndex = pageIndex;
                    group.items[groupItemId] = groupItem;
                    window.cbGroups[groupId] = group;
                    
                    group.renderGroupPage(groupItemId, pageIndex);
                }
            }

            currentPage.onclick = function(){
                let groupItemId = this.parentElement.parentElement.id;
                let groupId = this.parentElement.parentElement.parentElement.id;
                let group = window.cbGroups[groupId];
    
                if(group){
                    let groupItem = group.items[groupItemId];
                    let groupItemAssetsCount = Object.values(groupItem.assets).length;
                    let maxPage = Math.ceil(groupItemAssetsCount / group.maxAssetsPerPage);

                    if(maxPage == 1)
                        return;

                    quickAlert({
                        type: "prompt",
                        headerText: window.AtheneumInstance.Translation.getFormatted('cbEnterPageNumber', 'Enter a page number from 1 to {0}', [maxPage]),
                        inputFieldType: 'number',
                        alertType: "primary",
                        customInputParams: "max='"+maxPage+"' min='1'"
                      }).done(function (e) {
                        let pageIndex = 0;
                        try{
                            pageIndex = e - 1;
                        }catch(err){
                            pageIndex = 0;
                        } 
    
                        if(pageIndex < 0){
                            pageIndex = 0;
                        }
                      
                        if(pageIndex >= maxPage){
                            pageIndex = maxPage - 1;
                        }
                        
                        groupItem.pageIndex = pageIndex;
                        group.items[groupItemId] = groupItem;
                        window.cbGroups[groupId] = group;
                        
                        group.renderGroupPage(groupItemId, pageIndex);
                      });
                }
                
            }

             nextPage.onclick = function(){
                let groupItemId = this.parentElement.parentElement.id;
                let groupId = this.parentElement.parentElement.parentElement.id;
                let group = window.cbGroups[groupId];
    
                if(group){
                    let groupItem = group.items[groupItemId];
                    let currentPageIndex = groupItem.pageIndex;
                    let pageIndex = currentPageIndex + 1;
                    let groupItemAssetsCount = Object.values(groupItem.assets).length;
                    let maxPage = Math.ceil(groupItemAssetsCount / group.maxAssetsPerPage);
                    if(pageIndex >= maxPage){
                        pageIndex = maxPage - 1;
                    }
    
                    groupItem.pageIndex = pageIndex;
                    group.items[groupItemId] = groupItem;
                    window.cbGroups[groupId] = group;
                    
                    group.renderGroupPage(groupItemId, pageIndex);
                }
            }

            groupItem.currentPageUI = currentPage;
    
            pageControls.appendChild(firstPage);
            pageControls.appendChild(previousPage);
            pageControls.appendChild(currentPage);
            pageControls.appendChild(nextPage);
            pageControls.appendChild(lastPage);
            groupItemUI.appendChild(pageControls);
    
        }
        
        this.groupUI.appendChild(groupItemUI);  
        
        this.items[groupItem.id] = groupItem;
        if(groupItem.hasGroups){
            let cbGroup = new Atheneum.UI.CollectionBrowser.Group(this.Atheneum, this.CollectionBrowser, groupItem.assets, groupItem.info, groupItemSection, this.id + groupItem.name);
            groupItem.cbGroup = cbGroup;
            this.items[groupItem.id] = groupItem;
            if(!cbGroup.visible){
                groupItemUI.style.display = "none";
            }
        }else{
            // let assetCount = htmlToElement("<p style='font-size:1.5rem;'>"+Object.values(groupItem.assets).length+"</p>");
            // groupItemSection.appendChild(assetCount);
            this.renderGroupPage(groupItem.id, groupItem.pageIndex);
        }   
    }
}

Atheneum.UI.CollectionBrowser.Group.prototype.getGroupsFromProperty = function(collections){
    let cbGroup = this;
 
    let groupItems = {};
    for (let index = 0; index < collections.length; index++) {
        const collection = collections[index];
        let groupedProperty = ""+cbGroup.getPropertyValue(collection);
        let id = "cbGroup" + this.parentId + this.groupInfo.id + groupedProperty;
        id = id.replaceAll(/[\W_]+/g,"");
        
        let group = groupItems[id] || {};
        group.id = id;
        group.name = groupedProperty;
        group.hasGroups = (this.groupInfo.hasOwnProperty("group"));
        group.info = this.groupInfo.group;

        let assets = group.assets || {};
        let newAssets = this.getAssetsWithAncestor(collection);
        group.assets = Object.assign({}, assets, newAssets);
        
        groupItems[id] = group;
    }

    groupItems = Object.values(groupItems);
    if( this.groupInfo.shouldSort){
        groupItems.sort(function (a, b) {
            return  (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
        });
    }else if(this.groupInfo.shouldSortReverse){
        groupItems.sort(function (a, b) {
            return  (a.name < b.name) ? 1 : ((b.name < a.name) ? -1 : 0);
        });
    }
      
    return groupItems;
}

Atheneum.UI.CollectionBrowser.Group.prototype.getAssetsWithAncestor = function(collection){
    let assetsWithAncestor = {};
    let assetsArr = Object.values(this.assets);
    for (let index = 0; index < assetsArr.length; index++) {
        const asset = assetsArr[index];
        let item = asset;
        if(this.groupInfo.hasOwnProperty('fullArticleOnly') && this.groupInfo.fullArticleOnly === true && item.name !== 'Full Article'){
            continue;
        }

        while(item && item.containedBy !== null){
            if(item.containedBy == collection.id)
            {
                assetsWithAncestor[asset.id] = asset;
                break;
            }

            item = this.Atheneum.Library.collections[item.containedBy];
        }
    }

    return assetsWithAncestor;
}

Atheneum.UI.CollectionBrowser.Group.prototype.getPropertyValue = function(item){
    if(!item.hasOwnProperty(this.groupInfo.filterProperty))
        return this.Atheneum.Translation.get('cbGroupsUnknown', 'Unknown');

    if(this.groupInfo.filterType == 'dateYear'){
        try{

            if(this.Atheneum.Theme.getBooleanProperty('useAOPWhenGroupingYears', true)){
                let aopCollectionName = this.Atheneum.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
            
                var containingCollection = (typeof item.containedBy != 'string') ? null : this.Atheneum.Library.collections[item.containedBy];
                while (containingCollection && typeof containingCollection.containedBy == 'string') {
                    if (containingCollection.id == this.CollectionBrowser.topLevelCollection) {
                        break;
                    }
        
                    if(containingCollection.name === aopCollectionName)
                        break;
                    if(containingCollection.containedBy === this.CollectionBrowser.topLevelSectionId)
                        break;
        
                    containingCollection = (typeof containingCollection.containedBy == 'string') ? this.Atheneum.Library.collections[containingCollection.containedBy] : null;
                }

                if(item.name === aopCollectionName || containingCollection.name === aopCollectionName)
                    return aopCollectionName;

            }
            
            let date = new Date(item[this.groupInfo.filterProperty]);
            if(date instanceof Date && !isNaN(date)){
                return date.getFullYear();
            }else{
                return item[this.groupInfo.filterProperty];
            }
        }catch(err){
            return item[this.groupInfo.filterProperty];
        }
    }else{
        //String
        return item[this.groupInfo.filterProperty];
    }
}

Atheneum.UI.CollectionBrowser.Group.prototype.getCollectionsAtLevel = function(level, assets){
    let topLevelCollections = [];
    if (this.CollectionBrowser.topLevelCollection) {
        collection = this.Atheneum.Library.collections[this.CollectionBrowser.topLevelCollection];
        if (collection == undefined) {
            // this shouldn't happen, except in the case that the library hasn't scynced the top level collection yet
            // in which case there's nothing we can do
            return [];
        }
        if (this.Atheneum.User.canSee(collection)) {
            topLevelCollections = collection.stories;
        }else{
            return [];
        }
    }else{
        topLevelCollections = this.Atheneum.Library.getTopLevelCollections();
    }

    topLevelCollections.sort(function (collectionA, collectionB) {
        var collectionA_sortOrder = (collectionA.order == undefined) ? ((collectionA.storyOrder == undefined) ? 99999 : collectionA.storyOrder) : collectionA.order;
        var collectionB_sortOrder = (collectionB.order == undefined) ? ((collectionB.storyOrder == undefined) ? 99999 : collectionB.storyOrder) : collectionB.order
        return (collectionA_sortOrder > collectionB_sortOrder) ? 1 : -1;
    });

    if(level == 0){
        return topLevelCollections;
    }else if(level > 0){
        let collections = topLevelCollections;
        while(level > 0){
            let currentLength = collections.length;
            collections = this.getAllChildCollections(collections);
            if(collections.length == currentLength)
            {
                //Nothing changed so no new stories past the current level
                level = 0; 
                break;
            }
            level -= 1;
        }

        return collections;
    }else{
        //Start from assets
        let collections = this.getAllParentCollections(Object.values(this.assets));
        level += 1;
        
        while(level < 0){
            let currentLength = collections.length;
            collections = this.getAllParentCollections(collections);
            if(collections.length == currentLength)
            {
                //Nothing changed so no new stories past the current level
                level = 0; 
                break;
            }
            level += 1;
        }

        return collections;
    }

}

Atheneum.UI.CollectionBrowser.Group.prototype.getAllChildCollections = function(collections){
    let childCollections = [];
    collections.forEach(collection => {
        let stories = collection.stories;
        stories.sort(function (collectionA, collectionB) {
            var collectionA_sortOrder = (collectionA.order == undefined) ? ((collectionA.storyOrder == undefined) ? 99999 : collectionA.storyOrder) : collectionA.order;
            var collectionB_sortOrder = (collectionB.order == undefined) ? ((collectionB.storyOrder == undefined) ? 99999 : collectionB.storyOrder) : collectionB.order
            return (collectionA_sortOrder > collectionB_sortOrder) ? 1 : -1;
        });
        childCollections = childCollections.concat(stories);
    });

    return childCollections;
}

Atheneum.UI.CollectionBrowser.Group.prototype.getAllParentCollections = function(items){
    let parentCollections = {};
    let atheneum = this.Atheneum;
    items.forEach(item => {
        let parentItem = atheneum.Library.collections[item.containedBy];
        parentCollections[parentItem.id] = parentItem;
    });

    parentCollections = Object.values(parentCollections);

    parentCollections.sort(function (collectionA, collectionB) {
        var collectionA_sortOrder = (collectionA.order == undefined) ? ((collectionA.storyOrder == undefined) ? 99999 : collectionA.storyOrder) : collectionA.order;
        var collectionB_sortOrder = (collectionB.order == undefined) ? ((collectionB.storyOrder == undefined) ? 99999 : collectionB.storyOrder) : collectionB.order
        return (collectionA_sortOrder > collectionB_sortOrder) ? 1 : -1;
    });

    return parentCollections;
}

Atheneum.UI.CollectionBrowser.Group.prototype.renderGroupPage = function(groupItemId, pageIndex) {
    let groupItem = this.items[groupItemId];
    if(!groupItem.groupUI)
        return;

    if(!groupItem.assets || Object.values(groupItem.assets).length == 0){
        return;
    }

    let itemsContainer = groupItem.groupUI.querySelector('.cbGroupItems');
    if(itemsContainer == null)
        return;

        itemsContainer.innerHTML = "";
    let assets = Object.values(groupItem.assets);

    assets = assets.sort(function (assetA, assetB) {
        
        var assetA_sortOrder = (assetA.order == undefined) ? ((assetA.assetOrder == undefined) ? 99999 : assetA.assetOrder) : assetA.order;
        var assetB_sortOrder = (assetB.order == undefined) ? ((assetB.assetOrder == undefined) ? 99999 : assetB.assetOrder) : assetB.order;

        if(assetA_sortOrder == assetB_sortOrder)
            return assetA.name.localeCompare(assetB.name);

        return (assetA_sortOrder > assetB_sortOrder) ? 1 : -1;
    });

    let index = 0;
    if(pageIndex > 0){
        index = this.maxAssetsPerPage * pageIndex;
        if(index > assets.length)
            index = assets.length - 1;
    }

    let maxIndex = index+this.maxAssetsPerPage;
    if(maxIndex > assets.length)
        maxIndex = assets.length;
    for (index; index < maxIndex; index++) {
        let asset = assets[index];
        let assetItem = Atheneum.UI.ItemGroupDisplay.Item.fromAsset(asset, this.Atheneum, this.CollectionBrowser);
        let htmlElement = Atheneum.UI.ItemGroupDisplay.Item.buildItem(assetItem, this.CollectionBrowser.itemTemplate);
        itemsContainer.appendChild(htmlElement);

        htmlElement.addEventListener('click', function(){
            let action = this.dataset.atheneumItemAction;
            let item = JSON.parse(this.closest('.atheneum-item').getAttribute("data-atheneum-item").replace(/&quot;/g, "\""));
            if(action == 'view'){
                console.log('view requested');
                if (item.type == "asset"){
                     document.dispatchEvent(new CustomEvent(parent.SalesToolkitApplication.Events.LOAD_ASSET, {
                            detail: {
                                assetId: item.id
                            }
                        }));
                }
            }else if(action == 'toggle-favourite'){
                toggleFavourites(item);
            }else if(action == 'toggle-cart'){
                toggleCart(item);
            }else if(action == 'toggle-info'){
                toggleInfo(item);
            }
        });
    }

    let groupItemAssetsCount = Object.values(groupItem.assets).length;
    let maxPage = Math.ceil(groupItemAssetsCount / this.maxAssetsPerPage);
    groupItem.currentPageUI.innerHTML = (pageIndex + 1) + "/" + maxPage;

    document.querySelectorAll('.asset-style div[data-background-image-url]').forEach(thumbnailElement => {
            
         onVisible(thumbnailElement,  () => {
            setTimeout(function (){
             let item = JSON.parse(thumbnailElement.closest('.atheneum-item').getAttribute("data-atheneum-item").replace(/&quot;/g, "\""));
             document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.UPDATE_CART_FAVS, { detail: { item: item } }));
             try{
                 var infoIconElement = thumbnailElement.closest('.atheneum-item').querySelector('.asset-style .info-btn img');
                                 if(infoIconElement){
                                     if(AtheneumInstance.Theme.getBooleanProperty('hideAssetInformationButton', false))
                                         infoIconElement.style.display = 'none';
                                     else{
                                         parent.applyImageToElement(infoIconElement, 'assetInformationIcon', 'img/default/info_icon.svg')
                                         infoIconElement.style.display = 'block';
                                     }
                                 }
             }catch(err){

             }
             

             var bgImageURL = thumbnailElement.getAttribute('data-background-image-url');
             if (bgImageURL && !thumbnailElement.classList.contains('data-background-update-queued')) {
                 thumbnailElement.classList.add('data-background-update-queued');
                 parent.addUrlToRewriteQueue(bgImageURL, function (rewrittenURL) {
                     if (rewrittenURL != null && rewrittenURL.href)
                         rewrittenURL = rewrittenURL.href;

                     if (rewrittenURL !== null && rewrittenURL.indexOf("https:") >= 0 && rewrittenURL.indexOf("keepRatio=true&shouldCrop=false&width=800&height=450") < 0) {
                         rewrittenURL = rewrittenURL + "?keepRatio=true&shouldCrop=false&width=800&height=450";
                     }
                     thumbnailElement.style.backgroundImage = 'url(\'' + rewrittenURL + '\')'; thumbnailElement.style.opacity = 1;
                 });
             }
            }, 0);
         });

     });
}

// class Atheneum.UI.TreeView extends Atheneum.UI.CollectionBrowser
Atheneum.UI.TreeView = function AtheneumUITreeView(atheneum, element, topLevelCollection) {

    if (!(this instanceof Atheneum.UI.TreeView))
        return new Atheneum.UI.TreeView(atheneum, element, topLevelCollection);

    Atheneum.UI.CollectionBrowser.call(this, atheneum, element, topLevelCollection);

    this.path = [];
    this.puid = "TreeView" + (Math.random() + "").substring(2); // probably unique identifier
    this.jsTree = null;

    var treeview = this;
    this.on('item-click', function (item) {
        if (item.type == 'asset') {
            treeview.trigger('item-action-view-click', item);
        }
        return false;
    });

    //this.populateTree();
}

Atheneum.UI.TreeView.prototype = Object.create(Atheneum.UI.CollectionBrowser.prototype);
Atheneum.UI.TreeView.prototype.constructor = Atheneum.UI.TreeView;

Atheneum.UI.prototype.TreeView = function (element, topLevelCollection) {
    return new Atheneum.UI.TreeView(this.Atheneum, element, topLevelCollection);
}

Atheneum.UI.prototype.TreeView.setDefaultItemTemplate = function (template) {
    Atheneum.UI.TreeView.defaultItemTemplate = template;
}

// Override default collection browser behaviour
Atheneum.UI.TreeView.prototype.addItem = function (item) { console.log() };
Atheneum.UI.TreeView.prototype.removeItem = function (item) { console.log() };

Atheneum.UI.TreeView.prototype.populateTree = function () {

    if (this.jsTree)
        this.jsTree.destroy();

    if (!this.element)
        return;

        console.time('populateTreeView');
    this._topLevelCollectionWhenTreePopulated = this.topLevelCollection;

    this.element.innerHTML = "";

    var jsTreeNodes = [];

    if (!window.jQuery || !window.jQuery.jstree)
        return;

    var topLevelCollectionObject = this.Atheneum.Library.collections[this.topLevelCollection];

    var collectionIdsInTree = {};
    var formIdsInTree = {};

    try {


        if (this.Atheneum.UI.CollectionBrowser.Plugins != undefined &&
            this.Atheneum.UI.CollectionBrowser.Plugins != null &&
            this.Atheneum.UI.CollectionBrowser.Plugins.length > 0 &&
            this.Atheneum.Theme.getBooleanProperty('salesToolkitPluginsInTreeView', true)) {

            for (var i = 0; i < this.Atheneum.UI.CollectionBrowser.Plugins.length; i++) {

                var pluginId = this.Atheneum.UI.CollectionBrowser.Plugins[i].id;
                if (!pluginId)
                    continue;

                var plugin = this.Atheneum.Plugins.plugins.find(x => x.ID == pluginId || x.id == pluginId);
                if (plugin == undefined)
                    continue;

                if (plugin.allowedCollections) {

                    let allowedCols = plugin.allowedCollections;
                    if (typeof allowedCols === "string")
                        allowedCols = JSON.parse(allowedCols);

                    if (allowedCols.length == 0) {
                        var jsTreeNode = new Object();
                        jsTreeNode.id = this.puid + "_plugin_" + pluginId;
                        jsTreeNode.parent = "#";
                        jsTreeNode.text = plugin.Name || plugin.name;
                        jsTreeNode.text = jsTreeNode.text.replace("<br>", " ");
                        jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-file icon-state-warning icon-lg jstree-themeicon-custom " + pluginId;
                        jsTreeNode.sortOrder = -99999 - (plugin.order || plugin.Order || i);

                        jsTreeNode.a_attr = {
                            'data-atheneum-item': JSON.stringify(plugin).replace(/"/g, '&quot;'),
                            'data-atheneum-sort-order': -1
                        }

                        jsTreeNodes.push(jsTreeNode);
                    } else {
                        for (let x = 0; x < allowedCols.length; x++) {

                            let colId = allowedCols[x];
                            var jsTreeNode = new Object();
                            jsTreeNode.id = this.puid + "_plugin_" + pluginId;
                            jsTreeNode.parent = this.puid + "_collection_" + colId;
                            jsTreeNode.text = plugin.Name || plugin.name;
                            jsTreeNode.text = jsTreeNode.text.replace("<br>", " ");
                            jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-file icon-state-warning icon-lg jstree-themeicon-custom " + pluginId;
                            jsTreeNode.sortOrder = -99999 - (plugin.order || plugin.Order || i);

                            jsTreeNode.a_attr = {
                                'data-atheneum-item': JSON.stringify(plugin).replace(/"/g, '&quot;'),
                                'data-atheneum-sort-order': -1
                            }

                            jsTreeNodes.push(jsTreeNode);
                        }
                    }
                    continue;
                }
                var jsTreeNode = new Object();
                jsTreeNode.id = this.puid + "_plugin_" + pluginId;
                jsTreeNode.parent = "#";
                jsTreeNode.text = plugin.Name || plugin.name;
                jsTreeNode.text = jsTreeNode.text.replace("<br>", " ");
                jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-file icon-state-warning icon-lg jstree-themeicon-custom " + pluginId;
                jsTreeNode.sortOrder = -99999 - (plugin.order || plugin.Order || i);

                jsTreeNode.a_attr = {
                    'data-atheneum-item': JSON.stringify(plugin).replace(/"/g, '&quot;'),
                    'data-atheneum-sort-order': -1
                }

                jsTreeNodes.push(jsTreeNode);
            }
        }
    } catch (err) {
        console.log("Error setting up plugins in tree");
    }

    let aopFilterName = this.Atheneum.Translation.get('aopFilterName', 'AOP');

    for (var i in this.Atheneum.Library.collections) {

        if (!this.Atheneum.Library.collections.hasOwnProperty(i))
            continue;

        var collection = this.Atheneum.Library.collections[i];

        if ((!collection.assets || collection.assets.length == 0) && (!collection.stories || collection.stories.length == 0)) {
            var forms = Object.values(this.Atheneum.Forms.formList);
            if (forms && forms.length > 0) {
                var atheneum = this.Atheneum;
                var collectionForms = forms.find(function (f) {
                    if (!f || !f.items)
                        return false;

                    return atheneum.User.canSee(f) && f.items.indexOf(collection.id) >= 0;
                });

                if (!collectionForms || collectionForms == null || collectionForms.length == 0)
                    continue;
            } else {
                continue; // skip empty collections. Note: It *should* be impossible for an empty collection to exist.
            }
        }

        if(!this.Atheneum.User.canSee(collection)){
            continue;
        }

        
        var permitted = true;
        if (collection.allowedGroups && collection.allowedGroups.length > 0) {
            permitted = false;
            for (var k = 0; k < collection.allowedGroups.length; k++) {
                if (this.Atheneum.User.groups && this.Atheneum.User.groups.contains(collection.allowedGroups[k])) {
                    permitted = true;
                    break;
                }
            }
        }
        if (!permitted)
            continue;

        var isChildOfTopLevelCollection = false;
        if (this.topLevelCollection == null) {
            isChildOfTopLevelCollection = (collection.containedBy == null);
        }
        else if (collection.containedBy == this.topLevelCollection) {
            isChildOfTopLevelCollection = true;
        }

        var isDescendentOfTopLevelCollection = false;
        if (this.topLevelCollection == null) {
            isDescendentOfTopLevelCollection = true;
        }
        else {
            var containingCollection = (typeof collection.containedBy != 'string') ? null : this.Atheneum.Library.collections[collection.containedBy];
            while (containingCollection != null) {
                if (containingCollection.id == this.topLevelCollection) {
                    isDescendentOfTopLevelCollection = true;
                    break;
                }
                containingCollection = (typeof containingCollection.containedBy == 'string') ? this.Atheneum.Library.collections[containingCollection.containedBy] : null;
            }
        }

        if (!isDescendentOfTopLevelCollection) {
            continue;
        }

        let parentInvisible = false;
        var containingCollection = (typeof collection.containedBy != 'string') ? null : this.Atheneum.Library.collections[collection.containedBy];
        while (containingCollection && typeof containingCollection.containedBy == 'string') {
           if(!containingCollection.visible)    
                {
                    parentInvisible = true;
                    break;
                }
           
            if (containingCollection.id == this.topLevelCollection) {
                break;
            }

            if(containingCollection.containedBy === this.topLevelSectionId)
                break;

            containingCollection = (typeof containingCollection.containedBy == 'string') ? this.Atheneum.Library.collections[containingCollection.containedBy] : null;
        }

        if(parentInvisible){
            continue;
        }else if(containingCollection && !containingCollection.visible){
            continue;
        }

        if(typeof this.activeTopLevelFilter === 'string' && this.activeTopLevelFilter.length > 0){
            if(!containingCollection || collection.id === this.topLevelSectionId)
                continue;

            let aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
               
            if(collection.containedBy === this.topLevelSectionId && this.activeTopLevelFilter === aopFilterName && collection.name.toLowerCase().indexOf(aopCollectionName.toLowerCase())  < 0){
               continue;
            }

            if(collection.containedBy === this.topLevelSectionId && this.activeTopLevelFilter !== aopFilterName && collection.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  < 0)
                continue;

            if(containingCollection && containingCollection.id !== this.topLevelSectionId && this.activeTopLevelFilter === aopFilterName && containingCollection.name.toLowerCase().indexOf(aopCollectionName.toLowerCase())  < 0)
                continue;

            if(containingCollection && containingCollection.id !== this.topLevelSectionId && this.activeTopLevelFilter !== aopFilterName && containingCollection.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  < 0)
                continue;
        } 
        var jsTreeNode = new Object();
        jsTreeNode.id = this.puid + "_collection_" + collection.id;
        jsTreeNode.parent = !isChildOfTopLevelCollection ? (this.puid + "_collection_" + collection.containedBy) : "#";
        jsTreeNode.text = collection.name;
        jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-folder icon-state-warning icon-lg jstree-themeicon-custom";

        var sortOrder = (collection.storyOrder == undefined) ? 9999 : collection.storyOrder;
        // yes this means a collection with 10000 collections in it will be incorrectly ordered
        // however I think something else will break before you get to rendering the tree, so it's probably fine

        jsTreeNode.sortOrder = sortOrder;

        jsTreeNode.a_attr = {
            'data-atheneum-item': JSON.stringify(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(collection)).replace(/"/g, '&quot;'),
            'data-atheneum-sort-order': sortOrder
        }

        if (this.path.length != 0 && this.path[this.path.length - 1] == collection.id)
            jsTreeNode.state = { selected: true, opened: true };

        jsTreeNodes.push(jsTreeNode);
        collectionIdsInTree[collection.id] = true;
    }

    var assetsCountForCollection = {};
    for (var i in this.Atheneum.Library.assets) {

        if (!this.Atheneum.Library.assets.hasOwnProperty(i))
            continue;

        var asset = this.Atheneum.Library.assets[i];

        if (asset.containedBy != this.topLevelCollection && !collectionIdsInTree[asset.containedBy]) {
            continue;
        }

      

        var permitted = true;
        if (asset.allowedGroups && asset.allowedGroups.length > 0) {
            permitted = false;
            for (var k = 0; k < asset.allowedGroups.length; k++) {
                if (this.Atheneum.User.groups && this.Atheneum.User.groups.contains(asset.allowedGroups[k])) {
                    permitted = true;
                    break;
                }
            }
        }
        if (!permitted)
            continue;

        var containingCollection = (typeof asset.containedBy != 'string') ? null : this.Atheneum.Library.collections[asset.containedBy];
        while (containingCollection && typeof containingCollection.containedBy == 'string') {
            if (containingCollection.id == this.topLevelCollection) {
                break;
            }

            if(containingCollection.containedBy === this.topLevelSectionId)
                break;

            containingCollection = (typeof containingCollection.containedBy == 'string') ? this.Atheneum.Library.collections[containingCollection.containedBy] : null;
        }

        if(typeof this.activeTopLevelFilter === 'string' && this.activeTopLevelFilter.length > 0){
            if(!containingCollection || collection.id === this.topLevelSectionId)
                continue;

            let aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
            
            if(collection.containedBy === this.topLevelSectionId && this.activeTopLevelFilter === aopFilterName && collection.name.toLowerCase().indexOf(aopCollectionName.toLowerCase())  < 0){
                continue;
            }

            if(collection.containedBy === this.topLevelSectionId && this.activeTopLevelFilter !== aopFilterName && collection.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  < 0)
                continue;

            if(containingCollection && containingCollection.id !== this.topLevelSectionId && this.activeTopLevelFilter === aopFilterName && containingCollection.name.toLowerCase().indexOf(aopCollectionName.toLowerCase())  < 0)
                continue;

            if(containingCollection && containingCollection.id !== this.topLevelSectionId && this.activeTopLevelFilter !== aopFilterName && containingCollection.name.toLowerCase().indexOf(this.activeTopLevelFilter.toLowerCase())  < 0)
                continue;
        } 

        var isChildOfTopLevelCollection = (asset.containedBy == this.topLevelCollection) || asset.containedBy == null;

        if(assetsCountForCollection.hasOwnProperty(asset.containedBy) &&  assetsCountForCollection[asset.containedBy] >= this.Atheneum.Theme.getIntegerProperty('treeViewMaxAssetsPerNode', 100)){
            continue;
        }

        var jsTreeNode = new Object();
        jsTreeNode.id = this.puid + "_asset_" + asset.id;
        jsTreeNode.text = asset.name;
        jsTreeNode.parent = !isChildOfTopLevelCollection ? (this.puid + "_collection_" + asset.containedBy) : "#";
        jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-file icon-state-warning icon-lg jstree-themeicon-custom";

        var sortOrder = 10000 + ((asset.assetOrder == undefined) ? 9999 : asset.assetOrder);
        jsTreeNode.sortOrder = sortOrder;

        jsTreeNode.a_attr = {
            'data-atheneum-item': JSON.stringify(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(asset, this.Atheneum, this)).replace(/"/g, '&quot;'),
            'data-atheneum-sort-order': sortOrder
        }

        jsTreeNodes.push(jsTreeNode);
        if(assetsCountForCollection.hasOwnProperty(asset.containedBy)){
            assetsCountForCollection[asset.containedBy] += 1;
        }else{
            assetsCountForCollection[asset.containedBy] = 1;
        }
    }

    for (var i in this.Atheneum.Forms.formList) {

        if (!this.Atheneum.Forms.formList.hasOwnProperty(i))
            continue;
        if (!this.Atheneum.User.canSee(this.Atheneum.Forms.formList[i]))
            continue;


        var form = this.Atheneum.Forms.formList[i];
        //Only generic and consent forms here
        if (form.type !== this.Atheneum.Forms.Types.GENERIC && form.type !== this.Atheneum.Forms.Types.CONSENT && form.type !== this.Atheneum.Forms.Types.REMOTE_CONSENT && form.type !== this.Atheneum.Forms.Types.CREATE_MEETING && form.type !== this.Atheneum.Forms.Types.REMOTE)
            continue;


        var isChildOfTopLevelCollection = false;
        if (form.items == undefined || form.items == null || form.items.length == 0 || form.collectionId != undefined) {
            isChildOfTopLevelCollection = true;
        }

        var isDescendentOfTopLevelCollection = false;
        if (this.topLevelCollection == null) {
            isDescendentOfTopLevelCollection = true;
        }
        else  {
            for (let x = 0; x < form.items?.length; x++) {
                let colId = form.items[x];
                let collection = this.Atheneum.Library.collections[colId];
                if (!collection)
                    continue;

                if (collection.id == this.topLevelCollection) {
                    isDescendentOfTopLevelCollection = true;
                    break;
                }


                var containingCollection = (typeof collection.containedBy != 'string') ? null : this.Atheneum.Library.collections[collection.containedBy];
                while (containingCollection != null) {
                    if (containingCollection.id == this.topLevelCollection) {
                        isDescendentOfTopLevelCollection = true;
                        break;
                    }
                    containingCollection = (typeof containingCollection.containedBy == 'string') ? this.Atheneum.Library.collections[containingCollection.containedBy] : null;
                }
            }

        }

        if (!isDescendentOfTopLevelCollection) {
            continue;
        }


        if (!isChildOfTopLevelCollection && form.collectionId == undefined) {
            for (let x = 0; x < form.items.length; x++) {
                let colId = form.items[x];
                let collection = this.Atheneum.Library.collections[colId];
                if (!collection || !this.Atheneum.User.canSee(collection))
                    continue;

                var jsTreeNode = new Object();
                jsTreeNode.id = this.puid + "_form_" + form.id + "_collection_" + colId;
                jsTreeNode.parent = this.puid + "_collection_" + colId;
                jsTreeNode.text = this.Atheneum.Translation.get(form.title, form.title);
                jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-folder icon-state-warning icon-lg jstree-themeicon-custom";

                var sortOrder = (form.order == undefined) ? 9999 : 9999 + form.order;
                // yes this means a collection with 10000 collections in it will be incorrectly ordered
                // however I think something else will break before you get to rendering the tree, so it's probably fine
                if(SalesToolkit.Theme.getBooleanProperty('prependFormsInLibrary', false)){
                    sortOrder = (form.order == undefined) ? -9000 : -9000 - form.order;
                }
                jsTreeNode.sortOrder = sortOrder;

                jsTreeNode.a_attr = {
                    'data-atheneum-item': JSON.stringify(Atheneum.UI.ItemGroupDisplay.Item.fromForm(form)).replace(/"/g, '&quot;'),
                    'data-atheneum-sort-order': sortOrder
                }

                if ((window.location.href.indexOf('viewForm.html') >= 0 || document.body.classList.contains('module-previewForm')) && typeof formId === 'string' && formId === form.id)
                    jsTreeNode.state = { selected: true, opened: true };

                jsTreeNodes.push(jsTreeNode);
                formIdsInTree[form.id] = true;
            }
        } else {
            var jsTreeNode = new Object();
            jsTreeNode.id = this.puid + "_form_" + form.id;
            jsTreeNode.parent = (isChildOfTopLevelCollection) ? "#" : this.puid + "_collection_" + form.collectionId;
            jsTreeNode.text = this.Atheneum.Translation.get(form.title, form.title);
            jsTreeNode.icon = "jstree-icon jstree-themeicon fa fa-folder icon-state-warning icon-lg jstree-themeicon-custom";

            var sortOrder = (form.order == undefined) ? 9999 : 9999 + form.order;
            if(SalesToolkit.Theme.getBooleanProperty('prependFormsInLibrary', false)){
                sortOrder = (form.order == undefined) ? -9000 : -9000 - form.order;
            }
            // yes this means a collection with 10000 collections in it will be incorrectly ordered
            // however I think something else will break before you get to rendering the tree, so it's probably fine

            jsTreeNode.sortOrder = sortOrder;

            jsTreeNode.a_attr = {
                'data-atheneum-item': JSON.stringify(Atheneum.UI.ItemGroupDisplay.Item.fromForm(form)).replace(/"/g, '&quot;'),
                'data-atheneum-sort-order': sortOrder
            }

            if ((window.location.href.indexOf('viewForm.html') >= 0 || document.body.classList.contains('module-previewForm')) && typeof formId === 'string' && formId === form.id)
                jsTreeNode.state = { selected: true, opened: true };

            jsTreeNodes.push(jsTreeNode);
            formIdsInTree[form.id] = true;
        }
    }


    for (var i = 0; i < jsTreeNodes.length; i++) {
        parentFound = false;
        for (var j = 0; j < jsTreeNodes.length; j++) {
            if (jsTreeNodes[i].parent == jsTreeNodes[j].id) {
                parentFound = true;
                break;
            }
        }
        if (jsTreeNodes[i].parent == "#") {
            parentFound = true;
        }

        if (!parentFound) {
            console.log(jsTreeNodes[i].id + ": '" + jsTreeNodes[i].text + "' has no parent node");
            jsTreeNodes[i].parent = "#";
        }
    }

    // sort tree view data in advance for ie
    jsTreeNodes.sort(function (nodeA, nodeB) {
        return (nodeA.sortOrder < nodeB.sortOrder) ? 1 : -1;
    });

    var treeView = this;

    window.jQuery(this.element).jstree({
        core: {
            multiple: false,
            data: jsTreeNodes
        },
        sort: function (a, b) {

            // for some reason, chrome and firefox have no trouble with this code
            // internet explorer on the other hand seems to think the tree is undefined

            if (treeView && treeView.jsTree == undefined) {
                treeView.jsTree = window.jQuery.jstree.reference(treeView.element);
            }

            if (treeView && treeView.jsTree && typeof treeView.jsTree.get_node === "function") {
                var nodeA = treeView.jsTree.get_node(a);
                var nodeB = treeView.jsTree.get_node(b);

                if (nodeA && nodeA.a_attr && nodeA.a_attr['data-atheneum-sort-order'] != undefined
                    && nodeB && nodeB.a_attr && nodeB.a_attr['data-atheneum-sort-order'] != undefined) {

                    return treeView.jsTree.get_node(a).a_attr['data-atheneum-sort-order'] < treeView.jsTree.get_node(b).a_attr['data-atheneum-sort-order'] ? -1 : 1;
                }
            }
            return -1;

            //return treeView.jsTree.get_node(a).a_attr['data-atheneum-sort-order'] < treeView.jsTree.get_node(b).a_attr['data-atheneum-sort-order'] ? -1 : 1;
        },
        plugins: ["sort"]
    });

    this.jsTree = window.jQuery.jstree.reference(this.element);



    window.jQuery(this.element).on('select_node.jstree', function (event, data) {

        if (data.selected.length == 0)
            return;

        var node = document.getElementById(data.selected[0]).querySelector('a');
        var item = JSON.parse(node.getAttribute("data-atheneum-item").replace(/&quot;/g, '"'));

        if (item && data.node.id.includes("plugin")) {
            var pluginId = item.ID || item.id;
            loadPlugin(pluginId, document.getElementById(data.selected[0]));
            return;
        }

        if (item && data.node.id.includes("form")) {
            var formId = item.ID || item.id;
            loadForm(formId);
            return;
        }

        treeView.trigger('item-click', item);
    });

    console.timeEnd('populateTreeView');
    //window.jQuery(this.element).on('loaded.jstree', function() {
    //var $el = $(treeView.element);
    //var $items = $el.find('[data-atheneum-item]');
    //$items.addClass('atheneum-item');
    //});
}

Atheneum.UI.TreeView.prototype.selectAsset = function (assetId) {
    this.selectedAsset = assetId;
    this.selectedCollection = undefined;
}
Atheneum.UI.TreeView.prototype.selectCollection = function (collectionId) {
    this.selectedAsset = undefined;
    this.selectedCollection = collectionId;
}
Atheneum.UI.TreeView.prototype.clearSelection = function () {
    this.selectedAsset = undefined;
    this.selectedCollection = undefined;
}

Atheneum.UI.TreeView.prototype.refresh = function (forceRefresh = false) {
    if (!this.jsTree) return;

    if (this._topLevelCollectionWhenTreePopulated != this.topLevelCollection) {
        this.populateTree();
        this.refresh();
    }

    if (!forceRefresh && this.previouslySelectedCollection == this.selectedCollection
        && this.previouslySelectedAsset == this.selectedAsset) {
        // no need to update
        return;
    }

    this.jsTree.close_all();
    this.jsTree.deselect_all();

    for (var i = 0; i < this.path.length; i++) {
        var treeNode = this.jsTree.get_node(this.puid + "_collection_" + this.path[i]);

        this.jsTree.open_node(treeNode);

        if (this.selectedCollection == this.path[i]) {
            this.jsTree.select_node(treeNode);
        }
    }

    if (this.selectedAsset != undefined) {
        this.jsTree.select_node(this.jsTree.get_node(this.puid + "_asset_" + this.selectedAsset));
    }


    this.previouslySelectedCollection = this.selectedCollection;
    this.previouslySelectedAsset = this.selectedAsset;

}

// class Atheneum.UI.Favourites extends Atheneum.UI.ItemGroupDisplay
Atheneum.UI.Favourites = function AtheneumUIFavourites(atheneum, element) {

    if (!(this instanceof Atheneum.UI.Favourites))
        return new Atheneum.UI.Favourites(atheneum, element);

    Atheneum.UI.ItemGroupDisplay.call(this, atheneum, element);


    this.ratingMaxStars = this.constructor.defaultRatingMaxStars != undefined ? this.constructor.defaultRatingMaxStars : atheneum.UI.ItemGroupDisplay.defaultRatingMaxStars;
    this.ratingStarEmptyTemplate = this.constructor.defaultRatingStarEmptyTemplate != undefined ? this.constructor.defaultRatingStarEmptyTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate;
    this.ratingStarHalfTemplate = this.constructor.defaultRatingStarHalfTemplate != undefined ? this.constructor.defaultRatingStarHalfTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarHalfTemplate;
    this.ratingStarFullTemplate = this.constructor.defaultRatingStarFullTemplate != undefined ? this.constructor.defaultRatingStarFullTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarFullTemplate;
    this.unratedTemplate = this.constructor.defaultUnratedTemplate != undefined ? this.constructor.defaultUnratedTemplate : atheneum.UI.ItemGroupDisplay.defaultUnratedTemplate;


    var atheneumUIFavourites = this;

    this.on("item-added-to-favourites", function (item) {
        atheneumUIFavourites.refresh();
    });

    this.on("item-removed-from-favourites", function (item) {
        atheneumUIFavourites.removeItem(item);
    });
}

Atheneum.UI.Favourites.prototype = Object.create(Atheneum.UI.ItemGroupDisplay.prototype);
Atheneum.UI.Favourites.prototype.constructor = Atheneum.UI.Favourites;
Atheneum.UI.prototype.Favourites = function (element) {
    return new Atheneum.UI.Favourites(this.Atheneum, element);
}
Atheneum.UI.prototype.Favourites.setDefaultItemTemplate = function (template) {
    Atheneum.UI.Favourites.defaultItemTemplate = template;
}
Atheneum.UI.Favourites.defaultItemTemplate = '<div class="atheneum-item" data-atheneum-item="{item}" data-atheneum-item-type="{item.type}">'
    + '<img class="atheneum-item-image" src="{@item.imageUrl} />'
    + '<a>{item.name}</a>'
    + '<a class="atheneum-item-action" data-atheneum-item-action="toggle-cart">Add to / Remove from Cart</a>'
    + '<a class="atheneum-item-action" data-atheneum-item-action="remove-from-favourites">Remove from Favourites</a>'
    + '</div>';

Atheneum.UI.Favourites.prototype.refresh = function () {

    this.removeAllItems();

    for (var i = 0; i < this.Atheneum.Favourites.collectionIds.length; i++) {

        var collection = this.Atheneum.Library.collections[this.Atheneum.Favourites.collectionIds[i]];

        if (collection != undefined)
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(collection));
    }

    for (var i = 0; i < this.Atheneum.Favourites.assetIds.length; i++) {
        var asset = this.Atheneum.Library.assets[this.Atheneum.Favourites.assetIds[i]];
        if (asset != undefined)
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(asset, this.Atheneum, this));
    }

    this.trigger("refresh");
}

// class Atheneum.UI.Favourites extends Atheneum.UI.ItemGroupDisplay
Atheneum.UI.Cart = function AtheneumUICart(atheneum, element) {

    if (!(this instanceof Atheneum.UI.Cart))
        return new Atheneum.UI.Cart(atheneum, element);

    Atheneum.UI.ItemGroupDisplay.call(this, atheneum, element);

    this.ratingMaxStars = this.constructor.defaultRatingMaxStars != undefined ? this.constructor.defaultRatingMaxStars : atheneum.UI.ItemGroupDisplay.defaultRatingMaxStars;
    this.ratingStarEmptyTemplate = this.constructor.defaultRatingStarEmptyTemplate != undefined ? this.constructor.defaultRatingStarEmptyTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate;
    this.ratingStarHalfTemplate = this.constructor.defaultRatingStarHalfTemplate != undefined ? this.constructor.defaultRatingStarHalfTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarHalfTemplate;
    this.ratingStarFullTemplate = this.constructor.defaultRatingStarFullTemplate != undefined ? this.constructor.defaultRatingStarFullTemplate : atheneum.UI.ItemGroupDisplay.defaultRatingStarFullTemplate;
    this.unratedTemplate = this.constructor.defaultUnratedTemplate != undefined ? this.constructor.defaultUnratedTemplate : atheneum.UI.ItemGroupDisplay.defaultUnratedTemplate;
    this.inboxMode = false;
    
    var atheneumUICart = this;

    this.on("item-added-to-cart", function (item) {
        atheneumUICart.refresh();
    });

    this.on("item-removed-from-cart", function (item) {
        atheneumUICart.removeItem(item);
    });
}
Atheneum.UI.Cart.prototype = Object.create(Atheneum.UI.ItemGroupDisplay.prototype);
Atheneum.UI.Cart.prototype.constructor = Atheneum.UI.Cart;
Atheneum.UI.prototype.Cart = function (element) {
    return new Atheneum.UI.Cart(this.Atheneum, element);
}
Atheneum.UI.prototype.Cart.setDefaultItemTemplate = function (template) {
    Atheneum.UI.Cart.defaultItemTemplate = template;
}
Atheneum.UI.Cart.defaultItemTemplate = '<div class="atheneum-item" data-atheneum-item="{item}" data-atheneum-item-type="{item.type}">'
    + '<img class="atheneum-item-image" src="{@item.imageUrl} />'
    + '<a>{item.name}</a>'
    + '<a class="atheneum-item-action" data-atheneum-item-action="toggle-favourites">Add to / Remove from Favourites</a>'
    + '<a class="atheneum-item-action" data-atheneum-item-action="remove-from-cart">Remove from Cart</a>'
    + '</div>';

Atheneum.UI.Cart.prototype.refresh = function () {

    this.removeAllItems();

    for (var i = 0; i < this.Atheneum.Cart.collectionIds.length; i++) {

        var collection = this.Atheneum.Library.collections[this.Atheneum.Cart.collectionIds[i]];

        if (collection != undefined)
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromCollection(collection));
    }

    let assetIds = this.Atheneum.Cart.assetIds;

    if(this.inboxMode){
       let allCarts = this.Atheneum.Cart.carts;
       assetIds = [];
       let atheneum = this.Atheneum;
       allCarts = allCarts.filter(x=> x.myCart === false).sort((a, b)=> { return new Date(b.sharedDate) - new Date(a.sharedDate) })
        for (let i = 0; i < allCarts.length; i++) {
            let cart = allCarts[i];
            
            for(let j=0; j<cart.cart.length; j++){
                let cartItems = cart.cart[j];
                if(cartItems.assetIds === 'all'){
                    let collection = atheneum.Library.collections[cartItems.storyId];
                    if(collection){
                        let newAssets = collection.assets.filter((item) => assetIds.indexOf(item) < 0);
                        assetIds = assetIds.concat(newAssets.reverse());
                    } 
                }else{
                    let newAssets = cartItems.assetIds.filter((item) => assetIds.indexOf(item) < 0);
                    assetIds = assetIds.concat(newAssets.reverse());
                }
            }
        }
    }

    for (let i = 0; i < assetIds.length; i++) {
        let asset = this.Atheneum.Library.assets[assetIds[i]];
        if (asset != undefined)
            this.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(asset, this.Atheneum, this));
    }
   
    this.trigger("refresh");
}

/** This probably should not be under UI */
Atheneum.UI.Notifications = function AtheneumUINotifications(atheneum, element) {

    if (!(this instanceof Atheneum.UI.Notifications))
        return new Atheneum.UI.Notifications(atheneum);

    Atheneum.UI.Element.call(this, atheneum, element);

    this.Atheneum = atheneum;
    this.pollInterval = 300000;
    this.history = JSON.parse(this.Atheneum.LocalStorage.get('atheneumNotificationHistory') || "[]");
}

Atheneum.UI.Notifications.prototype = Object.create(Atheneum.UI.Element.prototype);
Atheneum.UI.Notifications.prototype.constructor = Atheneum.UI.Notifications;

Atheneum.UI.Notifications.prototype.setPollInterval = function (milliseconds) {
    this.pollInterval = milliseconds;
}

/** Waits for the duration, then polls the server for notifications */
Atheneum.UI.Notifications.prototype.startPolling = function (milliseconds, callback) {

    if (callback === undefined && typeof milliseconds !== "number") {
        callback = milliseconds;
        milliseconds = this.pollInterval;
    }

    var atheneumUINotifications = this;

    setTimeout(function () {
        atheneumUINotifications.poll(callback);
        atheneumUINotifications.startPolling(atheneumUINotifications.pollInterval, callback);
    }, milliseconds);
}

Atheneum.UI.Notifications.showCustomNotification = function (type, message, heading, link) {
    // Override This
    console.log(
        type + ": "
        + (heading ? (heading + ". ") : "")
        + (message || "")
        + (link ? (" ( " + link + " )") : "")
    );
}

Atheneum.UI.Notifications.prototype.getHistoryIndex = function (notificationOrId) {
    if (typeof notificationOrId === "object")
        notificationOrId = notificationOrId.id;

    for (var i = 0; i < this.history.length; i++) {
        if (this.history[i].id == notificationOrId)
            return i;
    }

    return -1;
}

Atheneum.UI.Notifications.prototype.hasReceivedNotification = function (notificationOrId) {
    return this.getHistoryIndex(notificationOrId) != -1;
}

// TODO: override this
Atheneum.UI.Notifications.prototype.render = function (notification) {

    var type = "";
    if (notification.subjectType) {
        type = notification.subjectType.toUpperCase().substring(0, 1) + notification.subjectType.toLowerCase().substring(1) + " ";
    }

    var link = "";
    if (notification.url) {
        link = "=> " + notification.url;
    } else if (notification.subjectType) {
        link = "(" + notification.subjectId + ")";
    }

    console.log(
        type
        + "Notification: "
        + (notification.title ? (notification.title + "; ") : "")
        + (notification.message ? (notification.message + ". ") : "")
        + link
    );
}

// TODO: you can override this
Atheneum.UI.Notifications.prototype.onNotificationExpiry = function (notification) {
    var index = this.getHistoryIndex(notification);

    if (index == -1)
        return;

    this.history.splice(index, 1);
};

Atheneum.UI.Notifications.prototype.poll = function (callback) {

    var successCallback = (typeof callback === "object" && typeof callback.success === "function") ? callback.success : callback;
    var failureCallback = (typeof callback === "object" && typeof callback.failure === "function") ? callback.failure : function () { };

    var atheneumUINotifications = this;

    return this.Atheneum.API.getNotifications({
        success: function (json) {
            var now = new Date().getTime();
            if (json.notifications) {
                for (var i = 0; i < json.notifications.length; i++) {

                    var notification = json.notifications[i];

                    if (notification.endDate && notification.endDate <= now)
                        continue; // ignore expired notifications

                    if (notification.startDate && notification.startDate >= now)
                        continue; // Atheneum does not approve of time travel

                    if (notification.allowedGroups && notification.allowedGroups.length > 0) {
                        var canSee = false;
                        for (var g = 0; g < notification.allowedGroups.length; g++) {
                            if (atheneumUINotifications.Atheneum.User.groups.contains(notification.allowedGroups[g])) {
                                canSee = true;
                                break;
                            }
                        }

                        if (!canSee)
                            continue; // skip notifications the user is not meant to see
                    }

                    if (notification.subjectType == "ASSET")
                        notification.type = "asset";
                    else if (notification.subjectType == "COLLECTION")
                        notification.type = "collection";
                    else if(notification.subjectType == "CART")
                        notification.type = "cart";
                    else 
                        notification.type = "system";

                    notification.received = now;		// the date we got the notification, so chronological order is maintained
                    notification.acknowledged = false; 	// set to true when user has acknowledged the notification
                    notification.dismissed = false;	// user has explicitly said they're fed up of seeing the notification
                    notification.expired = false;	// the notification
                    notification.source = "Atheneum";	// other notifications can be triggered

                    if (!atheneumUINotifications.hasReceivedNotification(notification)) {
                        atheneumUINotifications.history[atheneumUINotifications.history.length] = notification;
                        atheneumUINotifications.render(notification);
                    }
                }
            }

            for (var i = 0; i < atheneumUINotifications.history.length; i++) {
                if (atheneumUINotifications.history[i].endDate && atheneumUINotifications.history[i].endDate < now) {
                    atheneumUINotifications.history[i].expired = true;
                    atheneumUINotifications.onNotificationExpiry(atheneumUINotifications.history[i]);
                }
            }

            // sort the notification list in reverse, (so the newest notification is at index 0)
            atheneumUINotifications.history.sort(function (a, b) {
                if (a.received < b.received)
                    return 1;
                else if (a.received > b.received)
                    return -1;
                else if (a.startDate && b.startDate && a.startDate < b.startDate)
                    return 1;
                else if (a.startDate && b.startDate && a.startDate > b.startDate)
                    return -1;
                else if (a.endDate && b.endDate && a.endDate < b.endDate)
                    return 1;
                else if (a.endDate && b.endDate && a.endDate > b.endDate)
                    return -1;
                else
                    return 0;
            });

            atheneumUINotifications.Atheneum.LocalStorage.set('atheneumNotificationHistory', JSON.stringify(atheneumUINotifications.history));

            if (typeof successCallback === "function")
                successCallback(atheneumUINotifications.history.filter(function (n) { n.received == now }));
        },

        failure: failureCallback
    });
}

/**
 * Essentially a class for holding information about various pages
 * 
 */
Atheneum.Pages = function (atheneum, dummy) {

    if (!(this instanceof Atheneum.Pages))
        return new Atheneum.Pages(atheneum, dummy);

    this.Atheneum = atheneum;

    this.LoginPage = { requiresLogin: false, url: undefined, buildUrl: function () { return this.url; } };
    this.LockPage = { requiresLogin: false, url: undefined, buildUrl: function () { return this.url; } };
    this.PreviewAssetPage = { requiresLogin: true, url: undefined, buildUrl: function () { return this.url; } };
    this.ExploreCollectionPage = { requiresLogin: true, url: undefined, buildUrl: function () { return this.url; } };
    this.FavouritesPage = { requiresLogin: true, url: undefined, buildUrl: function () { return this.url; } };
    this.CartPage = { requiresLogin: true, url: undefined, buildUrl: function () { return this.url; } };

    var atheneumPages = this;

    this.CurrentPage = {
        requiresLogin: true,
        url: window.location,
        getQueryParam: function (paramName) {

            var queryParams = window.location.search.substring(1).split("&");
            for (var i = 0; i < queryParams.length; i++) {
                var pair = queryParams[i].split("=");
                if (pair[0] == paramName)
                    return decodeURIComponent(pair.slice(1, pair.length).join("="));
            }
        },
        declarePublic: function () {
            atheneumPages.CurrentPage.requiresLogin = false;
        },
        declarePrivate: function () {
            atheneumPages.CurrentPage.requiresLogin = true;
        }
    };

    if (!dummy) {

        setTimeout(function () {

            atheneumPages.Atheneum.User.checkLoginStatus({
                failure: function (reason, httpStatus, errorCode) {

                    if (!atheneumPages.CurrentPage.requiresLogin) {
                        return; // who cares if we're not logged in, it's a public page
                    }

                    if (!atheneumPages.Atheneum.User.isLoggedIn) {

                        if (atheneumPages.Atheneum.User.isLocked && atheneumPages.Atheneum.User.username && atheneumPages.LockPage.url != undefined) {
                            atheneumPages.redirectToLockPage();
                        }
                        else if (atheneumPages.CurrentPage.requiresLogin && atheneumPages.LoginPage.url != undefined) {
                            if (atheneumPages.Atheneum.CrossPlatform.enabled) {
                                atheneumPages.Atheneum.CrossPlatform.logMessage("LOGOUT FROM DUMMY");
                            }
                            atheneumPages.redirectToLoginPage();
                        }
                    }
                }
            });

        }, 3000);

        setInterval(function () {

            //TODO check why this is cancelling videos
            atheneumPages.Atheneum.User.checkLoginStatus({
                failure: function (reason, httpStatus, errorCode) {

                    if (!atheneumPages.CurrentPage.requiresLogin) {
                        return; // who cares if we're not logged in, it's a public page
                    }

                    if (!atheneumPages.Atheneum.User.isLoggedIn) {

                        if (atheneumPages.Atheneum.User.isLocked && atheneumPages.Atheneum.User.username && atheneumPages.LockPage.url != undefined) {
                            atheneumPages.redirectToLockPage();
                        }
                        else if (atheneumPages.CurrentPage.requiresLogin && atheneumPages.LoginPage.url != undefined) {
                            if (atheneumPages.Atheneum.CrossPlatform.enabled) {
                                atheneumPages.Atheneum.CrossPlatform.logMessage("LOGOUT FROM DUMMY INTERVAL");
                            }
                            atheneumPages.redirectToLoginPage();
                        }
                    }

                }
            });

        }, 15000);
    }
};

Atheneum.Pages.prototype.redirectTo = function AtheneumPages_redirectTo(pageOrUrl) {

    if (typeof pageOrUrl === "object" && pageOrUrl.url != undefined) {
        window.location = this.Atheneum.HttpUtils.appendQueryParamsToUrl(pageOrUrl.url, { goToURL:window.location.href.replace(window.location.origin, '').replace('/',''), redirect: (window.location + "") });
    }
    else if (pageOrUrl) {
        window.location = this.Atheneum.HttpUtils.appendQueryParamsToUrl(pageOrUrl, { goToURL:window.location.href.replace(window.location.origin, '').replace('/',''), redirect: (window.location + "") });
    }
}

Atheneum.Pages.prototype.openInNewTab = function AtheneumPages_openInNewTab(pageOrUrl) {

    var url = pageOrUrl;
    if (typeof pageOrUrl === "object" && pageOrUrl.url != undefined)
        url = pageOrUrl.url;

    var link = document.createElement("A");
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
}

Atheneum.Pages.prototype.redirectToLoginPage = function () {
    this.redirectTo(this.LoginPage);
}

Atheneum.Pages.prototype.redirectToLockPage = function () {
    this.redirectTo(this.LockPage);
}

Atheneum.Callbacks.parse = function (callbacksOrSuccessCallback, failureCallback, offlineCallback) {

    var defaultSuccessCallback = function () { };
    var defaultFailureCallback = function () { };
    var defaultOfflineCallback = function () { };

    var parsedSuccessCallback;
    var parsedFailureCallback;
    var parsedOfflineCallback;
    var parsedProgressCallback = undefined;

    if (typeof callbacksOrSuccessCallback === 'function') {
        parsedSuccessCallback = callbacksOrSuccessCallback;
        parsedFailureCallback = failureCallback || defaultFailureCallback;
        parsedOfflineCallback = offlineCallback || parsedFailureCallback;
    }
    else {
        callbacksOrSuccessCallback = callbacksOrSuccessCallback || {};
        parsedSuccessCallback = callbacksOrSuccessCallback.success || defaultSuccessCallback;
        parsedFailureCallback = callbacksOrSuccessCallback.failure || defaultFailureCallback;
        parsedOfflineCallback = callbacksOrSuccessCallback.offline || parsedFailureCallback;
        parsedProgressCallback = callbacksOrSuccessCallback.progress;
    }

    var callbacks = {
        success: parsedSuccessCallback,
        failure: parsedFailureCallback,
        offline: parsedOfflineCallback
    };

    if (parsedProgressCallback) {
        callbacks.progress = parsedProgressCallback;
    }

    return callbacks;
}

Atheneum.Cache = function AtheneumCache(atheneum) {

    if (!(this instanceof Atheneum.Cache))
        return new Atheneum.Cache(atheneum);

    this.Atheneum = atheneum;
    this.pollInterval = 30000;
    this.polling = false;

    var lastSync;
    try {
        lastSync = parseInt(atheneum.LocalStorage.get("atheneumLastSyncForUser_" + this.Atheneum.User.username));
    } catch (e) {
        lastSync = 0;
    }

    this.syncDate = new Date(lastSync);


    if (lastSync == 0) {
        this.syncDateFormatted = (this.syncDate.getDate() < 10 ? "0" : "")  	// month starts from 0, day starts from 1
            + this.syncDate.getDate()						// because javascript is "consistent"
            + "/"
            + (this.syncDate.getMonth() < 9 ? "0" : "")
            + (this.syncDate.getMonth() + 1)
            + "/"
            + this.syncDate.getFullYear();
    } else {
        this.syncDateFormatted = "never";
    }
}


/**
    Cache.initiateSync( )
    Cache.initiateSync( onSuccess )
    Cache.initiateSync( onSuccess, onFailure )
    Cache.initiateSync( { success: onSuccess, failure: onFailure } )
*/
Atheneum.Cache.prototype.initiateSync = function (onSuccess, onFailure) {

    var callbacks = Atheneum.Callbacks.parse(onSuccess, onFailure);
    var atheneum = this.Atheneum;

    if (!this.Atheneum.Proxy.enabled) {

        if (this.Atheneum.CrossPlatform.enabled) {
            this.Atheneum.CrossPlatform.initiateSync(callbacks);
            return;
        }

        callbacks.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);
    }

    var startCache = function () {
        Atheneum.HttpUtils.postJSON(
            "restful/library/cache/start",
            { apikey: atheneum.User.apikey, groups: atheneum.User.groups },
            callbacks
        );
    }

    atheneum.User.update({
        success: startCache,
        failure: startCache, // try anyway
        offline: startCache  // I don't have high hopes, but you never know...
    });
}

Atheneum.Cache.prototype.setPollInterval = function (milliseconds) {
    this.pollInterval = milliseconds;
}

Atheneum.Cache.prototype.startPolling = function (onGetProgressSuccess, onGetProgressFailure) {

    var callbacks = Atheneum.Callbacks.parse(onGetProgressSuccess, onGetProgressFailure);
    this.polling = true;
    this.pollStartTime = new Date();
    this.__poll_loop(callbacks);
}

Atheneum.Cache.prototype.stopPolling = function () {
    this.polling = false;
}

// unlike the other functions, I was lazy 
Atheneum.Cache.prototype.__poll_loop = function (callbacks) {

    var atheneumCache = this;

    if (atheneumCache.polling) {

        setTimeout(function () {

            if (atheneumCache.polling) {

                atheneumCache.getSyncProgress({
                    success: function (json) {
                        callbacks.success(json);
                        atheneumCache.__poll_loop(callbacks);
                    },

                    failure: function (reason, httpStatus, errorCode) {
                        callbacks.failure(reason, httpStatus, errorCode);
                        atheneumCache.__poll_loop(callbacks);
                    }
                });
            }
        }, atheneumCache.pollInterval);
    }
}

Atheneum.Cache.prototype.getSyncProgress = function (onSuccess, onFailure) {

    var callbacks = Atheneum.Callbacks.parse(onSuccess, onFailure);

    //TODO TEST CROSS PLATFORM WRAPPER

    if (!this.Atheneum.Proxy.enabled && !this.Atheneum.CrossPlatform.enabled) {
        callbacks.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);
    }

    var atheneumCache = this;

    var successCallback = callbacks.success;
    var failureCallback = callbacks.failure;

    callbacks.success = function (json) {


        if (!json.progress) {
            atheneumCache.progressPercentage = "N/A";
            atheneumCache.progressValue = 0;
            atheneumCache.assetsDownloaded = 0;
            atheneumCache.assetsFailed = 0;
            atheneumCache.assetsTotal = undefined;
            atheneumCache.started = false;
            atheneumCache.finished = false;
            atheneumCache.state = "online"
            atheneumCache.syncDate = new Date(0);
            atheneumCache.syncDateFormatted = "never";
            atheneumCache.calculating = false;
            return successCallback(json);
        }

        atheneumCache.offline = !!json.progress.offline;

        atheneumCache.assetsFailed = json.progress.assetsFailed || 0;
        atheneumCache.assetsDownloaded = json.progress.assetsDownloaded || 0;
        atheneumCache.assetsTotal = json.progress.assetsTotal || 0;

        if (atheneumCache.assetsTotal == 0) {
            atheneumCache.progressValue = 0;
        } else {
            atheneumCache.progressValue = Math.max(0, Math.min(1, ((atheneumCache.assetsDownloaded + atheneumCache.assetsFailed) / atheneumCache.assetsTotal)));
        }

        var syncedBefore = (atheneumCache.assetsTotal != 0 || json.progress.lastSync != 0);

        if (json.progress.calculating)
            atheneumCache.progressPercentage = 0 + "%";
        else
            atheneumCache.progressPercentage = Math.floor(atheneumCache.progressValue * 100) + "%";
        atheneumCache.started = syncedBefore && !json.progress.finished;
        atheneumCache.finished = syncedBefore && json.progress.finished;
        atheneumCache.neverSynced = !syncedBefore && json.progress.finished;

        if (atheneumCache.finished && atheneumCache.pollStartTime)
            atheneumCache.finished = (new Date().getTime() - atheneumCache.pollStartTime.getTime() > 4500);

        atheneumCache.syncDate = new Date(json.progress.lastSync || atheneumCache.syncDate.getTime());

        if (atheneumCache.syncDate.getTime() == 0) {
            atheneumCache.syncDateFormatted = "never";
        } else {
            atheneumCache.syncDateFormatted = (atheneumCache.syncDate.getDate() < 10 ? "0" : "")  // month starts from 0, day starts from 1
                + atheneumCache.syncDate.getDate()
                + "/"
                + (atheneumCache.syncDate.getMonth() < 9 ? "0" : "")
                + (atheneumCache.syncDate.getMonth() + 1)
                + "/"
                + atheneumCache.syncDate.getFullYear();

        }

        atheneumCache.state = (atheneumCache.finished ? "online" : "syncing");
        if (json.progress.calculating) {
            atheneumCache.state = "calculating";
        }
        atheneumCache.Atheneum.LocalStorage.set("atheneumLastSyncForUser_" + atheneumCache.Atheneum.User.username, atheneumCache.syncDate.getTime());

        //if(atheneumCache.finished)
        //	atheneumCache.pollStartTime = null; <- Why on earth did I put that there?

        return successCallback(json);
    }

    callbacks.failure = function (reason, httpStatus, errorCode) {
        // this should always succeed, unless someone kills the java applet
        atheneumCache.state = "offline";
        failureCallback(reason, httpStatus, errorCode);
    }

    if (this.Atheneum.CrossPlatform.enabled) {
        this.Atheneum.CrossPlatform.getSyncProgress(callbacks);
    }
    else if (this.Atheneum.Proxy.enabled) {
        Atheneum.HttpUtils.getJSON(
            "restful/library/cache/progress",
            { apikey: this.Atheneum.User.apikey },
            callbacks
        );
    }
}

Atheneum.Cache.prototype.downloadAsset = function (assetId, onSuccess, onFailure) {

    var callbacks = Atheneum.Callbacks.parse(onSuccess, onFailure);

    var successCallback = callbacks.success;
    var atheneum = this.Atheneum;

    callbacks.success = function (connection) {

        var downloadLink = document.createElement("A");
        downloadLink.href = "restful/library/" + assetId + "/download?apikey=" + atheneum.User.apikey;
        document.querySelector("body").appendChild(downloadLink);
        downloadLink.click();
        document.querySelector("body").removeChild(downloadLink);
        successCallback(connection);
    }

    Atheneum.HttpUtils.makeRequest(
        "GET",
        "restful/library/" + assetId + "/hasDownload",
        { apikey: this.Atheneum.User.apikey },
        callbacks
    );
}

/**

    Cache.loadAssetPreview( assetId )
    Cache.loadAssetPreview( assetId, onSuccess )
    Cache.loadAssetPreview( assetId, onSuccess, onFailure )
    Cache.loadAssetPreview( assetId, { success: onSuccess, failure: onFailure } )
*/
Atheneum.Cache.prototype.loadAssetPreview = function (assetId, onSuccess, onFailure) {
    var callbacks = Atheneum.Callbacks.parse(onSuccess, onFailure);
    // TODO
}

/**
 * OfflineAction
 *
 * {
 *
 * 		string			userId		(set automatically)
 * 		string			apiBase		(set automatically)
 *
 * 		string			name
 * 								"addFavourite"
 * 								"removeFavourite"
 * 								"shareCart"
 * 								"submitForm"
 * 								"postComment"
 * 								"rateAsset"
 * 								"updateProfile"
 * 								"tracking"
 *
 * 		long			timestamp			(mandatory)
 *
 * 		string			formId				(for "submitForm")
 * 		string			assetId				(for "addFavourite" / "removeFavourite" / "tracking" asset)
 * 		string[ ]		assetIds			(for "submitForm" vends)
 * 		string			collectionId		(for "addFavourite" / "removeFavourite" / "tracking" collection / "submitForm" shares)
 *
 * 		map				fields				(for "shareCart" and "submitForm")
 * 		map				cart				(for "shareCart")
 * 		string[ ]		emailAddresses		(for "shareCart" - optional)
 *
 * 		int				rating				(for "rateAsset")
 * 		string			newsItemId			(for "postComment" / "tracking" news item)
 * 		string			comment				(for "postComment" / "rateAsset")
 *
 * 		long			duration			(for "tracking")
 * 		string			formType			(for "submitForm")
 *
 * }
 */

Atheneum.Offline = function AtheneumOffline(atheneum) {
    this.Atheneum = atheneum;
    this.unsyncedActions = [];
    this.loadFromStorage();
    this.actionSizeLimitInBytes = 5 * 2014 * 1024;

    // sync actions on page load
    window.setTimeout(function () {
        atheneum.Offline.syncActions({ success: function () { }, failure: function () { } });
    }, 20);

    // attempt to sync actions once every 5 minutes
    window.setInterval(function () {
        atheneum.Offline.syncActions({ success: function () { }, failure: function () { } });
    }, 300000);
}

Atheneum.Offline.prototype.recordUnsynchedAction = function (action) {
    if (action.userId == null || action.apiBase == null) {
        action.userId = this.Atheneum.User.id;
        action.apiBase = this.Atheneum.API.BASE_URL;
    }
    var actionSizeInBytes = JSON.stringify(action).length * 2;
    if (actionSizeInBytes > this.actionSizeLimitInBytes) {
        console.error("warning: problems recording unsynced action as it exceeds the permitted size");
    }

    action.pendingID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});

    this.unsyncedActions[this.unsyncedActions.length] = action;
    this.saveToStorage();
}

Atheneum.Offline.prototype.deleteGenericTrackingActions = function () {
    try {
        this.unsyncedActions = this.unsyncedActions.filter(function (obj, index, arr) {
            return obj.name != 'tracking' || !obj.data;
        });

        this.saveToStorage();

    } catch (err) {

    }
}

Atheneum.Offline.prototype.syncAction = function (action, callback) {

    var atheneum = this.Atheneum;

    // TODO: add session ids to favourite api calls

    if (action.name == "addFavourite") {

        if (action.collectionId && action.assetId) {
            atheneum.API.addAssetToFavourites(action.collectionId, action.assetId, callback)
        }
        else if (action.collectionId) {
            atheneum.API.addCollectionToFavourites(action.collectionId, callback);
        }
        else {
            console.log("OfflineAction( 'addFavourite' ) missing collectionId");
        }

    }
    else if (action.name == "removeFavourite") {

        if (action.collectionId && action.assetId) {
            atheneum.API.removeAssetFromFavourites(action.collectionId, action.assetId, callback)
        }
        else if (action.collectionId) {
            atheneum.API.removeCollectionFromFavourites(action.collectionId, callback);
        }
        else {
            console.log("OfflineAction( 'removeFavourite' ) missing collectionId");
        }

    }
    else if (action.name == "shareCart") {

        var result = {
            successes: [],
            failures: [],
            offlines: [],
            total: [],
            error: {}
        };

        var onComplete = function () {

            if (result.offlines.length > 0) {
                // remove things from the list, then fail
                var remainingAddresses = [];
                var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                for (var j = 0; j < emailAddresses.length; j++) {
                    if (re.test(emailAddresses[j]) && result.offlines.contains(j)) {
                        remainingAddresses[remainingAddresses.length] = emailAddresses[j];
                    }
                }
                action.emailAddresses = remainingAddresses;
                if (remainingAddresses.length == 0)
                    callback.success({ errorCode: 0 });
                else
                    callback.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);

            } else if (result.failures.length > 0) {
                // some succeeded, some were invalid. continue anyway
                Atheneum.Callbacks.logFailureDetails(result.error.reason, result.error.httpStatus, result.error.errorCode);
                callback.success({ errorCode: 0 });

            } else {
                // the cart shared successfully. hooray!
                callback.success({ errorCode: 0 });
            }
        }

        //var emailContent = action.emailBody;

        //if( emailContent && action.emailHeader )
        //	emailContent = action.emailHeader + "<br/>" + emailContent;
        //
        //if( emailContent && action.emailFooter )
        //	emailContent = emailContent + "<br/>" + action.emailFooter;

        var emailAddresses = action.emailAddresses || [];
        for (var i = 0; i < emailAddresses.length; i++) {

            (function (index) {
                atheneum.API.shareCart(action.fields, emailAddresses[index], action.cart, action.timestamp, action.sessionId, atheneum.Tracking.Status.OFFLINE, {

                    success: function () {
                        result.successes[result.successes.length] = index;
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    },

                    failure: function (reason, httpStatus, errorCode) {

                        if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                            result.offlines[result.offlines.length] = index;
                        }
                        else if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT && (errorCode & Atheneum.API.ErrorCodes.API_ERROR_AUTH > 0)) {
                            // it's an error with the api key
                            // that's understandable as it probably became invalidated, treat it as offline
                            result.offlines[result.offlines.length] = index;
                        }
                        else {
                            result.failures[result.failures.length] = index;
                            result.error = { "reason": reason, "httpStatus": httpStatus, "errorCode": errorCode };
                        }
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    }

                });
            })(i);

        }
    }else if (action.name == "mlrReview") {

        var result = {
            successes: [],
            failures: [],
            offlines: [],
            total: [],
            error: {}
        };

        var onComplete = function () {

            if (result.offlines.length > 0) {
                // remove things from the list, then fail
                var remainingAddresses = [];
                var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                for (var j = 0; j < emailAddresses.length; j++) {
                    if (re.test(emailAddresses[j]) && result.offlines.contains(j)) {
                        remainingAddresses[remainingAddresses.length] = emailAddresses[j];
                    }
                }
                action.emailAddresses = remainingAddresses;
                if (remainingAddresses.length == 0)
                    callback.success({ errorCode: 0 });
                else
                    callback.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);

            } else if (result.failures.length > 0) {
                // some succeeded, some were invalid. continue anyway
                Atheneum.Callbacks.logFailureDetails(result.error.reason, result.error.httpStatus, result.error.errorCode);
                callback.success({ errorCode: 0 });

            } else {
                // the cart shared successfully. hooray!
                callback.success({ errorCode: 0 });
            }
        }

        //var emailContent = action.emailBody;

        //if( emailContent && action.emailHeader )
        //	emailContent = action.emailHeader + "<br/>" + emailContent;
        //
        //if( emailContent && action.emailFooter )
        //	emailContent = emailContent + "<br/>" + action.emailFooter;

        var emailAddresses = action.emailAddresses || [];
        for (var i = 0; i < emailAddresses.length; i++) {

            (function (index) {
                atheneum.API.mlrReview(action.fields, emailAddresses[index], action.cart, action.timestamp, action.sessionId, atheneum.Tracking.Status.OFFLINE, {

                    success: function () {
                        result.successes[result.successes.length] = index;
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    },

                    failure: function (reason, httpStatus, errorCode) {

                        if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                            result.offlines[result.offlines.length] = index;
                        }
                        else if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT && (errorCode & Atheneum.API.ErrorCodes.API_ERROR_AUTH > 0)) {
                            // it's an error with the api key
                            // that's understandable as it probably became invalidated, treat it as offline
                            result.offlines[result.offlines.length] = index;
                        }
                        else {
                            result.failures[result.failures.length] = index;
                            result.error = { "reason": reason, "httpStatus": httpStatus, "errorCode": errorCode };
                        }
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    }

                });
            })(i);

        }
    }else if (action.name == "registerInterest") {

        var result = {
            successes: [],
            failures: [],
            offlines: [],
            total: [],
            error: {}
        };

        var onComplete = function () {

            if (result.offlines.length > 0) {
                // remove things from the list, then fail
                var remainingAddresses = [];
                var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                for (var j = 0; j < emailAddresses.length; j++) {
                    if (re.test(emailAddresses[j]) && result.offlines.contains(j)) {
                        remainingAddresses[remainingAddresses.length] = emailAddresses[j];
                    }
                }
                action.emailAddresses = remainingAddresses;
                if (remainingAddresses.length == 0)
                    callback.success({ errorCode: 0 });
                else
                    callback.failure(Atheneum.API.Problems.CONNECTION_FAILED, undefined, undefined);

            } else if (result.failures.length > 0) {
                // some succeeded, some were invalid. continue anyway
                Atheneum.Callbacks.logFailureDetails(result.error.reason, result.error.httpStatus, result.error.errorCode);
                callback.success({ errorCode: 0 });

            } else {
                // the cart shared successfully. hooray!
                callback.success({ errorCode: 0 });
            }
        }

        //var emailContent = action.emailBody;

        //if( emailContent && action.emailHeader )
        //	emailContent = action.emailHeader + "<br/>" + emailContent;
        //
        //if( emailContent && action.emailFooter )
        //	emailContent = emailContent + "<br/>" + action.emailFooter;

        var emailAddresses = action.emailAddresses || [];
        for (var i = 0; i < emailAddresses.length; i++) {

            (function (index) {
                atheneum.API.registerInterest(action.fields, emailAddresses[index], action.cart, action.timestamp, action.sessionId, atheneum.Tracking.Status.OFFLINE, {

                    success: function () {
                        result.successes[result.successes.length] = index;
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    },

                    failure: function (reason, httpStatus, errorCode) {

                        if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                            result.offlines[result.offlines.length] = index;
                        }
                        else if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT && (errorCode & Atheneum.API.ErrorCodes.API_ERROR_AUTH > 0)) {
                            // it's an error with the api key
                            // that's understandable as it probably became invalidated, treat it as offline
                            result.offlines[result.offlines.length] = index;
                        }
                        else {
                            result.failures[result.failures.length] = index;
                            result.error = { "reason": reason, "httpStatus": httpStatus, "errorCode": errorCode };
                        }
                        result.total[result.total.length] = index;
                        if (result.total.length == emailAddresses.length)
                            onComplete();
                    }

                });
            })(i);

        }
    }

    else if (action.name == "rateAsset") {
        // TODO: offline rate asset 

    }
    else if (action.name == "postComment") {
        // TODO: move offline comments to this section

    }
    else if (action.name == "tracking") {
        let status =  this.Atheneum.Tracking.Status.ONLINE;
        if (action.isOffline == true)
            status =  this.Atheneum.Tracking.Status.OFFLINE; 
        if (action.data) {
            this.Atheneum.API.trackGeneric(action.data, this.Atheneum.Tracking.Status.OFFLINE, action.data.timestamp, callback);
        } else if (action.newsItemId) {
            this.Atheneum.API.trackNewsItemView(action.newsItemId, action.duration,
                status, action.timestamp, action.sessionId, callback);
        }
        else if (action.assetId) {
            this.Atheneum.API.trackAssetView(action.collectionId || action.storyId, action.assetId, action.duration,
                status, action.timestamp, action.sessionId, callback);
        }
        else if (action.storyId) {
            this.Atheneum.API.trackCollectionView(action.storyId, action.duration,
                status, action.timestamp, action.sessionId, callback);
        } else if (action.collectionId) {
            this.Atheneum.API.trackCollectionView(action.collectionId, action.duration,
                status, action.timestamp, action.sessionId, callback);
        }
        else {
            console.log("OfflineAction( 'tracking' ) missing [ 'storyId', 'assetId', 'newsItemId' ]");
        }
    }
    else if (action.name == "profile") {

        var preferences = JSON.parse(action.preferences);
        preferences.syncAction = true;
        preferences.timestamp = action.timestamp;
        this.Atheneum.User.changePreferences(preferences, callback);

    }
    else if (action.name == "submitForm") {

        if (action.formType == this.Atheneum.Forms.Types.SHARE) {

            if (action.collectionId && action.assetIds) {
                this.Atheneum.API.shareCollectionAssets(action.collectionId, action.assetIds, action.fields, action.timestamp, action.sessionId, callback);
            }
            else if (action.collectionId) {
                this.Atheneum.API.shareCollectionAssets(action.collectionId, action.fields, action.timestamp, action.sessionId, callback);
            }
            else {
                this.Atheneum.API.shareCart(action.fields, action.timestamp, action.sessionId, callback);
            }
        }
        else {

            // generic / notes from

            if (action.formId) {
                this.Atheneum.API.submitForm(action.formId, action.fields, action.timestamp, action.sessionId, callback);
            }
            else {
                console.log("OfflineAction( 'submitForm' ) missing [ 'formId' ]");
            }
        }
    }
    else {

        console.log("unrecognised offline action: " + action.name);
    }
}

/**
 * Sends requests to the server, causing all actions that took place offline to take effect.
 * 
 */
Atheneum.Offline.prototype.syncActions = function (callbacks) {

    var atheneum = this.Atheneum;

    var atheneumOffline = this;

    if(atheneumOffline.syncing)
        return;

    atheneumOffline.syncing = true;
    // move unsyncable actions to the end
    var index = 0;
    var unsyncable = 0;
    while (index < this.unsyncedActions.length) {
        if (this.unsyncedActions[index].userId != atheneum.User.id) {
            this.unsyncedActions[this.unsyncedActions.length] = this.unsyncedActions[index];
            this.unsyncedActions.splice(index - unsyncable, 1);
            unsyncable += 1;
        }
        index += 1;
    }

    if (this.unsyncedActions.length > 0
        && unsyncable < this.unsyncedActions.length) {

        this.syncAction(this.unsyncedActions[0], {
            success: function () {
                atheneum.Offline.unsyncedActions.splice(0, 1);
                atheneum.Offline.saveToStorage();
                atheneumOffline.syncing = false;
                atheneum.Offline.syncActions(callbacks);
            },

            failure: function (reason, httpStatus, errorCode) {
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Offline.syncAction");
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    // we're still offline: give up and try again when we have internet
                    if(atheneum.Offline.unsyncedActions[0]?.name == 'tracking '){
                        let action = atheneum.Offline.unsyncedActions[0];
                        action.isOffline = true;
                        atheneum.Offline.unsyncedActions[0] = action;
                            atheneum.Offline.saveToStorage();
                    }
                }
                else if (errorCode === Atheneum.API.ErrorCodes.API_ERROR_AUTH) {
                    // we're online but our apikey has expired.
                    // give up and try again when we've got a valid apikey
                    // the user will be redirected back to the login screen in a few seconds
                     if(atheneum.Offline.unsyncedActions[0]?.name == 'tracking '){
                         let action = atheneum.Offline.unsyncedActions[0];
                        action.isOffline = true;
                        atheneum.Offline.unsyncedActions[0] = action;
                            atheneum.Offline.saveToStorage();
                    }

                }
                else {
                    var failedActions = atheneum.LocalStorage.get('atheneumFailedActions');
                    if (failedActions == undefined) {
                        failedActions = '[';
                    } else {
                        failedActions = failedActions.substring(0, failedActions.length - 1) + ",";
                    }
                    failedActions += JSON.stringify(atheneum.Offline.unsyncedActions[0]);
                    failedActions += ']';
                    atheneum.LocalStorage.set('atheneumFailedActions', failedActions);

                    // remove the offending action and log it for later
                    atheneum.Offline.unsyncedActions.splice(0, 1);
                    atheneum.Offline.saveToStorage();
                    atheneumOffline.syncing = false;
                    atheneum.Offline.syncActions(callbacks);
                }
            }
        });
    }else{
        atheneumOffline.syncing = false;
    }

}

Atheneum.Offline.prototype.saveToStorage = function () {
    if (this.Atheneum.CrossPlatform.enabled) {
        let unsyncedCount = (this.unsyncedActions) ? this.unsyncedActions.filter(x => (x.name == "shareCart" || x.name == "submitForm")).length : 0;

        this.Atheneum.CrossPlatform.reportOfflineActionsCount(unsyncedCount);
    }

    if (this.Atheneum.User.username)
        this.Atheneum.LocalStorage.set("unsyncedOfflineActionsForUser_" + this.Atheneum.User.username, JSON.stringify(this.unsyncedActions || []));
}

Atheneum.Offline.prototype.loadFromStorage = function () {
    if (this.Atheneum.User.username)
         try{
            this.unsyncedActions = JSON.parse(this.Atheneum.LocalStorage.get("unsyncedOfflineActionsForUser_" + this.Atheneum.User.username) || "[]") || [];
        }catch(err){
            try{
                let compressed = this.Atheneum.LocalStorage.get("unsyncedOfflineActionsForUser_" + this.Atheneum.User.username) || "[]";
                this.unsyncedActions = JSON.parse(LZString.decompress(compressed)) || [];
     
            }catch(err){

            }
        }
}

/**
 * A wrapper around localStorage["prop"] = "value";
 * Allows for compression prior to storage / redirection to the wrapper to save on storage space
 */
Atheneum.LocalStorage = function (atheneum) {
    this.Atheneum = atheneum;

    if(!this.Atheneum.CrossPlatform.enabled && window.Dexie && SalesToolkit.Theme.getBooleanProperty("libraryApiIncremental", false)){
        this.db = new Dexie("AtheneumStorage");
        this.db.version(1).stores({
            json: 'key'
        });
    }
    
    // these items can get particularly big, and risk hitting the 5MB limit if saved in localStorage
    // if the AtheneumInstance is running locally, we should use the wrapper to save it
    // if not, we should really really think about compressing them
    this.wrapperPreferred = [
        "atheneumLibraryData",
        "atheneumContacts",
        "atheneumCollectionContacts",
        "atheneumLibraryTimestamp",
        "atheneumNewsFeedData",
        "atheneumNewsFeedTimestamp",
        "atheneumFormList",
        "atheneumTranslation",
        "atheneumTranslationsTimestamp",
        "atheneumArchiveIndex",
        "atheneumSummaries",
        "atheneumFailedActions",
        "atheneumArchiveEntry-.*",
        "adminUserList",
        "adminAccountList",
        "adminRegistrationsList",
        "adminTagsList",
        "adminGroupsList",
        "adminPermissionSetList"
    ];

    this.wrapperPreferredRegex = new RegExp(this.wrapperPreferred.map(function (regex) { return '(?:^' + regex + '$)'; }).join('|'));
}

Atheneum.LocalStorage.prototype.get = function (key) {
    if ((this.wrapperPreferredRegex.test(key) || key.startsWith("atheneumLibraryTimestamp") || key.startsWith("unsyncedOfflineActionsForUser") || key.startsWith("atheneumContacts")) && this.Atheneum.CrossPlatform && this.Atheneum.CrossPlatform.enabled) {
        return this.Atheneum.CrossPlatform.GetLocalStore(key);
    } else if (this.wrapperPreferredRegex.test(key) && this.Atheneum.Proxy.enabled) {
        var connection = new XMLHttpRequest();
        connection.open("GET", "/restful/localstorage?name=" + key, false);		// synchronous request
        connection.setRequestHeader("Content-Type", "application/json");
        connection.send();

        var parsedJSON = { "value": null };
        try {
            parsedJSON = JSON.parse(connection.responseText || '{ "value": null }');
        }
        catch (e) {
            console.warn("db.localStorage['" + key + "'] is corrupted, ignoring and defaulting to undefined.");
            return undefined;
        }
        return parsedJSON.value;
    } else {
        if (window.LZString && key.indexOf('unsyncedOfflineActionsForUser_') < 0 && key.indexOf('atheneumUserPreferences') < 0){
            let result = LZString.decompress(localStorage[key]);
            if(result == '')
                return undefined;
            return result;
        }
        return localStorage[key];
    }
}

Atheneum.LocalStorage.prototype.set = function (key, value) {
	var startTime = new Date().getTime();
    if (value === undefined)
        return this.clear(key);

    if ((this.wrapperPreferredRegex.test(key) || key.startsWith("atheneumLibraryTimestamp") || key.startsWith("unsyncedOfflineActionsForUser") || key.startsWith("atheneumContacts")) && this.Atheneum.CrossPlatform.enabled) {
        this.Atheneum.CrossPlatform.SetLocalStore(key, value);
		var endTime = new Date().getTime();
		//console.log('storing "' + key + '" took ' + (endTime - startTime) + 'ms');
        return value;
    } else if (this.wrapperPreferredRegex.test(key) && this.Atheneum.Proxy.enabled) {
        var connection = new XMLHttpRequest();
        connection.open("POST", "/restful/localstorage", false); // synchronous request
        connection.setRequestHeader("Content-Type", "application/json");
        connection.send(JSON.stringify({ "name": key, "value": value }));
		var endTime = new Date().getTime();
		//console.log('storing "' + key + '" took ' + (endTime - startTime) + 'ms');
        return value;
    } else {
        if (key == 'atheneumUserPreferences' && (window.location + '').indexOf('debug') != -1) {
            debugPreferences(key, localStorage[key], value);
        }
        try {
            
            if(typeof value !== 'string'){
                value = ""+value;
            }
               
            if (window.LZString && key.indexOf('unsyncedOfflineActionsForUser_') < 0 && key.indexOf('atheneumUserPreferences') < 0){
                value = LZString.compress(value);
            }

            localStorage[key] = value;
        }
        catch (e) {
            console.error('unable to set localStorage["' + key + '"] to "' + value + '"');
        }
		var endTime = new Date().getTime();
		//console.log('storing "' + key + '" took ' + (endTime - startTime) + 'ms');
    }
}

Atheneum.LocalStorage.prototype.clear = function (key) {
    if ((this.wrapperPreferredRegex.test(key) || key.startsWith("atheneumLibraryTimestamp") || key.startsWith("unsyncedOfflineActionsForUser")) && this.Atheneum.CrossPlatform.enabled) {
        return this.Atheneum.CrossPlatform.ClearLocalStore(key);
    } else if (this.wrapperPreferredRegex.test(key) && this.Atheneum.CrossPlatform.enabled) {
        this.Atheneum.CrossPlatform.ClearLocalStore(key);
        return value;
    } else if (this.wrapperPreferredRegex.test(key) && this.Atheneum.Proxy.enabled) {
        var connection = new XMLHttpRequest();
        connection.open("DELETE", "/restful/localstorage?name=" + key, false); // synchronous request
        connection.setRequestHeader("Content-Type", "application/json");
        connection.send();
        return connection.status == 200;
    } else {
        return delete localStorage[key];
    }
}

Atheneum.LocalStorage.prototype.getJSON = function (key) {
    try {
        return JSON.parse(this.get(key) || 'null');
    } catch (error) {
        try{
            if (window.LZString && key.indexOf('unsyncedOfflineActionsForUser_') < 0 && key.indexOf('atheneumUserPreferences') < 0){
                let result = LZString.decompress(this.get(key));
                return JSON.parse( result || 'null');
            }   
        }catch(err){
         
        }
       
    }

    return null;
   
}

Atheneum.LocalStorage.prototype.setJSON = function (key, value) {
    return this.set(key, JSON.stringify(value));
}

/**
 * @Deprecated
 * @See Atheneum.Translation
 * Translations were implemented in a slightly different way, and this section is no longer accurate.
 * It's a bit of a shame as this is the best commented section in the entire script
 * 
 * Translations:
 * 
 * 	 Set the default text for an element, in case there is no translation template available for that key.
 *   If this is not specified, it is assumed to be the element's innerHTML when the translation is first rendered;
 * 	 data-atheneum-translation-default=""
 * 
 * 	 Attach translation keys to static text via a data attribute.
 *   This will automatically set the 'data-atheneum-translation-template' attribute to the current language's template for that key.
 * 
 * 	 	data-atheneum-translation-key="TRANSLATION_KEY_WELCOME_MESSAGE"
 * 
 * 	Alternatively, you can attach a translation template attribute to it directly.
 *	This won't update when you change languages, so you'll probably never want to do this
 *		data-atheneum-translation-template="Welcome Back!"
 * 
 * 
 * 	 Translation templates may require arguments:
 * 			eg: "Welcome Back {0}, it's been {1} days since you last logged in"
 * 
 * 	 Arguments can be specified via an array:
 *   	data-atheneum-translation-arguments="[ 'TestUser', 4 ]"
 *   
 *   Or via individual attributes:
 *   	data-atheneum-translation-arg0-value="TestUser"
 *   	data-atheneum-translation-arg1-value="4"
 *   
 *   The individual attributes take precedence over the argument array.
 *   You should not use both on the same element to avoid confusion.
 *   
 *   You can optionally name translation arguments for easier debugging and references (highly recommended)
 *   	data-atheneum-translation-arg0-name="username"
 *   
 *   Argument names must be unique for that element, and must not start with a number.
 *   Named arguments can be referenced by their names when getting / setting their values
 *   	eg: Atheneum.Translations.setElementArgument( "username", "TestUser" )
 *   
 *   For dynamic text, which depends on values which are not known at compile time:
 *   
 *   	set/update the key ( this can be done statically in the page html )
 *   	set/update the translation arguments
 *   	render the new translations
 *   
 *   Atheneum.Translations.get( key, arguments, options )
 *   
 *   Atheneum.Translations.get( "EXAMPLE_KEY", [ arg0, arg1, arg2 ], "example key" )
 *   
 *   
 *   Atheneum.Translations.Element( element );
 *   Atheneum.Translations.Element.translate( key, arguments )
 *   Atheneum.Translations.Element.translate( key, arguments, language )
 *   Atheneum.Translations.Element.getArgument( argNo )
 *   Atheneum.Translations.Element.getArgument( argName )
 *   Atheneum.Translations.Element.setArgument( argNo, value )
 *   Atheneum.Translations.Element.setArgument( argName, value )
 *   Atheneum.Translations.Element.getArgumentList( )
 *   Atheneum.Translations.Element.setArgumentList( argumentArray )
 *   Atheneum.Translations.Element.setArgumentList( argumentMap )
 *   Atheneum.Translations.Element.getTemplate( );
 *   Atheneum.Translations.Element.setTemplate( translationTemplate );
 *   Atheneum.Translations.Element.render( );
 *   Atheneum.Translations.Element.render( language );
 *   
 *   // This is the method you will normally be using.
 *   // Sets the key and arguments in one handy call, then renders it using the user's current language
 *   Atheneum.Translations.translateElement( element, key, arguments );
 *   Atheneum.Translations.translateElement( element, key, arguments, language );
 *   
 *   Atheneum.Translations.getElementArgument( element, argNo );
 *   Atheneum.Translations.setElementArgument( element, argNo, argValue );
 *   Atheneum.Translations.getElementArgumentList( );
 *   Atheneum.Translations.setElementArgumentList( [ arg0Value, arg1Value, ... ] );
 *   Atheneum.Translations.setElementArgumentList( { 0:arg0Value, 1:arg1Value, ... } );
 *   
 *   // if the arguments are named, you can also use the following:
 *   Atheneum.Translations.getElementArgument( element, argName );
 *   Atheneum.Translations.setElementArgument( element, argName, argValue );
 *   Atheneum.Translations.setElementArgumentList( { argName: argValue, ... } );
 *   
 *   // You will likely never want to call these
 *   Atheneum.Translations.setElementTemplate( element, translationTemplate );
 *   Atheneum.Translations.getElementTemplate( element );
 *   
 *   Atheneum.Translations.generateTemplate( key );
 *   Atheneum.Translations.generateTemplate( key, language );
 *   
 *   // This replaces the contents of the element with its current translation
 *   // You probably won't need to call it, as every other method calls it automatically
 *   // But if for some reason you decide to manually change the element's translation attributes, call this to update it
 *   Atheneum.Translations.renderElement( element );
 *   Atheneum.Translations.renderElement( element, language );
 *  
 *   // renders every element with a translation key or template on the page. 
 *   Atheneum.Translations.renderPage();
 *   Atheneum.Translations.renderPage( language );
 *   
 *   
 *   // the following deal with loading / saving the translation map
 *   Atheneum.Translations.saveToStorage( );
 *   Atheneum.Translations.loadFromStorage( );
 *   Atheneum.Translations.update( callback );
 *   
 *   // returns the translation map from translationKey => translationArgument
 *   // has the user's language if not specified
 *   Atheneum.Translations.getTranslationMap( );
 *   Atheneum.Translations.getTranslationMap( language );
 *   
 *   Atheneum.Translations.translationMaps
 */

Atheneum.Translations = function AtheneumTranslations(atheneum) {
    this.Atheneum = atheneum;
}

Atheneum.Translations.Element = function (element, atheneum) {

    if (!(this instanceof Atheneum.Translations.Element))
        return new Atheneum.Translations.Element(element, atheneum);

    this.element = element;
    this.Atheneum = atheneum;
}

Atheneum.Translations.prototype.Element = function AtheneumTranslationsElement(element) {
    return new Atheneum.Translations.Element(element, this.Atheneum);
}

Atheneum.Translations.Element.prototype.render = function AtheneumTranslationsElement_render(language) {

    if (language == undefined) {
        language = this.Atheneum.Language.getUserLanguage();
    } else if (typeof language === "string") {
        language = this.Atheneum.Language.prototype.getByIsoCode(language);
    }


}

Atheneum.Translations.prototype.renderPage = function (language) {
    var translatedElements = document.querySelectorAll("[data-atheneum-translation-key], [data-atheneum-translation-template], [data-atheneum-translation-default]");

    for (var i = 0; i < translatedElements.length; i++) {
        this.renderElement(translatedElements[i], language);
    }
}

/**
 * Renders the element with translated text if applicable
 * If language is not provided, uses the user's language.
 */
Atheneum.Translations.prototype.renderElement = function (element, language) {
    return this.Atheneum.Translations.Element(element).render(language);
}

Atheneum.Translations.prototype.getElementTemplate = function (element) {

    if (!(element instanceof HTMLElement))
        throw IllegalArgumentException("element must be a HTMLElement");

    return element.getAttribute("data-atheneum-translation-template");
}

Atheneum.Translations.prototype.setElementTemplate = function (element, translationTemplate) {

    if (!(element instanceof HTMLElement))
        throw IllegalArgumentException("element must be a HTMLElement");

    return element.setAttribute("data-atheneum-translation-template", translationTemplate);
}

Atheneum.prototype.Crypto = Atheneum.Crypto = {};

// Atheneum.Crypto.md5 = function( string ) { ... };
// https://github.com/blueimp/JavaScript-MD5
!function (n) { "use strict"; function t(n, t) { var r = (65535 & n) + (65535 & t), e = (n >> 16) + (t >> 16) + (r >> 16); return e << 16 | 65535 & r } function r(n, t) { return n << t | n >>> 32 - t } function e(n, e, o, u, c, f) { return t(r(t(t(e, n), t(u, f)), c), o) } function o(n, t, r, o, u, c, f) { return e(t & r | ~t & o, n, t, u, c, f) } function u(n, t, r, o, u, c, f) { return e(t & o | r & ~o, n, t, u, c, f) } function c(n, t, r, o, u, c, f) { return e(t ^ r ^ o, n, t, u, c, f) } function f(n, t, r, o, u, c, f) { return e(r ^ (t | ~o), n, t, u, c, f) } function i(n, r) { n[r >> 5] |= 128 << r % 32, n[(r + 64 >>> 9 << 4) + 14] = r; var e, i, a, h, d, l = 1732584193, g = -271733879, v = -1732584194, m = 271733878; for (e = 0; e < n.length; e += 16)i = l, a = g, h = v, d = m, l = o(l, g, v, m, n[e], 7, -680876936), m = o(m, l, g, v, n[e + 1], 12, -389564586), v = o(v, m, l, g, n[e + 2], 17, 606105819), g = o(g, v, m, l, n[e + 3], 22, -1044525330), l = o(l, g, v, m, n[e + 4], 7, -176418897), m = o(m, l, g, v, n[e + 5], 12, 1200080426), v = o(v, m, l, g, n[e + 6], 17, -1473231341), g = o(g, v, m, l, n[e + 7], 22, -45705983), l = o(l, g, v, m, n[e + 8], 7, 1770035416), m = o(m, l, g, v, n[e + 9], 12, -1958414417), v = o(v, m, l, g, n[e + 10], 17, -42063), g = o(g, v, m, l, n[e + 11], 22, -1990404162), l = o(l, g, v, m, n[e + 12], 7, 1804603682), m = o(m, l, g, v, n[e + 13], 12, -40341101), v = o(v, m, l, g, n[e + 14], 17, -1502002290), g = o(g, v, m, l, n[e + 15], 22, 1236535329), l = u(l, g, v, m, n[e + 1], 5, -165796510), m = u(m, l, g, v, n[e + 6], 9, -1069501632), v = u(v, m, l, g, n[e + 11], 14, 643717713), g = u(g, v, m, l, n[e], 20, -373897302), l = u(l, g, v, m, n[e + 5], 5, -701558691), m = u(m, l, g, v, n[e + 10], 9, 38016083), v = u(v, m, l, g, n[e + 15], 14, -660478335), g = u(g, v, m, l, n[e + 4], 20, -405537848), l = u(l, g, v, m, n[e + 9], 5, 568446438), m = u(m, l, g, v, n[e + 14], 9, -1019803690), v = u(v, m, l, g, n[e + 3], 14, -187363961), g = u(g, v, m, l, n[e + 8], 20, 1163531501), l = u(l, g, v, m, n[e + 13], 5, -1444681467), m = u(m, l, g, v, n[e + 2], 9, -51403784), v = u(v, m, l, g, n[e + 7], 14, 1735328473), g = u(g, v, m, l, n[e + 12], 20, -1926607734), l = c(l, g, v, m, n[e + 5], 4, -378558), m = c(m, l, g, v, n[e + 8], 11, -2022574463), v = c(v, m, l, g, n[e + 11], 16, 1839030562), g = c(g, v, m, l, n[e + 14], 23, -35309556), l = c(l, g, v, m, n[e + 1], 4, -1530992060), m = c(m, l, g, v, n[e + 4], 11, 1272893353), v = c(v, m, l, g, n[e + 7], 16, -155497632), g = c(g, v, m, l, n[e + 10], 23, -1094730640), l = c(l, g, v, m, n[e + 13], 4, 681279174), m = c(m, l, g, v, n[e], 11, -358537222), v = c(v, m, l, g, n[e + 3], 16, -722521979), g = c(g, v, m, l, n[e + 6], 23, 76029189), l = c(l, g, v, m, n[e + 9], 4, -640364487), m = c(m, l, g, v, n[e + 12], 11, -421815835), v = c(v, m, l, g, n[e + 15], 16, 530742520), g = c(g, v, m, l, n[e + 2], 23, -995338651), l = f(l, g, v, m, n[e], 6, -198630844), m = f(m, l, g, v, n[e + 7], 10, 1126891415), v = f(v, m, l, g, n[e + 14], 15, -1416354905), g = f(g, v, m, l, n[e + 5], 21, -57434055), l = f(l, g, v, m, n[e + 12], 6, 1700485571), m = f(m, l, g, v, n[e + 3], 10, -1894986606), v = f(v, m, l, g, n[e + 10], 15, -1051523), g = f(g, v, m, l, n[e + 1], 21, -2054922799), l = f(l, g, v, m, n[e + 8], 6, 1873313359), m = f(m, l, g, v, n[e + 15], 10, -30611744), v = f(v, m, l, g, n[e + 6], 15, -1560198380), g = f(g, v, m, l, n[e + 13], 21, 1309151649), l = f(l, g, v, m, n[e + 4], 6, -145523070), m = f(m, l, g, v, n[e + 11], 10, -1120210379), v = f(v, m, l, g, n[e + 2], 15, 718787259), g = f(g, v, m, l, n[e + 9], 21, -343485551), l = t(l, i), g = t(g, a), v = t(v, h), m = t(m, d); return [l, g, v, m] } function a(n) { var t, r = ""; for (t = 0; t < 32 * n.length; t += 8)r += String.fromCharCode(n[t >> 5] >>> t % 32 & 255); return r } function h(n) { var t, r = []; for (r[(n.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1)r[t] = 0; for (t = 0; t < 8 * n.length; t += 8)r[t >> 5] |= (255 & n.charCodeAt(t / 8)) << t % 32; return r } function d(n) { return a(i(h(n), 8 * n.length)) } function l(n, t) { var r, e, o = h(n), u = [], c = []; for (u[15] = c[15] = void 0, o.length > 16 && (o = i(o, 8 * n.length)), r = 0; 16 > r; r += 1)u[r] = 909522486 ^ o[r], c[r] = 1549556828 ^ o[r]; return e = i(u.concat(h(t)), 512 + 8 * t.length), a(i(c.concat(e), 640)) } function g(n) { var t, r, e = "0123456789abcdef", o = ""; for (r = 0; r < n.length; r += 1)t = n.charCodeAt(r), o += e.charAt(t >>> 4 & 15) + e.charAt(15 & t); return o } function v(n) { return unescape(encodeURIComponent(n)) } function m(n) { return d(v(n)) } function p(n) { return g(m(n)) } function s(n, t) { return l(v(n), v(t)) } function C(n, t) { return g(s(n, t)) } n.md5 = function A(n, t, r) { return t ? r ? s(t, n) : C(t, n) : r ? m(n) : p(n) } }(Atheneum.Crypto);

Atheneum.Crypto.hash = function (data, salt) {

    if (data === null || data === undefined)
        throw new IllegalArgumentException("data is null or undefined");

    if (window.sha256 && window.sha256.create)
        return this.sha256(data + 'ceb20772e0c9d240c75eb26b0e37abee' + salt);
    else
        return this.md5(data + 'ceb20772e0c9d240c75eb26b0e37abee' + salt);
}

/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
!function () { "use strict"; function t(t, i) { i ? (d[0] = d[16] = d[1] = d[2] = d[3] = d[4] = d[5] = d[6] = d[7] = d[8] = d[9] = d[10] = d[11] = d[12] = d[13] = d[14] = d[15] = 0, this.blocks = d) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], t ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = t } function i(i, r, s) { var e, n = typeof i; if ("string" === n) { var o, a = [], u = i.length, c = 0; for (e = 0; e < u; ++e)(o = i.charCodeAt(e)) < 128 ? a[c++] = o : o < 2048 ? (a[c++] = 192 | o >> 6, a[c++] = 128 | 63 & o) : o < 55296 || o >= 57344 ? (a[c++] = 224 | o >> 12, a[c++] = 128 | o >> 6 & 63, a[c++] = 128 | 63 & o) : (o = 65536 + ((1023 & o) << 10 | 1023 & i.charCodeAt(++e)), a[c++] = 240 | o >> 18, a[c++] = 128 | o >> 12 & 63, a[c++] = 128 | o >> 6 & 63, a[c++] = 128 | 63 & o); i = a } else { if ("object" !== n) throw new Error(h); if (null === i) throw new Error(h); if (f && i.constructor === ArrayBuffer) i = new Uint8Array(i); else if (!(Array.isArray(i) || f && ArrayBuffer.isView(i))) throw new Error(h) } i.length > 64 && (i = new t(r, !0).update(i).array()); var y = [], p = []; for (e = 0; e < 64; ++e) { var l = i[e] || 0; y[e] = 92 ^ l, p[e] = 54 ^ l } t.call(this, r, s), this.update(p), this.oKeyPad = y, this.inner = !0, this.sharedMemory = s } var h = "input is invalid type", r = "object" == typeof window, s = r ? window : {}; s.JS_SHA256_NO_WINDOW && (r = !1); var e = !r && "object" == typeof self, n = !s.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node; n ? s = global : e && (s = self); var o = !s.JS_SHA256_NO_COMMON_JS && "object" == typeof module && module.exports, a = "function" == typeof define && define.amd, f = !s.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, u = "0123456789abcdef".split(""), c = [-2147483648, 8388608, 32768, 128], y = [24, 16, 8, 0], p = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], l = ["hex", "array", "digest", "arrayBuffer"], d = []; !s.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (t) { return "[object Array]" === Object.prototype.toString.call(t) }), !f || !s.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (t) { return "object" == typeof t && t.buffer && t.buffer.constructor === ArrayBuffer }); var A = function (i, h) { return function (r) { return new t(h, !0).update(r)[i]() } }, w = function (i) { var h = A("hex", i); n && (h = b(h, i)), h.create = function () { return new t(i) }, h.update = function (t) { return h.create().update(t) }; for (var r = 0; r < l.length; ++r) { var s = l[r]; h[s] = A(s, i) } return h }, b = function (t, i) { var r = eval("require('crypto')"), s = eval("require('buffer').Buffer"), e = i ? "sha224" : "sha256", n = function (i) { if ("string" == typeof i) return r.createHash(e).update(i, "utf8").digest("hex"); if (null === i || void 0 === i) throw new Error(h); return i.constructor === ArrayBuffer && (i = new Uint8Array(i)), Array.isArray(i) || ArrayBuffer.isView(i) || i.constructor === s ? r.createHash(e).update(new s(i)).digest("hex") : t(i) }; return n }, v = function (t, h) { return function (r, s) { return new i(r, h, !0).update(s)[t]() } }, _ = function (t) { var h = v("hex", t); h.create = function (h) { return new i(h, t) }, h.update = function (t, i) { return h.create(t).update(i) }; for (var r = 0; r < l.length; ++r) { var s = l[r]; h[s] = v(s, t) } return h }; t.prototype.update = function (t) { if (!this.finalized) { var i, r = typeof t; if ("string" !== r) { if ("object" !== r) throw new Error(h); if (null === t) throw new Error(h); if (f && t.constructor === ArrayBuffer) t = new Uint8Array(t); else if (!(Array.isArray(t) || f && ArrayBuffer.isView(t))) throw new Error(h); i = !0 } for (var s, e, n = 0, o = t.length, a = this.blocks; n < o;) { if (this.hashed && (this.hashed = !1, a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0), i) for (e = this.start; n < o && e < 64; ++n)a[e >> 2] |= t[n] << y[3 & e++]; else for (e = this.start; n < o && e < 64; ++n)(s = t.charCodeAt(n)) < 128 ? a[e >> 2] |= s << y[3 & e++] : s < 2048 ? (a[e >> 2] |= (192 | s >> 6) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]) : s < 55296 || s >= 57344 ? (a[e >> 2] |= (224 | s >> 12) << y[3 & e++], a[e >> 2] |= (128 | s >> 6 & 63) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]) : (s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(++n)), a[e >> 2] |= (240 | s >> 18) << y[3 & e++], a[e >> 2] |= (128 | s >> 12 & 63) << y[3 & e++], a[e >> 2] |= (128 | s >> 6 & 63) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]); this.lastByteIndex = e, this.bytes += e - this.start, e >= 64 ? (this.block = a[16], this.start = e - 64, this.hash(), this.hashed = !0) : this.start = e } return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this } }, t.prototype.finalize = function () { if (!this.finalized) { this.finalized = !0; var t = this.blocks, i = this.lastByteIndex; t[16] = this.block, t[i >> 2] |= c[3 & i], this.block = t[16], i >= 56 && (this.hashed || this.hash(), t[0] = this.block, t[16] = t[1] = t[2] = t[3] = t[4] = t[5] = t[6] = t[7] = t[8] = t[9] = t[10] = t[11] = t[12] = t[13] = t[14] = t[15] = 0), t[14] = this.hBytes << 3 | this.bytes >>> 29, t[15] = this.bytes << 3, this.hash() } }, t.prototype.hash = function () { var t, i, h, r, s, e, n, o, a, f = this.h0, u = this.h1, c = this.h2, y = this.h3, l = this.h4, d = this.h5, A = this.h6, w = this.h7, b = this.blocks; for (t = 16; t < 64; ++t)i = ((s = b[t - 15]) >>> 7 | s << 25) ^ (s >>> 18 | s << 14) ^ s >>> 3, h = ((s = b[t - 2]) >>> 17 | s << 15) ^ (s >>> 19 | s << 13) ^ s >>> 10, b[t] = b[t - 16] + i + b[t - 7] + h << 0; for (a = u & c, t = 0; t < 64; t += 4)this.first ? (this.is224 ? (e = 300032, w = (s = b[0] - 1413257819) - 150054599 << 0, y = s + 24177077 << 0) : (e = 704751109, w = (s = b[0] - 210244248) - 1521486534 << 0, y = s + 143694565 << 0), this.first = !1) : (i = (f >>> 2 | f << 30) ^ (f >>> 13 | f << 19) ^ (f >>> 22 | f << 10), r = (e = f & u) ^ f & c ^ a, w = y + (s = w + (h = (l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & d ^ ~l & A) + p[t] + b[t]) << 0, y = s + (i + r) << 0), i = (y >>> 2 | y << 30) ^ (y >>> 13 | y << 19) ^ (y >>> 22 | y << 10), r = (n = y & f) ^ y & u ^ e, A = c + (s = A + (h = (w >>> 6 | w << 26) ^ (w >>> 11 | w << 21) ^ (w >>> 25 | w << 7)) + (w & l ^ ~w & d) + p[t + 1] + b[t + 1]) << 0, i = ((c = s + (i + r) << 0) >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), r = (o = c & y) ^ c & f ^ n, d = u + (s = d + (h = (A >>> 6 | A << 26) ^ (A >>> 11 | A << 21) ^ (A >>> 25 | A << 7)) + (A & w ^ ~A & l) + p[t + 2] + b[t + 2]) << 0, i = ((u = s + (i + r) << 0) >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), r = (a = u & c) ^ u & y ^ o, l = f + (s = l + (h = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7)) + (d & A ^ ~d & w) + p[t + 3] + b[t + 3]) << 0, f = s + (i + r) << 0; this.h0 = this.h0 + f << 0, this.h1 = this.h1 + u << 0, this.h2 = this.h2 + c << 0, this.h3 = this.h3 + y << 0, this.h4 = this.h4 + l << 0, this.h5 = this.h5 + d << 0, this.h6 = this.h6 + A << 0, this.h7 = this.h7 + w << 0 }, t.prototype.hex = function () { this.finalize(); var t = this.h0, i = this.h1, h = this.h2, r = this.h3, s = this.h4, e = this.h5, n = this.h6, o = this.h7, a = u[t >> 28 & 15] + u[t >> 24 & 15] + u[t >> 20 & 15] + u[t >> 16 & 15] + u[t >> 12 & 15] + u[t >> 8 & 15] + u[t >> 4 & 15] + u[15 & t] + u[i >> 28 & 15] + u[i >> 24 & 15] + u[i >> 20 & 15] + u[i >> 16 & 15] + u[i >> 12 & 15] + u[i >> 8 & 15] + u[i >> 4 & 15] + u[15 & i] + u[h >> 28 & 15] + u[h >> 24 & 15] + u[h >> 20 & 15] + u[h >> 16 & 15] + u[h >> 12 & 15] + u[h >> 8 & 15] + u[h >> 4 & 15] + u[15 & h] + u[r >> 28 & 15] + u[r >> 24 & 15] + u[r >> 20 & 15] + u[r >> 16 & 15] + u[r >> 12 & 15] + u[r >> 8 & 15] + u[r >> 4 & 15] + u[15 & r] + u[s >> 28 & 15] + u[s >> 24 & 15] + u[s >> 20 & 15] + u[s >> 16 & 15] + u[s >> 12 & 15] + u[s >> 8 & 15] + u[s >> 4 & 15] + u[15 & s] + u[e >> 28 & 15] + u[e >> 24 & 15] + u[e >> 20 & 15] + u[e >> 16 & 15] + u[e >> 12 & 15] + u[e >> 8 & 15] + u[e >> 4 & 15] + u[15 & e] + u[n >> 28 & 15] + u[n >> 24 & 15] + u[n >> 20 & 15] + u[n >> 16 & 15] + u[n >> 12 & 15] + u[n >> 8 & 15] + u[n >> 4 & 15] + u[15 & n]; return this.is224 || (a += u[o >> 28 & 15] + u[o >> 24 & 15] + u[o >> 20 & 15] + u[o >> 16 & 15] + u[o >> 12 & 15] + u[o >> 8 & 15] + u[o >> 4 & 15] + u[15 & o]), a }, t.prototype.toString = t.prototype.hex, t.prototype.digest = function () { this.finalize(); var t = this.h0, i = this.h1, h = this.h2, r = this.h3, s = this.h4, e = this.h5, n = this.h6, o = this.h7, a = [t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n]; return this.is224 || a.push(o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o), a }, t.prototype.array = t.prototype.digest, t.prototype.arrayBuffer = function () { this.finalize(); var t = new ArrayBuffer(this.is224 ? 28 : 32), i = new DataView(t); return i.setUint32(0, this.h0), i.setUint32(4, this.h1), i.setUint32(8, this.h2), i.setUint32(12, this.h3), i.setUint32(16, this.h4), i.setUint32(20, this.h5), i.setUint32(24, this.h6), this.is224 || i.setUint32(28, this.h7), t }, i.prototype = new t, i.prototype.finalize = function () { if (t.prototype.finalize.call(this), this.inner) { this.inner = !1; var i = this.array(); t.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(i), t.prototype.finalize.call(this) } }; var B = w(); B.sha256 = B, B.sha224 = w(!0), B.sha256.hmac = _(), B.sha224.hmac = _(!0), o ? module.exports = B : (s.sha256 = B.sha256, s.sha224 = B.sha224, a && define(function () { return B })) }();

Atheneum.Crypto.sha256 = function (data) {
    var hash = window.sha256.create();
    hash.update(data);
    return hash.hex();
}

// xors two hexadecimal strings together

Atheneum.Crypto.xor = function (string1, string2) {
    if (string2 == '') {
        return string1;
    }
    if (string1 == '') {
        return string2;
    }
    while (string1.length > string2.length) {
        string2 += string2;
    }
    var output = '';
    for (var i = 0; i < string1.length; i++) {
        var c1 = string1.charAt(i);
        var c2 = string2.charAt(i);
        var xorc = parseInt(c1, 16) ^ parseInt(c2, 16);
        output += xorc.toString(16);
    }
    return output;
}

/**
 * Tracking what the user views so pretty charts can be made later
 */
Atheneum.Tracking = function AtheneumTracking(atheneum) {

    if (!(this instanceof Atheneum.Tracking)) {
        return new Atheneum.Tracking(atheneum);
    }

    this.Atheneum = atheneum;
    this.trackedViews = {};

    if (document != null && document.body != null) {

        if (this.Atheneum.CrossPlatform.enabled && this.Atheneum.CrossPlatform.isIOS()) {
            window.addEventListener('pagehide', function () {
                console.log("pagehide works!");
                if (SalesToolkit.Theme.getBooleanProperty('allowIgnoreUpdates', false) && SalesToolkit.LocalStorage.db && window.location.href.indexOf("login") < 0 && window.location.href.indexOf("index") < 0 && window.location.pathname != "/")
                    localStorage["doNotServerUpdate"] = true;
                atheneum.Tracking.unloadCallback();
               
            });
        } else {
            window.addEventListener('beforeunload', function logData() {
                console.log("beforeunload works!");
                if (SalesToolkit.Theme.getBooleanProperty('allowIgnoreUpdates', false) && SalesToolkit.LocalStorage.db && window.location.href.indexOf("login") < 0 && window.location.href.indexOf("index") < 0 && window.location.pathname != "/"){
                    
                    if (!window.forceLibraryUpdate){
                        localStorage["doNotServerUpdate"] = true;
                    } else {
                        localStorage.removeItem("doNotServerUpdate");
                        window.forceLibraryUpdate = false;
                    }

                }
                    
                atheneum.Tracking.unloadCallback();
                
            });
        }
    }
}

Atheneum.Tracking.prototype.Status = Atheneum.Tracking.Status = { ONLINE: "ONLINE", OFFLINE: "OFFLINE" };

Atheneum.Tracking.prototype.Type = Atheneum.Tracking.Type = { PLUGIN: "PLUGIN", COLLECTION: "COLLECTION", ASSET: "ASSET", APP: "APP", PRESENTATION : "PRESENTATION" };

Atheneum.Tracking.prototype.PluginSubtype = Atheneum.Tracking.PluginSubtype = { OPENED: "PLUGIN_OPENED", CLOSED: "PLUGIN_CLOSED", CONTENT_INTERACTION: "PLUGIN_CONTENT_INTERACTION" };

Atheneum.Tracking.prototype.AppSubtype = Atheneum.Tracking.AppSubtype = { FOREGROUND: "SWITCHED_TO_FOREGROUND", BACKGROUND: "SWITCHED_TO_BACKGROUND", AUTO_LOGIN:"AUTO_LOGIN", CONTENT_INTERACTION: "APP_CONTENT_INTERACTION", MESSAGE_RECEIVED: "SOCKET_MESSAGE_RECEIVED"};

Atheneum.Tracking.prototype.TrackingProperties = Atheneum.Tracking.TrackingProperties = { JS_EVENT_TYPE: "eventType", ELEMENT_ID: "eventTarget", JS_EVENT_LOC: "eventLocation" };

Atheneum.Tracking.prototype.PresentationSubtype = Atheneum.Tracking.PresentationSubtype = { OPENED: "PRESENTATION_OPENED", CLOSED: "PRESENTATION_CLOSED", CONTENT_INTERACTION: "PRESENTATION_CONTENT_INTERACTION" };

Atheneum.Tracking.prototype.trackGeneric = function (eventProperties, type, subtype, entity, status, timestamp, callback) {

    //Workaround for servers that don't have generic tracking setup
    if (this.Atheneum && this.Atheneum.Theme && !this.Atheneum.Theme.getBooleanProperty('allowGenericTracking', false)) {
        return;
    }

    if (typeof status !== "string")
        throw new IllegalArgumentException("status is required and must be a string, and must be either \"ONLINE\" or \"OFFLINE\"");


    if (timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if ((status === Atheneum.Tracking.Status.OFFLINE && typeof timestamp === "undefined")
        || (typeof timestamp !== "undefined" && typeof timestamp !== "number")) {
        throw new IllegalArgumentException("timestamp is required when state is \"OFFLINE\", and must be a long or a Date");
    }

    var parsedCallbacks = Atheneum.Callbacks.parse(callback)
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;


    if (timestamp == undefined)
        timestamp = new Date().getTime();

    if (typeof timestamp === "object" && timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if (typeof timestamp !== "number")
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    if (Math.floor(timestamp) != timestamp)
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    var atheneum = this.Atheneum;

    var data = {
        type: type,
        subtype: subtype,
        eventProperties: eventProperties,
        timestamp: timestamp
    };

    if (entity) {
        data.entity = entity;
    }



    this.Atheneum.API.trackGeneric(data, this.Status.ONLINE, timestamp, {

        success: function (json) {
            successCallback();
        },

        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                atheneum.Offline.recordUnsynchedAction({
                    name: "tracking",
                    data: data
                });

                return successCallback({ errorCode: 0 });
            }
            return failureCallback(reason, httpStatus, errorCode, "Atheneum.Tracking.trackGeneric");
        }
    });
    //}


}

Atheneum.Tracking.prototype.trackCollectionView = function (collectionId, duration, timestamp, sessionId, callback) {

    if (arguments.length == 4 && (typeof sessionId === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = sessionId;
        sessionId = undefined;
    }

    if (arguments.length == 3 && (typeof timestamp === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = timestamp;
        timestamp = undefined;
        sessionId = undefined
    }

    var parsedCallbacks = Atheneum.Callbacks.parse(callback)
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;

    if (sessionId == undefined && arguments.length <= 4 && typeof this.Atheneum.Session !== 'undefined') {
        sessionId = this.Atheneum.Session.sessionId || undefined;
    }

    if (timestamp == undefined)
        timestamp = new Date().getTime();

    if (typeof timestamp === "object" && timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if (typeof timestamp !== "number")
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    if (Math.floor(timestamp) != timestamp)
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    var atheneum = this.Atheneum;

    if(SalesToolkit.Theme.getBooleanProperty('delayCollectionTrackingToTransactions', false)){

            atheneum.Offline.recordUnsynchedAction({
                    name: "tracking",
                    timestamp: timestamp,
                    duration: duration,
                    collectionId: collectionId
                });

                return successCallback({ errorCode: 0 });
    }


    this.Atheneum.API.trackCollectionView(collectionId, duration, this.Status.ONLINE, timestamp, sessionId, {

        success: successCallback,

        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                 atheneum.Offline.recordUnsynchedAction({
                    name: "tracking",
                    timestamp: timestamp,
                    duration: duration,
                    collectionId: collectionId
                });

                return successCallback({ errorCode: 0 });
            }
            return failureCallback(reason, httpStatus, errorCode, "Atheneum.Tracking.trackCollectionView");
        }
    });
}

Atheneum.Tracking.prototype.trackAssetView = function (assetId, duration, timestamp, sessionId, callback) {

    if (arguments.length == 4 && (typeof sessionId === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = sessionId;
        sessionId = undefined;
    }

    if (arguments.length == 3 && (typeof timestamp === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = timestamp;
        timestamp = undefined;
        sessionId = undefined
    }

    var asset = this.Atheneum.Library.assets[assetId];
    if (!asset || !asset.containedBy)
        return;

    var collectionId = asset.containedBy;

    var parsedCallbacks = Atheneum.Callbacks.parse(callback)
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;

    if (sessionId == undefined && arguments.length <= 4 && typeof this.Atheneum.Session !== 'undefined') {
        sessionId = this.Atheneum.Session.sessionId || undefined;
    }


    if (timestamp == undefined)
        timestamp = new Date().getTime();

    if (typeof timestamp === "object" && timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if (typeof timestamp !== "number")
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    if (Math.floor(timestamp) != timestamp)
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    var atheneum = this.Atheneum;

    if(atheneum.Theme.getBooleanProperty('delayAssetViewTrackingToTransaction', false)){
         //Just create the offline as this may be causing duplicates otherwise
        atheneum.Offline.recordUnsynchedAction({
                        name: "tracking",
                        timestamp: timestamp,
                        duration: duration,
                        collectionId: collectionId,
                        assetId: assetId,
                        sessionId: sessionId
                    });
         return successCallback({ errorCode: 0 });
    }
   

    this.Atheneum.API.trackAssetView(collectionId, assetId, duration, this.Status.ONLINE, timestamp, sessionId, {

        success: successCallback,

        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                atheneum.Offline.recordUnsynchedAction({
                    name: "tracking",
                    timestamp: timestamp,
                    duration: duration,
                    collectionId: collectionId,
                    assetId: assetId,
                    sessionId: sessionId
                });

                return successCallback({ errorCode: 0 });
            }
            return failureCallback(reason, httpStatus, errorCode, "Atheneum.Tracking.trackAssetView");
        }
    });
    
}

Atheneum.Tracking.prototype.trackNewsItemView = function (newsItemId, duration, timestamp, sessionId, callback) {

    if (arguments.length == 4 && (typeof sessionId === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = sessionId;
        sessionId = undefined;
    }

    if (arguments.length == 3 && (typeof timestamp === "function"
        || (typeof timestamp === "object" && !(timestamp instanceof Date)))) {
        callback = timestamp;
        timestamp = undefined;
        sessionId = undefined
    }

    var parsedCallbacks = Atheneum.Callbacks.parse(callback)
    var successCallback = parsedCallbacks.success;
    var failureCallback = parsedCallbacks.failure;

    if (sessionId == undefined && arguments.length <= 4 && typeof this.Atheneum.Session !== 'undefined') {
        sessionId = this.Atheneum.Session.sessionId || undefined;
    }

    if (timestamp == undefined)
        timestamp = new Date().getTime();

    if (typeof timestamp === "object" && timestamp instanceof Date)
        timestamp = timestamp.getTime();

    if (typeof timestamp !== "number")
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    if (Math.floor(timestamp) != timestamp)
        throw new IllegalArgumentException("timestamp must be a Date or a long, or undefined")

    var atheneum = this.Atheneum;

    this.Atheneum.API.trackNewsItemView(newsItemId, duration, this.Status.ONLINE, timestamp, sessionId, {

        success: successCallback,

        failure: function (reason, httpStatus, errorCode) {

            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                atheneum.Offline.recordUnsynchedAction({
                    name: "tracking",
                    timestamp: timestamp,
                    duration: duration,
                    newsItemId: newsItemId,
                    sessionId: sessionId
                });

                return successCallback({ errorCode: 0 });
            }
            return failureCallback(reason, httpStatus, errorCode, "Atheneum.Tracking.trackNewsItemView");
        }
    });
}

Atheneum.Tracking.prototype.ViewTypes = Atheneum.Tracking.ViewTypes = {
    COLLECTION: "collection",
    ASSET: "asset",
    NEWS_ITEM: "newsItem"
}

Atheneum.Tracking.prototype.start = function (viewType, itemId, callback) {

    var trackId = viewType + "-" + itemId;

    var trackedItem = {};
    if (this.trackedViews.hasOwnProperty(trackId)) {
        trackedItem = this.trackedViews[trackId];
    }

    trackedItem.trackingId = crypto.randomUUID();
    trackedItem.viewType = viewType;
    trackedItem.itemId = itemId;
    trackedItem.callback = callback;
    trackedItem.startTime = new Date().getTime();
    trackedItem.originalAPIKey = this.Atheneum.User.apikey;
    this.trackedViews[trackId] = trackedItem;

    return trackedItem;
}

Atheneum.Tracking.prototype.startTrackingCollectionView = function (collectionId, callback) {
    return this.start(Atheneum.Tracking.ViewTypes.COLLECTION, collectionId, callback);
}
Atheneum.Tracking.prototype.startTrackingAssetView = function (assetId, callback) {
    return this.start(Atheneum.Tracking.ViewTypes.ASSET, assetId, callback);
}
Atheneum.Tracking.prototype.startTrackingNewsItemView = function (newsItemId, callback) {
    return this.start(Atheneum.Tracking.ViewTypes.NEWS_ITEM, newsItemId, callback);
}

// TODO: maybe add a "heartbeat" so we can detect a browser close

/** 
 * Atheneum.Tracking.finish( trackedView );
 * Atheneum.Tracking.finish( viewType, itemId );
 */
Atheneum.Tracking.prototype.finish = function (viewType, itemId) {
    console.log("atheneum tracking called: " + viewType);

    var trackedView;
    if (typeof viewType === "object" && viewType.hasOwnProperty("viewType")) {
        trackedView = viewType;
        viewType = trackedView.viewType;
        itemId = trackedView.itemId;
    } else if (typeof viewType === "string" && typeof itemId === "string") {
        trackedView = this.trackedViews[viewType + "-" + itemId];
    } else {
        throw new IllegalArgumentException("expected ( Object trackedView ) or ( String viewType, String itemId ). Got " + typeof (viewType));
    }

    if(Object.values(this.trackedViews).filter(x=> x.trackingId === trackedView.trackingId).length == 0)
        return;    

    if (typeof trackedView !== "undefined") {

        if(this.trackedViews)

        var currentTime = new Date().getTime();
        var duration = currentTime - trackedView.startTime;
        if (duration > 200) {

            console.log(itemId + " was viewed for " + Math.round(duration / 1000) + "s");

            if (trackedView.viewType == this.ViewTypes.COLLECTION)
                this.trackCollectionView(itemId, duration, currentTime, trackedView.callback);

            else if (trackedView.viewType == this.ViewTypes.ASSET)
                this.trackAssetView(itemId, duration, currentTime, trackedView.callback);

            else if (trackedView.viewType == this.ViewTypes.NEWS_ITEM)
                this.trackNewsItemView(itemId, duration, currentTime, trackedView.callback);

            else
                console.log(viewType + " is not a recognised viewType");
        }

        delete this.trackedViews[viewType + "-" + itemId];
    }
}

Atheneum.Tracking.prototype.unloadCallback = function () {
    //console.log("unload callback called");
    Atheneum.HttpUtils.async = false;
    for (var prop in this.trackedViews) {
        if (this.trackedViews.hasOwnProperty(prop)) {
            this.finish(this.trackedViews[prop]);
        }
    }
    Atheneum.HttpUtils.async = true;
    //console.log("unload callback finished");
};

Atheneum.Forms = function (atheneum) {

    if (!(this instanceof Atheneum.Forms))
        return new Atheneum.Forms(atheneum);

    this.Atheneum = atheneum;

    this.formList = {};
    this.loadFromStorage();
}

Atheneum.Forms.prototype.Types = Atheneum.Forms.Types = {
    GENERIC: "GENERIC",
    CONSENT: "CONSENT",
    REMOTE_CONSENT: "REMOTE_CONSENT",
    NOTES: "NOTES",
    SHARE: "VEND",
    SELF_REGISTRATION: "SELF_REGISTRATION",
    CREATE_MEETING: "CREATE_MEETING",
    CERTIFICATION: "CERTIFICATION",
    REMOTE: "REMOTE",
    MLR_REVIEW: "MLR_REVIEW",
    REGISTER_INTEREST: "REGISTER_INTEREST",
    CART_SHARE: "CART_SHARE",
    SIGN_UP: "SIGNUP",
};

Atheneum.Forms.prototype.saveToStorage = function () {
    this.Atheneum.LocalStorage.setJSON("atheneumFormList", this.formList);
    if(this.userDetails)
        this.Atheneum.LocalStorage.setJSON("atheneumFormPrefill", this.userDetails); 
    else 
        this.Atheneum.LocalStorage.clear("atheneumFormPrefill");
}

Atheneum.Forms.prototype.loadFromStorage = function () {
    this.formList = this.Atheneum.LocalStorage.getJSON('atheneumFormList') || {};
    this.userDetails = this.Atheneum.LocalStorage.getJSON('atheneumFormPrefill') || undefined;
}

Atheneum.Forms.prototype.preloadUserDetails = async function(userDetailsObj) {
    if(!userDetailsObj.hasOwnProperty('resourceCentreFormPrefill')){
        return false;
    }
    let atheneum = this.Atheneum;
    this.userDetails = userDetailsObj;

    this.saveToStorage();

    this.deleteAssetTimers();

    if(typeof updateFormHistoryLink === 'function')
        updateFormHistoryLink();
    
    return true;
}

Atheneum.Forms.prototype.deleteAssetTimers = function(){
    Object.keys(localStorage)
 .filter(x =>
    x.startsWith('assetTimerFinished_'))
 .forEach(x => 
    localStorage.removeItem(x));

}

Atheneum.Forms.prototype.unloadUserDetails = function() {
    try{
        this.Atheneum.User.endVisit();
        this.Atheneum.User.startVisit();

        delete this.userDetails;
        this.saveToStorage();

        if(typeof updateFormHistoryLink === 'function')
            updateFormHistoryLink();

        this.Atheneum.Session.end();
        
    }catch(err){

    }
}

/** Updates the formList with the latest forms from the server */
Atheneum.Forms.prototype.update = function (callbacks) {

    var atheneum = this.Atheneum;
    callbacks = callbacks || {};

    return this.Atheneum.API.getAllForms({

        success: function (json) {
            atheneum.Forms.formList = {};
            if (json.forms) {
                for (var i = 0; i < json.forms.length; i++) {
                    atheneum.Forms.formList[json.forms[i].id || null] = json.forms[i];
                }
            }
            atheneum.Forms.saveToStorage();

            if (typeof callbacks.success === 'function')
                callbacks.success(json);
        },

        failure: function (reason, httpStatus, errorCode) {

            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Forms.update");

            if (typeof callbacks.failure === 'function')
                callbacks.failure(reason, httpStatus, errorCode, "Atheneum.Forms.update");
        },

        offline: callbacks.offline || function (reason, httpStatus, errorCode) { }
    });
}

/**
 * Returns a list of generic forms associated with no collection.<br>
 * In other words, returns all the forms you'd expect to see at the home screen.
 * 
 * @returns {Array}
 */
Atheneum.Forms.prototype.getHomeScreenForms = function () {
    return this.getGenericAndConsentFormsInCollection(null);
}

/**
 * Returns the form with the specified id, or null if no such form exists
 * 
 * @param {String} formId - the id of the form to retrieve
 * @returns {Form}
 */
Atheneum.Forms.prototype.getFormById = function (formId) {
    return this.formList[formId] || null;
}

/** Returns the Notes Form associated with the item (if any) */
Atheneum.Forms.prototype.getNotesForm = function (item) {

    if (item == null) {
        return null;
    }
    else if (typeof item === 'object' && item.id != undefined) {
        id = item.id;
    }
    else if (typeof item === 'string' && item.trim().length > 0) {
        id = item;
    }
    else {
        throw IllegalArgumentException("expected an id string or an asset/collection");
    }

    for (var i in this.formList) {

        if (!this.formList.hasOwnProperty(i))
            continue;

        if (this.formList[i].type == this.Atheneum.Forms.Types.NOTES
            && (this.formList[i].items && (id in this.formList[i].items))
            && this.Atheneum.User.canSee(this.formList[i])) {

            return this.formList[i];
        }
    }

    return null;
}

/** Returns the Cerftification Form associated with the item (if any) */
Atheneum.Forms.prototype.getCertificationForm = function (item) {
    if (item == null) {
        return null;
    }
    else if (typeof item === 'object' && item.id != undefined) {
        id = item.id;
    }
    else if (typeof item === 'string' && item.trim().length > 0) {
        id = item;
    }
    else {
        throw IllegalArgumentException("expected an id string or an asset/collection");
    }
    for (var i in this.formList) {

        if (!this.formList.hasOwnProperty(i))
            continue;

        if (this.formList[i].type == this.Atheneum.Forms.Types.CERTIFICATION
            && this.formList[i].items && this.formList[i].items.contains(id)) {
            return this.formList[i];

        }
    }

    if (this.Atheneum.Library
        && this.Atheneum.Library.assets
        && this.Atheneum.Library.collections) {
        // if asset, check for certification form of parent collection
        var asset = this.Atheneum.Library.assets[id];
        if (asset && asset.containedBy) {
            var collection = this.Atheneum.Library.collections[asset.containedBy];
            if (collection) {
                var parentForm = this.getCertificationForm(collection);
                if (parentForm
                    && parentForm.properties
                    && parentForm.properties.generic
                    && (parentForm.properties.generic.toLowerCase().trim() == 'on'
                        || parentForm.properties.generic.toLowerCase().trim() == 'true'
                        || parentForm.properties.generic.toLowerCase().trim() == 'yes')) {
                    return null;
                }
                return parentForm;
            }
        }
    }

    return null;
}

Atheneum.Forms.prototype.getFormsAssociatedWithCollection = function (collection) {

    var collectionId;

    if (collection == null) {
        collectionId = null;
    }
    else if (typeof collection === 'object' && collection.id != undefined) {
        collectionId = collection.id;
    }
    else if (typeof collection === 'object' && collection.id == undefined) {
        collectionId = null;
    }
    else if (typeof collection === 'string' && collection.trim().length > 0) {
        collectionId = collection;
    }
    else {
        throw IllegalArgumentException("expected an id string or a collection");
    }

    var formsInCollectionVisibleToUser = [];
    for (var i in this.formList) {

        if (!this.formList.hasOwnProperty(i))
            continue;

        // skip forms that the user cannot see
        if (!this.Atheneum.User.canSee(this.formList[i]))
            continue;

        // if the collection is the top-level collection, only include forms unassociated with a collection/asset
        if (collectionId == null && this.formList[i].collectionId == null
            && (!this.formList[i].items || this.formList[i].items.length == 0)) {

            formsInCollectionVisibleToUser[formsInCollectionVisibleToUser.length] = this.formList[i];
            continue;
        }

        // otherwise, only include it if the collection ids match
        if ((this.formList[i].collectionId && this.formList[i].collectionId == collectionId)
            || (this.formList[i].items && this.formList[i].items.contains(collectionId))) {

            formsInCollectionVisibleToUser[formsInCollectionVisibleToUser.length] = this.formList[i];
        }
    }

    return formsInCollectionVisibleToUser.sort(function (a, b) { return a.order - b.order; });
}

/**
 * Returns all forms of a specific <code>type</code> associated with the <code>collection</code>
 * 
 * @param {CollectionRef} collection - collection or collection id
 * @param {String} type
 * @returns {Array}
 */
Atheneum.Forms.prototype.getFormsAssociatedWithCollectionOfType = function (collection, type) {
    return this.getFormsAssociatedWithCollection(collection).filter(function (form) {
        if (Array.isArray(type)) {
            return type.indexOf(form.type) != -1;
        }
        return form.type == type;
    });
}

/**
 * Returns the Generic Forms contained inside the collection.<br>
 * If collection is null, returns the home screen forms instead. 
 * 
 * @param {CollectionRef} collection - collection or collection id
 * @returns {Array}
 */
Atheneum.Forms.prototype.getGenericFormsInCollection = function (collection) {
    return this.getFormsAssociatedWithCollectionOfType(collection, this.Atheneum.Forms.Types.GENERIC);
}

/**
 * Returns the Consent Forms contained inside the collection.<br>
 * If collection is null, returns the home screen forms instead. 
 * 
 * @param {CollectionRef} collection - collection or collection id
 * @returns {Array}
 */
Atheneum.Forms.prototype.getConsentFormsInCollection = function (collection) {
    return this.getFormsAssociatedWithCollectionOfType(collection, [this.Atheneum.Forms.Types.CONSENT, this.Atheneum.Forms.Types.REMOTE_CONSENT]);
}

/**
 * Returns the Generic and Consent Forms contained inside the collection.<br>
 * If collection is null, returns the home screen forms instead. 
 * 
 * @param {CollectionRef} collection - collection or collection id
 * @returns {Array}
 */
Atheneum.Forms.prototype.getGenericAndConsentFormsInCollection = function (collection) {
    var forms = this.getFormsAssociatedWithCollectionOfType(collection, [this.Atheneum.Forms.Types.GENERIC, this.Atheneum.Forms.Types.CONSENT, this.Atheneum.Forms.Types.REMOTE_CONSENT, this.Atheneum.Forms.Types.CREATE_MEETING, this.Atheneum.Forms.Types.CERTIFICATION, this.Atheneum.Forms.Types.REMOTE]);
    var atheneum = this.Atheneum;
    return forms.filter(function (form) {
        return (form.type != atheneum.Forms.Types.CERTIFICATION) || (form.properties && form.properties.generic && (
            form.properties.generic.toLowerCase().trim() == 'on'
            || form.properties.generic.toLowerCase().trim() == 'true'
            || form.properties.generic.toLowerCase().trim() == 'yes'));
    });
}

/**
 * Returns the <code>"SHARE"</code> form associated with the asset's collection.
 * If there is no such form, falls back to the default share form for that user.
 * In the unlikely event there are multiple share forms, returns the first one.
 * Returns null if no share form is found
 * 
 * @param {AssetRef} asset
 * @returns {Form}
 */
Atheneum.Forms.prototype.getAssetShareForm = function (asset) {
    if (typeof asset === 'string') {
        var assetId = asset;
        asset = this.Atheneum.Library.assets[assetId];
    }
    if (asset != null) {
        return this.getCollectionShareForm(asset.containedBy);
    }
    return this.getDefaultShareForm();
}

/**
 * Returns the <code>"SHARE"</code> form associated with the collection.
 * If there is no such form, falls back to the default share form for that user.
 * In the unlikely event there are multiple share forms, returns the first one.
 * Returns null if no share form is found
 * 
 * @param {CollectionRef} collection
 * @returns {Form}
 */
Atheneum.Forms.prototype.getCollectionShareForm = function (collection) {

    var collectionShareForms = [];

    if (collection != null)
        collectionShareForms = this.getFormsAssociatedWithCollectionOfType(collection, this.Atheneum.Forms.Types.SHARE);

    if (collectionShareForms.length == 0) {
        if (typeof collection == 'string') {
            collection = this.Atheneum.Library.collections[collection];
        }
    }

    if (collection != null && collection.containedBy) {
        // check parent collection
        return this.getCollectionShareForm(collection.containedBy);
    }


    if (collectionShareForms.length == 0)
        collectionShareForms = this.getFormsAssociatedWithCollectionOfType(null, this.Atheneum.Forms.Types.SHARE);

    return (collectionShareForms.length == 0) ? null : collectionShareForms[0];
}

/**
 * Returns the <code>"MLR_REVIEW"</code> form associated with the collection.
 * If there is no such form, falls back to the default share form for that user.
 * In the unlikely event there are multiple share forms, returns the first one.
 * Returns null if no share form is found
 * 
 * @param {CollectionRef} collection
 * @returns {Form}
 */
Atheneum.Forms.prototype.getCollectionMLRForm = function (collection) {

    var collectionMLRForms = [];

    if (collection != null)
    collectionMLRForms = this.getFormsAssociatedWithCollectionOfType(collection, this.Atheneum.Forms.Types.MLR_REVIEW);

    if (collectionMLRForms.length == 0) {
        if (typeof collection == 'string') {
            collection = this.Atheneum.Library.collections[collection];
        }
    }

    if (collection != null && collection.containedBy) {
        // check parent collection
        return this.getCollectionMLRForm(collection.containedBy);
    }


    if (collectionMLRForms.length == 0)
        collectionMLRForms = this.getFormsAssociatedWithCollectionOfType(null, this.Atheneum.Forms.Types.MLR_REVIEW);

    return (collectionMLRForms.length == 0) ? null : collectionMLRForms[0];
}


/**
 * Returns the <code>"REGISTER_INTEREST"</code> form associated with the collection.
 * If there is no such form, falls back to the default share form for that user.
 * In the unlikely event there are multiple share forms, returns the first one.
 * Returns null if no share form is found
 * 
 * @param {CollectionRef} collection
 * @returns {Form}
 */
Atheneum.Forms.prototype.getCollectionRegisterInterestForm = function (collection) {

    var collectionRIForms = [];

    if (collection != null)
    collectionRIForms = this.getFormsAssociatedWithCollectionOfType(collection, this.Atheneum.Forms.Types.REGISTER_INTEREST);

    if (collectionRIForms.length == 0) {
        if (typeof collection == 'string') {
            collection = this.Atheneum.Library.collections[collection];
        }
    }

    if (collection != null && collection.containedBy) {
        // check parent collection
        return this.getCollectionRegisterInterestForm(collection.containedBy);
    }


    if (collectionRIForms.length == 0)
        collectionRIForms = this.getFormsAssociatedWithCollectionOfType(null, this.Atheneum.Forms.Types.REGISTER_INTEREST);

    return (collectionRIForms.length == 0) ? null : collectionRIForms[0];
}

/**
 * Returns the <code>"SHARE_CART"</code> form associated with the collection.
 * If there is no such form, falls back to the default share form for that user.
 * In the unlikely event there are multiple share forms, returns the first one.
 * Returns null if no share form is found
 * 
 * @param {CollectionRef} collection
 * @returns {Form}
 */
Atheneum.Forms.prototype.getCollectionShareCartForm = function (collection) {

    var collectionSCForms = [];

    if (collection != null)
    collectionSCForms = this.getFormsAssociatedWithCollectionOfType(collection, this.Atheneum.Forms.Types.CART_SHARE);

    if (collectionSCForms.length == 0) {
        if (typeof collection == 'string') {
            collection = this.Atheneum.Library.collections[collection];
        }
    }

    if (collection != null && collection.containedBy) {
        // check parent collection
        return this.getCollectionShareCartForm(collection.containedBy);
    }


    if (collectionSCForms.length == 0)
        collectionSCForms = this.getFormsAssociatedWithCollectionOfType(null, this.Atheneum.Forms.Types.CART_SHARE);

    return (collectionSCForms.length == 0) ? null : collectionSCForms[0];
}

/**
 * Returns the default "SHARE" form for the user.
 * Shown if the collection has no overriding share form.
 * 
 * @returns {Form}
 */
Atheneum.Forms.prototype.getDefaultShareForm = function () {
    return this.getCollectionShareForm(null);
}

/**
 * Returns the Meeting Form associated with the collection (or root if null is passed)
 * If there is no meeting form associated with the collection, checks its parent
 * returns null if the form cannot be found
 */
Atheneum.Forms.prototype.getMeetingForm = function (collectionOrId) {

    var collectionId = null;
    var collection = null;
    if (typeof collectionOrId === 'string') {
        collectionId = collectionOrId;
        collection = (this.Atheneum.Library && this.Atheneum.Library.collections) ? (this.Atheneum.Library.collections[collectionOrId] || null) : null;
        if (collection == null) {
            throw IllegalArgumentException("expected a collection id string or collection");
        }
    }
    else if (collectionOrId && typeof collectionOrId === 'object' && typeof collectionOrId.id === 'string') {
        collectionId = collectionOrId.id;
        collection = collectionOrId;
    }
    else if (collectionOrId) {
        throw IllegalArgumentException("expected a collection id string or collection");
    }

    for (var i in this.formList) {
        if (!this.formList.hasOwnProperty(i))
            continue;

        var form = this.formList[i];

        if (form.type == this.Atheneum.Forms.Types.CREATE_MEETING
            && this.Atheneum.User.canSee(form)) {

            if (collectionId == null && !(form.items && form.items.length > 0)) {
                return form;
            }
            else if (collectionId && form.items && form.items.indexOf(collectionId) != -1) {
                return form;
            }
        }
    }

    if (collection != null) {
        return this.getMeetingForm(collection.containedBy);
    }

    return null;
}

/**
 * Returns collection ids that contain meeting forms
 */
Atheneum.Forms.prototype.getCollectionsWithMeetingForms = function () {

    let collectionIds = [];
    for (var i in this.formList) {
        if (!this.formList.hasOwnProperty(i))
            continue;

        var form = this.formList[i];

        if (form.type == this.Atheneum.Forms.Types.CREATE_MEETING
            && this.Atheneum.User.canSee(form)) {

            if (!(form.items && form.items.length > 0)) {
                collectionIds.push("top");
            }
            else {
                for (var j = 0; j < form.items.length; j++) {
                    let collectionId = form.items[j];
                    collectionIds.push(collectionId);
                }
            }
        }
    }

    return collectionIds;
}

/**
 * Returns the Remote Consent Form associated with the collection (or root if null is passed)
 * If there is no remote consent form associated with the collection, checks its parent
 * returns null if the form cannot be found
 */
Atheneum.Forms.prototype.getRemoteConsentForm = function (collectionOrId) {

    var collectionId = null;
    var collection = null;
    if (typeof collectionOrId === 'string') {
        collectionId = collectionOrId;
        collection = (this.Atheneum.Library && this.Atheneum.Library.collections) ? (this.Atheneum.Library.collections[collectionOrId] || null) : null;
        if (collection == null) {
            throw IllegalArgumentException("expected a collection id string or collection");
        }
    }
    else if (collectionOrId && typeof collectionOrId === 'object' && typeof collectionOrId.id === 'string') {
        collectionId = collectionOrId.id;
        collection = collectionOrId;
    }
    else if (collectionOrId) {
        throw IllegalArgumentException("expected a collection id string or collection");
    }

    for (var i in this.formList) {
        if (!this.formList.hasOwnProperty(i))
            continue;

        var form = this.formList[i];

        if (form.type == this.Atheneum.Forms.Types.REMOTE_CONSENT
            && this.Atheneum.User.canSee(form)) {

            if (collectionId == null && !(form.items && form.items.length > 0)) {
                return form;
            }
            else if (collectionId && form.items && form.items.indexOf(collectionId) != -1) {
                return form;
            }
        }
    }

    if (collection != null) {
        return this.getRemoteConsentForm(collection.containedBy);
    }

    return null;
}

/**
 * Submits the form
 * 
 * @param form		- form or formId of form being submitted
 * @param formData	- a map { "field": "value" }
 */
Atheneum.Forms.prototype.submitForm = function (form, formData, sessionId, callbacks) {

    var formId = null;
    if (typeof form === 'object' && form != null) {
        formId = form.id || null;
    }
    else if (form == null || typeof form === 'string' && form.trim().length > 0) {
        formId = form || null;
    }
    else {
        throw IllegalArgumentException("expected an id string or a form");
    }

    if (formData == undefined || typeof formData !== 'object') {
        throw IllegalArgumentException("expected formData to be a map of { fields: values }");
    }

    if (typeof sessionId === 'function' || typeof sessionId === 'object' && callbacks == undefined) {
        callbacks = sessionId;
        sessionId = undefined;
    }

    if (typeof callbacks === 'function') {
        callbacks = { success: callbacks };
    }

    callbacks = {
        success: callbacks.success || function (json) { },
        failure: callbacks.failure || function (reason, httpStatus, errorCode) { },
        offline: callbacks.offline || callbacks.failure
    }
    if (!callbacks.offline)
        callbacks.offline = callbacks.failure

    var timestamp = new Date().getTime();
    var atheneum = this.Atheneum;
    if (form.type == this.Atheneum.Forms.Types.GENERIC
        || form.type == this.Atheneum.Forms.Types.NOTES
        || form.type == this.Atheneum.Forms.Types.CONSENT
        || form.type == this.Atheneum.Forms.Types.REMOTE_CONSENT
        || form.type == this.Atheneum.Forms.Types.CREATE_MEETING
        || form.type == this.Atheneum.Forms.Types.CERTIFICATION
        || form.type == this.Atheneum.Forms.Types.REMOTE) {

        var formType = form.type;
        return this.Atheneum.API.submitForm(formId, formData, timestamp, sessionId, {

            success: callbacks.success,

            failure: function (reason, httpStatus, errorCode, json) {
                callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm', json);
            },

            offline: function (reason, httpStatus, errorCode) {
                atheneum.Offline.recordUnsynchedAction({
                    name: "submitForm",
                    timestamp: timestamp,
                    fields: formData,
                    formId: formId,
                    formType: formType,
                    sessionId: sessionId
                });
                callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
            }
        });
    }
    else if (form.type == this.Atheneum.Forms.Types.SELF_REGISTRATION) {

        // self registration forms can't be submitted while offline

        return this.Atheneum.API.submitForm(formId, formData, timestamp, sessionId, {

            success: callbacks.success,

            failure: function (reason, httpStatus, errorCode) {
                callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
            },

            offline: function (reason, httpStatus, errorCode) {
                callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
            }
        });
    }
    else if (form.type == this.Atheneum.Forms.Types.SHARE) {

        var collectionId = undefined;
        if (form.collectionId) {
            collectionId = form.collectionId;
        }
        else if (form.items && form.items.length == 1) {
            collectionId = form.items[0];
        }
        else if (formData.assetIds) {
            // check each asset in the assetId list, to see if they are in the same story
            for (var i = 0; i < formData.assetIds.length; i++) {
                var asset = this.Atheneum.Library.assets[formData.assetIds[i]];
                if (asset && (collectionId === undefined || collectionId == asset.containedBy)) {
                    collectionId = asset.containedBy;
                }
                else {
                    collectionId = null;
                }
            }
            collectionId = collectionId || null;
        }

        var timestamp = new Date().getTime();

        if (collectionId == null) {
            // Share cart

            return this.Atheneum.API.shareCart(formData, timestamp, sessionId, {

                success: callbacks.success,

                failure: function (reason, httpStatus, errorCode) {
                    callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
                },

                offline: function (reason, httpStatus, errorCode) {
                    atheneum.Offline.recordUnsynchedAction({
                        name: "submitForm",
                        timestamp: timestamp,
                        fields: formData,
                        collectionId: null,
                        assetIds: formData.assetIds,
                        formType: atheneum.Forms.Types.SHARE,
                        sessionId: sessionId
                    });
                    callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
                }
            });
        }
        else {

            return this.Atheneum.API.shareCollectionAssets(collectionId, formData.assetIds, formData, timestamp, sessionId, {

                success: callbacks.success,

                failure: function (reason, httpStatus, errorCode) {
                    callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
                },

                offline: function (reason, httpStatus, errorCode) {
                    atheneum.Offline.recordUnsynchedAction({
                        name: "submitForm",
                        timestamp: timestamp,
                        fields: formData,
                        collectionId: collectionId,
                        assetIds: formData.assetIds,
                        formType: atheneum.Forms.Types.SHARE,
                        sessionId: sessionId
                    });
                    callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Forms.submitForm');
                }
            });
        }
    }

}

Atheneum.Forms.prototype.getFormProperty = function (form, property, fallback) {

    var formId = null;
    if (typeof form === 'object' && form != null) {
        formId = form.id || null;
    }
    else if (form == null || typeof form === 'string' && form.trim().length > 0) {
        formId = form || null;
    }
    else {
        throw IllegalArgumentException("expected an id string or a form");
    }

    form = form || (formId ? this.formList[formId] : null);

    if (form === undefined) {
        // formId did not correspond to an actual form
        throw IllegalArgumentException("formId (" + formId + ") did not correspond to an actual form");
    }

    if (typeof property !== 'string' || !property)
        throw new IllegalArgumentException('propertyName must be a string');

    var formProperties = form.properties || {};

    if (formProperties[property] == undefined) {
        return fallback;
    }

    return formProperties[property];
}

Atheneum.Forms.prototype.getBooleanFormProperty = function (form, property, fallback) {

    if (typeof property !== 'string' || !property)
        throw new IllegalArgumentException('propertyName must be a string');


    if (typeof fallback === 'string' && Atheneum.Theme.TRUE_VALUES.contains(fallback.trim().toLowerCase())) {
        fallback = true;
    }

    if (typeof fallback === 'string' && Atheneum.Theme.FALSE_VALUES.contains(defaultValue.trim().toLowerCase())) {
        fallback = false;
    }

    if (typeof fallback !== 'undefined' && typeof fallback !== 'boolean')
        throw new IllegalArgumentException('defaultValue must be a boolean');

    var stringValue = this.getFormProperty(form, property, fallback != undefined ? (fallback ? 'on' : 'off') : undefined);

    if (stringValue && Atheneum.Theme.TRUE_VALUES.contains(stringValue.trim().toLowerCase()))
        return true;

    if (stringValue && Atheneum.Theme.FALSE_VALUES.contains(stringValue.trim().toLowerCase()))
        return false;

    return Atheneum.Theme.MISSING_BOOLEAN_PROPERTY_FALLBACK_VALUE;
}

Atheneum.Theme = function AtheneumTheme(atheneum) {

    if (!(this instanceof Atheneum.Theme)) {
        return new Atheneum.Theme(atheneum);
    }

    this.accountRef = null;

    this.defaults = window.defaultAtheneumTheme || {
        'tncsShareMode': 'off',
        'sharingSubHeaderHTML': 'theme key tncsHTML'
    };
    this.properties = {};
    this.collectionOverrides = {};
    this.overridingCollectionId = null;
    this.usingDefaults = true;

    this.recursionLimit = Atheneum.Theme.DEFAULT_RECURSION_LIMIT;

    this.Atheneum = atheneum;

    this.exists = false;
    this.loadFromStorage();
}

Atheneum.Theme.DEFAULT_RECURSION_LIMIT = 10;
Atheneum.Theme.MISSING_BOOLEAN_PROPERTY_FALLBACK_VALUE = undefined;

Atheneum.Theme.TRUE_VALUES = ['on', 'true', 'y', 'yes'];
Atheneum.Theme.FALSE_VALUES = ['off', 'false', 'n', 'no'];

Atheneum.Theme.COLLECTION_OVERRIDES_INHERIT_FROM_PARENT_COLLECTION_OVERRIDES_THEME_KEY =
    "collectionThemeInheritsFromParentCollectionTheme";

Atheneum.Theme.prototype.loadFromStorage = function () {
    var json = this.Atheneum.LocalStorage.getJSON('atheneumThemeProperties');
    if (json && Object.keys(json).length > 0) {
        this.exists = true;
        this.properties = json;
        this.usingDefaults = false;
    }
    else {
        this.properties = this.defaults || {};
        this.usingDefaults = true;
    }

    var cachedCollectionTheme = localStorage['salestoolkitCollectionThemeOverrideProperties'] || null;
    if (cachedCollectionTheme) {
        cachedCollectionTheme = JSON.parse(cachedCollectionTheme);
        if (cachedCollectionTheme && cachedCollectionTheme.theme && cachedCollectionTheme.theme.properties) {
            for (var prop in cachedCollectionTheme.theme.properties) {
                if (cachedCollectionTheme.theme.properties.hasOwnProperty(prop)) {
                    this.collectionOverrides[prop] = cachedCollectionTheme.theme.properties[prop];
                }
            }
        }
    }
}

Atheneum.Theme.prototype.saveToStorage = function () {
    if (!(this.usingDefaults)) {
        this.Atheneum.LocalStorage.setJSON('atheneumThemeProperties', this.properties);
    }
}

/** Grabs the latest version of the theme from the server */
Atheneum.Theme.prototype.update = function (successCallbackOrCallbacks, failureCallback, offlineCallback) {

    var atheneum = this.Atheneum;
    var callbacks = Atheneum.Callbacks.parse(successCallbackOrCallbacks, failureCallback, offlineCallback);
    //TODO TEST CROSS PLATFORM WRAPPER
    if (this.Atheneum.Proxy.enabled || this.Atheneum.CrossPlatform.enabled) {

        var successCallback = callbacks.success;
        var failureCallback = callbacks.failure;

        callbacks.success = function (json) {
            if (json && Object.keys(json).length > 0 && json.theme && json.theme.properties) {
                atheneum.Theme.exists = true;
                atheneum.Theme.usingDefaults = false;
            }
            atheneum.Theme.properties = json.theme && json.theme.properties || {};
            atheneum.Theme.saveToStorage();
            successCallback(json);
        }

        callbacks.failure = function (reason, httpStatus, errorCode) {
            failureCallback(reason, httpStatus, errorCode, "Atheneum.Theme.update");
        }

        if (this.Atheneum.CrossPlatform.enabled) {
            return this.Atheneum.CrossPlatform.updateTheme(callbacks);
        }

        return this.Atheneum.HttpUtils.getJSON("/restful/theme", { apikey: this.Atheneum.User.apikey }, callbacks);
    }

    if (!atheneum.User.apikey && this.accountRef) {
        return this.Atheneum.API.lookupTheme(this.accountRef, {
            success: function (json) {
                atheneum.Theme.properties = json.theme && json.theme.properties || {};
                atheneum.Theme.usingDefaults = false;
                atheneum.Theme.exists = true;
                atheneum.Theme.saveToStorage();
                callbacks.success(json);
            },
            failure: function (reason, httpStatus, errorCode) {
                callbacks.failure(reason, httpStatus, errorCode, "Atheneum.Theme.update");
            },

            offline: callbacks.offline
        });
    }

    // do not pass a timestamp: always grab a fresh version
    return this.Atheneum.API.getTheme(undefined, {

        success: function (json) {
            if (json.theme) {
                atheneum.Theme.properties = json.theme && json.theme.properties || {};
                atheneum.Theme.usingDefaults = false;
                atheneum.Theme.exists = true;
                atheneum.Theme.saveToStorage();

            }

            callbacks.success(json);
        },

        failure: function (reason, httpStatus, errorCode) {
            callbacks.failure(reason, httpStatus, errorCode, "Atheneum.Theme.update");
        },

        offline: callbacks.offline
    }); 
}

/** Removes the overriding collection */
Atheneum.Theme.prototype.clearOverridingCollection = function AtheneumTheme_clearOverridingCollection() {
    this.setOverridingCollection(null);
}

/** Sets the overriding collection */
Atheneum.Theme.prototype.setOverridingCollection = function (collection) {

    var collectionId = null;

    if (typeof collection === 'string') {
        collectionId = collection;
    }
    else if (typeof collection === 'object' && collection == null) {
        collectionId = null;
    }
    else if (typeof collection === 'object' && typeof collection.id === 'string') {
        collectionId = collection.id;
    }
    else {
        throw new IllegalArgumentException('collection must be a string containing a collection id, a collection object, or null');
    }

    if (collectionId == null) {
        this.collectionOverrides = {};
        this.overridingCollectionId = null;
        return;
    }

    collection = this.Atheneum.Library.collections[collectionId];


    if (!collection) {
        var cachedCollectionTheme = localStorage['salestoolkitCollectionThemeOverrideProperties'] || null;
        if (cachedCollectionTheme) {
            cachedCollectionTheme = JSON.parse(cachedCollectionTheme);
            if (cachedCollectionTheme.id == collectionId)
                collection = cachedCollectionTheme;
            else {
                collection = {};
                console.warn("overriding collection (id = " + collectionId + ") does not exist");
            }

        } else {
            collection = {};
            console.warn("overriding collection (id = " + collectionId + ") does not exist");
        }
    }

    while (collection && !collection.theme) {
        collectionId = collection.containedBy;
        collection = collectionId ? this.Atheneum.Library.collections[collectionId] : null;
    }

    this.overridingCollectionId = collectionId;
    this.collectionOverrides = {};

    if (collection && collection.theme && collection.theme.properties) {
        for (var prop in collection.theme.properties) {
            if (collection.theme.properties.hasOwnProperty(prop)) {
                this.collectionOverrides[prop] = collection.theme.properties[prop];
            }
        }
    }

    if (this.collectionOverrides.hasOwnProperty(Atheneum.Theme.COLLECTION_OVERRIDES_INHERIT_FROM_PARENT_COLLECTION_OVERRIDES_THEME_KEY)
        && Atheneum.Theme.TRUE_VALUES.contains(this.collectionOverrides[Atheneum.Theme.COLLECTION_OVERRIDES_INHERIT_FROM_PARENT_COLLECTION_OVERRIDES_THEME_KEY])) {

        while (true) {
            var collection = this.Atheneum.Library.collections[collectionId];
            collectionId = collection.containedBy;
            collection = this.Atheneum.Library.collections[collectionId];
            if (collection && collection.theme) {
                if (!collection.theme || !collection.theme.properties || !collection.theme.properties.hasOwnProperty(prop)) {
                    continue;
                }
                for (var prop in collection.theme) {
                    if (this.collectionOverrides.hasOwnProperty(prop)) {
                        continue;
                    }
                    this.collectionOverrides[prop] = collection.theme[prop];
                }
                if (collection.theme.hasOwnProperty(Atheneum.Theme.COLLECTION_OVERRIDES_INHERIT_FROM_PARENT_COLLECTION_OVERRIDES_THEME_KEY)
                    && Atheneum.Theme.TRUE_VALUES.contains(this.collectionOverrides[Atheneum.Theme.COLLECTION_OVERRIDES_INHERIT_FROM_PARENT_COLLECTION_OVERRIDES_THEME_KEY])) {
                    collectionId = collection.containedBy;
                    continue;
                }
                else {
                    // the collection theme does not inherit keys from parent collection themes
                    // thus any subcollections which inherit from it will not inherit keys from its parent collection themes either
                    // they will however inherit from it
                    break;
                }

            }
            break;
        }

    }

    if (typeof renderTranslations == 'function')
        renderTranslations();
}

/** 
 * Atheneum.Theme.__getProperty( propertyName, overrides, defaultValue, recursionDepth )
 * 
 * Internal method to retrieve the theme property and handle recursively hunting through theme keys
 * 
 * @param propertyName		- the name of the property to get
 * @param overrides			- the collection overrides
 * @param defaultValue		- the default value to return if it is not found
 * @param recursionDepth 	- keeps track of how many times this method has called itself
 */
Atheneum.Theme.prototype.__getProperty = function (propertyName, overrides, defaultValue, recursionDepth) {

    if (typeof propertyName !== 'string' || !propertyName)
        throw new IllegalArgumentException('propertyName must be a string');

    if (typeof overrides === 'undefined')
        overrides = {};

    if (typeof overrides !== 'object')
        throw new IllegalArgumentException('overrides must be a map { themeKey: value }');

    if (typeof recursionDepth === 'undefined')
        recursionDepth = 0;

    if (typeof recursionDepth !== 'number' || ((recursionDepth | 0) != recursionDepth))
        throw new IllegalArgumentException('recursionDepth must be an integer');

    if (typeof defaultValue !== 'string' && typeof defaultValue !== 'undefined')
        throw new IllegalArgumentException('defaultValue must be a string');

    if (defaultValue == undefined)
        defaultValue = this.defaults[propertyName];

    if (arguments.length <= 2)
        recursionDepth = 0;

    if (overrides.hasOwnProperty('properties'))
        overrides = overrides.properties;

    var value = overrides[propertyName];

    if (typeof value === 'undefined')
        value = this.properties[propertyName];

    if (typeof value === 'string' && value.trim().toLowerCase().startsWith('theme key ')) {
        propertyName = value.trim().substring(10);
        value = undefined;

        if (recursionDepth < this.recursionLimit)
            value = this.__getProperty(propertyName, overrides, defaultValue, recursionDepth + 1);
    }

    if (typeof value === 'string' && value.trim().toLowerCase().startsWith('translation key ')) {
        propertyName = value.trim().substring(16);
        value = undefined;
    }

    if (value == undefined) {
        if (this.Atheneum.Translation.debug || ((this.Atheneum.User.preferences || {}).language || '').toLowerCase() == 'debug') {
            value = undefined;
        }
        else {
            value = this.Atheneum.Translation.get(propertyName);
        }
    }

    if (value == undefined) {
        value = defaultValue;

        // check in case the default value is a theme key / translation key

        var isThemeKey = false;
        if (typeof value === 'string' && value.trim().toLowerCase().startsWith('theme key ')) {
            propertyName = value.trim().substring(10);
            value = undefined;
            isThemeKey = true;

            if (recursionDepth < this.recursionLimit) {
                value = this.__getProperty(propertyName, overrides, defaultValue, recursionDepth + 1);
            }
        }
        if ((typeof value === 'string' && value.trim().toLowerCase().startsWith('translation key ')) || (isThemeKey && value == undefined)) {
            if (value != undefined) {
                propertyName = value.trim().substring(16);
            }
            value = this.Atheneum.Translation.get(propertyName);
        }
    }

    return value;
}

/**
 * Atheneum.Theme.getProperty( propertyName [, defaultValue] )
 * 
 * @param propertyName				- string identifying the theme key
 * @param defaultValue (optional)	- string to return if the theme key is not present
 */
Atheneum.Theme.prototype.getProperty = function AtheneumTheme_getProperty(propertyName, defaultValue) {
    return this.__getProperty(propertyName, this.collectionOverrides, defaultValue, 0);
}

/**
 * Atheneum.Theme.getCollectionProperty( collection, propertyName [, defaultValue] )
 * 
 * @param collection				- collection or collection id
 * @param propertyName				- string identifying the theme key
 * @param defaultValue (optional)	- string to return if the theme key is not present
 */
Atheneum.Theme.prototype.getCollectionProperty = function AtheneumTheme_getCollectionProperty(collection, propertyName, defaultValue) {
    if (this.Atheneum.Library == null) {
        return;
    }
    let collectionId = '';
    if (typeof collection === 'string') {
        collectionId = collection;
    }
    else if (typeof collection === 'object' && collection == null) {
        collectionId = null;
    }
    else if (typeof collection === 'object' && typeof collection.id === 'string') {
        collectionId = collection.id;
    }
    else if (typeof collection === 'object' && collection.id === null) {
        collectionId = null;
    }
    else {
        throw new IllegalArgumentException('collection must be a string containing a collection id, a collection object, or null');
    }

    return this.__getProperty(propertyName, (this.Atheneum.Library.collections[collectionId] || {}).theme || {}, defaultValue, 0);
}

/**
 
 */
Atheneum.Theme.prototype.getCollectionIntegerProperty = function AtheneumTheme_getCollectionIntegerProperty(collection, propertyName, defaultValue) {

    let collectionId = '';
    if (typeof collection === 'string') {
        collectionId = collection;
    }
    else if (typeof collection === 'object' && collection == null) {
        collectionId = null;
    }
    else if (typeof collection === 'object' && typeof collection.id === 'string') {
        collectionId = collection.id;
    }
    else {
        throw new IllegalArgumentException('collection must be a string containing a collection id, a collection object, or null');
    }


    var fallbackString = (typeof defaultValue === 'number') ? defaultValue + '' : defaultValue;
    var numberString = this.__getProperty(propertyName, (this.Atheneum.Library.collections[collectionId] || {}).theme || {}, fallbackString, 0);
    if (numberString == '') {
        numberString = fallbackString
    }
    if (numberString == undefined) {
        return undefined;
    }
    var number = parseInt(numberString);
    if (isNaN(number) && (numberString != 'NaN') && (numberString != fallbackString)) {
        number = parseInt(fallbackString);
    }
    return number;
}

/**
 *
 *
 * Returns a boolean value depending on the themeKey
 */
Atheneum.Theme.prototype.getCollectionBooleanProperty = function AtheneumTheme_getCollectionBooleanProperty(collection, propertyName, defaultValue) {

    if (typeof propertyName !== 'string' || !propertyName)
        throw new IllegalArgumentException('propertyName must be a string');

    if (typeof defaultValue === 'string' && Atheneum.Theme.TRUE_VALUES.contains(defaultValue.trim().toLowerCase())) {
        defaultValue = true;
    }

    if (typeof defaultValue === 'string' && Atheneum.Theme.FALSE_VALUES.contains(defaultValue.trim().toLowerCase())) {
        defaultValue = false;
    }

    if (typeof defaultValue !== 'undefined' && typeof defaultValue !== 'boolean')
        throw new IllegalArgumentException('defaultValue must be a boolean');

    let collectionId = '';
    if (typeof collection === 'string') {
        collectionId = collection;
    }
    else if (typeof collection === 'object' && collection == null) {
        collectionId = null;
    }
    else if (typeof collection === 'object' && typeof collection.id === 'string') {
        collectionId = collection.id;
    }
    else {
        throw new IllegalArgumentException('collection must be a string containing a collection id, a collection object, or null');
    }

    let stringValue = this.__getProperty(propertyName, (this.Atheneum.Library.collections[collectionId] || {}).theme || {}, defaultValue != undefined ? (defaultValue ? 'on' : 'off') : undefined, 0);

    if (stringValue && Atheneum.Theme.TRUE_VALUES.contains(stringValue.trim().toLowerCase()))
        return true;

    if (stringValue && Atheneum.Theme.FALSE_VALUES.contains(stringValue.trim().toLowerCase()))
        return false;

    return defaultValue;
}

/**
 * 
 * 
 * Returns a boolean value depending on the themeKey
 */
Atheneum.Theme.prototype.getBooleanProperty = function AtheneumTheme_getBooleanProperty(propertyName, defaultValue) {

    if (typeof propertyName !== 'string' || !propertyName)
        throw new IllegalArgumentException('propertyName must be a string');


    if (typeof defaultValue === 'string' && Atheneum.Theme.TRUE_VALUES.contains(defaultValue.trim().toLowerCase())) {
        defaultValue = true;
    }

    if (typeof defaultValue === 'string' && Atheneum.Theme.FALSE_VALUES.contains(defaultValue.trim().toLowerCase())) {
        defaultValue = false;
    }

    if (typeof defaultValue !== 'undefined' && typeof defaultValue !== 'boolean')
        throw new IllegalArgumentException('defaultValue must be a boolean');

    var stringValue = this.getProperty(propertyName, defaultValue != undefined ? (defaultValue ? 'on' : 'off') : undefined);

    if (stringValue && Atheneum.Theme.TRUE_VALUES.contains(stringValue.trim().toLowerCase()))
        return true;

    if (stringValue && Atheneum.Theme.FALSE_VALUES.contains(stringValue.trim().toLowerCase()))
        return false;

    return Atheneum.Theme.MISSING_BOOLEAN_PROPERTY_FALLBACK_VALUE;
}

Atheneum.Theme.prototype.getStringProperty = function AtheneumTheme_getStringProperty(propertyName, defaultValue) {
    return this.getProperty(propertyName, defaultValue);
}

Atheneum.Theme.prototype.getColourProperty = function AtheneumTheme_getStringProperty(propertyName, defaultValue) {
    var fallbackString = defaultValue instanceof Atheneum.Colour ? defaultValue.toHexString().slice(1) : defaultValue;
    var colourString = this.getStringProperty(propertyName, fallbackString);
    return colourString ? new Atheneum.Colour(colourString) : (fallbackString ? new Atheneum.Colour(fallbackString) : undefined);
}

Atheneum.Theme.prototype.getIntegerProperty = function AtheneumTheme_getIntegerProperty(propertyName, defaultValue) {
    var fallbackString = (typeof defaultValue === 'number') ? defaultValue + '' : defaultValue;
    var numberString = this.getStringProperty(propertyName, fallbackString);
    if (numberString == '') {
        numberString = fallbackString
    }
    if (numberString == undefined) {
        return undefined;
    }
    var number = parseInt(numberString);
    if (isNaN(number) && (numberString != 'NaN') && (numberString != fallbackString)) {
        number = parseInt(fallbackString);
    }
    return number;
}

Atheneum.Theme.prototype.getFloatProperty = function AtheneumTheme_getFloatProperty(propertyName, defaultValue) {
    var fallbackString = (typeof defaultValue === 'number') ? defaultValue + '' : defaultValue;
    var numberString = this.getStringProperty(propertyName, fallbackString);
    if (numberString == '') {
        numberString = fallbackString
    }
    if (numberString == undefined) {
        return undefined;
    }
    var number = parseFloat(numberString);
    if (isNaN(number) && (numberString != 'NaN') && (numberString != fallbackString)) {
        number = parseFloat(fallbackString);
    }
    return number;
}

Atheneum.Theme.prototype.getLengthProperty = function AtheneumTheme_getLengthProperty(propertyName, defaultValue) {
    if (typeof defaultValue === 'number') {
        defaultValue = defaultValue + 'px';
    }
    if (defaultValue == undefined) {
        defaultValue = '';
    }
    var numberString = this.getStringProperty(propertyName, defaultValue);
    if (numberString == '') {
        numberString = defaultValue;
    }
    if (/^[0-9]+$/.test(numberString)) {
        numberString = numberString + 'px';
    }
    return numberString;
}

Atheneum.Theme.prototype.getStringArrayProperty = function AtheneumTheme_getArrayProperty(propertyName, defaultValue) {

    if (typeof propertyName !== 'string' || !propertyName) {
        throw new IllegalArgumentException('propertyName must be a string');
    }
    if (defaultValue != undefined && (typeof defaultValue !== 'string') && !Array.isArray(defaultValue)) {
        throw new IllegalArgumentException('defaultValue must be an Array');
    }

    var stringValue = this.getStringProperty(propertyName);

    if (stringValue == undefined && defaultValue == undefined) {
        return defaultValue;
    }
    if (defaultValue == undefined && stringValue.trim() == '') {
        return [];
    }
    if ((stringValue == undefined || stringValue.trim() == '') && Array.isArray(defaultValue)) {
        return defaultValue;
    }
    if ((stringValue == undefined || stringValue.trim() == '') && (typeof defaultValue === 'string')) {
        stringValue = defaultValue;
    }

    var array = [];

    //	var matches = stringValue.matchAll(/\s*("(?:(?:\\.)|(?:[^\"]))*?"|[^,]*[^ ,]+)\s*/g);
    //	var match = matches ? matches.next() : { value: undefined, done: true };
    //	while(!match.done) {
    //		array[array.length] = match.value[1];
    //		match = matches.next();
    //	}
    // Replacing above as String.prototype.matchAll not currently supported by Edge, IE or Safari iOS
    const regex = /\s*("(?:(?:\\.)|(?:[^\"]))*?"|[^,]*[^ ,]+)\s*/g;
    var match;
    while (match = regex.exec(stringValue)) {
        array[array.length] = match[1];
    }

    var allArrayItemsQuoted = true;
    for (var s = 0; s < array.length; s++) {
        if (array[s].length < 2
            || array[s][0] != '"'
            || array[s][array[s].length - 1] != '"') {
            allArrayItemsQuoted = false;
        }
    }
    if (allArrayItemsQuoted) {
        for (var s = 0; s < array.length; s++) {
            array[s] = array[s].substring(1, array[s].length - 1);
        }
    }
    return array;
}

/**
 * Very similar to Atheneum.Offline, but hangs around after being successfully submitted
 */
Atheneum.Archive = function AtheneumArchive(atheneum, autorecord) {
    this.Atheneum = atheneum;
    this.autorecord = (autorecord == undefined) ? true : !!autorecord;

    /**
     * if autorecord is true, the following api calls will automatically be recorded:
     * 
     * 		share cart
     * 		share collection assets
     * 		share download collection asset
     * 		track asset
     * 		submit form
     * 
     * 	 TODO - MAYBE:
     * 
     * 		redeliver share
     * 		track collection
     * 		track news item
     * 		
     */

    // TODO: remove this when no longer necessary
    // There was a bug that caused archived actions to always be stored in localStorage regardless of proxy
    // The following is a work around that migrates localStorage actions to the proxy db on page load
    var archivedActions = [];
    var archivedActionIds = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
    for (var i = 0; i < archivedActionIds.length; i++) {

        if (archivedActionIds[i] in localStorage) {
            try {
                var action = JSON.parse(localStorage[archivedActionIds[i]]);
                var inCorrectLocation = !!this.Atheneum.LocalStorage.get(archivedActionIds[i]);
                if (action && !inCorrectLocation) {
                    this.Atheneum.LocalStorage.setJSON(archivedActionIds[i], action);
                }
                else if (action
                    && inCorrectLocation
                    && (this.Atheneum.Proxy.enabled || this.Atheneum.CrossPlatform.enabled)
                    && this.Atheneum.LocalStorage.wrapperPreferredRegex.test(archivedActionIds[i])) {
                    // if it's been moved to the db successfully, delete the localStorage copy
                    // otherwise it's going to hang noticeably as it makes a load of synchronous requests
                    delete localStorage[archivedActionIds[i]];
                }
            }
            catch (e) {
                // meh
            }
        }
    }
}

Atheneum.Archive.prototype.wrapJsonCallback = function AtheneumArchive_wrapCallbacks(jsonCallback, actionType, timestamp, request, status) {

    var oldCallback = {};

    if (typeof callbacks === 'function')
        oldCallback = { success: jsonCallback };
    else
        oldCallback.success = (typeof jsonCallback.success === 'function') ? jsonCallback.success : function (json) { };

    oldCallback.failure = (typeof jsonCallback.failure === 'function') ? jsonCallback.failure : function (reason, httpStatus, errorCode) { }
    oldCallback.offline = (typeof jsonCallback.offline === 'function') ? jsonCallback.offline : oldCallback.failure;

    var archivedActionId = this.Atheneum.Archive.record(actionType, timestamp, request);

    var atheneum = this.Atheneum;
    var wrappedCallback = {
        success: function (json) {
            atheneum.Archive.recordSuccess(archivedActionId);
            oldCallback.success(json);
        },
        failure: function (reason, httpStatus, errorCode, json) {
            atheneum.Archive.recordFailure(archivedActionId);
            oldCallback.failure(reason, httpStatus, errorCode, json);
        },
        offline: function (reason, httpStatus, errorCode) {
            atheneum.Archive.recordOffline(archivedActionId);
            oldCallback.offline(reason, httpStatus, errorCode);
        }
    };
    return wrappedCallback;
}

Atheneum.Archive.prototype.recordSuccess = function AtheneumArchive_recordSuccess(actionId) {
    var action = this.Atheneum.LocalStorage.getJSON(actionId);
    if (action == null)
        return;
    if (action) {
        action.status = 'SUCCESS';
        this.Atheneum.LocalStorage.setJSON(actionId, action);
    }
}

Atheneum.Archive.prototype.recordFailure = function AtheneumArchive_recordSuccess(actionId) {
    var action = this.Atheneum.LocalStorage.getJSON(actionId);
    if (action == null)
        return;

    if (action) {
        action.status = 'FAILURE';
        this.Atheneum.LocalStorage.setJSON(actionId, action);
    }
  
}

Atheneum.Archive.prototype.recordOffline = function AtheneumArchive_recordSuccess(actionId) {
    var action = this.Atheneum.LocalStorage.getJSON(actionId);
    if (action == null)
        return;

    if (action) {
        action.status = 'OFFLINE';
        this.Atheneum.LocalStorage.setJSON(actionId, action);
    }
}

Atheneum.Archive.prototype.record = function AtheneumArchive_record(actionType, timestamp, request, status) {

    if (status == undefined)
        status = 'OFFLINE';

    if (timestamp == undefined)
        timestamp = new Date();

    if (typeof timestamp === 'object' && timestamp instanceof Date)
        timestamp = timestamp.getTime();

    var username = Atheneum.User.username || this.Atheneum.LocalStorage.get('atheneumUserName');

    var actionIdSuffix = + ('0000000000000000' + timestamp).substr(-16, 16) + '-' + username;
    var actionIdPrefix = 'atheneumArchiveEntry-';
    var actionId = actionIdPrefix + actionIdSuffix;

    var action = {
        id: actionId,
        user: username,
        type: actionType,
        timestamp: timestamp,
        status: status,
        requestMethod: request.method,
        requestUrl: request.url,
        requestBody: request.body,
        attempts: [new Date().getTime()]
    };

    var append = true;
    var cotemporalActions = 1;
    var existingAction = this.Atheneum.LocalStorage.getJSON(actionId);
    while (true) {
        if (existingAction
            && action.type == existingAction.type
            && action.timestamp == existingAction.timestamp
            && action.requestUrl == existingAction.requestUrl
            && action.requestMethod == existingAction.requestMethod
            && action.requestBody == existingAction.requestBody) {

            action == existingAction;
            action.attempts[action.attempts.length] = new Date().getTime();
            action.status = status;
            append = false;
            break;
        }
        else if (existingAction == null) {
            append = true;
            break;
        }
        else {
            cotemporalActions += 1;
            actionId = actionIdPrefix + cotemporalActions + '-' + actionIdSuffix;
            existingAction = this.Atheneum.LocalStorage.getJSON(actionId);
        }
    }

    this.Atheneum.LocalStorage.setJSON(actionId, action);

    if (append) {
        var index = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
        index[index.length] = actionId;
        this.Atheneum.LocalStorage.setJSON('atheneumArchiveIndex', index);
    }

    return actionId;
}

Atheneum.Archive.prototype.download = function AtheneumArchive_download() {
    var archivedActions = [];
    var archivedActionIds = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
    for (var i = 0; i < archivedActionIds.length; i++) {
        var action = this.Atheneum.LocalStorage.getJSON(archivedActionIds[i]);
        if (action) {
            archivedActions[archivedActions.length] = action;
        }
    }

    var downloadLink = document.createElement('A');
    downloadLink.style.visibility = 'hidden';
    downloadLink.style.position = 'absolute';
    downloadLink.setAttribute('href', 'data:text/plain;charset=UTF-8,' + JSON.stringify(archivedActions));
    downloadLink.setAttribute('download', 'archivedActions.txt');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.parentNode.removeChild(downloadLink);
}

Atheneum.Archive.prototype.clear = function AtheneumArchive_clear() {
    var archivedActionIds = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
    for (var i = 0; i < archivedActionIds.length; i++) {
        this.Atheneum.LocalStorage.clear(archivedActionIds[i]);
    }
    this.Atheneum.LocalStorage.setJSON('atheneumArchiveIndex', []);
}

Atheneum.Archive.prototype.getSize = function AtheneumArchive_getSize() {
    var index = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
    return index.length;
}

Atheneum.Archive.prototype.getFailedActions = function AtheneumArchive_getFailedActions() {
    var actions = [];
    var index = this.Atheneum.LocalStorage.getJSON('atheneumArchiveIndex') || [];
    for (i = 0; i < index.length; i++) {
        var json = this.Atheneum.LocalStorage.getJSON(index[i]);
        if (json && json.status == 'FAILURE') {
            actions[actions.length] = json;
        }
    }
    return actions;
}

Atheneum.Colour = function AtheneumColour(stringOrRed, green, blue, alpha) {

    if (!(this instanceof Atheneum.Colour))
        return new Atheneum.Colour(stringOrRed, green, blue, alpha);

    if (arguments.length == 1) {

        if (stringOrRed.match(/^#?([0-9a-fA-F]{3}){1,2}$/)) {
            // hex
            stringOrRed = (stringOrRed[0] == '#') ? stringOrRed.slice(1) : stringOrRed;
            if (stringOrRed.length == 3) {
                stringOrRed = stringOrRed[0] + stringOrRed[0] + stringOrRed[1] + stringOrRed[1] + stringOrRed[2] + stringOrRed[2];
            }
            this.red = parseInt(stringOrRed[0] + stringOrRed[1], 16);
            this.green = parseInt(stringOrRed[2] + stringOrRed[3], 16);
            this.blue = parseInt(stringOrRed[4] + stringOrRed[5], 16);
            this.alpha = 1;
        }
        else if (stringOrRed.match(/^((rgb)?\([ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?\))|([ ]?[0-9][ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9][ ]?)$/)) {
            // TODO - rgb
            this.red = 0;
            this.blue = 0;
            this.green = 0;
            this.alpha = 1;
        }
        else if (stringOrRed.match(/^((rgba)?\([ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9](:?\\.[0-9]+)?[ ]?\))|([ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9]+[ ]?,[ ]?[0-9](:?\\.[0-9]+)[ ]?)$/)) {
            // TODO - rgba
            this.red = 0;
            this.blue = 0;
            this.green = 0;
            this.alpha = 0;
        }
        else {
            // TODO - custom text

            if (stringOrRed == 'black') { return new Atheneum.Colour(0, 0, 0); }
            if (stringOrRed == 'blue') { return new Atheneum.Colour(0, 0, 255); }
            if (stringOrRed == 'green') { return new Atheneum.Colour(0, 255, 0); }
            if (stringOrRed == 'cyan') { return new Atheneum.Colour(0, 255, 255); }
            if (stringOrRed == 'red') { return new Atheneum.Colour(255, 0, 0); }
            if (stringOrRed == 'magenta') { return new Atheneum.Colour(255, 0, 255); }
            if (stringOrRed == 'yellow') { return new Atheneum.Colour(255, 255, 0); }
            if (stringOrRed == 'white') { return new Atheneum.Colour(255, 255, 255); }

            if (stringOrRed == 'transparent') { return new Atheneum.Colour(0, 0, 0, 0); }

            // TODO
            this.red = 0;
            this.blue = 0;
            this.green = 0;
            this.alpha = 0;
        }

    }
    else {
        this.red = parseInt(stringOrRed);
        this.green = parseInt(green);
        this.blue = parseInt(blue);
        this.alpha = isNaN(parseInt(alpha)) ? 1 : parseInt(alpha);
    }
}

Atheneum.Colour.prototype.toString = function () {
    return this.toRGBAString();
}

Atheneum.Colour.prototype.toRGBString = function () {
    return 'rgb(' + this.red + ', ' + this.green + ', ' + this.blue + ')';
}
Atheneum.Colour.prototype.toRGBAString = function () {
    return 'rgba(' + this.red + ', ' + this.green + ', ' + this.blue + ', ' + this.alpha + ')';
}
// thanks to @cwolves from http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
Atheneum.Colour.prototype.toHexString = function () {
    return "#" + ((1 << 24) + (this.red << 16) + (this.green << 8) + this.blue).toString(16).slice(1);
}

Atheneum.Colour.WHITE = new Atheneum.Colour('white');
Atheneum.Colour.BLACK = new Atheneum.Colour('black');

Atheneum.Colour.RED = new Atheneum.Colour('red');
Atheneum.Colour.GREEN = new Atheneum.Colour('green');
Atheneum.Colour.BLUE = new Atheneum.Colour('blue');

Atheneum.Colour.TRANSPARENT = new Atheneum.Colour('transparent');

Atheneum.Contact = function (object) {
    if (!(this instanceof Atheneum.Contact)) {
        return new Atheneum.Contact(object);
    }
    for (prop in object) {
        if (object.hasOwnProperty(prop)) {
            this[prop] = object[prop];
        }
    }
    this.sanityCheck();
}

Atheneum.Contact.prototype.sanityCheck = function () {
    if (!(this.info)) {
        this.info = {};
    }
    if (!(this.info.email && this.email)) {
        this.info.email = this.email;
    }
    if (!(this.info.to) && this.email) {
        this.info.to = this.email;
    }
    if (!(this.email) && this.info.to) {
        this.email = this.info.to;
    }
    if (!(this.info.email) && this.info.to) {
        this.info.email = this.info.to;
    }
}

Atheneum.Contact.prototype.isConsented = function () {
    return (this.status == Atheneum.Contact.Status.SUBSCRIBED) || (this.status == Atheneum.Contact.Status.SUBSCRIBED_PENDING);
}

Atheneum.Contact.Status = {};
Atheneum.Contact.Status.SUBSCRIBED = 'SUBSCRIBED';
Atheneum.Contact.Status.SUBSCRIBED_PENDING = 'SUBSCRIBED_PENDING';
Atheneum.Contact.Status.PENDING = 'PENDING';
Atheneum.Contact.Status.UNSUBSCRIBED = 'UNSUBSCRIBED';

Atheneum.Contact.prototype.isBlocked = function (formId, includeOtherFormSubmissionsInCount, maxSubmissionsPerContact) {
    if (typeof maxSubmissionsPerContact === 'undefined' || maxSubmissionsPerContact <= 0 || (includeOtherFormSubmissionsInCount == "false" && !this.formSubmissionsCount[formId])) {
        return false;
    }
    return (includeOtherFormSubmissionsInCount == "true" ? this.totalFormSubmissions >= maxSubmissionsPerContact : this.formSubmissionsCount[formId] >= maxSubmissionsPerContact);
}

/**
 * 
 * Contacts API
 * 
 * Provides a series of methods to retrieve information about contacts.
 * 
 */

Atheneum.Contacts = function AtheneumContacts(atheneum) {
    this.Atheneum = atheneum;
    this.timestamp = undefined;
    this.contactsLoaded = false;
    let atheneumContacts = this;

    this.contactHelper = undefined;
    let useOnlyDb = this.Atheneum.Theme.getBooleanProperty('useContactsDBOnly', false);
    if(window.Dexie && useOnlyDb){
            this.contactHelper = new AtheneumContactsHelper(atheneum);
    }else if(window.Dexie && !this.Atheneum.CrossPlatform.enabled && SalesToolkit.Theme.getBooleanProperty("useDBForContacts", false)){
            window.indexedDB.deleteDatabase("AtheneumContactsHelper");
            this.db = new Dexie("AtheneumContactsStorage");
            this.db.version(1).stores({
                json: 'key'
            });
    }else{
         window.indexedDB.databases().then((databases) => {
            for (let i = 0; i < databases.length; i++) {
                // Check if the database name starts with the target string
                if (databases[i].name.startsWith('AtheneumContactsHelper')) {
                    // If it matches, delete it.
                    window.indexedDB.deleteDatabase(databases[i].name);
                }
            }
        });
    }

    const promise = new Promise(async resolve =>{
        resolve(await atheneumContacts.loadFromStorage(useOnlyDb? false : this.Atheneum.Theme.getBooleanProperty('delayContactsLoading', false)));
    }).then(value => {
        atheneumContacts.totalNumberOfContacts = atheneumContacts.totalContacts;
        atheneumContacts.caching = atheneumContacts.totalContacts == 0;
        if(atheneumContacts.delayed){
            atheneumContacts.contactsLoaded = false;
        }else{
            atheneumContacts.contactsLoaded = true;
        }; // promise: always a promise
    });

    this.__contactPageSize = this.Atheneum.Theme.getIntegerProperty('contactsPerPage', '10000');
    
    this.__proxyContactPageSize = 250;
    this.__delayBetweenContactPageRequests = 0;
    this.__proxyDelayBetweenContactPageRequests = 0;
    this.__abortAnyCacheAttemptStartedBefore = undefined;
    this.__preferProxyQueryToCache = false;
    this.__preferLiveQueryToCache = false;
    
   
}

Atheneum.Contacts.prototype.getCustomFieldListForForm = function (form){
    if(this.contactHelper)
        return this.contactHelper.getCustomFieldListForForm(form);
    let fieldList = "";
    let typeIgnoreList = this.Atheneum.Theme.getStringProperty('customFieldListIgnoreTypeList', 'HIDDEN,SIGNATURE,LABEL,FILE,SIGNATURE,SELECT,RADIO,RADIO_MULTI,CONSENT_TYPE,CONFIRM');
    typeIgnoreList = typeIgnoreList.split(',');

    for(let i=0; i< form.fields.length; i++){
        let field = form.fields[i];
        if(typeIgnoreList.indexOf(field.type) >= 0)
            continue;

        if(fieldList.length == 0)
            fieldList += this.Atheneum.Theme.getStringProperty('customFieldNameConversion_'+field.name, field.name);
        else
            fieldList += ("," + this.Atheneum.Theme.getStringProperty('customFieldNameConversion_'+field.name, field.name));
    }

    return fieldList;
}

Atheneum.Contacts.prototype.clearCache = async function () {
    if(this.contactHelper)
        await this.contactHelper.clearCache();
    this.cache = {};
    this.totalNumberOfContacts = 0;
    this.totalContacts = 0;
    this.timestamp = undefined;
    this.__abortAnyCacheAttemptStartedBefore = new Date().getTime();

    this.saveToStorage(true);
}

Atheneum.Contacts.prototype.getTotalNumberOfContacts = async function () {
    if(this.contactHelper){
        if(!this.contactHelper.totalContacts || this.contactHelper.totalContacts == 0)
             return await this.contactHelper.getTotalContacts();
        else
            return this.contactHelper.totalContacts;
    }
       
    let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
    if(!TRUE_VALUES.contains(this.Atheneum.User.test)){
        return Object.values(this.cache).filter(x=> !x.hasOwnProperty('test')  || !x.test).length;
    }
    return this.totalNumberOfContacts;
}

Atheneum.Contacts.prototype.saveToStorage = function (force = false) {

    if(this.contactHelper)
        return this.contactHelper.saveToStorage();

    this.Atheneum.LocalStorage.set('atheneumContactsCachedInstance', this.Atheneum.API.BASE_URL);
     let atheneumContacts = this;


     let locations = (window.location.href.indexOf('viewForm') < 0 && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0);
     if(this.Atheneum.Theme.getBooleanProperty('includeCartInContactsNeeded', false)){
         locations = (window.location.href.indexOf('viewForm') < 0 && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0 && window.location.href.indexOf('cart') < 0 && !(window.location.href.indexOf('index.html') >= 0 && !document.body.classList.contains('module-cart')));
     }
 
     if (!force && this.totalContacts > 0 && this.Atheneum.Theme.getBooleanProperty('onlyLoadContactsIfNeeded', false) && locations) {
         return;
     }

    try {
        this.totalContacts = Object.keys(this.cache).length;
        this.Atheneum.LocalStorage.set('totalContacts', this.totalContacts);
        this.Atheneum.LocalStorage.set('atheneumContactsCachedTimestamp', this.timestamp);
   
    } catch (err) {
        console.log(err);
        this.totalContacts = 0;
        this.timestamp = 0;
        this.Atheneum.LocalStorage.set('atheneumContactsCachedTimestamp', this.timestamp);
    }
   

    if(atheneumContacts.db){
        return new Promise((resolve, reject) =>{
            var contactData = JSON.stringify(atheneumContacts.cache);
            
            let start = performance.now();
            let db = atheneumContacts.db;
            db.json.put({key: "atheneumContacts", data: contactData}).then(function(data){
                let end = performance.now();
                console.log('saved contacts cache to db in '+(end - start)+'ms');
                resolve();
            }).catch(function(error){
                console.log(error);
            });
          
        });
    }

    if (this.Atheneum.CrossPlatform.enabled && (this.Atheneum.CrossPlatform.isAndroid() || this.Atheneum.Theme.getBooleanProperty('saveIOSContactsInChunks', false))) {
        this.saveToStorageIndividually();
    } else {
        try {
            this.Atheneum.LocalStorage.set('atheneumContacts', JSON.stringify(this.cache));
        } catch (err) { }
    }

    this.caching = false;
}

Atheneum.Contacts.prototype.saveToStorageIndividually = function(){
    const chunkSize = 25000;
    let array = Object.values(this.cache);
    let chunkIndex = 0;
    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        this.Atheneum.LocalStorage.set('atheneumContacts' + chunkIndex, JSON.stringify(chunk));
        chunkIndex += 1;
    }
}

Atheneum.Contacts.prototype.loadFromStorage = async function (delay = false) {

    if(this.contactHelper)
        return await this.contactHelper.loadFromStorage(delay);
    try {

        if ((this.Atheneum.LocalStorage.get('atheneumContactsCachedInstance') || "") != this.Atheneum.API.BASE_URL) {
            //If the current instance logged into is not the one the contacts were cached for return blank so that it can rebuild for the new instance
            this.timestamp = undefined;
            this.cache = {};
            this.totalContacts = 0;
            return;
        } else {
            //Same instance, we are ok to use stored cache
            try{
                this.timestamp = parseInt((this.Atheneum.LocalStorage.get('atheneumContactsCachedTimestamp') || 0));
            }catch(err){

            }
           
            
        }
    } catch (err) { }

    try {
        let contactsCount = this.Atheneum.LocalStorage.get('totalContacts') || '0';
        this.totalContacts = parseInt(contactsCount);
        if(this.totalContacts == 0)
            this.timestamp = 0;
    } catch (err) {
        console.log(err);
        this.totalContacts = 0;
    }

    let locations = (window.location.href.indexOf('viewForm') < 0 && !document.body.classList.contains("module-previewForm") && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0);
    if(this.Atheneum.Theme.getBooleanProperty('includeCartInContactsNeeded', false)){
        locations = (window.location.href.indexOf('viewForm') < 0 && !document.body.classList.contains("module-previewForm") && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0 && window.location.href.indexOf('cart') < 0 && !(window.location.href.indexOf('index.html') >= 0 && !document.body.classList.contains('module-cart')));
    }


    if(delay){
        this.cache = {};
        this.delayed = true;
        return;
    }

    this.delayed = false;

    if (this.totalContacts > 0 && this.Atheneum.Theme.getBooleanProperty('onlyLoadContactsIfNeeded', false) && locations) {
        this.cache = {};
        return;
    }

    if(this.db){
        let atheneumContacts = this;
        return new Promise((resolve, reject) => {

            let db =  atheneumContacts.db;
            db.json.get("atheneumContacts").then(function(entry){
                try{
                    let contactData = entry.data;
                    contactData = JSON.parse(contactData);
                    if(contactData != null) {
                        atheneumContacts.cache = contactData;
                    }

                    atheneumContacts.totalContacts = Object.keys(contactData).length;
                    for (key of Object.keys(atheneumContacts.cache)) {
                        if(!(atheneumContacts.cache[key] instanceof Atheneum.Contact)){
                            atheneumContacts.cache[key] = new Atheneum.Contact(atheneumContacts.cache[key]);
                        }
                    }
                    
                    resolve(true);
                }catch(err){
                    console.log(err);
                }
                resolve(false)
            }).catch(function callback (error) {
                // Handle error
                console.log(error);
                resolve(false);
            });
          });
    }

    if (this.Atheneum.CrossPlatform.enabled && (this.Atheneum.CrossPlatform.isAndroid() || this.Atheneum.Theme.getBooleanProperty('saveIOSContactsInChunks', false))) {
        this.loadFromStorageIndividually();
    } else {
        try {
            this.cache = JSON.parse((this.Atheneum.LocalStorage.get('atheneumContacts') || '{}')) || {};
            for (key of Object.keys(this.cache)) {
                if (!(this.cache[key] instanceof Atheneum.Contact)) {
                    this.cache[key] = new Atheneum.Contact(this.cache[key]);
                }
            }
        } catch (err) { }
    }
}

Atheneum.Contacts.prototype.loadFromStorageIndividually = function(){
    let i;
    let max = this.totalContacts;

    if (typeof this.cache === 'undefined')
        this.cache = {};

    const chunkSize = 25000;
    const limit = Math.ceil(max / chunkSize);
    let fullArray = [];
    for (let i = 0; i < limit; i++) {
        let stringValue = this.Atheneum.LocalStorage.get('atheneumContacts' + i) || "";
        if (typeof stringValue !== 'string' || stringValue == '' || stringValue == 'null')
            break;
        const chunk = JSON.parse(stringValue);
        for (let j = 0; j < chunk.length; j++) {
            if(!(chunk[j] instanceof Atheneum.Contact)){
                chunk[j] = new Atheneum.Contact(chunk[j]);
            }
        }

       fullArray = fullArray.concat(chunk);
    }

    fullArray = fullArray.filter(x=> x != null);

    this.cache = Object.fromEntries(fullArray.map(x => [x.id, x]));

}

Atheneum.Contacts.prototype.getByFieldValueAsync = async function (fieldName, fieldValue, partial, limit, successCallbackOrCallbacks, failureCallback, offlineCallback, formFilterMode = false, formObj, $form) {

    if(this.contactHelper)
        return await this.contactHelper.getByFieldValueAsync(fieldName, fieldValue, partial, limit, successCallbackOrCallbacks, failureCallback, offlineCallback, formFilterMode, formObj, $form);

    var atheneum = this.Atheneum;
    var callbacks = Atheneum.Callbacks.parse(successCallbackOrCallbacks, failureCallback, offlineCallback);

    if (fieldValue == '') {
        callbacks.success([]);
        return;
    }

    if (fieldValue == null)
        fieldValue = '';

    if (atheneum.Contacts.__preferProxyQueryToCache && atheneum.Proxy.enabled) {
        return atheneum.HttpUtils.getJSON("/restful/contacts/query", {
            'apikey': this.Atheneum.User.apikey,
            'fieldName': fieldName,
            'value': fieldValue,
            'partial': partial,
            'limit': limit
        }, {
            success: function (json) {
                if (json.contacts) {
                    for (var c = 0; c < json.contacts.length; c++) {
                        var contact = json.contacts[c];
                        if (contact.id) {
                            var existingContact = atheneum.Contacts.cache[json.contacts[c].id];
                            if (existingContact == null) {
                                atheneum.Contacts.cache[json.contacts[c].id] = new Atheneum.Contact(json.contacts[c]);
                            }
                            else {
                                if (existingContact.info) {
                                    for (var prop in existingContact.info) {
                                        if (!(existingContact.info.hasOwnProperty(prop))) {
                                            continue;
                                        }
                                        delete existingContact.info[prop];
                                    }
                                }
                                else {
                                    existingContact.info = {};
                                }
                                // preserve references to contact and info, but make sure they're updated
                                for (var prop in existingContact) {
                                    if (!(existingContact.hasOwnProperty(prop))) {
                                        continue;
                                    }
                                    if (prop != 'info') {
                                        delete existingContact[prop];
                                    }
                                }
                                for (var prop in json.contacts[c]) {
                                    if (!(json.contacts[c].hasOwnProperty(prop))) {
                                        continue;
                                    }
                                    if (prop != 'info') {
                                        existingContact[prop] = json.contacts[c][prop];
                                    }
                                }
                                if (json.contacts[c].info) {
                                    for (var prop in json.contacts[c].info) {
                                        if (!(json.contacts[c].info.hasOwnProperty(prop))) {
                                            continue;
                                        }
                                        existingContact.info[prop] = json.contacts[c].info[prop];
                                    }
                                }
                                if (!(existingContact.info.email)) {
                                    existingContact.info.email = existingContact.email;
                                }
                                if (!(existingContact.info.to)) {
                                    existingContact.info.to = existingContact.email;
                                }
                            }

                        }
                    }
                }
                callbacks.success(json.contacts);
            },
            failure: function (reason, httpStatus, errorCode) {
                callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Contacts.getByFieldValueAsync [Proxied]');
            },
            offline: function (reason, httpStatus, errorCode) {
                callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Contacts.getByFieldValueAsync [Proxied]');
            }
        });
    }
    else if (atheneum.Contacts.__preferLiveQueryToCache) {
        // make a query to atheneum
        return atheneum.API.searchContacts({
            fieldName: fieldName,
            query: fieldValue,
            partialMatch: partial,
            itemsPerPage: limit
        }, {
            success: function (searchResults) {
                var contacts = [];
                if (searchResults && searchResults.contacts) {
                    for (var c = 0; c < searchResults.contacts.length; c++) {
                        var contact = searchResults.contacts[c];
                        var existingContact = atheneum.Contacts.cache[contact.id];
                        if (existingContact == null) {
                            atheneum.Contacts.cache[contact.id] = new Atheneum.Contact(contact);
                        }
                        else {

                            // delete all properties in old contact not in new contact data
                            for (var prop in existingContact) {
                                if (contact.hasOwnProperty(prop)) {
                                    continue;
                                }
                                if (prop != 'info') {
                                    delete existingContact[prop];
                                }
                            }
                            if (existingContact.info) {
                                // delete all properties in info that are now gone
                                for (var infoProp in existingContact.info) {
                                    if (contact.info && contact.info.hasOwnProperty(prop)) {
                                        continue;
                                    }
                                    delete existingContact.info[prop];
                                }
                            }

                            // overwrite existing contact data with new contact data
                            for (var prop in contact) {
                                if (!(contact.hasOwnProperty(prop))) {
                                    continue;
                                }
                                if (prop == 'info') {
                                    if (!existingContact.info) {
                                        existingContact.info = {};
                                    }
                                    for (var i = 0; i < contact.info.length; i++) {
                                        existingContact.info[i] = contact.info[i];
                                    }
                                }
                                else {
                                    existingContact[prop] = contact[prop];
                                }
                            }

                            // ensure info, email, info.to, etc are populated
                            existingContact.sanityCheck();
                        }

                        contacts[contacts.length] = new Atheneum.Contact(contact);
                    }
                }

                if (searchResults.totalUnfilteredContacts) {
                    Atheneum.Contacts.totalNumberOfContacts = searchResults.totalUnfilteredContacts;
                }

                callbacks.success(contacts);
            },
            failure: function (reason, httpStatus, errorCode) {
                callbacks.failure(reason, httpStatus, errorCode, 'Atheneum.Contacts.getByFieldValueAsync');
            },
            offline: function (reason, httpStatus, errorCode) {
                callbacks.offline(reason, httpStatus, errorCode, 'Atheneum.Contacts.getByFieldValueAsync');
            }
        });
    }
    else {
        // check the cache

        var options = {
            exact: partial == null ? null : !partial,
            consented: null,
            limit: limit,
            offset: 0
        };

        
        if(formFilterMode && fieldValue.length >= 3 && typeof formObj === 'object'){
            let oldLimit = options.limit;
            options.limit = 0;
            var contacts = await this.getByFieldValue(fieldName, fieldValue, options);

            for(let i=0; i< formObj.fields.length; i++){
                let fieldObj = formObj.fields[i];
                let key = fieldObj.name;
                let field = $form.find(
                    'input[name="' + key + '"]'
                    + ', select[name="' + key + '"]'
                    + ', textarea[name="' + key + '"]'
                );

                if (field.length == 0)
                    continue;
                if(key === fieldName)
                    continue;

                field = field[0];

                if (field.type !== 'text')
                    continue;

                let val = $(field).val();
                if (val !== undefined && val.length > 0) {
                    contacts = contacts.filter(x=> !x.info.hasOwnProperty(key) || (x.info[key].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(val.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) >= 0))
                }
            }

            if(oldLimit > 0)
                contacts = contacts.slice(0, oldLimit);

            callbacks.success(contacts);
            return;
        }

        var contactList = await this.getByFieldValue(fieldName, fieldValue, options);
        callbacks.success(contactList);
    }
}

/**
 * 
 * config:
 * 	
 * 		initiatedAt		- timestamp of when the call to Atheneum.Contacts.update was made
 * 
 * 		delay			- time to wait between requests
 * 
 * 		timestamp 		- request timestamp (last time contacts were updated, or undefined)
 * 		contactsPerPage	- request itemsPerPage
 * 		pageIndex		- request pageIndex
 * 
 * 		callbacks		- callbacks { success, failure, offline, progress }
 * 
 * 		timestampAfter	- new timestamp after call to contacts is complete (initially undefined)
 * 
 */
Atheneum.Contacts.prototype.__downloadContacts = function (config) {

    if(this.contactHelper)
        return this.contactHelper.downloadContacts(config);
    var atheneum = this.Atheneum;

    if (atheneum.Contacts.__abortAnyCacheAttemptStartedBefore
        && atheneum.Contacts.__abortAnyCacheAttemptStartedBefore > config.intiatedAt) {
        return callbacks.failure(Atheneum.API.Problems.USER_ABORT, 200, 0, "Atheneum.Contacts.update");
    }

    var downloadSuccessCallback = function (json) {

        if (atheneum.Contacts.__abortAnyCacheAttemptStartedBefore
            && atheneum.Contacts.__abortAnyCacheAttemptStartedBefore > config.intiatedAt) {
            return callbacks.failure(Atheneum.API.Problems.USER_ABORT, 200, 0, "Atheneum.Contacts.update");
        }

        if ((config.timestamp == undefined && config.pageIndex == 0) || (config.pageIndex == 0 && json.accessLevelChanged === true)) {
            //TODOFROMROB possible new flag if(json.accessLevelChanged)
            //     config.timestamp = 0;
            
            atheneum.Contacts.cache = {};
            atheneum.Contacts.totalNumberOfContacts = 0;
        }

        if (config.timestampAfter == undefined && json.timestamp) {
            config.timestampAfter = json.timestamp;
        }

        if (json.contacts) {
            let shouldStripContactsToMinimum = atheneum.Theme.getBooleanProperty('stripContactsInformation', false);
            let shouldDeleteLocalSubmissionInfo = atheneum.Theme.getBooleanProperty('stripContactsSubmissionInformation', false);
            let shouldDeleteTestInfo = atheneum.Theme.getBooleanProperty('stripContactsTestInformation', false);
            let shouldDeleteGroupsInfo = atheneum.Theme.getBooleanProperty('stripContactGroupInformation', false);

            for (var c = 0; c < json.contacts.length; c++) {
                var contact = new Atheneum.Contact(json.contacts[c]);
                if (atheneum.Contacts.cache[contact.id] == undefined) {
                    atheneum.Contacts.totalNumberOfContacts += 1;
                }

                if(shouldStripContactsToMinimum){
                    delete contact.created;
                    delete contact.modified;
                    delete contact.createdBy;
                    delete contact.lastModifiedBy;
                }

                if(shouldDeleteLocalSubmissionInfo){
                    delete contact.formSubmissionsCount;
                    delete contact.totalFormSubmissions;
                    delete contact.repSubmitted;
                }

                if(shouldDeleteTestInfo){
                    delete contact.test;
                }

                if(shouldDeleteGroupsInfo){
                    delete contact.groups;
                }

                atheneum.Contacts.cache[contact.id] = contact;
            }
        }
        if (json.deletedContacts) {
            for (var c = 0; c < json.deletedContacts.length; c++) {
                var deletedContactId = json.deletedContacts[c];
                if (atheneum.Contacts.cache[deletedContactId] != undefined) {
                    atheneum.Contacts.totalNumberOfContacts -= 1;
                }
                delete atheneum.Contacts.cache[deletedContactId];
            }
        }

        var totalContacts = json.totalContacts || (json.contacts && json.contacts.length) || 0;
        var modifiedContacts = (config.timestamp == undefined || config.timestamp == 0) ? totalContacts : (json.modifiedContacts || json.contacts.length);

        if ((config.pageIndex || 0) == 0 && config.timestamp == undefined || config.timestamp == 0 && totalContacts > Object.keys(atheneum.Contacts.cache).length) {
            atheneum.Contacts.caching = true;
        }

        var totalPages = Math.ceil(modifiedContacts / config.contactsPerPage);

        var remainingPagesToDownload = Math.max(0, ((totalPages || 1) - config.pageIndex - 1));

        var now = new Date().getTime();

        var estimatedTimePerPage = (now - config.initiatedAt) / ((config.pageIndex || 0) + 1);
        if (estimatedTimePerPage == 0) {
            estimatedTimePerPage = config.delay || 50;
        }

        var estimatedCompletionDate = now + (estimatedTimePerPage * remainingPagesToDownload);

        if (typeof config.callbacks.progress === 'function') {
            config.callbacks.progress({
                failured: 0,
                syncedContacts: atheneum.Contacts.totalNumberOfContacts,
                totalContacts: totalContacts,
                successes: config.pageIndex + 1,
                remaining: remainingPagesToDownload,
                total: totalPages || 1,
                done: (remainingPagesToDownload == 0),
                percentage: ((config.pageIndex + 1) / (totalPages || 1)) * 100,
                eta: estimatedCompletionDate
            }, json);
        }

        if (remainingPagesToDownload == 0) {
            atheneum.Contacts.timestamp = config.timestampAfter;
            const promise = Promise.resolve(atheneum.Contacts.saveToStorage()).then(value => {
                config.callbacks.success(json);
            }); // promise: always a promise
        }
        else {
            var configForNextDownloadCall = {
                initiatedAt: config.initiatedAt,
                timestamp: config.timestamp,
                contactsPerPage: config.contactsPerPage,
                pageIndex: config.pageIndex + 1,
                callbacks: config.callbacks,
                timestampAfter: config.timestampAfter,
                delay: config.delay
            };

            if (config.delay) {
                window.setTimeout(function () {
                    atheneum.Contacts.__downloadContacts(configForNextDownloadCall);
                }, config.delay);
            }
            else {
                atheneum.Contacts.__downloadContacts(configForNextDownloadCall);
            }
        }
    }

    //todo crossplatform
    if (this.Atheneum.Proxy.enabled) {
        Atheneum.HttpUtils.getJSON('/restful/contacts', { pageIndex: config.pageIndex, itemsPerPage: config.contactsPerPage }, {
            success: downloadSuccessCallback,
            failure: function (reason, httpStatus, errorCode) {
                config.callbacks.failure(reason, httpStatus, errorCode, "Atheneum.Contacts.update [Proxied]");
            },
            offline: function (reason, httpStatus, errorCode) {
                // this should never happen
                config.callbacks.offline(reason, httpStatus, errorCode, "Atheneum.Contacts.update [Proxied]");
            }
        });
    }
    else {
        this.Atheneum.API.getContacts(config.contactsPerPage, config.pageIndex, config.timestamp, {
            success: downloadSuccessCallback,
            failure: function (reason, httpStatus, errorCode) {
                config.callbacks.failure(reason, httpStatus, errorCode, "Atheneum.Contacts.update");
            },
            offline: function (reason, httpStatus, errorCode) {
                config.callbacks.offline(reason, httpStatus, errorCode, "Atheneum.Contacts.update");
            }
        });
    }
}

Atheneum.Contacts.prototype.update = function AtheneumContacts_update(successCallbackOrCallbacks, failureCallback, offlineCallback) {

     if(this.contactHelper)
       return this.contactHelper.update(successCallbackOrCallbacks, failureCallback, offlineCallback);
    var atheneum = this.Atheneum;
    var callbacks = Atheneum.Callbacks.parse(successCallbackOrCallbacks, failureCallback, offlineCallback);

   if( atheneum.Theme.getBooleanProperty('disableContacts', false)){
        try {
            callbacks.failure();
            return;
        } catch (error) {
            console.log(err);
        }
   }

    if (!callbacks.progress) {
        callbacks.progress = function (progress, json) { /* do nothing */ };
    }

    //TODO crossplatform
    var downloadContactsConfig = {
        initiatedAt: new Date().getTime(),
        timestamp: atheneum.Contacts.timestamp || 0,
        contactsPerPage: atheneum.Proxy.enabled ? atheneum.Contacts.__proxyContactPageSize : atheneum.Contacts.__contactPageSize,
        pageIndex: 0,
        callbacks: callbacks,
        delay: atheneum.Proxy.enabled ? atheneum.Contacts.__proxyDelayBetweenContactPageRequests : atheneum.Contacts.__delayBetweenContactPageRequests
    };

    this.__abortAnyCacheAttemptStartedBefore = downloadContactsConfig.initiatedAt - 1;

    this.__downloadContacts(downloadContactsConfig);
}

// Atheneum.Contacts.prototype.deleteOrphanedContacts = async function AtheneumContacts_deleteOrphanedContacts(){
//     if(this.contactHelper)
//         return await this.contactHelper.deleteOrphanedContacts();

//     return true;
// }

Atheneum.Contacts.prototype.query = async function AtheneumContacts_query(query, successCallbackOrCallbacks, failureCallback, offlineCallback) {

    if(this.contactHelper)
       return await this.contactHelper.query(query, successCallbackOrCallbacks, failureCallback, offlineCallback);

    var buffer = '';
    var bufferType = undefined;
    var stringType = undefined;

    var tokens = [];
    for (var c = 0; c < query.length; c++) {

        if ((bufferType == 'object' || bufferType == 'symbol') && (query[c] == ' ' || query[c] == '\n' || query[c] == '\t')) {
            if (bufferType == 'object' && ['true', 'false'].indexOf(buffer.toLowerCase()) != -1) {
                bufferType = 'boolean';
                buffer = buffer.toLowerCase();
            }
            else if (bufferType == 'object' && ['select', 'from', 'like', 'where', 'limit', 'offset', 'and', 'or'].indexOf(buffer.toLowerCase()) != -1) {
                bufferType = 'keyword';
                buffer = buffer.toLowerCase();
            }
            tokens.push({ type: bufferType, value: buffer });
            bufferType = 'whitespace';
            buffer = '';
        }

        if ((bufferType == undefined || bufferType == 'whitespace') && (query[c] == ' ' || query[c] == '\n' || query[c] == '\t')) {
            bufferType = 'whitespace';
            buffer += query[c];
            continue;
        }

        if (bufferType == 'whitespace') {
            tokens.push({ type: bufferType, value: buffer });
            bufferType = undefined;
            buffer = '';
        }

        if (bufferType == undefined && (query[c] == '"' || query[c] == '\'')) {
            stringType = query[c];
            bufferType = 'string';
            continue;
        }

        if (bufferType == 'string' && query[c] == stringType) {
            tokens.push({ type: 'string', value: buffer });
            bufferType = undefined;
            stringType = undefined;
            buffer = '';
            continue;
        }

        if (bufferType != 'string' && ['=', '!', '&', '|', '*'].indexOf(query[c]) != -1) {
            if (buffer != '') {
                tokens.push({ type: bufferType, value: buffer });
            }
            stringType = undefined;
            bufferType = 'symbol';
            buffer = query[c];
            continue;
        }

        if (bufferType != 'number' && bufferType != 'string' && query[c] == '.') {
            tokens.push({ type: bufferType, value: buffer });
            bufferType = 'symbol';
            buffer = query[c];
            tokens.push({ type: 'symbol', value: '.' });
            bufferType = undefined;
            buffer = '';
            continue;
        }

        if (bufferType != 'object' && bufferType != 'string' && ['0123456789'].indexOf(query[c]) != -1) {
            if (bufferType != 'number') {
                tokens.push({ type: 'symbol', value: '.' });
                bufferType = 'number';
                buffer = '';
            }
            stringType = undefined;
            bufferType = 'number';
            buffer += query[c];
            continue;
        }

        if (bufferType == undefined) {
            bufferType = 'object';
        }
        buffer += query[c];
        continue;

    }
    if (buffer != '' && bufferType != 'string') {
        tokens.push({ type: bufferType, value: buffer });
    }
    if (bufferType == 'string') {
        throw new Atheneum.Contacts.QuerySyntaxError('unclosed string in query');
    }

    if (tokens.length > 0 && tokens[0].type == 'whitespace') {
        tokens = tokens.splice(1);
    }
    if (tokens.length > 0 && tokens[tokens.length - 1].type == 'whitespace') {
        tokens = tokens.splice(0, tokens.length - 1);
    }

    tokens = tokens.filter(function (token) {
        return (token.type != 'whitespace');
    });

    if (tokens[0].type == 'keyword' && tokens[0].value == 'select'
        && tokens[1].type == 'object' && tokens[1].value == 'Contacts'
        && tokens[2].type == 'object' && tokens[2].value == 'where') {
        tokens.splice(1, 0, { type: 'keyword', value: 'from' });
        tokens.splice(1, 0, { type: 'symbol', value: '*' });
    }

    if (tokens[0].type == 'object'
        && tokens[1].type == 'keyword' && tokens[1].value == 'where') {
        tokens[0].unshift({ type: 'keyword', value: 'from' });
        tokens[0].unshift({ type: 'symbol', value: '*' });
        tokens[0].unshift({ type: 'keyword', value: 'select' });
    }

    if (tokens[0].type == 'keyword' && tokens[0].value == 'where') {
        tokens[0].unshift({ type: 'keyword', value: 'Contacts' });
        tokens[0].unshift({ type: 'keyword', value: 'from' });
        tokens[0].unshift({ type: 'symbol', value: '*' });
        tokens[0].unshift({ type: 'keyword', value: 'select' });
    }

    if (tokens[0].type == 'keyword' && tokens[0].value == 'from') {
        tokens[0].unshift({ type: 'symbol', value: '*' });
        tokens[0].unshift({ type: 'keyword', value: 'select' });
    }

    if (tokens[0].type == 'keyword' && tokens[0].value == 'select'
        && tokens[1].type == 'keyword' && tokens[1].value == 'from') {
        tokens.splice(1, 0, { type: 'symbol', value: '*' });
    }


    // TODO

    if ((tokens[0].type != 'keyword' && tokens[0].value != 'select')
        || (tokens[1].type != 'object' && tokens[1].type != 'symbol')
        || (tokens[2].type != 'keyword' && tokens[2].value != 'from')
        || (tokens[3].type != 'object')
    ) {
        throw new Atheneum.Contacts.QuerySyntaxError('syntax error');
    }

    if (!(tokens.length == 4
        || (tokens[4].type == 'keyword' && tokens[4].value == 'where')
        || (tokens[4].type == 'keyword' && tokens[4].value == 'limit'))
    ) {
        throw new Atheneum.Contacts.QuerySyntaxError('syntax error');
    }

    var fieldsToSelect = tokens[1].value;

    var limit = null;
    var offset = null;
    for (var t = 0; t < tokens.length; t++) {
        var token = tokens[t];

        if (token.type == 'keyword' && token.value == 'limit') {

            if (limit != null) {
                throw new Atheneum.Contacts.QuerySyntaxError('multiple instances of keyword \'limit\' in query');
            }

            if (tokens[t + 1] == undefined || tokens[t + 1].type != 'number') {
                throw new Atheneum.Contacts.QuerySyntaxError('expected number after keyword \'limit\'');
            }
            limit = tokens[t + 1] | 0;
        }

        if (token.type == 'keyword' && token.value == 'offset') {

            if (offset != null) {
                throw new Atheneum.Contacts.QuerySyntaxError('multiple instances of keyword \'offset\' in query');
            }

            if (tokens[t + 1] == undefined || tokens[t + 1].type != 'number') {
                throw new Atheneum.Contacts.QuerySyntaxError('expected number after keyword \'offset\'');
            }
            limit = tokens[t + 1] | 0;
        }
    }
    if (offset == null) {
        offset = 0;
    }

    var results = [];
    if (tokens[3].value == 'Contacts' || tokens[3].value == 'contacts' || tokens[3].value == 'CONTACTS') {

        if (tokens.length <= 4
            || tokens[4].type == 'keyword' && tokens[4].value == 'limit'
            || tokens[4].type == 'keyword' && tokens[4].value == 'offset'
        ) {
            results = [];
            for (var contact in this.cache) {
                results[results.length] = this.cache[contact];
            }
        }
        else if (tokens[5].type == 'object' && tokens[7].type == 'string') {
            if (tokens[6].type == 'symbol' && tokens[6].value == '=') {
                results = await this.getByFieldValue(tokens[5].value, tokens[7].value, { 'exact': true, 'limit': limit, 'offset': offset });
            }
            else if (tokens[6].type == 'keyword' && tokens[6].value == 'like') {
                results = await this.getByFieldValue(tokens[5].value, tokens[7].value.replace('%', ''), { 'exact': false, 'limit': limit, 'offset': offset });
            }
        }
    }

    if (fieldsToSelect == '*') {
        return results;
    }

    if (fieldsToSelect == 'id') {
        results = results.map(function (contact) { if (contact) { return contact.id; } else { return null; } });
    }
    if (fieldsToSelect == 'email') {
        results = results.map(function (contact) { if (contact) { return contact.email; } else { return null; } });
    }
    if (fieldsToSelect == 'firstName') {
        results = results.map(function (contact) { if (contact && contact.info) { return contact.info.firstName; } else { return null; } });
    }
    if (fieldsToSelect == 'lastName') {
        results = results.map(function (contact) { if (contact && contact.info) { return contact.info.lastName; } else { return null; } });
    }

    results = results.filter(function (result) { return result != null; });

    return results;
}

Atheneum.Contacts.QuerySyntaxError = function (message) {
    this.message = message;
    this.name = 'QuerySyntaxError';
    this.toString = function () {
        return this.name + ': ' + this.message;
    }
}

Atheneum.Contacts.FieldMap = {};
Atheneum.Contacts.FieldMap['id'] = 'id';
Atheneum.Contacts.FieldMap['email'] = 'email';
Atheneum.Contacts.FieldMap['firstname'] = 'info.firstName';
Atheneum.Contacts.FieldMap['lastname'] = 'info.lastName';

Atheneum.Contacts.prototype.getByFieldValue = async function (fieldName, fieldValue, options) {

    if(this.contactHelper)
    {
        return await this.contactHelper.getByFieldValue(fieldName, fieldValue, options);
    }
    var defaults = {
        exact: (fieldName.toLowerCase() == 'id'),
        consented: null,
        limit: null,
        offset: 0
    };

    var optionsToUseForQuery = {};
    for (var prop in defaults) {
        if (defaults.hasOwnProperty(prop)) {
            optionsToUseForQuery[prop] = defaults[prop];
        }
    }
    if (options != undefined) {
        for (var prop in options) {
            if (options.hasOwnProperty(prop)) {
                optionsToUseForQuery[prop] = options[prop];
            }
        }
    }

    var results = [];

    var fieldNameLowerCase = fieldName.toLowerCase();


    if (fieldNameLowerCase == 'id' && optionsToUseForQuery.exact) {
        var contact = this.cache[fieldValue];
        if (contact != undefined) {
            if (typeof (contact.isConsented) == 'undefined')
                contact = new Atheneum.Contact(contact);

            results.push(contact);
        }
    }
    else {
        var fieldNameChain = (Atheneum.Contacts.FieldMap[fieldNameLowerCase] || ('info.' + fieldName)).trim().split('.');
        for (var contactId in this.cache) {
            if (!this.cache.hasOwnProperty(contactId)) {
                continue;
            }

            var contact = this.cache[contactId];

            var objectToCheckValueOf = contact;
            for (var f = 0; f < (fieldNameChain.length - 1); f++) {
                var prop = fieldNameChain[f];
                if (objectToCheckValueOf[prop] != undefined) {
                    objectToCheckValueOf = objectToCheckValueOf[prop];
                }
                else {
                    objectToCheckValueOf = undefined;
                    break;
                }
            }
            var fieldValueOfContact = undefined;
            if (objectToCheckValueOf != undefined) {
                fieldValueOfContact = objectToCheckValueOf[fieldNameChain[fieldNameChain.length - 1]];
            }

            if (fieldValueOfContact == undefined) {
                continue;
            }

            var match = false;
            if (optionsToUseForQuery.exact) {
                match = fieldValueOfContact == fieldValue;
            }
            else if(fieldValue) {
                try{
                match = fieldValueOfContact.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(fieldValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) != -1;
                }catch(e){
                    console.log(e);
                }
            }else if(!optionsToUseForQuery.exact && !fieldValue){
                match = true;
            }

            if (match) {
                results.push(contact);
            }
        }
    }

    results = results.filter(function (result) {
        if (optionsToUseForQuery.consented == undefined
            || ((optionsToUseForQuery.consented == true) && result.isConsented())
            || ((optionsToUseForQuery.consented == false) && !(result.isConsented()))) {

            return true;
        }
        return false;
    });

    if (optionsToUseForQuery.offset && optionsToUseForQuery.offset >= results.length) {
        results = [];
    }
    else {
        results = results.splice(results.offset);
    }

    if (optionsToUseForQuery.limit && optionsToUseForQuery.limit < results.length) {
        results = results.splice(0, optionsToUseForQuery.limit);
    }

    return results;
}

Atheneum.Contacts.prototype.getById = async function (id, options) {
     if(this.contactHelper)
        return await this.contactHelper.getById(id, options);

    return await this.getByFieldValue('id', id, options);
}
Atheneum.Contacts.prototype.getByFirstName = async function (firstName, options) {
     if(this.contactHelper)
        return await this.contactHelper.getByFirstName(firstName, options);
    return await this.getByFieldValue('firstName', firstName, options);
}
Atheneum.Contacts.prototype.getByLastName = async function (lastName, options) {
     if(this.contactHelper)
        return await this.contactHelper.getByLastName(lastName, options);
    return await this.getByFieldValue('lastName', lastName, options);
}
Atheneum.Contacts.prototype.getByEmailAddress = async function (emailAddress, options) {
    if(this.contactHelper)
        return await this.contactHelper.getByEmailAddress(emailAddress, options);
    return await this.getByFieldValue('email', emailAddress, options);
}

Atheneum.Badges = function AtheneumBadges(atheneum) {
    if (!(this instanceof AtheneumBadges)) {
        return new AtheneumBadges(atheneum);
    }
    this.Atheneum = atheneum;
    this.lastScannedBadgeId = null;
    this.scannedAt = 0;
    this.badgeScanCallbacks = [];
    this.pollingForBadges = false;
}

Atheneum.Badges.prototype.lookup = function AtheneumBadges_lookup(badgeId, successCallbackOrCallbacks, failureCallback, offlineCallback) {
    var callback = Atheneum.Callbacks.parse(successCallbackOrCallbacks, failureCallback, offlineCallback);
    return this.Atheneum.API.getBadgeInfo(badgeId, {
        success: function (badge) {
            if (badge.errorCode != 0) {
                callback.failure(reason, httpStatus, badge.errorCode, "Atheneum.Badges.lookup");
            }
            else {
                var badgeSansErrorCode = {};
                for (prop in badge) {
                    if (badge.hasOwnProperty(prop) && (prop != 'errorCode')) {
                        badgeSansErrorCode[prop] = badge[prop];
                    }
                }
                if (callback.success) {
                    callback.success(badgeSansErrorCode);
                }
            }
        },
        failure: function (reason, httpStatus, errorCode) {
            callback.failure(reason, httpStatus, errorCode, "Atheneum.Badges.lookup");
        },
        offline: callback.offline || callback.failure
    });
}

Atheneum.Badges.prototype.addBadgeScanCallback = function AtheneumBadges_addBadgeScanCallback(callback) {
    this.badgeScanCallbacks.push(callback);
}

Atheneum.Badges.prototype.removeAllBadgeScanCallbacks = function AtheneumBadges_removeAllBadgeScanCallbacks() {
    this.badgeScanCallbacks = [];
}

Atheneum.Badges.prototype.triggerBadgeScanCallbacks = function AtheneumBadges_triggerBadgeScanCallbacks(badgeId) {
    for (var i = 0; i < this.badgeScanCallbacks.length; i++) {
        try {
            this.badgeScanCallbacks[i](badgeId);
        }
        catch (e) {
            console.error(e);
        }
    }
}

Atheneum.Badges.prototype.pollForLatestScannedBadge = function AtheneumBadges_pollForLatestScannedBadge() {
    var atheneum = this.Atheneum;

    if (atheneum.Badges.pollingForBadges) {
        // already polling
        return;
    }

    //TODO crossplatform
    if (Atheneum.Proxy.enabled) {
        window.setInterval(function () {
            Atheneum.HttpUtils.getJSON(window.location.origin + '/restful/badge-scanner/latest', {
                success: function (latestBadge) {

                    var isNewBadge = false;
                    if (latestBadge != null
                        && latestBadge.data != null
                        && (latestBadge.data != atheneum.Badges.lastScannedBadgeId
                            || latestBadge.scannedAt > (atheneum.Badges.scannedAt + 2500))
                    ) {
                        isNewBadge = true;
                    }

                    if (isNewBadge) {
                        atheneum.Badges.lastScannedBadgeId = latestBadge.data;
                        atheneum.Badges.scannedAt = latestBadge.scannedAt;
                        atheneum.Badges.triggerBadgeScanCallbacks(atheneum.Badges.lastScannedBadgeId);
                    }
                },
                failure: function (reason, httpStatus, errorCode) {
                    Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Badges.pollForLatestScannedBadge");
                }
            });
        }, 500);
        atheneum.Badges.pollingForBadges = true;
    }
    else if (window.Instascan && window.Instascan.Scanner && Instascan.Camera) {
        /*
        var scanner = new Instascan.Scanner({ scanPeriod: 5, refractoryPeriod: 2500, backgroundScan: false, mirror: false });
        scanner.addListener('scan', function (content, image) {
            var latestBadge = {
                data: content,
                scannedAt: new Date().getTime()
            }
        	
            var isNewBadge = false;
            if( latestBadge != null
                    && latestBadge.data != null
                    && (latestBadge.data != atheneum.Badges.lastScannedBadgeId
                        || latestBadge.scannedAt > (atheneum.Badges.scannedAt + 2500))
            ) {
                isNewBadge = true;
            }
        	
            if( isNewBadge ) {
                atheneum.Badges.lastScannedBadgeId = latestBadge.data;
                atheneum.Badges.scannedAt = latestBadge.scannedAt;
                atheneum.Badges.triggerBadgeScanCallbacks(atheneum.Badges.lastScannedBadgeId);
            }
        });
        Instascan.Camera.getCameras().then(function (cameras) {
            cameras = cameras;
            if (cameras.length > 0) {
                scanner.start(cameras[0]);
                atheneum.Badges.pollingForBadges = true;
            }
            else {
                console.error('No cameras found.');
            }
        }).catch(function (e) {
            console.error(e);
        });
        */
    }
}

Atheneum.Session = function AtheneumSession(atheneum) {

    if (!(this instanceof AtheneumSession)) {
        return new AtheneumSession(atheneum);
    }

    this.Atheneum = atheneum;
    this.sessionId = null;
    this.loadFromStorage();

    this.keepAliveInterval = window.setInterval(function () {
        if (atheneum && atheneum.Session && atheneum.Session.sessionId) {
            atheneum.API.keepSessionAlive({
                failure: function (reason, httpStatus, errorCode) {
                    if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT
                        && (errorCode == ATHENEUM_API_ERROR_SESSION_INVALID)) {
                        atheneum.Session.sessionId = null;
                        atheneum.Session.saveToStorage();
                    }
                }
            });
        }
    }, 31000);
}

Atheneum.Session.prototype.saveToStorage = function () {
    this.Atheneum.LocalStorage.set('atheneumSessionId', this.sessionId || '');
}

Atheneum.Session.prototype.loadFromStorage = function () {
    this.sessionId = this.Atheneum.LocalStorage.get('atheneumSessionId') || null;
}

Atheneum.Session.prototype.start = function (sessionVariables, callback) {
    var atheneum = this.Atheneum;
    var callback = Atheneum.Callbacks.parse(callback);
    return atheneum.API.startSession(sessionVariables, {
        success: function (json) {
            atheneum.Session.sessionId = json.sessionId;
            atheneum.Session.saveToStorage();
            callback.success(atheneum.Session.sessionId);
        },
        failure: function (reason, httpStatus, errorCode) {
            atheneum.Session.sessionId = 'offline-' + uuid();
             atheneum.Session.saveToStorage();
            callback.failure(reason, httpStatus, errorCode, 'Atheneum.Session.start');
        }
    });
}

Atheneum.Session.prototype.end = function (callback) {
    var atheneum = this.Atheneum;
    var callback = Atheneum.Callbacks.parse(callback);
    atheneum.Session.sessionId = null;
    atheneum.Session.saveToStorage();
    return atheneum.API.endSession({
        success: function () {
            callback.success();
        },
        failure: function (reason, httpStatus, errorCode) {
            callback.failure(reason, httpStatus, errorCode, 'Atheneum.Session.end');
        }
    });
}

Atheneum.Session.prototype.update = function (sessionVariables, callback) {
    var atheneum = this.Atheneum;
    var callback = Atheneum.Callbacks.parse(callback);
    return atheneum.API.keepSessionAlive(sessionVariables, {
        success: function () {
            callback.success();
        },
        failure: function (reason, httpStatus, errorCode) {
            if (reason == Atheneum.API.Problems.ERROR_CODE_PRESENT
                && (errorCode == ATHENEUM_API_ERROR_SESSION_INVALID)) {
                atheneum.Session.sessionId = null;
                atheneum.Session.saveToStorage();
            }
            callback.failure(reason, httpStatus, errorCode, 'Atheneum.Session.update');
        }
    });
}

//#region Plugins
Atheneum.Plugins = function AtheneumPlugins(atheneum) {

    if (!(this instanceof Atheneum.Plugins))
        return new Atheneum.Plugins(atheneum);

    this.Atheneum = atheneum;
    this.plugins = [];
    this.activeElementId = null;
    this.activePluginId = null;
    this.activePluginParameters = {};
    this.loadFromStorage();

}

Atheneum.Plugins.prototype.setActivePluginId = function (pluginId) {
    if (pluginId == undefined) {
        this.activePluginId = null;
    } else {
        this.activePluginId = pluginId;
    }

    this.saveToStorage();

}

Atheneum.Plugins.prototype.setActivePluginParameters = function (pluginParameters) {

    if (pluginParameters == undefined) {
        try {
            delete this.activePluginParameters[this.activePluginId]
        } catch (err) {

        }
    } else {
        this.activePluginParameters[this.activePluginId] = pluginParameters;
    }

    this.saveToStorage();

}

Atheneum.Plugins.prototype.setActiveElementId = function (element) {
    if (element == undefined || element.id == undefined) {
        this.activeElementId = null;
        this.saveToStorage();
        return;
    }

    this.activeElementId = element.id;
    this.saveToStorage();
}

Atheneum.Plugins.prototype.saveToStorage = function () {
    if (typeof this.activeElementId !== 'string')
        this.Atheneum.LocalStorage.clear("pluginsActiveElementId");
    else
        this.Atheneum.LocalStorage.set('pluginsActiveElementId', this.activeElementId);

    if (typeof this.activePluginId !== 'string')
        this.Atheneum.LocalStorage.clear("pluginsActivePluginId");
    else
        this.Atheneum.LocalStorage.set('pluginsActivePluginId', this.activePluginId);

    if (typeof this.activePluginParameters !== 'object')
        this.Atheneum.LocalStorage.clear("pluginsActivePluginParameters");
    else
        this.Atheneum.LocalStorage.set('pluginsActivePluginParameters', JSON.stringify(this.activePluginParameters));

    if (typeof this.plugins !== 'object')
        this.Atheneum.LocalStorage.clear("plugins");
    else
        this.Atheneum.LocalStorage.set('plugins', JSON.stringify(this.plugins));


}

Atheneum.Plugins.prototype.loadFromStorage = function () {

    try {
        this.activeElementId = this.Atheneum.LocalStorage.get('pluginsActiveElementId') || null;
        this.activePluginId = this.Atheneum.LocalStorage.get('pluginsActivePluginId') || null;
        var activeParams = this.Atheneum.LocalStorage.get('pluginsActivePluginParameters');

        this.activePluginParameters = (activeParams) ? JSON.parse(activeParams) : {};
        this.plugins = JSON.parse(this.Atheneum.LocalStorage.get('plugins')) || [];
    } catch (err) {
    }
}


Atheneum.Plugins.prototype.getActiveElementId = function () {
    return this.activeElementId;
}

Atheneum.Plugins.prototype.getPlugins = function (callbacks) {

    if (this.Atheneum.CrossPlatform.enabled) {
        var atheneumPlugins = this;
        var callback = function (json) {

            if (Array.isArray(json)) {
                let jsObj = json;
                jsObj.plugins = json;
                json = jsObj;
            }

            if (json && json.hasOwnProperty("plugins")) {
                let plugins = json.plugins.map( x => {
                    x.instance = atheneumPlugins.Atheneum.API.BASE_URL;
                    return x
                    });
                json.plugins = plugins;

                atheneumPlugins.plugins = json.plugins;
                atheneumPlugins.saveToStorage();
                callbacks.success(json.plugins);
            } else {
                callbacks.failure();
            }
        }

        this.Atheneum.CrossPlatform.getPlugins(callback);

    } else {
        var atheneumPlugins = this;
        var callback = {
            success: function (json) {
                let plugins = json.plugins.map( x => {
                    x.instance = atheneumPlugins.Atheneum.API.BASE_URL;
                    return x
                    });
                json.plugins = plugins;

                atheneumPlugins.plugins = json.plugins;
                atheneumPlugins.saveToStorage();
                callbacks.success(json.plugins);
            },
            failure: function (reason, httpStatus, errorCode) {
                callbacks.failure(reason, httpStatus, errorCode);
            }
        }

        this.Atheneum.API.getPlugins(callback);
    }
}

//#endregion

//#region Admin
//#region Plugins
Atheneum.Admin = function AtheneumAdmin(atheneum) {
    if (!(this instanceof Atheneum.Admin))
        return new Atheneum.Admin(atheneum);

    this.Atheneum = atheneum;
    this.userRegistrationStatuses = ["COMPLETE", "PREAPPROVED", "PENDING", "APPROVED", "REJECTED"];
    this.accounts = [];
    this.registrations = [];
    this.tags = [];
    this.users = [];
    this.groups = [];
    this.permissionSets = [];
    this.loadFromStorage();

}

/**
 * Saves admin information to storage, must provide key and data individually to avoid overhead
 * 
 * keys:
 * adminUserList
 * adminGroupsList
 * adminAccountList
 * adminRegistrationsList
 * adminTagsList
 * adminPermissionSetList
 * 
 * @param {*} key 
 * @param {*} data 
 */
Atheneum.Admin.prototype.saveToStorage = function (key, data) {
    let jsonToStore = JSON.stringify(data);
    this.Atheneum.LocalStorage.set(key, jsonToStore);
}

/**
 * Loads admin information from storage
 */
Atheneum.Admin.prototype.loadFromStorage = function () {

    try {
        //Users
        var data = this.Atheneum.LocalStorage.get('adminUserList') || "[]";
        this.users = JSON.parse(data || "[]");

        //Tags
        data = this.Atheneum.LocalStorage.get('adminPermissionSetList') || "[]";
        this.permissionSets = JSON.parse(data || "[]");

        //Accounts
        data = this.Atheneum.LocalStorage.get('adminAccountList') || "[]";
        this.accounts = JSON.parse(data || "[]");

        //Groups
        data = this.Atheneum.LocalStorage.get('adminGroupsList') || "[]";
        this.groups = JSON.parse(data || "[]");

        //Registrations 
        data = this.Atheneum.LocalStorage.get('adminRegistrationsList') || "[]";
        this.registrations = JSON.parse(data || "[]");

        //Tags
        data = this.Atheneum.LocalStorage.get('adminTagsList') || "[]";
        this.tags = JSON.parse(data || "[]");

         //Tag History
         //We only need this on profile page
         if(window.location.href.indexOf("extra_profile") >= 0){
            data = this.Atheneum.LocalStorage.get('adminTagHistory') || "[]";
            this.tagHistory = JSON.parse(data || "[]");
         }else{
            this.tagHistory = [];
         }
        
    } catch (err) {
    }
}

//ACCOUNTS
/**
 * Updates the accoutns available to this user
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.updateAccounts = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetAccounts({
        success: function (json) {
            admin.accounts = json.accounts;
            admin.saveToStorage('adminUserList', admin.accounts);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateAccounts');
            if(httpStatus === 401){
                admin.accounts = [];
                admin.saveToStorage('adminUserList', admin.accounts);
            }
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

//END ACCOUNTS

//USER GROUPS
/**
 * Updates user groups available to the current user to work with
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.updateUserGroups = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetUserGroups(undefined, true, {
        success: function (json) {
            admin.groups = json.groups;
            admin.saveToStorage('adminGroupsList', admin.groups);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if(httpStatus === 401){
                admin.groups = [];
            admin.saveToStorage('adminGroupsList', admin.groups);
            }
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUserGroups');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to create a new user group.
 * @param {string} name Name of the user group.
 * @param {string} description A text description for the purpose of this user group.
 * @param {number} priority An integer to identify this user groups priority. The lower the number the higher the priority (1 equals highest priority). 
 *                          If a user is in multiple groups, some situations may require a setting to be taken from their highest priority group. If this is not provided when creating a new user group, the new group will be setup with the lowest priority.
 * @param {array} userIds An array of the user IDs that belong to this user group.
 * @param {string} externalId Optional unique id for this user group in an external system.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.createUserGroup = function (name, description, priority, userIds, externalId, accountId, callback) {
    var admin = this;
    
    if (typeof (userIds) === 'object' && userIds.hasOwnProperty('success')) {
        //userIds is the callback
        callback = userIds;
        userIds = undefined;
        externalId = undefined;
        accountId = undefined;
    } else if (typeof (externalId) === 'object' && externalId.hasOwnProperty('success')) {
        //externalId is the callback
        callback = externalId;
        externalId = undefined;
        accountId = undefined;
    } else if (typeof (accountId) === 'object' && accountId.hasOwnProperty('success')) {
        //accountId is the callback
        callback = accountId;
        accountId = undefined;
    }
    var userGroupData = {
        name: name,
        description: description,
        priority: priority
    };

    if (typeof (userIds) !== 'undefined' && Array.isArray(userIds)) {
        userGroupData.userIds = userIds;
    } else {
        userGroupData.userIds = [];
    }

    if (typeof (externalId) === 'string') {
        userGroupData.externalId = externalId;
    }

    if (typeof (accountId) === 'string') {
        userGroupData.accountId = accountId;
    }

    this.Atheneum.API.adminCreateUserGroup(userGroupData, {
        success: function (json) {

            admin.groups.push(json.group);
            admin.saveToStorage('adminGroupsList', admin.groups);

            admin.updateUserGroups({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.createUserGroup');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to update user group.
 * @param {string} groupId id of the group to be updated
 * @param {string} name Name of the user group.
 * @param {string} description A text description for the purpose of this user group.
 * @param {number} priority An integer to identify this user groups priority. The lower the number the higher the priority (1 equals highest priority). 
 *                          If a user is in multiple groups, some situations may require a setting to be taken from their highest priority group. If this is not provided when creating a new user group, the new group will be setup with the lowest priority.
 * @param {array} userIds An array of the user IDs that belong to this user group.
 * @param {string} externalId Optional unique id for this user group in an external system.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.editUserGroup = function (groupId, name, description, priority, userIds, externalId, accountId, callback) {
    var admin = this;

    if (typeof (userIds) === 'object' && userIds.hasOwnProperty('success')) {
        //userIds is the callback
        callback = userIds;
        userIds = undefined;
        externalId = undefined;
        accountId = undefined;
    } else if (typeof (externalId) === 'object' && externalId.hasOwnProperty('success')) {
        //externalId is the callback
        callback = externalId;
        externalId = undefined;
        accountId = undefined;
    } else if (typeof (accountId) === 'object' && accountId.hasOwnProperty('success')) {
        //accountId is the callback
        callback = accountId;
        accountId = undefined;
    }

    var userGroupData = {
        name: name,
        description: description,
        priority: priority
    };

    if (typeof (userIds) !== 'undefined' && Array.isArray(userIds)) {
        userGroupData.userIds = userIds;
    } else {
        userGroupData.userIds = [];
    }

    if (typeof (externalId) === 'string') {
        userGroupData.externalId = externalId;
    }

    if (typeof (accountId) === 'string') {
        userGroupData.accountId = accountId;
    }

    this.Atheneum.API.adminEditUserGroup(groupId, userGroupData, {
        success: function (json) {

            admin.updateUserGroups({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editUserGroup');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * 
 * @param {string} groupId 
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.deactivateUserGroup = function (groupId, callback) {
    var admin = this;
    this.Atheneum.API.adminDeactivateUserGroup(groupId, {
        success: function (json) {

            admin.groups = admin.groups.filter(function (obj) {
                return obj.id !== groupId;
            });

            admin.saveToStorage('adminGroupsList', admin.groups);

            admin.updateUserGroups({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.deleteUserGroup');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to add users to the user group
 * @param {string} groupId id of the group to be updated
 * @param {array} userIds An array of the user IDs that belong to this user group.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.addUsersToGroup = function (groupId, userIds, callback) {
    var admin = this;

    this.Atheneum.API.adminAddUsersToGroup(groupId, userIds, {
        success: function (json) {

            let group = admin.groups.filter(function (obj) {
                return obj.id === groupId;
            });

            if (!group.userIds) {
                group.userIds = [];
            } else {
                group.userIds = group.userIds.filter(x => userIds.indexOf(x) == -1);
            }

            admin.groups = admin.groups.filter(function (obj) {
                return obj.id !== groupId;
            });

            admin.groups.push(group);
            admin.saveToStorage('adminGroupsList', admin.groups);

            admin.updateUserGroups({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editUserGroup');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to remove users from the user group
 * @param {string} groupId id of the group to be updated
 * @param {array} userIds An array of the user IDs that belong to this user group.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.removeUsersFromGroup = function (groupId, userIds, callback) {
    var admin = this;

    this.Atheneum.API.adminRemoveUsersFromGroup(groupId, userIds, {
        success: function (json) {

            let group = admin.groups.filter(function (obj) {
                return obj.id === groupId;
            });

            if (!group.userIds) {
                group.userIds = [];
            } else {
                group.userIds
            }

            let mergedIds = group.userIds.concat(userIds);
            mergedIds = mergedIds.filter((item, index) => {
                return (mergedIds.indexOf(item) == index)
            });

            group.userIds = mergedIds;

            admin.groups = admin.groups.filter(function (obj) {
                return obj.id !== groupId;
            });

            admin.groups.push(group);
            admin.saveToStorage('adminGroupsList', admin.groups);

            admin.updateUserGroups({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editUserGroup');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

//END USER GROUPS

//USER REGISTRATIONS
/**
 * Updates user registrations available to the current user to work with
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.updateUserRegistrations = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetUserRegistrations({
        success: function (json) {
            admin.registrations = json.registrations;
            admin.saveToStorage('adminRegistrationsList', admin.registrations);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if(httpStatus === 401){
                admin.registrations = [];
            admin.saveToStorage('adminRegistrationsList', admin.registrations);
            }
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUserRegistrations');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to approve a user registration request. Note, only registrations with status “PENDING” can be approved.
 * @param {string} registrationId id of the registration to be approved
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.approveUserRegistration = function (registrationId, callback) {
    var admin = this;
    this.Atheneum.API.adminApproveUserRegistration([registrationId], {
        success: function (json) {
            let registration = admin.registrations.filter(function (obj) {
                return obj.id === registrationId;
            });

            registration.status = "APPROVED";

            admin.registrations = admin.registrations.filter(function (obj) {
                return obj.id !== registrationId;
            });

            admin.registrations.push(registration);
            admin.saveToStorage('adminRegistrationsList', admin.registrations);
            admin.updateUserRegistrations(callback);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUserRegistrations');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to reject a user registration request. Note, only registrations with status “PENDING” can be rejected.
 * @param {string} registrationId id of the registration to be rejected
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.rejectUserRegistration = function (registrationId, callback) {
    var admin = this;
    this.Atheneum.API.adminRejectUserRegistration([registrationId], {
        success: function (json) {
            let registration = admin.registrations.filter(function (obj) {
                return obj.id === registrationId;
            });

            registration.status = "REJECTED";

            admin.registrations = admin.registrations.filter(function (obj) {
                return obj.id !== registrationId;
            });

            admin.registrations.push(registration);
            admin.saveToStorage('adminRegistrationsList', admin.registrations);
            admin.updateUserRegistrations(callback);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUserRegistrations');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}
//END USER REGISTRATIONS

//USERS
/**
 * You can use this call to retrieve a list of existing users available to the current user.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.updateUsers = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetUsers({
        success: function (json) {
            admin.users = json.users;
            admin.saveToStorage('adminUserList', admin.users);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if(httpStatus === 401){
                admin.users = [];
            admin.saveToStorage('adminUserList', admin.users);
            }
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUsers');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to create a new user.
 * User parameters
 * userName - type = String - The username this user will use to login with.
 * title - type = String - The user's title, eg Mr, Mrs, etc.
 * firstName - type = String - The user's first name.
 * middleName - type = String - The user's middle name.
 * lastName - type = String - The user's last name.
 * email - type = String - The user's email address.
 * startDate - type = Timestamp - Indicates the date/time the user will become enabled.
 * endDate - type = Timestamp - Indicates the date/time the user will expire.
 * permissionsSetId - type = String - Id of the permissions set currently assigned to this user.
 * userGroupIds - type = Array - An array of user group IDs this user belongs to.
 * 
 * Extra parameters - only password is required
 * password - type = String - required = TRUE - Password for new user to login with. Note an error may be thrown if the password is deemed to weak. There are no fixed rules for passwords so long as the system detects sufficient complexity. Therefore please avoid using the userName or common English words.
 * accountId - type = String - required = FALSE - The id of a communal account to add the new user to. If this is not provided and generateIndividualAccount is false, the new user will be added to the account the calling user belongs to. However, if the calling user belongs to multiple accounts, an error will be thrown prompting for a specific accountId.
 * generateIndividualAccount - type = Boolean - required = FALSE - If true, an individual account will be created for the new user. If not set, this will default to false.
 * sendUserWelcomeEmail - type = Boolean - required = FALSE - If true, a welcome email will sent to the new user. If not set, this will default to false.
 * includePasswordReset - type = Boolean - required = FALSE - If sendUserWelcomeEmail is true, this option can be used to specify whether a password reset link will be included in the email. This will default to false.

 * @param {object} userFormData object containing information on the user to be created
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.createUser = function (userFormData, callback) {
    var admin = this;
    this.Atheneum.API.adminCreateUser(userFormData, {
        success: function (json) {

            admin.users.push(json);
            admin.saveToStorage('adminUserList', admin.users);

            admin.updateUsers({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.createUser');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to update a specific user.
 * User parameters
 * userName - type = String - The username this user will use to login with.
 * title - type = String - The user's title, eg Mr, Mrs, etc.
 * firstName - type = String - The user's first name.
 * middleName - type = String - The user's middle name.
 * lastName - type = String - The user's last name.
 * email - type = String - The user's email address.
 * startDate - type = Timestamp - Indicates the date/time the user will become enabled.
 * endDate - type = Timestamp - Indicates the date/time the user will expire.
 * permissionsSetId - type = String - Id of the permissions set currently assigned to this user.
 * userGroupIds - type = Array - An array of user group IDs this user belongs to.
 * 
 * Extra parameters - only password is required
 * password - type = String - required = TRUE - Password for new user to login with. Note an error may be thrown if the password is deemed to weak. There are no fixed rules for passwords so long as the system detects sufficient complexity. Therefore please avoid using the userName or common English words.
 * accountId - type = String - required = FALSE - The id of a communal account to add the new user to. If this is not provided and generateIndividualAccount is false, the new user will be added to the account the calling user belongs to. However, if the calling user belongs to multiple accounts, an error will be thrown prompting for a specific accountId.
 * generateIndividualAccount - type = Boolean - required = FALSE - If true, an individual account will be created for the new user. If not set, this will default to false.
 * sendUserWelcomeEmail - type = Boolean - required = FALSE - If true, a welcome email will sent to the new user. If not set, this will default to false.
 * includePasswordReset - type = Boolean - required = FALSE - If sendUserWelcomeEmail is true, this option can be used to specify whether a password reset link will be included in the email. This will default to false.
 * @param {string} userId id of the user to be modified
 * @param {object} userFormData object containing information on the user to be created
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.editUser = function (userId, userFormData, callback) {
    var admin = this;
    this.Atheneum.API.adminEditUser(userId, userFormData, {
        success: function (json) {

            admin.updateUsers({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editUser');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to deactivate a specific user. This will revoke any current authentication tokens for this user and prevent them from logging in.
 * 
 * @param {string} userId id of the user to be deactivated
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
Atheneum.Admin.prototype.deactivateUser = function (userId, callback) {
    var admin = this;
    this.Atheneum.API.adminDeactivateUser(userId, {
        success: function (json) {

            admin.users = admin.users.filter(function (obj) {
                return obj.id !== userId;
            });

            admin.saveToStorage('adminUserList', admin.users);

            admin.updateUsers({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callback && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.deleteUser');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

//END USERS

//PERMISSION SETS
/**
 * You can use this call to retrieve a list of available permissions sets that can be assigned to users.
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
 Atheneum.Admin.prototype.updatePermissionSets = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetUserPermissionSets({
        success: function (json) {
            admin.permissionSets = json.permissionsSets;
            admin.saveToStorage('adminPermissionSetList', admin.users);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if(httpStatus === 401){
                admin.permissionSets = [];
                admin.saveToStorage('adminPermissionSetList', admin.users);
            }
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateUsers');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason,httpStatus,errorCode);
        }
    });
}
//END PERMISSION SETS
//TAGS
/**
 * Updates tags available to the current user to work with
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 */
 Atheneum.Admin.prototype.updateTags = function (callback) {
    var admin = this;
    this.Atheneum.API.adminGetTags(undefined, {
        success: function (json) {
            admin.tags = json.tags;
            admin.saveToStorage('adminTagsList', admin.tags);

            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            if(httpStatus === 401){
                admin.tags = [];
            admin.saveToStorage('adminTagsList', admin.tags);
            }
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateTags');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/**
 * Use this call to retrieve a list of tag + options assigned to an asset with {assetId} along with the reasons it was tagged (if available) 
 * @param {string} assetId unique id of the asset for the information you are requesting
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.getTagReasonsForAsset = function (assetId, callback) {
    var admin = this;
    this.Atheneum.API.admingGetAssetTagReasons(assetId, {
        success: function (json) {
            if (callback && callback.success)
                callback.success(json);
            else if(typeof callback === 'function')
                callback(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateTags');
            if (callback && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to add a new library tag. 
 * Note, if a tag/option name is not provided, it will be auto generated from the label by removing all non alphanumeric characters and joining all words using camel case.
 * 
 * Tags - 
 * 
 * name	- String - The name for this tag. This is the key used in collections/assets properties map. If not specified when creating/updating tags, 
 *                  this will be auto generated from the label by removing non alphanumeric characters and joining words with camel case.	
 * label - String	- The display name for this tag.	
 * order - Integer	- An integer (starting from 1) indicating the display order of this tag.	
 * options - Array - An array of library tag options to appear beneath this tag. There is no limit to the number of option levels a tag can have.	
 * -----------------------------------------
 * Options - each option is an object that contains the same parameters as tags - name, label, order, and optionally a list of options in itself
 * 
 * 
 * @param {object} tagData object containing tag information - see above
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.createTag = function (tagData, callback) {
    var admin = this;
    this.Atheneum.API.adminCreateTag(tagData, {
        success: function (json) {

            admin.tags.push(json.tag);
            admin.saveToStorage('adminTagsList', admin.tags);

            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.createTag');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to add a new library tag. 
 * Note, if a tag/option name is not provided, it will be auto generated from the label by removing all non alphanumeric characters and joining all words using camel case.
 * 
 * Tags - 
 * 
 * name	- String - The name for this tag. This is the key used in collections/assets properties map. If not specified when creating/updating tags, 
 *                  this will be auto generated from the label by removing non alphanumeric characters and joining words with camel case.	
 * label - String	- The display name for this tag.	
 * order - Integer	- An integer (starting from 1) indicating the display order of this tag.	
 * options - Array - An array of library tag options to appear beneath this tag. There is no limit to the number of option levels a tag can have.	
 * -----------------------------------------
 * Options - each option is an object that contains the same parameters as tags - name, label, order, and optionally a list of options in itself
 * 
 * @param {String} tagId id of the tag to be updated
 * @param {object} tagData object containing tag information - see above
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.Admin.prototype.editTag = function (tagId, tagData, callback) {
    var admin = this;
    this.Atheneum.API.adminEditTag(tagId, tagData, {
        success: function (json) {
            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editTag');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to remove a tag. Note, tags that have already been applied to library content, can not be removed.
 
 * @param {string} tagId id of the tag to be removed
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.removeTag = function (tagId, callback) {
    var admin = this;
    this.Atheneum.API.adminRemoveTag(tagId, {
        success: function (json) {

            admin.tags = admin.tags.filter(function (obj) {
                return obj.id !== tagId;
            });

            admin.saveToStorage('adminTagsList', admin.tags);

            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.removeTag');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/** 
 * You can use this call to apply a tag to one or more assets from the library. 
 * Note, tags must belong to the same account as the assets you wish to tag. 
 * There may also be a small delay before the tags appear against the assets in the library API call.
 * 
 * @param {string} tagId - id for the tag to be applied
 * @param {string} optionName option  within the tag to be applied
 * @param {array} assetIds array of ids for the reprints / assets to apply the tag  to
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.applyTagToItems = function(tagId, optionName, assetIds, callback){
    if (optionName == undefined || typeof optionName !== 'string')
        throw new IllegalArgumentException("optionName must be supplied for one of the tags options");

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("tagId must be an string of the unique id of the tag to be applied");
    
    this.Atheneum.API.adminApplyTagToItems(tagId, optionName, assetIds, [], {
        success: function (json) {

            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                    else if(typeof callback === 'function')
                        callback(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                    else if(typeof callback === 'function')
                        callback("Applied tag correctly but failed to update tags call - "+ reason, httpStatus, errorCode);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.applyTagToItems');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}

/** 
 * You can use this call to remove a tag from one or more assets from the library. 
 * Note, there may be a small delay before the tags are removed from the assets in the library API call.
 * 
 * @param {string} tagId - id for the tag to be applied
 * @param {string} optionName option  within the tag to be applied
 * @param {array} assetIds array of ids for the reprints / assets to apply the tag  to
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.removeTagFromItems = function(tagId, optionName, assetIds, callback){
    if (optionName == undefined || typeof optionName !== 'string')
        throw new IllegalArgumentException("optionName must be supplied for one of the tags options");

    if (tagId == undefined || typeof tagId !== 'string')
        throw new IllegalArgumentException("tagId must be an string of the unique id of the tag to be removed");
    
    this.Atheneum.API.adminRemoveTagFromItems(tagId, optionName, assetIds, [], {
        success: function (json) {

            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                    else if(typeof callback === 'function')
                        callback(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                    else if(typeof callback === 'function')
                        callback("Applied tag correctly but failed to update tags call - "+ reason, httpStatus, errorCode);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.removeTagFromItems');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
            else if(typeof callback === 'function')
                callback(reason, httpStatus, errorCode);
        }
    });
}


/** 
 * You can use this call to assign one or more tags to a specific collection or asset from the library. 
 * Note, you must specify all tags that should be associated with the library item. 
 * Any previous tags that are not specified will be removed. 
 * The tags selected must belong to the same account as the collection/asset you wish to tag. 
 * There may also be a small delay before the tags appear against the collections/assets in the library API call.
 * 
 * @param {string} assetId - id for the tag to be applied
 * @param {object} tags object containing  {tagId : optionName} 
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
Atheneum.Admin.prototype.assignTagsToAsset = function (assetId, tags, callback) {
    var admin = this;
    this.Atheneum.API.adminAssignTagsToItem(assetId, tags, {
        success: function (json) {
            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.editTag');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

/**
 * You can use this call to remove a tag. Note, tags that have already been applied to library content, can not be removed.
 
 * @param {string} tagId id of the tag to be removed
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.Admin.prototype.removeTag = function (tagId, callback) {
    var admin = this;
    this.Atheneum.API.adminRemoveTag(tagId, {
        success: function (json) {

            admin.tags = admin.tags.filter(function (obj) {
                return obj.id !== tagId;
            });

            admin.saveToStorage('adminTagsList', admin.tags);

            admin.updateTags({
                success: function (json) {
                    if (callback && callback.success)
                        callback.success(json);
                },
                failure: function (reason, httpStatus, errorCode) {
                    if (callbacks && callback.success)
                        callback.success(json);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.removeTag');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}

Atheneum.Admin.prototype.updateTagHistory = function (callback) {
    var admin = this;
    this.Atheneum.API.adminUpdateTagHistory({
        success: function (json) {

            admin.tagHistory = json.filterHistory;
            admin.saveToStorage('adminTagHistory', admin.tagHistory);
            if (callback && callback.success)
                callback.success(json);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.updateTagHistory');
            if (typeof callback !== 'undefined' && callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}


//END TAGS
// RELATED ASSETS

Atheneum.Admin.prototype.getRelatedAssetIds = function (assetId, callback) {
    var admin = this;

    let asset = this.Atheneum.Library.assets[assetId];
    if(!asset || !this.Atheneum.User.canSee(asset))
    {
        if(callback)
            callback([]);
    }
    
    this.Atheneum.API.getRelatedAssets(assetId, {
        success: function (json) {

            let relatedAssets = typeof asset.relatedAssets === 'string' ? asset.relatedAssets?.split(',') : asset.relatedAssets;
            let relatedIds = json.relatedAssets || relatedAssets || [];
          
            if (callback)
                callback(relatedIds);
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.getRelatedAssets');
            let relatedAssets = typeof asset.relatedAssets === 'string' ? asset.relatedAssets?.split(',') : asset.relatedAssets;
           
            let relatedIds = relatedAssets || [];
            if (callback)
                callback(relatedIds);
        }
    });
}

/**
 * You can use this call to set related assets for a particular asset id
 * @param {string} assetId id of the asset to be modified
 * @param {Array} relatedAssets array of assets to be set as related to the assetId
 * @param {boolean} reciprocateAdds any new assetIds will go both ways
 * @param {boolean} reciprocateRemovals any removed items will be removed both ways
 * @param {boolean} reciprocateExisting any existing items will have the relationship updated to go both ways
 * @param {object} callback object with up to 3 functions - success(json), failure(reason,httpstatus, errorcode), and offline(reason,httpstatus, errorcode)
 * @returns 
 */
 Atheneum.Admin.prototype.setRelatedAssets = function (assetId, relatedAssets, reciprocateAdds, reciprocateRemovals, reciprocateExisting, callback) {
    var admin = this;
    this.Atheneum.API.setRelatedAssets(assetId, relatedAssets, reciprocateAdds, reciprocateRemovals, reciprocateExisting, {
        success: function (json) {

            let relatedAssetIds = relatedAssets.map(x=> x.id) || [];

            admin.getRelatedAssetIds(assetId, function(relatedAssetIds){
                if(callback && callback.success){
                    callback.success(relatedAssetIds);
                }
            });
        },
        failure: function (reason, httpStatus, errorCode) {
            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Admin.setRelatedAssets');
            if (callback.failure)
                callback.failure(reason, httpStatus, errorCode);
        }
    });
}
// END RELATED ASSETS
//#endregion

Atheneum.Device = {};
Atheneum.prototype.Device = Atheneum.Device;

Atheneum.Device.getOSName = function () {
    return this._getInfo().os;
}

Atheneum.Device.getOSVersion = function () {
    return this._getInfo().osVersion;
}

Atheneum.Device.Category = {};
Atheneum.Device.Category.PHONE = 'Phone';
Atheneum.Device.Category.TABLET = 'Tablet';
Atheneum.Device.Category.DESKTOP = 'Desktop';

/** Returns a device category from Atheneum.Device.Category which best represents the device */
Atheneum.Device.getCategory = function () {
    var info = this._getInfo();

    var category = null;

    if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent || '')) {
        category = Atheneum.Device.Category.TABLET;
    }
    else if (info.mobile) {
        category = Atheneum.Device.Category.PHONE;
    }
    else {
        category = Atheneum.Device.Category.DESKTOP;
    }

    return category;
}

Atheneum.Device.Browser = {};
Atheneum.Device.Browser.EDGE = "Edge";
Atheneum.Device.Browser.INTERNET_EXPLORER = "Internet Explorer";
Atheneum.Device.Browser.CHROME = "Chrome";
Atheneum.Device.Browser.FIREFOX = "Firefox";
Atheneum.Device.Browser.SAFARI = "Safari";
Atheneum.Device.Browser.OPERA = "Opera";

/** Returns a string representing */
Atheneum.Device.getBrowserName = function () {
    return this._getInfo().browser;
}
/**
 * Usually returns a string of the form "X.X" or "X.X.X" indicating the version of the browser.
 * If the browser could not be determined, returns the empty string "" instead.
 */
Atheneum.Device.getBrowserVersion = function () {
    return this._getInfo().browserVersion;
}
/** Returns a string of the form "WxH" (eg: "1920x1080")*/
Atheneum.Device.getScreenDimensions = function () {
    return this._getInfo().screen;
}

/**
 * Returns various statistics about the browser and operating system
 * 
 * adapted from https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript#18706818
 * (C) viazenetti GmbH (Christian Ludwig)
 */
Atheneum.Device._getInfo = function () {

    // screen
    var screenSize = '';
    if (screen.width) {
        width = (screen.width) ? screen.width : '';
        height = (screen.height) ? screen.height : '';
        screenSize += '' + width + "x" + height;
    }

    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // Opera
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = Atheneum.Device.Browser.OPERA;
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = Atheneum.Device.Browser.OPERA;
        version = nAgt.substring(verOffset + 4);
    }
    // Legacy Edge
    else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
        browser = Atheneum.Device.Browser.EDGE;
        version = nAgt.substring(verOffset + 5);
    }
    // Edge (Chromium)
    else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
        browser = Atheneum.Device.Browser.EDGE;
        version = nAgt.substring(verOffset + 4);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = Atheneum.Device.Browser.INTERNET_EXPLORER;
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = Atheneum.Device.Browser.CHROME;
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = Atheneum.Device.Browser.SAFARI;
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = Atheneum.Device.Browser.FIREFOX;
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') != -1) {
        browser = Atheneum.Device.Browser.INTERNET_EXPLORER;
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

    majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    // mobile version
    var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // system
    var os = null;
    var clientStrings = [
        { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Chrome OS', r: /CrOS/ },
        { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = null;

    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
        case 'Android':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            break;

        case 'iOS':
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
    }

    return {
        screen: screenSize,
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        os: os,
        osVersion: osVersion
    };
}

/* ASYNC METHODS */
Atheneum.Contacts.prototype.getContactsAsync = async function(){
    try{
        return new Promise((resolve, reject) => {
            SalesToolkit.API.getContacts(9999,0,0,  {
                success:function(json){ 
                    resolve(json);
                }, failure: function(reason, httpstatus, errorCode){
                    reject( {errorCode: errorCode, error: reason});
                }});
          });
    }catch(err){
        throw new Error({errorCode: -1, error: error});
    }
}

function htmlToElement  (html) {
    var template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
}

function onVisible(element, callback) {
    new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
        }
        });
    }).observe(element);
    }
console.log("atheneumAPI.js - loaded");

function quickAlert (options) {
	var deferredObject = $.Deferred();
	var defaults = {
		type: "alert", //alert, prompt,confirm 
		modalSize: 'modal-sm', //modal-sm, modal-lg
		okButtonText: window.AtheneumInstance.Translation.get('ok', "OK"),
		cancelButtonText: window.AtheneumInstance.Translation.get('cancel', "Cancel"),
		yesButtonText: window.AtheneumInstance.Translation.get('yes', "Yes"),
		noButtonText: window.AtheneumInstance.Translation.get('no', "No"),
		headerText: window.AtheneumInstance.Translation.get('attention', "Atttention"),
		messageText: '',
		alertType: 'default', //default, primary, success, info, warning, danger
		inputFieldType: 'text', //could ask for number,email,etc
        customInputParams: '',
	}
	$.extend(defaults, options);
  
	var _show = function(){
		var headClass = "navbar-default";
		switch (defaults.alertType) {
			case "primary":
				headClass = "alert-primary";
				break;
			case "success":
				headClass = "alert-success";
				break;
			case "info":
				headClass = "alert-info";
				break;
			case "warning":
				headClass = "alert-warning";
				break;
			case "danger":
				headClass = "alert-danger";
				break;
        }
		$('BODY').append(
			'<div id="ezAlerts" class="modal fade">' +
			'<div class="modal-dialog" class="' + defaults.modalSize + '">' +
			'<div class="modal-content">' +
			'<div id="ezAlerts-header" class="modal-header ' + headClass + '">' +
			'<button id="close-button" type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>' +
			'<h4 id="ezAlerts-title" class="modal-title">Modal title</h4>' +
			'</div>' +
			'<div id="ezAlerts-body" class="modal-body">' +
			'<div id="ezAlerts-message" ></div>' +
			'</div>' +
			'<div id="ezAlerts-footer" class="modal-footer">' +
			'</div>' +
			'</div>' +
			'</div>' +
			'</div>'
		);

		$('.modal-header').css({
			'padding': '15px 15px',
			'-webkit-border-top-left-radius': '5px',
			'-webkit-border-top-right-radius': '5px',
			'-moz-border-radius-topleft': '5px',
			'-moz-border-radius-topright': '5px',
			'border-top-left-radius': '5px',
			'border-top-right-radius': '5px'
		});
    
		$('#ezAlerts-title').text(defaults.headerText);
		$('#ezAlerts-message').html(defaults.messageText);

		var keyb = "false", backd = "static";
		var calbackParam = "";
		switch (defaults.type) {
			case 'alert':
				keyb = "true";
				backd = "true";
				$('#ezAlerts-footer').html('<button class="btn btn-' + defaults.alertType + '">' + defaults.okButtonText + '</button>').on('click', ".btn", function () {
					calbackParam = true;
					$('#ezAlerts').modal('hide');
				});
				break;
			case 'confirm':
				var btnhtml = '<button id="ezok-btn" class="btn btn-primary">' + defaults.yesButtonText + '</button>';
				if (defaults.noButtonText && defaults.noButtonText.length > 0) {
					btnhtml += '<button id="ezclose-btn" class="btn btn-default">' + defaults.noButtonText + '</button>';
				}
				$('#ezAlerts-footer').html(btnhtml).on('click', 'button', function (e) {
						if (e.target.id === 'ezok-btn') {
							calbackParam = true;
							$('#ezAlerts').modal('hide');
						} else if (e.target.id === 'ezclose-btn') {
							calbackParam = false;
							$('#ezAlerts').modal('hide');
						}
					});
				break;
			case 'prompt':
				$('#ezAlerts-message').html(defaults.messageText + '<br /><br /><div class="form-group"><input "'+defaults.customInputParams+'" type="' + defaults.inputFieldType + '" class="form-control" id="prompt" /></div>');
				$('#ezAlerts-footer').html('<button class="btn btn-primary">' + defaults.okButtonText + '</button>').on('click', ".btn", function () {
					calbackParam = $('#prompt').val();
					$('#ezAlerts').modal('hide');
				});
				break;
		}
   
		$('#ezAlerts').modal({ 
          show: false, 
          backdrop: backd, 
          keyboard: keyb 
        }).on('hidden.bs.modal', function (e) {
			$('#ezAlerts').remove();
			deferredObject.resolve(calbackParam);
		}).on('shown.bs.modal', function (e) {
			if ($('#prompt').length > 0) {
				$('#prompt').focus();
			}
		}).modal('show');
	}
    
  _show();  
  return deferredObject.promise();    
}